/*! For license information please see template.index.js.LICENSE.txt */
(() => {
  var e,
    t,
    i,
    n,
    r,
    o,
    a = {
      2800: (e, t) => {
        "use strict";
        t.l = function (e, t) {
          "string" == typeof e && (e = e.replace(".", ""));
          var n = "",
            r = /\{\{\s*(\w+)\s*\}\}/,
            o = t || i;
          function a(e) {
            var t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : 2,
              i =
                arguments.length > 2 && void 0 !== arguments[2]
                  ? arguments[2]
                  : ",",
              n =
                arguments.length > 3 && void 0 !== arguments[3]
                  ? arguments[3]
                  : ".";
            if (isNaN(e) || null == e) return 0;
            var r = (e = (e / 100).toFixed(t)).split(".");
            return (
              r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
              (r[1] ? n + r[1] : "")
            );
          }
          switch (o.match(r)[1]) {
            case "amount":
              n = a(e, 2);
              break;
            case "amount_no_decimals":
              n = a(e, 0);
              break;
            case "amount_with_comma_separator":
              n = a(e, 2, ".", ",");
              break;
            case "amount_no_decimals_with_comma_separator":
              n = a(e, 0, ".", ",");
          }
          return o.replace(r, n);
        };
        var i = "${{amount}}";
      },
      8595: (e, t, i) => {
        "use strict";
        function n(e, t) {
          for (var i = 0; i < t.length; i++) {
            var n = t[i];
            (n.enumerable = n.enumerable || !1),
              (n.configurable = !0),
              "value" in n && (n.writable = !0),
              Object.defineProperty(e, n.key, n);
          }
        }
        i.r(t),
          i.d(t, {
            CLASSES: () => Kt,
            CLASS_ACTIVE: () => Ht,
            CLASS_ARROW: () => xt,
            CLASS_ARROWS: () => Ct,
            CLASS_ARROW_NEXT: () => It,
            CLASS_ARROW_PREV: () => Lt,
            CLASS_CLONE: () => Pt,
            CLASS_CONTAINER: () => _t,
            CLASS_FOCUS_IN: () => Gt,
            CLASS_INITIALIZED: () => Rt,
            CLASS_LIST: () => Tt,
            CLASS_LOADING: () => zt,
            CLASS_NEXT: () => $t,
            CLASS_PAGINATION: () => Ot,
            CLASS_PAGINATION_PAGE: () => qt,
            CLASS_PREV: () => Ut,
            CLASS_PROGRESS: () => Mt,
            CLASS_PROGRESS_BAR: () => Nt,
            CLASS_ROOT: () => Et,
            CLASS_SLIDE: () => At,
            CLASS_SPINNER: () => Bt,
            CLASS_SR: () => Ft,
            CLASS_TOGGLE: () => jt,
            CLASS_TOGGLE_PAUSE: () => Dt,
            CLASS_TOGGLE_PLAY: () => Vt,
            CLASS_TRACK: () => kt,
            CLASS_VISIBLE: () => Wt,
            DEFAULTS: () => fi,
            EVENT_ACTIVE: () => ke,
            EVENT_ARROWS_MOUNTED: () => De,
            EVENT_ARROWS_UPDATED: () => Be,
            EVENT_AUTOPLAY_PAUSE: () => We,
            EVENT_AUTOPLAY_PLAY: () => Ue,
            EVENT_AUTOPLAY_PLAYING: () => $e,
            EVENT_CLICK: () => Ee,
            EVENT_DESTROY: () => Ve,
            EVENT_DRAG: () => Oe,
            EVENT_DRAGGED: () => Me,
            EVENT_DRAGGING: () => qe,
            EVENT_HIDDEN: () => Pe,
            EVENT_INACTIVE: () => Te,
            EVENT_LAZYLOAD_LOADED: () => ze,
            EVENT_MOUNTED: () => ye,
            EVENT_MOVE: () => be,
            EVENT_MOVED: () => we,
            EVENT_NAVIGATION_MOUNTED: () => He,
            EVENT_PAGINATION_MOUNTED: () => Fe,
            EVENT_PAGINATION_UPDATED: () => Re,
            EVENT_READY: () => ve,
            EVENT_REFRESH: () => Ce,
            EVENT_RESIZE: () => Le,
            EVENT_RESIZED: () => Ie,
            EVENT_SCROLL: () => Ne,
            EVENT_SCROLLED: () => je,
            EVENT_SHIFTED: () => Se,
            EVENT_SLIDE_KEYDOWN: () => _e,
            EVENT_UPDATED: () => xe,
            EVENT_VISIBLE: () => Ae,
            EventBinder: () => ge,
            EventInterface: () => Ge,
            FADE: () => ti,
            LOOP: () => ei,
            LTR: () => it,
            RTL: () => nt,
            RequestInterval: () => Qe,
            SLIDE: () => Zt,
            STATUS_CLASSES: () => Qt,
            Splide: () => yi,
            SplideRenderer: () => wi,
            State: () => Ke,
            TTB: () => rt,
            Throttle: () => Ye,
            default: () => yi,
          });
        var r = "(prefers-reduced-motion: reduce)",
          o = {
            CREATED: 1,
            MOUNTED: 2,
            IDLE: 3,
            MOVING: 4,
            SCROLLING: 5,
            DRAGGING: 6,
            DESTROYED: 7,
          };
        function a(e) {
          e.length = 0;
        }
        function s(e, t, i) {
          return Array.prototype.slice.call(e, t, i);
        }
        function l(e) {
          return e.bind.apply(e, [null].concat(s(arguments, 1)));
        }
        var c = setTimeout,
          u = function () {};
        function d(e) {
          return requestAnimationFrame(e);
        }
        function h(e, t) {
          return typeof t === e;
        }
        function p(e) {
          return !v(e) && h("object", e);
        }
        var f = Array.isArray,
          m = l(h, "function"),
          g = l(h, "string"),
          y = l(h, "undefined");
        function v(e) {
          return null === e;
        }
        function b(e) {
          return e instanceof HTMLElement;
        }
        function w(e) {
          return f(e) ? e : [e];
        }
        function S(e, t) {
          w(e).forEach(t);
        }
        function E(e, t) {
          return e.indexOf(t) > -1;
        }
        function k(e, t) {
          return e.push.apply(e, w(t)), e;
        }
        function T(e, t, i) {
          e &&
            S(t, function (t) {
              t && e.classList[i ? "add" : "remove"](t);
            });
        }
        function A(e, t) {
          T(e, g(t) ? t.split(" ") : t, !0);
        }
        function P(e, t) {
          S(t, e.appendChild.bind(e));
        }
        function _(e, t) {
          S(e, function (e) {
            var i = (t || e).parentNode;
            i && i.insertBefore(e, t);
          });
        }
        function C(e, t) {
          return b(e) && (e.msMatchesSelector || e.matches).call(e, t);
        }
        function x(e, t) {
          var i = e ? s(e.children) : [];
          return t
            ? i.filter(function (e) {
                return C(e, t);
              })
            : i;
        }
        function L(e, t) {
          return t ? x(e, t)[0] : e.firstElementChild;
        }
        var I = Object.keys;
        function O(e, t, i) {
          if (e) {
            var n = I(e);
            n = i ? n.reverse() : n;
            for (var r = 0; r < n.length; r++) {
              var o = n[r];
              if ("__proto__" !== o && !1 === t(e[o], o)) break;
            }
          }
          return e;
        }
        function q(e) {
          return (
            s(arguments, 1).forEach(function (t) {
              O(t, function (i, n) {
                e[n] = t[n];
              });
            }),
            e
          );
        }
        function M(e) {
          return (
            s(arguments, 1).forEach(function (t) {
              O(t, function (t, i) {
                f(t)
                  ? (e[i] = t.slice())
                  : p(t)
                  ? (e[i] = M({}, p(e[i]) ? e[i] : {}, t))
                  : (e[i] = t);
              });
            }),
            e
          );
        }
        function N(e, t) {
          w(t || I(e)).forEach(function (t) {
            delete e[t];
          });
        }
        function j(e, t) {
          S(e, function (e) {
            S(t, function (t) {
              e && e.removeAttribute(t);
            });
          });
        }
        function V(e, t, i) {
          p(t)
            ? O(t, function (t, i) {
                V(e, i, t);
              })
            : S(e, function (e) {
                v(i) || "" === i ? j(e, t) : e.setAttribute(t, String(i));
              });
        }
        function D(e, t, i) {
          var n = document.createElement(e);
          return t && (g(t) ? A(n, t) : V(n, t)), i && P(i, n), n;
        }
        function B(e, t, i) {
          if (y(i)) return getComputedStyle(e)[t];
          v(i) || (e.style[t] = "" + i);
        }
        function F(e, t) {
          B(e, "display", t);
        }
        function R(e) {
          (e.setActive && e.setActive()) || e.focus({ preventScroll: !0 });
        }
        function H(e, t) {
          return e.getAttribute(t);
        }
        function U(e, t) {
          return e && e.classList.contains(t);
        }
        function $(e) {
          return e.getBoundingClientRect();
        }
        function W(e) {
          S(e, function (e) {
            e && e.parentNode && e.parentNode.removeChild(e);
          });
        }
        function z(e) {
          return L(new DOMParser().parseFromString(e, "text/html").body);
        }
        function G(e, t) {
          e.preventDefault(),
            t && (e.stopPropagation(), e.stopImmediatePropagation());
        }
        function Q(e, t) {
          return e && e.querySelector(t);
        }
        function K(e, t) {
          return t ? s(e.querySelectorAll(t)) : [];
        }
        function Y(e, t) {
          T(e, t, !1);
        }
        function X(e) {
          return e.timeStamp;
        }
        function J(e) {
          return g(e) ? e : e ? e + "px" : "";
        }
        var Z = "splide",
          ee = "data-" + Z;
        function te(e, t) {
          if (!e) throw new Error("[" + Z + "] " + (t || ""));
        }
        var ie = Math.min,
          ne = Math.max,
          re = Math.floor,
          oe = Math.ceil,
          ae = Math.abs;
        function se(e, t, i) {
          return ae(e - t) < i;
        }
        function le(e, t, i, n) {
          var r = ie(t, i),
            o = ne(t, i);
          return n ? r < e && e < o : r <= e && e <= o;
        }
        function ce(e, t, i) {
          var n = ie(t, i),
            r = ne(t, i);
          return ie(ne(n, e), r);
        }
        function ue(e) {
          return +(e > 0) - +(e < 0);
        }
        function de(e) {
          return e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
        }
        function he(e, t) {
          return (
            S(t, function (t) {
              e = e.replace("%s", "" + t);
            }),
            e
          );
        }
        function pe(e) {
          return e < 10 ? "0" + e : "" + e;
        }
        var fe = {};
        function me(e) {
          return "" + e + pe((fe[e] = (fe[e] || 0) + 1));
        }
        function ge() {
          var e = [];
          function t(e, t, i) {
            S(e, function (e) {
              e &&
                S(t, function (t) {
                  t.split(" ").forEach(function (t) {
                    var n = t.split(".");
                    i(e, n[0], n[1]);
                  });
                });
            });
          }
          return {
            bind: function (i, n, r, o) {
              t(i, n, function (t, i, n) {
                var a = "addEventListener" in t,
                  s = a
                    ? t.removeEventListener.bind(t, i, r, o)
                    : t.removeListener.bind(t, r);
                a ? t.addEventListener(i, r, o) : t.addListener(r),
                  e.push([t, i, n, r, s]);
              });
            },
            unbind: function (i, n, r) {
              t(i, n, function (t, i, n) {
                e = e.filter(function (e) {
                  return (
                    !!(
                      e[0] !== t ||
                      e[1] !== i ||
                      e[2] !== n ||
                      (r && e[3] !== r)
                    ) || (e[4](), !1)
                  );
                });
              });
            },
            dispatch: function (e, t, i) {
              var n;
              return (
                "function" == typeof CustomEvent
                  ? (n = new CustomEvent(t, { bubbles: !0, detail: i }))
                  : (n = document.createEvent("CustomEvent")).initCustomEvent(
                      t,
                      !0,
                      !1,
                      i
                    ),
                e.dispatchEvent(n),
                n
              );
            },
            destroy: function () {
              e.forEach(function (e) {
                e[4]();
              }),
                a(e);
            },
          };
        }
        var ye = "mounted",
          ve = "ready",
          be = "move",
          we = "moved",
          Se = "shifted",
          Ee = "click",
          ke = "active",
          Te = "inactive",
          Ae = "visible",
          Pe = "hidden",
          _e = "slide:keydown",
          Ce = "refresh",
          xe = "updated",
          Le = "resize",
          Ie = "resized",
          Oe = "drag",
          qe = "dragging",
          Me = "dragged",
          Ne = "scroll",
          je = "scrolled",
          Ve = "destroy",
          De = "arrows:mounted",
          Be = "arrows:updated",
          Fe = "pagination:mounted",
          Re = "pagination:updated",
          He = "navigation:mounted",
          Ue = "autoplay:play",
          $e = "autoplay:playing",
          We = "autoplay:pause",
          ze = "lazyload:loaded";
        function Ge(e) {
          var t = e ? e.event.bus : document.createDocumentFragment(),
            i = ge();
          return (
            e && e.event.on(Ve, i.destroy),
            q(i, {
              bus: t,
              on: function (e, n) {
                i.bind(t, w(e).join(" "), function (e) {
                  n.apply(n, f(e.detail) ? e.detail : []);
                });
              },
              off: l(i.unbind, t),
              emit: function (e) {
                i.dispatch(t, e, s(arguments, 1));
              },
            })
          );
        }
        function Qe(e, t, i, n) {
          var r,
            o,
            a = Date.now,
            s = 0,
            l = !0,
            c = 0;
          function u() {
            if (!l) {
              if (
                ((s = e ? ie((a() - r) / e, 1) : 1),
                i && i(s),
                s >= 1 && (t(), (r = a()), n && ++c >= n))
              )
                return h();
              d(u);
            }
          }
          function h() {
            l = !0;
          }
          function p() {
            o && cancelAnimationFrame(o), (s = 0), (o = 0), (l = !0);
          }
          return {
            start: function (t) {
              !t && p(), (r = a() - (t ? s * e : 0)), (l = !1), d(u);
            },
            rewind: function () {
              (r = a()), (s = 0), i && i(s);
            },
            pause: h,
            cancel: p,
            set: function (t) {
              e = t;
            },
            isPaused: function () {
              return l;
            },
          };
        }
        function Ke(e) {
          var t = e;
          return {
            set: function (e) {
              t = e;
            },
            is: function (e) {
              return E(w(e), t);
            },
          };
        }
        function Ye(e, t) {
          var i;
          return function () {
            i ||
              (i = Qe(
                t || 0,
                function () {
                  e(), (i = null);
                },
                null,
                1
              )).start();
          };
        }
        var Xe = "Arrow",
          Je = Xe + "Left",
          Ze = Xe + "Right",
          et = Xe + "Up",
          tt = Xe + "Down",
          it = "ltr",
          nt = "rtl",
          rt = "ttb",
          ot = {
            width: ["height"],
            left: ["top", "right"],
            right: ["bottom", "left"],
            x: ["y"],
            X: ["Y"],
            Y: ["X"],
            ArrowLeft: [et, Ze],
            ArrowRight: [tt, Je],
          };
        function at(e, t, i) {
          return {
            resolve: function (e, t, n) {
              var r =
                (n = n || i.direction) !== nt || t ? (n === rt ? 0 : -1) : 1;
              return (
                (ot[e] && ot[e][r]) ||
                e.replace(/width|left|right/i, function (e, t) {
                  var i = ot[e.toLowerCase()][r] || e;
                  return t > 0 ? i.charAt(0).toUpperCase() + i.slice(1) : i;
                })
              );
            },
            orient: function (e) {
              return e * (i.direction === nt ? 1 : -1);
            },
          };
        }
        var st = "role",
          lt = "tabindex",
          ct = "aria-",
          ut = ct + "controls",
          dt = ct + "current",
          ht = ct + "selected",
          pt = ct + "label",
          ft = ct + "labelledby",
          mt = ct + "hidden",
          gt = ct + "orientation",
          yt = ct + "roledescription",
          vt = ct + "live",
          bt = ct + "busy",
          wt = ct + "atomic",
          St = [st, lt, "disabled", ut, dt, pt, ft, mt, gt, yt],
          Et = Z,
          kt = Z + "__track",
          Tt = Z + "__list",
          At = Z + "__slide",
          Pt = At + "--clone",
          _t = At + "__container",
          Ct = Z + "__arrows",
          xt = Z + "__arrow",
          Lt = xt + "--prev",
          It = xt + "--next",
          Ot = Z + "__pagination",
          qt = Ot + "__page",
          Mt = Z + "__progress",
          Nt = Mt + "__bar",
          jt = Z + "__toggle",
          Vt = jt + "__play",
          Dt = jt + "__pause",
          Bt = Z + "__spinner",
          Ft = Z + "__sr",
          Rt = "is-initialized",
          Ht = "is-active",
          Ut = "is-prev",
          $t = "is-next",
          Wt = "is-visible",
          zt = "is-loading",
          Gt = "is-focus-in",
          Qt = [Ht, Wt, Ut, $t, zt, Gt],
          Kt = {
            slide: At,
            clone: Pt,
            arrows: Ct,
            arrow: xt,
            prev: Lt,
            next: It,
            pagination: Ot,
            page: qt,
            spinner: Bt,
          },
          Yt = "touchstart mousedown",
          Xt = "touchmove mousemove",
          Jt = "touchend touchcancel mouseup click",
          Zt = "slide",
          ei = "loop",
          ti = "fade";
        var ii = "http://www.w3.org/2000/svg",
          ni =
            "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z",
          ri = ee + "-interval",
          oi = { passive: !1, capture: !0 },
          ai = { Spacebar: " ", Right: Ze, Left: Je, Up: et, Down: tt };
        function si(e) {
          return (e = g(e) ? e : e.key), ai[e] || e;
        }
        var li = "keydown",
          ci = ee + "-lazy",
          ui = ci + "-srcset",
          di = "[" + ci + "], [" + ui + "]",
          hi = [" ", "Enter"],
          pi = Object.freeze({
            __proto__: null,
            Media: function (e, t, i) {
              var n = e.state,
                o = i.breakpoints || {},
                a = i.reducedMotion || {},
                s = ge(),
                l = [];
              function c(e) {
                e && s.destroy();
              }
              function u(e, t) {
                var i = matchMedia(t);
                s.bind(i, "change", d), l.push([e, i]);
              }
              function d() {
                var t = n.is(7),
                  r = i.direction,
                  o = l.reduce(function (e, t) {
                    return M(e, t[1].matches ? t[0] : {});
                  }, {});
                N(i),
                  h(o),
                  i.destroy
                    ? e.destroy("completely" === i.destroy)
                    : t
                    ? (c(!0), e.mount())
                    : r !== i.direction && e.refresh();
              }
              function h(t, r) {
                M(i, t),
                  r && M(Object.getPrototypeOf(i), t),
                  n.is(1) || e.emit(xe, i);
              }
              return {
                setup: function () {
                  var e = "min" === i.mediaQuery;
                  I(o)
                    .sort(function (t, i) {
                      return e ? +t - +i : +i - +t;
                    })
                    .forEach(function (t) {
                      u(
                        o[t],
                        "(" + (e ? "min" : "max") + "-width:" + t + "px)"
                      );
                    }),
                    u(a, r),
                    d();
                },
                destroy: c,
                reduce: function (e) {
                  matchMedia(r).matches && (e ? M(i, a) : N(i, I(a)));
                },
                set: h,
              };
            },
            Direction: at,
            Elements: function (e, t, i) {
              var n,
                r,
                o,
                s = Ge(e),
                l = s.on,
                c = s.bind,
                u = e.root,
                d = i.i18n,
                h = {},
                p = [],
                f = [],
                g = [];
              function y() {
                var e, t;
                (n = w("." + kt)),
                  (r = L(n, "." + Tt)),
                  te(n && r, "A track/list element is missing."),
                  k(p, x(r, "." + At + ":not(." + Pt + ")")),
                  O(
                    {
                      arrows: Ct,
                      pagination: Ot,
                      prev: Lt,
                      next: It,
                      bar: Nt,
                      toggle: jt,
                    },
                    function (e, t) {
                      h[t] = w("." + e);
                    }
                  ),
                  q(h, { root: u, track: n, list: r, slides: p }),
                  (e = u.id || me(Z)),
                  (t = i.role),
                  (u.id = e),
                  (n.id = n.id || e + "-track"),
                  (r.id = r.id || e + "-list"),
                  !H(u, st) && "SECTION" !== u.tagName && t && V(u, st, t),
                  V(u, yt, d.carousel),
                  V(r, st, "presentation"),
                  b();
              }
              function v(e) {
                var t = St.concat("style");
                a(p),
                  Y(u, f),
                  Y(n, g),
                  j([n, r], t),
                  j(u, e ? t : ["style", yt]);
              }
              function b() {
                Y(u, f),
                  Y(n, g),
                  (f = S(Et)),
                  (g = S(kt)),
                  A(u, f),
                  A(n, g),
                  V(u, pt, i.label),
                  V(u, ft, i.labelledby);
              }
              function w(e) {
                var t = Q(u, e);
                return t &&
                  (function (e, t) {
                    if (m(e.closest)) return e.closest(t);
                    for (var i = e; i && 1 === i.nodeType && !C(i, t); )
                      i = i.parentElement;
                    return i;
                  })(t, "." + Et) === u
                  ? t
                  : void 0;
              }
              function S(e) {
                return [
                  e + "--" + i.type,
                  e + "--" + i.direction,
                  i.drag && e + "--draggable",
                  i.isNavigation && e + "--nav",
                  e === Et && Ht,
                ];
              }
              return q(h, {
                setup: y,
                mount: function () {
                  l(Ce, v),
                    l(Ce, y),
                    l(xe, b),
                    c(
                      document,
                      Yt + " keydown",
                      function (e) {
                        o = "keydown" === e.type;
                      },
                      { capture: !0 }
                    ),
                    c(u, "focusin", function () {
                      T(u, Gt, !!o);
                    });
                },
                destroy: v,
              });
            },
            Slides: function (e, t, i) {
              var n = Ge(e),
                r = n.on,
                o = n.emit,
                s = n.bind,
                c = t.Elements,
                u = c.slides,
                d = c.list,
                h = [];
              function p() {
                u.forEach(function (e, t) {
                  y(e, t, -1);
                });
              }
              function f() {
                k(function (e) {
                  e.destroy();
                }),
                  a(h);
              }
              function y(t, i, n) {
                var r = (function (e, t, i, n) {
                  var r,
                    o = Ge(e),
                    a = o.on,
                    s = o.emit,
                    c = o.bind,
                    u = e.Components,
                    d = e.root,
                    h = e.options,
                    p = h.isNavigation,
                    f = h.updateOnMove,
                    m = h.i18n,
                    g = h.pagination,
                    y = h.slideFocus,
                    v = u.Direction.resolve,
                    b = H(n, "style"),
                    w = H(n, pt),
                    S = i > -1,
                    E = L(n, "." + _t),
                    k = K(n, h.focusableNodes || "");
                  function A() {
                    var r = e.splides
                      .map(function (e) {
                        var i = e.splide.Components.Slides.getAt(t);
                        return i ? i.slide.id : "";
                      })
                      .join(" ");
                    V(n, pt, he(m.slideX, (S ? i : t) + 1)),
                      V(n, ut, r),
                      V(n, st, y ? "button" : ""),
                      y && j(n, yt);
                  }
                  function P() {
                    r || _();
                  }
                  function _() {
                    if (!r) {
                      var i = e.index;
                      (o = C()) !== U(n, Ht) &&
                        (T(n, Ht, o),
                        V(n, dt, (p && o) || ""),
                        s(o ? ke : Te, x)),
                        (function () {
                          var t = (function () {
                              if (e.is(ti)) return C();
                              var t = $(u.Elements.track),
                                i = $(n),
                                r = v("left", !0),
                                o = v("right", !0);
                              return (
                                re(t[r]) <= oe(i[r]) && re(i[o]) <= oe(t[o])
                              );
                            })(),
                            i = !t && (!C() || S);
                          if (
                            (e.state.is([4, 5]) || V(n, mt, i || ""),
                            V(k, lt, i ? -1 : ""),
                            y && V(n, lt, i ? -1 : 0),
                            t !== U(n, Wt) && (T(n, Wt, t), s(t ? Ae : Pe, x)),
                            !t && document.activeElement === n)
                          ) {
                            var r = u.Slides.getAt(e.index);
                            r && R(r.slide);
                          }
                        })(),
                        T(n, Ut, t === i - 1),
                        T(n, $t, t === i + 1);
                    }
                    var o;
                  }
                  function C() {
                    var n = e.index;
                    return n === t || (h.cloneStatus && n === i);
                  }
                  var x = {
                    index: t,
                    slideIndex: i,
                    slide: n,
                    container: E,
                    isClone: S,
                    mount: function () {
                      S ||
                        ((n.id = d.id + "-slide" + pe(t + 1)),
                        V(n, st, g ? "tabpanel" : "group"),
                        V(n, yt, m.slide),
                        V(n, pt, w || he(m.slideLabel, [t + 1, e.length]))),
                        c(n, "click", l(s, Ee, x)),
                        c(n, "keydown", l(s, _e, x)),
                        a([we, Se, je], _),
                        a(He, A),
                        f && a(be, P);
                    },
                    destroy: function () {
                      (r = !0),
                        o.destroy(),
                        Y(n, Qt),
                        j(n, St),
                        V(n, "style", b),
                        V(n, pt, w || "");
                    },
                    update: _,
                    style: function (e, t, i) {
                      B((i && E) || n, e, t);
                    },
                    isWithin: function (i, n) {
                      var r = ae(i - t);
                      return (
                        S ||
                          (!h.rewind && !e.is(ei)) ||
                          (r = ie(r, e.length - r)),
                        r <= n
                      );
                    },
                  };
                  return x;
                })(e, i, n, t);
                r.mount(), h.push(r);
              }
              function v(e) {
                return e
                  ? x(function (e) {
                      return !e.isClone;
                    })
                  : h;
              }
              function k(e, t) {
                v(t).forEach(e);
              }
              function x(e) {
                return h.filter(
                  m(e)
                    ? e
                    : function (t) {
                        return g(e) ? C(t.slide, e) : E(w(e), t.index);
                      }
                );
              }
              return {
                mount: function () {
                  p(),
                    r(Ce, f),
                    r(Ce, p),
                    r([ye, Ce], function () {
                      h.sort(function (e, t) {
                        return e.index - t.index;
                      });
                    });
                },
                destroy: f,
                update: function () {
                  k(function (e) {
                    e.update();
                  });
                },
                register: y,
                get: v,
                getIn: function (e) {
                  var n = t.Controller,
                    r = n.toIndex(e),
                    o = n.hasFocus() ? 1 : i.perPage;
                  return x(function (e) {
                    return le(e.index, r, r + o - 1);
                  });
                },
                getAt: function (e) {
                  return x(e)[0];
                },
                add: function (e, t) {
                  S(e, function (e) {
                    if ((g(e) && (e = z(e)), b(e))) {
                      var n = u[t];
                      n ? _(e, n) : P(d, e),
                        A(e, i.classes.slide),
                        (r = e),
                        (a = l(o, Le)),
                        (c = K(r, "img")),
                        (h = c.length)
                          ? c.forEach(function (e) {
                              s(e, "load error", function () {
                                --h || a();
                              });
                            })
                          : a();
                    }
                    var r, a, c, h;
                  }),
                    o(Ce);
                },
                remove: function (e) {
                  W(
                    x(e).map(function (e) {
                      return e.slide;
                    })
                  ),
                    o(Ce);
                },
                forEach: k,
                filter: x,
                style: function (e, t, i) {
                  k(function (n) {
                    n.style(e, t, i);
                  });
                },
                getLength: function (e) {
                  return e ? u.length : h.length;
                },
                isEnough: function () {
                  return h.length > i.perPage;
                },
              };
            },
            Layout: function (e, t, i) {
              var n,
                r,
                o = Ge(e),
                a = o.on,
                s = o.bind,
                c = o.emit,
                u = t.Slides,
                d = t.Direction.resolve,
                h = t.Elements,
                f = h.root,
                m = h.track,
                g = h.list,
                y = u.getAt,
                v = u.style;
              function b() {
                (r = null),
                  (n = i.direction === rt),
                  B(f, "maxWidth", J(i.width)),
                  B(m, d("paddingLeft"), S(!1)),
                  B(m, d("paddingRight"), S(!0)),
                  w();
              }
              function w() {
                var e,
                  t = $(f);
                (r && r.width === t.width && r.height === t.height) ||
                  (B(
                    m,
                    "height",
                    ((e = ""),
                    n &&
                      (te((e = E()), "height or heightRatio is missing."),
                      (e = "calc(" + e + " - " + S(!1) + " - " + S(!0) + ")")),
                    e)
                  ),
                  v(d("marginRight"), J(i.gap)),
                  v(
                    "width",
                    i.autoWidth ? null : J(i.fixedWidth) || (n ? "" : k())
                  ),
                  v(
                    "height",
                    J(i.fixedHeight) || (n ? (i.autoHeight ? null : k()) : E()),
                    !0
                  ),
                  (r = t),
                  c(Ie));
              }
              function S(e) {
                var t = i.padding,
                  n = d(e ? "right" : "left");
                return (t && J(t[n] || (p(t) ? 0 : t))) || "0px";
              }
              function E() {
                return J(i.height || $(g).width * i.heightRatio);
              }
              function k() {
                var e = J(i.gap);
                return (
                  "calc((100%" +
                  (e && " + " + e) +
                  ")/" +
                  (i.perPage || 1) +
                  (e && " - " + e) +
                  ")"
                );
              }
              function T(e, t) {
                var i = y(e);
                if (i) {
                  var n = $(i.slide)[d("right")],
                    r = $(g)[d("left")];
                  return ae(n - r) + (t ? 0 : A());
                }
                return 0;
              }
              function A() {
                var e = y(0);
                return (e && parseFloat(B(e.slide, d("marginRight")))) || 0;
              }
              return {
                mount: function () {
                  b(),
                    s(window, "resize load", Ye(l(c, Le))),
                    a([xe, Ce], b),
                    a(Le, w);
                },
                listSize: function () {
                  return $(g)[d("width")];
                },
                slideSize: function (e, t) {
                  var i = y(e || 0);
                  return i ? $(i.slide)[d("width")] + (t ? 0 : A()) : 0;
                },
                sliderSize: function () {
                  return T(e.length - 1, !0) - T(-1, !0);
                },
                totalSize: T,
                getPadding: function (e) {
                  return (
                    parseFloat(B(m, d("padding" + (e ? "Right" : "Left")))) || 0
                  );
                },
              };
            },
            Clones: function (e, t, i) {
              var n,
                r = Ge(e),
                o = r.on,
                s = r.emit,
                l = t.Elements,
                c = t.Slides,
                u = t.Direction.resolve,
                d = [];
              function h() {
                (n = m()) &&
                  ((function (t) {
                    var n = c.get().slice(),
                      r = n.length;
                    if (r) {
                      for (; n.length < t; ) k(n, n);
                      k(n.slice(-t), n.slice(0, t)).forEach(function (o, a) {
                        var s = a < t,
                          u = (function (t, n) {
                            var r = t.cloneNode(!0);
                            return (
                              A(r, i.classes.clone),
                              (r.id = e.root.id + "-clone" + pe(n + 1)),
                              r
                            );
                          })(o.slide, a);
                        s ? _(u, n[0].slide) : P(l.list, u),
                          k(d, u),
                          c.register(u, a - t + (s ? 0 : r), o.index);
                      });
                    }
                  })(n),
                  s(Le));
              }
              function p() {
                W(d), a(d);
              }
              function f() {
                n < m() && s(Ce);
              }
              function m() {
                var n = i.clones;
                if (e.is(ei)) {
                  if (!n) {
                    var r = i[u("fixedWidth")] && t.Layout.slideSize(0);
                    n =
                      (r && oe($(l.track)[u("width")] / r)) ||
                      (i[u("autoWidth")] && e.length) ||
                      2 * i.perPage;
                  }
                } else n = 0;
                return n;
              }
              return {
                mount: function () {
                  h(), o(Ce, p), o(Ce, h), o([xe, Le], f);
                },
                destroy: p,
              };
            },
            Move: function (e, t, i) {
              var n,
                r = Ge(e),
                o = r.on,
                a = r.emit,
                s = e.state.set,
                l = t.Layout,
                c = l.slideSize,
                u = l.getPadding,
                d = l.totalSize,
                h = l.listSize,
                p = l.sliderSize,
                f = t.Direction,
                m = f.resolve,
                g = f.orient,
                v = t.Elements,
                b = v.list,
                w = v.track;
              function S() {
                t.Controller.isBusy() ||
                  (t.Scroll.cancel(), E(e.index), t.Slides.update());
              }
              function E(e) {
                k(_(e, !0));
              }
              function k(i, n) {
                if (!e.is(ti)) {
                  var r = n
                    ? i
                    : (function (i) {
                        if (e.is(ei)) {
                          var n = P(i),
                            r = n > t.Controller.getEnd();
                          (n < 0 || r) && (i = T(i, r));
                        }
                        return i;
                      })(i);
                  B(b, "transform", "translate" + m("X") + "(" + r + "px)"),
                    i !== r && a(Se);
                }
              }
              function T(e, t) {
                var i = e - x(t),
                  n = p();
                return e - g(n * (oe(ae(i) / n) || 1)) * (t ? 1 : -1);
              }
              function A() {
                k(C()), n.cancel();
              }
              function P(e) {
                for (
                  var i = t.Slides.get(), n = 0, r = 1 / 0, o = 0;
                  o < i.length;
                  o++
                ) {
                  var a = i[o].index,
                    s = ae(_(a, !0) - e);
                  if (!(s <= r)) break;
                  (r = s), (n = a);
                }
                return n;
              }
              function _(t, n) {
                var r = g(
                  d(t - 1) -
                    (function (e) {
                      var t = i.focus;
                      return "center" === t
                        ? (h() - c(e, !0)) / 2
                        : +t * c(e) || 0;
                    })(t)
                );
                return n
                  ? (function (t) {
                      return (
                        i.trimSpace && e.is(Zt) && (t = ce(t, 0, g(p() - h()))),
                        t
                      );
                    })(r)
                  : r;
              }
              function C() {
                var e = m("left");
                return $(b)[e] - $(w)[e] + g(u(!1));
              }
              function x(e) {
                return _(e ? t.Controller.getEnd() : 0, !!i.trimSpace);
              }
              return {
                mount: function () {
                  (n = t.Transition), o([ye, Ie, xe, Ce], S);
                },
                move: function (e, t, i, r) {
                  var o, l;
                  e !== t &&
                    ((o = e > i),
                    (l = g(T(C(), o))),
                    o ? l >= 0 : l <= b[m("scrollWidth")] - $(w)[m("width")]) &&
                    (A(), k(T(C(), e > i), !0)),
                    s(4),
                    a(be, t, i, e),
                    n.start(t, function () {
                      s(3), a(we, t, i, e), r && r();
                    });
                },
                jump: E,
                translate: k,
                shift: T,
                cancel: A,
                toIndex: P,
                toPosition: _,
                getPosition: C,
                getLimit: x,
                exceededLimit: function (e, t) {
                  t = y(t) ? C() : t;
                  var i = !0 !== e && g(t) < g(x(!1)),
                    n = !1 !== e && g(t) > g(x(!0));
                  return i || n;
                },
                reposition: S,
              };
            },
            Controller: function (e, t, i) {
              var n,
                r,
                o,
                a = Ge(e).on,
                s = t.Move,
                c = s.getPosition,
                u = s.getLimit,
                d = s.toPosition,
                h = t.Slides,
                p = h.isEnough,
                f = h.getLength,
                m = e.is(ei),
                v = e.is(Zt),
                b = l(T, !1),
                w = l(T, !0),
                S = i.start || 0,
                E = S;
              function k() {
                (n = f(!0)), (r = i.perMove), (o = i.perPage);
                var e = ce(S, 0, n - 1);
                e !== S && ((S = e), s.reposition());
              }
              function T(e, t) {
                var i = r || (I() ? 1 : o),
                  n = A(S + i * (e ? -1 : 1), S, !(r || I()));
                return -1 === n && v && !se(c(), u(!e), 1)
                  ? e
                    ? 0
                    : _()
                  : t
                  ? n
                  : P(n);
              }
              function A(t, a, s) {
                if (p()) {
                  var l = _(),
                    u = (function (t) {
                      if (v && "move" === i.trimSpace && t !== S)
                        for (
                          var n = c();
                          n === d(t, !0) && le(t, 0, e.length - 1, !i.rewind);

                        )
                          t < S ? --t : ++t;
                      return t;
                    })(t);
                  u !== t && ((a = t), (t = u), (s = !1)),
                    t < 0 || t > l
                      ? (t =
                          r || (!le(0, t, a, !0) && !le(l, a, t, !0))
                            ? m
                              ? s
                                ? t < 0
                                  ? -(n % o || o)
                                  : n
                                : t
                              : i.rewind
                              ? t < 0
                                ? l
                                : 0
                              : -1
                            : C(x(t)))
                      : s && t !== a && (t = C(x(a) + (t < a ? -1 : 1)));
                } else t = -1;
                return t;
              }
              function P(e) {
                return m ? (e + n) % n || 0 : e;
              }
              function _() {
                return ne(n - (I() || (m && r) ? 1 : o), 0);
              }
              function C(e) {
                return ce(I() ? e : o * e, 0, _());
              }
              function x(e) {
                return I() ? e : re((e >= _() ? n - 1 : e) / o);
              }
              function L(e) {
                e !== S && ((E = S), (S = e));
              }
              function I() {
                return !y(i.focus) || i.isNavigation;
              }
              function O() {
                return e.state.is([4, 5]) && !!i.waitForTransition;
              }
              return {
                mount: function () {
                  k(), a([xe, Ce], k);
                },
                go: function (e, t, i) {
                  if (!O()) {
                    var n = (function (e) {
                        var t = S;
                        if (g(e)) {
                          var i = e.match(/([+\-<>])(\d+)?/) || [],
                            n = i[1],
                            r = i[2];
                          "+" === n || "-" === n
                            ? (t = A(S + +("" + n + (+r || 1)), S))
                            : ">" === n
                            ? (t = r ? C(+r) : b(!0))
                            : "<" === n && (t = w(!0));
                        } else t = m ? e : ce(e, 0, _());
                        return t;
                      })(e),
                      r = P(n);
                    r > -1 && (t || r !== S) && (L(r), s.move(n, r, E, i));
                  }
                },
                scroll: function (e, i, n, r) {
                  t.Scroll.scroll(e, i, n, function () {
                    L(P(s.toIndex(c()))), r && r();
                  });
                },
                getNext: b,
                getPrev: w,
                getAdjacent: T,
                getEnd: _,
                setIndex: L,
                getIndex: function (e) {
                  return e ? E : S;
                },
                toIndex: C,
                toPage: x,
                toDest: function (e) {
                  var t = s.toIndex(e);
                  return v ? ce(t, 0, _()) : t;
                },
                hasFocus: I,
                isBusy: O,
              };
            },
            Arrows: function (e, t, i) {
              var n,
                r,
                o = Ge(e),
                a = o.on,
                s = o.bind,
                c = o.emit,
                u = i.classes,
                d = i.i18n,
                h = t.Elements,
                p = t.Controller,
                f = h.arrows,
                m = h.track,
                g = f,
                y = h.prev,
                v = h.next,
                b = {};
              function w() {
                var e;
                !(e = i.arrows) ||
                  (y && v) ||
                  ((g = f || D("div", u.arrows)),
                  (y = T(!0)),
                  (v = T(!1)),
                  (n = !0),
                  P(g, [y, v]),
                  !f && _(g, m)),
                  y &&
                    v &&
                    (q(b, { prev: y, next: v }),
                    F(g, e ? "" : "none"),
                    A(g, (r = Ct + "--" + i.direction)),
                    e &&
                      (a([we, Ce, je], C),
                      s(v, "click", l(k, ">")),
                      s(y, "click", l(k, "<")),
                      C(),
                      V([y, v], ut, m.id),
                      c(De, y, v))),
                  a(xe, S);
              }
              function S() {
                E(), w();
              }
              function E() {
                o.destroy(),
                  Y(g, r),
                  n ? (W(f ? [y, v] : g), (y = v = null)) : j([y, v], St);
              }
              function k(e) {
                p.go(e, !0);
              }
              function T(e) {
                return z(
                  '<button class="' +
                    u.arrow +
                    " " +
                    (e ? u.prev : u.next) +
                    '" type="button"><svg xmlns="' +
                    ii +
                    '" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="' +
                    (i.arrowPath || ni) +
                    '" />'
                );
              }
              function C() {
                var t = e.index,
                  i = p.getPrev(),
                  n = p.getNext(),
                  r = i > -1 && t < i ? d.last : d.prev,
                  o = n > -1 && t > n ? d.first : d.next;
                (y.disabled = i < 0),
                  (v.disabled = n < 0),
                  V(y, pt, r),
                  V(v, pt, o),
                  c(Be, y, v, i, n);
              }
              return { arrows: b, mount: w, destroy: E };
            },
            Autoplay: function (e, t, i) {
              var n,
                r,
                o = Ge(e),
                a = o.on,
                s = o.bind,
                l = o.emit,
                c = Qe(i.interval, e.go.bind(e, ">"), function (e) {
                  var t = d.bar;
                  t && B(t, "width", 100 * e + "%"), l($e, e);
                }),
                u = c.isPaused,
                d = t.Elements,
                h = t.Elements,
                p = h.root,
                f = h.toggle,
                m = i.autoplay,
                g = "pause" === m;
              function y() {
                u() &&
                  t.Slides.isEnough() &&
                  (c.start(!i.resetProgress), (r = n = g = !1), w(), l(Ue));
              }
              function v(e) {
                void 0 === e && (e = !0),
                  (g = !!e),
                  w(),
                  u() || (c.pause(), l(We));
              }
              function b() {
                g || (n || r ? v(!1) : y());
              }
              function w() {
                f && (T(f, Ht, !g), V(f, pt, i.i18n[g ? "play" : "pause"]));
              }
              function S(e) {
                var n = t.Slides.getAt(e);
                c.set((n && +H(n.slide, ri)) || i.interval);
              }
              return {
                mount: function () {
                  m &&
                    (i.pauseOnHover &&
                      s(p, "mouseenter mouseleave", function (e) {
                        (n = "mouseenter" === e.type), b();
                      }),
                    i.pauseOnFocus &&
                      s(p, "focusin focusout", function (e) {
                        (r = "focusin" === e.type), b();
                      }),
                    f &&
                      s(f, "click", function () {
                        g ? y() : v(!0);
                      }),
                    a([be, Ne, Ce], c.rewind),
                    a(be, S),
                    f && V(f, ut, d.track.id),
                    g || y(),
                    w());
                },
                destroy: c.cancel,
                play: y,
                pause: v,
                isPaused: u,
              };
            },
            Cover: function (e, t, i) {
              var n = Ge(e).on;
              function r(e) {
                t.Slides.forEach(function (t) {
                  var i = L(t.container || t.slide, "img");
                  i && i.src && o(e, i, t);
                });
              }
              function o(e, t, i) {
                i.style(
                  "background",
                  e ? 'center/cover no-repeat url("' + t.src + '")' : "",
                  !0
                ),
                  F(t, e ? "none" : "");
              }
              return {
                mount: function () {
                  i.cover && (n(ze, l(o, !0)), n([ye, xe, Ce], l(r, !0)));
                },
                destroy: l(r, !1),
              };
            },
            Scroll: function (e, t, i) {
              var n,
                r,
                o = Ge(e),
                a = o.on,
                s = o.emit,
                c = e.state.set,
                u = t.Move,
                d = u.getPosition,
                h = u.getLimit,
                p = u.exceededLimit,
                f = u.translate,
                m = 1;
              function g(e, i, o, a, h) {
                var p = d();
                if ((b(), o)) {
                  var f = t.Layout.sliderSize(),
                    g = ue(e) * f * re(ae(e) / f) || 0;
                  e = u.toPosition(t.Controller.toDest(e % f)) + g;
                }
                var w = se(p, e, 1);
                (m = 1),
                  (i = w ? 0 : i || ne(ae(e - p) / 1.5, 800)),
                  (r = a),
                  (n = Qe(i, y, l(v, p, e, h), 1)),
                  c(5),
                  s(Ne),
                  n.start();
              }
              function y() {
                c(3), r && r(), s(je);
              }
              function v(t, n, o, a) {
                var s,
                  l,
                  c = d(),
                  u =
                    (t +
                      (n - t) *
                        ((s = a),
                        (l = i.easingFunc) ? l(s) : 1 - Math.pow(1 - s, 4)) -
                      c) *
                    m;
                f(c + u),
                  e.is(Zt) &&
                    !o &&
                    p() &&
                    ((m *= 0.6), ae(u) < 10 && g(h(p(!0)), 600, !1, r, !0));
              }
              function b() {
                n && n.cancel();
              }
              function w() {
                n && !n.isPaused() && (b(), y());
              }
              return {
                mount: function () {
                  a(be, b), a([xe, Ce], w);
                },
                destroy: b,
                scroll: g,
                cancel: w,
              };
            },
            Drag: function (e, t, i) {
              var n,
                r,
                o,
                a,
                s,
                l,
                c,
                d,
                h = Ge(e),
                f = h.on,
                m = h.emit,
                g = h.bind,
                y = h.unbind,
                v = e.state,
                b = t.Move,
                w = t.Scroll,
                S = t.Controller,
                E = t.Elements.track,
                k = t.Media.reduce,
                T = t.Direction,
                A = T.resolve,
                P = T.orient,
                _ = b.getPosition,
                x = b.exceededLimit,
                L = !1;
              function I() {
                var e = i.drag;
                H(!e), (a = "free" === e);
              }
              function O(e) {
                if (((l = !1), !c)) {
                  var t = R(e);
                  (n = e.target),
                    (r = i.noDrag),
                    C(n, "." + qt + ", ." + xt) ||
                      (r && C(n, r)) ||
                      (!t && e.button) ||
                      (S.isBusy()
                        ? G(e, !0)
                        : ((d = t ? E : window),
                          (s = v.is([4, 5])),
                          (o = null),
                          g(d, Xt, q, oi),
                          g(d, Jt, M, oi),
                          b.cancel(),
                          w.cancel(),
                          j(e)));
                }
                var n, r;
              }
              function q(t) {
                if ((v.is(6) || (v.set(6), m(Oe)), t.cancelable))
                  if (s) {
                    b.translate(n + V(t) / (L && e.is(Zt) ? 5 : 1));
                    var r = D(t) > 200,
                      o = L !== (L = x());
                    (r || o) && j(t), (l = !0), m(qe), G(t);
                  } else
                    (function (e) {
                      return ae(V(e)) > ae(V(e, !0));
                    })(t) &&
                      ((s = (function (e) {
                        var t = i.dragMinThreshold,
                          n = p(t),
                          r = (n && t.mouse) || 0,
                          o = (n ? t.touch : +t) || 10;
                        return ae(V(e)) > (R(e) ? o : r);
                      })(t)),
                      G(t));
              }
              function M(n) {
                v.is(6) && (v.set(3), m(Me)),
                  s &&
                    ((function (n) {
                      var r = (function (t) {
                          if (e.is(ei) || !L) {
                            var i = D(t);
                            if (i && i < 200) return V(t) / i;
                          }
                          return 0;
                        })(n),
                        o = (function (e) {
                          return (
                            _() +
                            ue(e) *
                              ie(
                                ae(e) * (i.flickPower || 600),
                                a
                                  ? 1 / 0
                                  : t.Layout.listSize() * (i.flickMaxPages || 1)
                              )
                          );
                        })(r),
                        s = i.rewind && i.rewindByDrag;
                      k(!1),
                        a
                          ? S.scroll(o, 0, i.snap)
                          : e.is(ti)
                          ? S.go(P(ue(r)) < 0 ? (s ? "<" : "-") : s ? ">" : "+")
                          : e.is(Zt) && L && s
                          ? S.go(x(!0) ? ">" : "<")
                          : S.go(S.toDest(o), !0),
                        k(!0);
                    })(n),
                    G(n)),
                  y(d, Xt, q),
                  y(d, Jt, M),
                  (s = !1);
              }
              function N(e) {
                !c && l && G(e, !0);
              }
              function j(e) {
                (o = r), (r = e), (n = _());
              }
              function V(e, t) {
                return F(e, t) - F(B(e), t);
              }
              function D(e) {
                return X(e) - X(B(e));
              }
              function B(e) {
                return (r === e && o) || r;
              }
              function F(e, t) {
                return (R(e) ? e.changedTouches[0] : e)[
                  "page" + A(t ? "Y" : "X")
                ];
              }
              function R(e) {
                return (
                  "undefined" != typeof TouchEvent && e instanceof TouchEvent
                );
              }
              function H(e) {
                c = e;
              }
              return {
                mount: function () {
                  g(E, Xt, u, oi),
                    g(E, Jt, u, oi),
                    g(E, Yt, O, oi),
                    g(E, "click", N, { capture: !0 }),
                    g(E, "dragstart", G),
                    f([ye, xe], I);
                },
                disable: H,
                isDragging: function () {
                  return s;
                },
              };
            },
            Keyboard: function (e, t, i) {
              var n,
                r,
                o = Ge(e),
                a = o.on,
                s = o.bind,
                l = o.unbind,
                u = e.root,
                d = t.Direction.resolve;
              function h() {
                var e = i.keyboard;
                e && ((n = "global" === e ? window : u), s(n, li, m));
              }
              function p() {
                l(n, li);
              }
              function f() {
                var e = r;
                (r = !0),
                  c(function () {
                    r = e;
                  });
              }
              function m(t) {
                if (!r) {
                  var i = si(t);
                  i === d(Je) ? e.go("<") : i === d(Ze) && e.go(">");
                }
              }
              return {
                mount: function () {
                  h(), a(xe, p), a(xe, h), a(be, f);
                },
                destroy: p,
                disable: function (e) {
                  r = e;
                },
              };
            },
            LazyLoad: function (e, t, i) {
              var n = Ge(e),
                r = n.on,
                o = n.off,
                s = n.bind,
                c = n.emit,
                u = "sequential" === i.lazyLoad,
                d = [ye, Ce, we, je],
                h = [];
              function p() {
                a(h),
                  t.Slides.forEach(function (e) {
                    K(e.slide, di).forEach(function (t) {
                      var n = H(t, ci),
                        r = H(t, ui);
                      if (n !== t.src || r !== t.srcset) {
                        var o = i.classes.spinner,
                          a = t.parentElement,
                          s = L(a, "." + o) || D("span", o, a);
                        h.push([t, e, s]), t.src || F(t, "none");
                      }
                    });
                  }),
                  u && y();
              }
              function f() {
                (h = h.filter(function (t) {
                  var n = i.perPage * ((i.preloadPages || 1) + 1) - 1;
                  return !t[1].isWithin(e.index, n) || m(t);
                })).length || o(d);
              }
              function m(e) {
                var t = e[0];
                A(e[1].slide, zt),
                  s(t, "load error", l(g, e)),
                  V(t, "src", H(t, ci)),
                  V(t, "srcset", H(t, ui)),
                  j(t, ci),
                  j(t, ui);
              }
              function g(e, t) {
                var i = e[0],
                  n = e[1];
                Y(n.slide, zt),
                  "error" !== t.type && (W(e[2]), F(i, ""), c(ze, i, n), c(Le)),
                  u && y();
              }
              function y() {
                h.length && m(h.shift());
              }
              return {
                mount: function () {
                  i.lazyLoad && (p(), r(Ce, p), u || r(d, f));
                },
                destroy: l(a, h),
              };
            },
            Pagination: function (e, t, i) {
              var n,
                r,
                o = Ge(e),
                c = o.on,
                u = o.emit,
                d = o.bind,
                h = t.Slides,
                p = t.Elements,
                f = t.Controller,
                m = f.hasFocus,
                g = f.getIndex,
                y = f.go,
                v = t.Direction.resolve,
                b = [];
              function w() {
                n &&
                  (W(p.pagination ? s(n.children) : n),
                  Y(n, r),
                  a(b),
                  (n = null)),
                  o.destroy();
              }
              function S(e) {
                y(">" + e, !0);
              }
              function E(e, t) {
                var i = b.length,
                  n = si(t),
                  r = k(),
                  o = -1;
                n === v(Ze, !1, r)
                  ? (o = ++e % i)
                  : n === v(Je, !1, r)
                  ? (o = (--e + i) % i)
                  : "Home" === n
                  ? (o = 0)
                  : "End" === n && (o = i - 1);
                var a = b[o];
                a && (R(a.button), y(">" + o), G(t, !0));
              }
              function k() {
                return i.paginationDirection || i.direction;
              }
              function T(e) {
                return b[f.toPage(e)];
              }
              function P() {
                var e = T(g(!0)),
                  t = T(g());
                if (e) {
                  var i = e.button;
                  Y(i, Ht), j(i, ht), V(i, lt, -1);
                }
                if (t) {
                  var r = t.button;
                  A(r, Ht), V(r, ht, !0), V(r, lt, "");
                }
                u(Re, { list: n, items: b }, e, t);
              }
              return {
                items: b,
                mount: function t() {
                  w(),
                    c([xe, Ce], t),
                    i.pagination &&
                      h.isEnough() &&
                      (c([be, Ne, je], P),
                      (function () {
                        var t = e.length,
                          o = i.classes,
                          a = i.i18n,
                          s = i.perPage,
                          c = m() ? t : oe(t / s);
                        A(
                          (n =
                            p.pagination ||
                            D("ul", o.pagination, p.track.parentElement)),
                          (r = Ot + "--" + k())
                        ),
                          V(n, st, "tablist"),
                          V(n, pt, a.select),
                          V(n, gt, k() === rt ? "vertical" : "");
                        for (var u = 0; u < c; u++) {
                          var f = D("li", null, n),
                            g = D(
                              "button",
                              { class: o.page, type: "button" },
                              f
                            ),
                            y = h.getIn(u).map(function (e) {
                              return e.slide.id;
                            }),
                            v = !m() && s > 1 ? a.pageX : a.slideX;
                          d(g, "click", l(S, u)),
                            i.paginationKeyboard && d(g, "keydown", l(E, u)),
                            V(f, st, "presentation"),
                            V(g, st, "tab"),
                            V(g, ut, y.join(" ")),
                            V(g, pt, he(v, u + 1)),
                            V(g, lt, -1),
                            b.push({ li: f, button: g, page: u });
                        }
                      })(),
                      P(),
                      u(Fe, { list: n, items: b }, T(e.index)));
                },
                destroy: w,
                getAt: T,
                update: P,
              };
            },
            Sync: function (e, t, i) {
              var n = i.isNavigation,
                r = i.slideFocus,
                o = [];
              function s() {
                e.splides.forEach(function (t) {
                  t.isParent || (c(e, t.splide), c(t.splide, e));
                }),
                  n &&
                    (function () {
                      var t = Ge(e),
                        i = t.on;
                      i(Ee, d),
                        i(_e, h),
                        i([ye, xe], u),
                        o.push(t),
                        t.emit(He, e.splides);
                    })();
              }
              function l() {
                o.forEach(function (e) {
                  e.destroy();
                }),
                  a(o);
              }
              function c(e, t) {
                var i = Ge(e);
                i.on(be, function (e, i, n) {
                  t.go(t.is(ei) ? n : e);
                }),
                  o.push(i);
              }
              function u() {
                V(t.Elements.list, gt, i.direction === rt ? "vertical" : "");
              }
              function d(t) {
                e.go(t.index);
              }
              function h(e, t) {
                E(hi, si(t)) && (d(e), G(t));
              }
              return {
                setup: function () {
                  e.options = { slideFocus: y(r) ? n : r };
                },
                mount: s,
                destroy: l,
                remount: function () {
                  l(), s();
                },
              };
            },
            Wheel: function (e, t, i) {
              var n = Ge(e).bind,
                r = 0;
              function o(n) {
                if (n.cancelable) {
                  var o = n.deltaY,
                    a = o < 0,
                    s = X(n),
                    l = i.wheelMinThreshold || 0,
                    c = i.wheelSleep || 0;
                  ae(o) > l && s - r > c && (e.go(a ? "<" : ">"), (r = s)),
                    (function (n) {
                      return (
                        !i.releaseWheel ||
                        e.state.is(4) ||
                        -1 !== t.Controller.getAdjacent(n)
                      );
                    })(a) && G(n);
                }
              }
              return {
                mount: function () {
                  i.wheel && n(t.Elements.track, "wheel", o, oi);
                },
              };
            },
            Live: function (e, t, i) {
              var n = Ge(e).on,
                r = t.Elements.track,
                o = i.live && !i.isNavigation,
                a = D("span", Ft),
                s = Qe(90, l(c, !1));
              function c(e) {
                V(r, bt, e), e ? (P(r, a), s.start()) : W(a);
              }
              function u(e) {
                o && V(r, vt, e ? "off" : "polite");
              }
              return {
                mount: function () {
                  o &&
                    (u(!t.Autoplay.isPaused()),
                    V(r, wt, !0),
                    (a.textContent = "…"),
                    n(Ue, l(u, !0)),
                    n(We, l(u, !1)),
                    n([we, je], l(c, !0)));
                },
                disable: u,
                destroy: function () {
                  j(r, [vt, wt, bt]), W(a);
                },
              };
            },
          }),
          fi = {
            type: "slide",
            role: "region",
            speed: 400,
            perPage: 1,
            cloneStatus: !0,
            arrows: !0,
            pagination: !0,
            paginationKeyboard: !0,
            interval: 5e3,
            pauseOnHover: !0,
            pauseOnFocus: !0,
            resetProgress: !0,
            easing: "cubic-bezier(0.25, 1, 0.5, 1)",
            drag: !0,
            direction: "ltr",
            trimSpace: !0,
            focusableNodes: "a, button, textarea, input, select, iframe",
            live: !0,
            classes: Kt,
            i18n: {
              prev: "Previous slide",
              next: "Next slide",
              first: "Go to first slide",
              last: "Go to last slide",
              slideX: "Go to slide %s",
              pageX: "Go to page %s",
              play: "Start autoplay",
              pause: "Pause autoplay",
              carousel: "carousel",
              slide: "slide",
              select: "Select a slide to show",
              slideLabel: "%s of %s",
            },
            reducedMotion: { speed: 0, rewindSpeed: 0, autoplay: "pause" },
          };
        function mi(e, t, i) {
          var n = Ge(e).on;
          return {
            mount: function () {
              n([ye, Ce], function () {
                c(function () {
                  t.Slides.style(
                    "transition",
                    "opacity " + i.speed + "ms " + i.easing
                  );
                });
              });
            },
            start: function (e, i) {
              var n = t.Elements.track;
              B(n, "height", J($(n).height)),
                c(function () {
                  i(), B(n, "height", "");
                });
            },
            cancel: u,
          };
        }
        function gi(e, t, i) {
          var n,
            r = Ge(e).bind,
            o = t.Move,
            a = t.Controller,
            s = t.Scroll,
            c = t.Elements.list,
            u = l(B, c, "transition");
          function d() {
            u(""), s.cancel();
          }
          return {
            mount: function () {
              r(c, "transitionend", function (e) {
                e.target === c && n && (d(), n());
              });
            },
            start: function (t, r) {
              var l = o.toPosition(t, !0),
                c = o.getPosition(),
                d = (function (t) {
                  var n = i.rewindSpeed;
                  if (e.is(Zt) && n) {
                    var r = a.getIndex(!0),
                      o = a.getEnd();
                    if ((0 === r && t >= o) || (r >= o && 0 === t)) return n;
                  }
                  return i.speed;
                })(t);
              ae(l - c) >= 1 && d >= 1
                ? i.useScroll
                  ? s.scroll(l, d, !1, r)
                  : (u("transform " + d + "ms " + i.easing),
                    o.translate(l, !0),
                    (n = r))
                : (o.jump(t), r());
            },
            cancel: d,
          };
        }
        var yi = (function () {
          function e(t, i) {
            (this.event = Ge()),
              (this.Components = {}),
              (this.state = Ke(1)),
              (this.splides = []),
              (this._o = {}),
              (this._E = {});
            var n = g(t) ? Q(document, t) : t;
            te(n, n + " is invalid."),
              (this.root = n),
              (i = M(
                { label: H(n, pt) || "", labelledby: H(n, ft) || "" },
                fi,
                e.defaults,
                i || {}
              ));
            try {
              M(i, JSON.parse(H(n, ee)));
            } catch (e) {
              te(!1, "Invalid JSON");
            }
            this._o = Object.create(M({}, i));
          }
          var t,
            i,
            r = e.prototype;
          return (
            (r.mount = function (e, t) {
              var i = this,
                n = this.state,
                r = this.Components;
              return (
                te(n.is([1, 7]), "Already mounted!"),
                n.set(1),
                (this._C = r),
                (this._T = t || this._T || (this.is(ti) ? mi : gi)),
                (this._E = e || this._E),
                O(q({}, pi, this._E, { Transition: this._T }), function (e, t) {
                  var n = e(i, r, i._o);
                  (r[t] = n), n.setup && n.setup();
                }),
                O(r, function (e) {
                  e.mount && e.mount();
                }),
                this.emit(ye),
                A(this.root, Rt),
                n.set(3),
                this.emit(ve),
                this
              );
            }),
            (r.sync = function (e) {
              return (
                this.splides.push({ splide: e }),
                e.splides.push({ splide: this, isParent: !0 }),
                this.state.is(3) &&
                  (this._C.Sync.remount(), e.Components.Sync.remount()),
                this
              );
            }),
            (r.go = function (e) {
              return this._C.Controller.go(e), this;
            }),
            (r.on = function (e, t) {
              return this.event.on(e, t), this;
            }),
            (r.off = function (e) {
              return this.event.off(e), this;
            }),
            (r.emit = function (e) {
              var t;
              return (
                (t = this.event).emit.apply(t, [e].concat(s(arguments, 1))),
                this
              );
            }),
            (r.add = function (e, t) {
              return this._C.Slides.add(e, t), this;
            }),
            (r.remove = function (e) {
              return this._C.Slides.remove(e), this;
            }),
            (r.is = function (e) {
              return this._o.type === e;
            }),
            (r.refresh = function () {
              return this.emit(Ce), this;
            }),
            (r.destroy = function (e) {
              void 0 === e && (e = !0);
              var t = this.event,
                i = this.state;
              return (
                i.is(1)
                  ? Ge(this).on(ve, this.destroy.bind(this, e))
                  : (O(
                      this._C,
                      function (t) {
                        t.destroy && t.destroy(e);
                      },
                      !0
                    ),
                    t.emit(Ve),
                    t.destroy(),
                    e && a(this.splides),
                    i.set(7)),
                this
              );
            }),
            (t = e),
            (i = [
              {
                key: "options",
                get: function () {
                  return this._o;
                },
                set: function (e) {
                  this._C.Media.set(e, !0);
                },
              },
              {
                key: "length",
                get: function () {
                  return this._C.Slides.getLength(!0);
                },
              },
              {
                key: "index",
                get: function () {
                  return this._C.Controller.getIndex();
                },
              },
            ]) && n(t.prototype, i),
            Object.defineProperty(t, "prototype", { writable: !1 }),
            e
          );
        })();
        (yi.defaults = {}), (yi.STATES = o);
        var vi = { listTag: "ul", slideTag: "li" },
          bi = (function () {
            function e(e, t) {
              (this.styles = {}), (this.id = e), (this.options = t);
            }
            var t = e.prototype;
            return (
              (t.rule = function (e, t, i, n) {
                n = n || "default";
                var r = (this.styles[n] = this.styles[n] || {});
                (r[e] = r[e] || {})[t] = i;
              }),
              (t.build = function () {
                var e = this,
                  t = "";
                return (
                  this.styles.default &&
                    (t += this.buildSelectors(this.styles.default)),
                  Object.keys(this.styles)
                    .sort(function (t, i) {
                      return "min" === e.options.mediaQuery ? +t - +i : +i - +t;
                    })
                    .forEach(function (i) {
                      "default" !== i &&
                        ((t += "@media screen and (max-width: " + i + "px) {"),
                        (t += e.buildSelectors(e.styles[i])),
                        (t += "}"));
                    }),
                  t
                );
              }),
              (t.buildSelectors = function (e) {
                var t = this,
                  i = "";
                return (
                  O(e, function (e, n) {
                    (n = ("#" + t.id + " " + n).trim()),
                      (i += n + " {"),
                      O(e, function (e, t) {
                        (e || 0 === e) && (i += t + ": " + e + ";");
                      }),
                      (i += "}");
                  }),
                  i
                );
              }),
              e
            );
          })(),
          wi = (function () {
            function e(e, t, i, n) {
              (this.slides = []),
                (this.options = {}),
                (this.breakpoints = []),
                M(fi, n || {}),
                M(M(this.options, fi), t || {}),
                (this.contents = e),
                (this.config = q({}, vi, i || {})),
                (this.id = this.config.id || me("splide")),
                (this.Style = new bi(this.id, this.options)),
                (this.Direction = at(0, 0, this.options)),
                te(this.contents.length, "Provide at least 1 content."),
                this.init();
            }
            e.clean = function (e) {
              var t = Ge(e).on,
                i = e.root,
                n = K(i, "." + Pt);
              t(ye, function () {
                W(L(i, "style"));
              }),
                W(n);
            };
            var t = e.prototype;
            return (
              (t.init = function () {
                this.parseBreakpoints(),
                  this.initSlides(),
                  this.registerRootStyles(),
                  this.registerTrackStyles(),
                  this.registerSlideStyles(),
                  this.registerListStyles();
              }),
              (t.initSlides = function () {
                var e = this;
                k(
                  this.slides,
                  this.contents.map(function (t, i) {
                    ((t = g(t) ? { html: t } : t).styles = t.styles || {}),
                      (t.attrs = t.attrs || {}),
                      e.cover(t);
                    var n = e.options.classes.slide + " " + (0 === i ? Ht : "");
                    return (
                      q(t.attrs, {
                        class: (n + " " + (t.attrs.class || "")).trim(),
                        style: e.buildStyles(t.styles),
                      }),
                      t
                    );
                  })
                ),
                  this.isLoop() && this.generateClones(this.slides);
              }),
              (t.registerRootStyles = function () {
                var e = this;
                this.breakpoints.forEach(function (t) {
                  var i = t[0],
                    n = t[1];
                  e.Style.rule(" ", "max-width", J(n.width), i);
                });
              }),
              (t.registerTrackStyles = function () {
                var e = this,
                  t = this.Style,
                  i = "." + kt;
                this.breakpoints.forEach(function (n) {
                  var r = n[0],
                    o = n[1];
                  t.rule(i, e.resolve("paddingLeft"), e.cssPadding(o, !1), r),
                    t.rule(
                      i,
                      e.resolve("paddingRight"),
                      e.cssPadding(o, !0),
                      r
                    ),
                    t.rule(i, "height", e.cssTrackHeight(o), r);
                });
              }),
              (t.registerListStyles = function () {
                var e = this,
                  t = this.Style,
                  i = "." + Tt;
                this.breakpoints.forEach(function (n) {
                  var r = n[0],
                    o = n[1];
                  t.rule(i, "transform", e.buildTranslate(o), r),
                    e.cssSlideHeight(o) ||
                      t.rule(i, "aspect-ratio", e.cssAspectRatio(o), r);
                });
              }),
              (t.registerSlideStyles = function () {
                var e = this,
                  t = this.Style,
                  i = "." + At;
                this.breakpoints.forEach(function (n) {
                  var r = n[0],
                    o = n[1];
                  t.rule(i, "width", e.cssSlideWidth(o), r),
                    t.rule(i, "height", e.cssSlideHeight(o) || "100%", r),
                    t.rule(i, e.resolve("marginRight"), J(o.gap) || "0px", r),
                    t.rule(
                      i + " > img",
                      "display",
                      o.cover ? "none" : "inline",
                      r
                    );
                });
              }),
              (t.buildTranslate = function (e) {
                var t = this.Direction,
                  i = t.resolve,
                  n = t.orient,
                  r = [];
                return (
                  r.push(this.cssOffsetClones(e)),
                  r.push(this.cssOffsetGaps(e)),
                  this.isCenter(e) &&
                    (r.push(this.buildCssValue(n(-50), "%")),
                    r.push.apply(r, this.cssOffsetCenter(e))),
                  r
                    .filter(Boolean)
                    .map(function (e) {
                      return "translate" + i("X") + "(" + e + ")";
                    })
                    .join(" ")
                );
              }),
              (t.cssOffsetClones = function (e) {
                var t = this.Direction,
                  i = t.resolve,
                  n = t.orient,
                  r = this.getCloneCount();
                if (this.isFixedWidth(e)) {
                  var o = this.parseCssValue(e[i("fixedWidth")]),
                    a = o.value,
                    s = o.unit;
                  return this.buildCssValue(n(a) * r, s);
                }
                return n((100 * r) / e.perPage) + "%";
              }),
              (t.cssOffsetCenter = function (e) {
                var t = this.Direction,
                  i = t.resolve,
                  n = t.orient;
                if (this.isFixedWidth(e)) {
                  var r = this.parseCssValue(e[i("fixedWidth")]),
                    o = r.value,
                    a = r.unit;
                  return [this.buildCssValue(n(o / 2), a)];
                }
                var s = [],
                  l = e.perPage,
                  c = e.gap;
                if ((s.push(n(50 / l) + "%"), c)) {
                  var u = this.parseCssValue(c),
                    d = u.value,
                    h = u.unit,
                    p = (d / l - d) / 2;
                  s.push(this.buildCssValue(n(p), h));
                }
                return s;
              }),
              (t.cssOffsetGaps = function (e) {
                var t = this.getCloneCount();
                if (t && e.gap) {
                  var i = this.Direction.orient,
                    n = this.parseCssValue(e.gap),
                    r = n.value,
                    o = n.unit;
                  if (this.isFixedWidth(e))
                    return this.buildCssValue(i(r * t), o);
                  var a = t / e.perPage;
                  return this.buildCssValue(i(a * r), o);
                }
                return "";
              }),
              (t.resolve = function (e) {
                return de(this.Direction.resolve(e));
              }),
              (t.cssPadding = function (e, t) {
                var i = e.padding,
                  n = this.Direction.resolve(t ? "right" : "left", !0);
                return (i && J(i[n] || (p(i) ? 0 : i))) || "0px";
              }),
              (t.cssTrackHeight = function (e) {
                var t = "";
                return (
                  this.isVertical() &&
                    (te((t = this.cssHeight(e)), '"height" is missing.'),
                    (t =
                      "calc(" +
                      t +
                      " - " +
                      this.cssPadding(e, !1) +
                      " - " +
                      this.cssPadding(e, !0) +
                      ")")),
                  t
                );
              }),
              (t.cssHeight = function (e) {
                return J(e.height);
              }),
              (t.cssSlideWidth = function (e) {
                return e.autoWidth
                  ? ""
                  : J(e.fixedWidth) ||
                      (this.isVertical() ? "" : this.cssSlideSize(e));
              }),
              (t.cssSlideHeight = function (e) {
                return (
                  J(e.fixedHeight) ||
                  (this.isVertical()
                    ? e.autoHeight
                      ? ""
                      : this.cssSlideSize(e)
                    : this.cssHeight(e))
                );
              }),
              (t.cssSlideSize = function (e) {
                var t = J(e.gap);
                return (
                  "calc((100%" +
                  (t && " + " + t) +
                  ")/" +
                  (e.perPage || 1) +
                  (t && " - " + t) +
                  ")"
                );
              }),
              (t.cssAspectRatio = function (e) {
                var t = e.heightRatio;
                return t ? "" + 1 / t : "";
              }),
              (t.buildCssValue = function (e, t) {
                return "" + e + t;
              }),
              (t.parseCssValue = function (e) {
                return g(e)
                  ? {
                      value: parseFloat(e) || 0,
                      unit: e.replace(/\d*(\.\d*)?/, "") || "px",
                    }
                  : { value: e, unit: "px" };
              }),
              (t.parseBreakpoints = function () {
                var e = this,
                  t = this.options.breakpoints;
                this.breakpoints.push(["default", this.options]),
                  t &&
                    O(t, function (t, i) {
                      e.breakpoints.push([i, M(M({}, e.options), t)]);
                    });
              }),
              (t.isFixedWidth = function (e) {
                return !!e[this.Direction.resolve("fixedWidth")];
              }),
              (t.isLoop = function () {
                return this.options.type === ei;
              }),
              (t.isCenter = function (e) {
                if ("center" === e.focus) {
                  if (this.isLoop()) return !0;
                  if (this.options.type === Zt) return !this.options.trimSpace;
                }
                return !1;
              }),
              (t.isVertical = function () {
                return this.options.direction === rt;
              }),
              (t.buildClasses = function () {
                var e = this.options;
                return [
                  Et,
                  Et + "--" + e.type,
                  Et + "--" + e.direction,
                  e.drag && Et + "--draggable",
                  e.isNavigation && Et + "--nav",
                  Ht,
                  !this.config.hidden && "is-rendered",
                ]
                  .filter(Boolean)
                  .join(" ");
              }),
              (t.buildAttrs = function (e) {
                var t = "";
                return (
                  O(e, function (e, i) {
                    t += e ? " " + de(i) + '="' + e + '"' : "";
                  }),
                  t.trim()
                );
              }),
              (t.buildStyles = function (e) {
                var t = "";
                return (
                  O(e, function (e, i) {
                    t += " " + de(i) + ":" + e + ";";
                  }),
                  t.trim()
                );
              }),
              (t.renderSlides = function () {
                var e = this,
                  t = this.config.slideTag;
                return this.slides
                  .map(function (i) {
                    return (
                      "<" +
                      t +
                      " " +
                      e.buildAttrs(i.attrs) +
                      ">" +
                      (i.html || "") +
                      "</" +
                      t +
                      ">"
                    );
                  })
                  .join("");
              }),
              (t.cover = function (e) {
                var t = e.styles,
                  i = e.html,
                  n = void 0 === i ? "" : i;
                if (this.options.cover && !this.options.lazyLoad) {
                  var r = n.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
                  r &&
                    r[2] &&
                    (t.background =
                      "center/cover no-repeat url('" + r[2] + "')");
                }
              }),
              (t.generateClones = function (e) {
                for (
                  var t = this.options.classes,
                    i = this.getCloneCount(),
                    n = e.slice();
                  n.length < i;

                )
                  k(n, n);
                k(n.slice(-i).reverse(), n.slice(0, i)).forEach(function (
                  n,
                  r
                ) {
                  var o = q({}, n.attrs, {
                      class: n.attrs.class + " " + t.clone,
                    }),
                    a = q({}, n, { attrs: o });
                  r < i ? e.unshift(a) : e.push(a);
                });
              }),
              (t.getCloneCount = function () {
                if (this.isLoop()) {
                  var e = this.options;
                  return e.clones
                    ? e.clones
                    : ne.apply(
                        void 0,
                        this.breakpoints.map(function (e) {
                          return e[1].perPage;
                        })
                      ) *
                        ((e.flickMaxPages || 1) + 1);
                }
                return 0;
              }),
              (t.renderArrows = function () {
                var e = "";
                return (
                  (e += '<div class="' + this.options.classes.arrows + '">'),
                  (e += this.renderArrow(!0)),
                  (e += this.renderArrow(!1)) + "</div>"
                );
              }),
              (t.renderArrow = function (e) {
                var t = this.options,
                  i = t.classes,
                  n = t.i18n,
                  r = {
                    class: i.arrow + " " + (e ? i.prev : i.next),
                    type: "button",
                    ariaLabel: e ? n.prev : n.next,
                  };
                return (
                  "<button " +
                  this.buildAttrs(r) +
                  '><svg xmlns="' +
                  ii +
                  '" viewBox="0 0 40 40" width="40" height="40"><path d="' +
                  (this.options.arrowPath || ni) +
                  '" /></svg></button>'
                );
              }),
              (t.html = function () {
                var e = this.config,
                  t = e.rootClass,
                  i = e.listTag,
                  n = e.arrows,
                  r = e.beforeTrack,
                  o = e.afterTrack,
                  a = e.slider,
                  s = e.beforeSlider,
                  l = e.afterSlider,
                  c = "";
                return (
                  (c +=
                    '<div id="' +
                    this.id +
                    '" class="' +
                    this.buildClasses() +
                    " " +
                    (t || "") +
                    '">'),
                  (c += "<style>" + this.Style.build() + "</style>"),
                  a && ((c += s || ""), (c += '<div class="splide__slider">')),
                  (c += r || ""),
                  n && (c += this.renderArrows()),
                  (c += '<div class="splide__track">'),
                  (c += "<" + i + ' class="splide__list">'),
                  (c += this.renderSlides()),
                  (c += "</" + i + ">"),
                  (c += "</div>"),
                  (c += o || ""),
                  a && ((c += "</div>"), (c += l || "")),
                  (c += "</div>")
                );
              }),
              e
            );
          })();
      },
      8171: (e) => {
        var t, i, n;
        (t = window),
          (i = 0),
          (n = function e(t, n) {
            var r = this,
              o = this,
              a = !1;
            if (Array.isArray(t))
              return (
                !!t.length &&
                t.map(function (t) {
                  return new e(t, n);
                })
              );
            var s = {
              init: function () {
                this.options = Object.assign(
                  {
                    duration: 600,
                    ariaEnabled: !0,
                    collapse: !0,
                    showMultiple: !1,
                    onlyChildNodes: !0,
                    openOnInit: [],
                    elementClass: "ac",
                    triggerClass: "ac-trigger",
                    panelClass: "ac-panel",
                    activeClass: "is-active",
                    beforeOpen: function () {},
                    onOpen: function () {},
                    beforeClose: function () {},
                    onClose: function () {},
                  },
                  n
                );
                var e = "string" == typeof t;
                (this.container = e ? document.querySelector(t) : t),
                  this.createDefinitions(),
                  o.attachEvents();
              },
              createDefinitions: function () {
                var e = this,
                  t = this.options,
                  n = t.elementClass,
                  r = t.openOnInit,
                  o = t.onlyChildNodes
                    ? this.container.childNodes
                    : this.container.querySelectorAll(u(n));
                (this.elements = Array.from(o).filter(function (e) {
                  return e.classList && e.classList.contains(n);
                })),
                  (this.firstElement = this.elements[0]),
                  (this.lastElement = this.elements[this.elements.length - 1]),
                  this.elements
                    .filter(function (e) {
                      return !e.classList.contains("js-enabled");
                    })
                    .forEach(function (t) {
                      t.classList.add("js-enabled"),
                        e.generateIDs(t),
                        e.setARIA(t),
                        e.setTransition(t);
                      var n = e.elements.indexOf(t);
                      i++,
                        r.includes(n)
                          ? e.showElement(t, !1)
                          : e.closeElement(t, !1);
                    });
              },
              setTransition: function (e) {
                var t =
                    arguments.length > 1 &&
                    void 0 !== arguments[1] &&
                    arguments[1],
                  i = this.options,
                  n = i.duration,
                  r = i.panelClass,
                  o = e.querySelector(u(r)),
                  a = l("transitionDuration");
                o.style[a] = t ? null : "".concat(n, "ms");
              },
              generateIDs: function (e) {
                var t = this.options,
                  n = t.triggerClass,
                  r = t.panelClass,
                  o = e.querySelector(u(n)),
                  a = e.querySelector(u(r));
                e.setAttribute("id", e.id || "ac-".concat(i)),
                  o.setAttribute("id", o.id || "ac-trigger-".concat(i)),
                  a.setAttribute("id", a.id || "ac-panel-".concat(i));
              },
              removeIDs: function (e) {
                var t = this.options,
                  i = t.triggerClass,
                  n = t.panelClass,
                  r = e.querySelector(u(i)),
                  o = e.querySelector(u(n));
                e.id.startsWith("ac-") && e.removeAttribute("id"),
                  r.id.startsWith("ac-") && r.removeAttribute("id"),
                  o.id.startsWith("ac-") && o.removeAttribute("id");
              },
              setARIA: function (e) {
                var t = this.options,
                  i = t.ariaEnabled,
                  n = t.triggerClass,
                  r = t.panelClass;
                if (i) {
                  var o = e.querySelector(u(n)),
                    a = e.querySelector(u(r));
                  o.setAttribute("role", "button"),
                    o.setAttribute("aria-controls", a.id),
                    o.setAttribute("aria-disabled", !1),
                    o.setAttribute("aria-expanded", !1),
                    a.setAttribute("role", "region"),
                    a.setAttribute("aria-labelledby", o.id);
                }
              },
              updateARIA: function (e, t) {
                var i = t.ariaExpanded,
                  n = t.ariaDisabled,
                  r = this.options,
                  o = r.ariaEnabled,
                  a = r.triggerClass;
                if (o) {
                  var s = e.querySelector(u(a));
                  s.setAttribute("aria-expanded", i),
                    s.setAttribute("aria-disabled", n);
                }
              },
              removeARIA: function (e) {
                var t = this.options,
                  i = t.ariaEnabled,
                  n = t.triggerClass,
                  r = t.panelClass;
                if (i) {
                  var o = e.querySelector(u(n)),
                    a = e.querySelector(u(r));
                  o.removeAttribute("role"),
                    o.removeAttribute("aria-controls"),
                    o.removeAttribute("aria-disabled"),
                    o.removeAttribute("aria-expanded"),
                    a.removeAttribute("role"),
                    a.removeAttribute("aria-labelledby");
                }
              },
              focus: function (e, t) {
                e.preventDefault();
                var i = this.options.triggerClass;
                t.querySelector(u(i)).focus();
              },
              focusFirstElement: function (e) {
                this.focus(e, this.firstElement), (this.currFocusedIdx = 0);
              },
              focusLastElement: function (e) {
                this.focus(e, this.lastElement),
                  (this.currFocusedIdx = this.elements.length - 1);
              },
              focusNextElement: function (e) {
                var t = this.currFocusedIdx + 1;
                if (t > this.elements.length - 1)
                  return this.focusFirstElement(e);
                this.focus(e, this.elements[t]), (this.currFocusedIdx = t);
              },
              focusPrevElement: function (e) {
                var t = this.currFocusedIdx - 1;
                if (t < 0) return this.focusLastElement(e);
                this.focus(e, this.elements[t]), (this.currFocusedIdx = t);
              },
              showElement: function (e) {
                var t =
                    !(arguments.length > 1 && void 0 !== arguments[1]) ||
                    arguments[1],
                  i = this.options,
                  n = i.panelClass,
                  r = i.activeClass,
                  o = i.collapse,
                  a = i.beforeOpen;
                t && a(e);
                var s = e.querySelector(u(n)),
                  l = s.scrollHeight;
                e.classList.add(r),
                  requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                      s.style.height = t ? "".concat(l, "px") : "auto";
                    });
                  }),
                  this.updateARIA(e, { ariaExpanded: !0, ariaDisabled: !o });
              },
              closeElement: function (e) {
                var t =
                    !(arguments.length > 1 && void 0 !== arguments[1]) ||
                    arguments[1],
                  i = this.options,
                  n = i.panelClass,
                  r = i.activeClass,
                  o = i.beforeClose,
                  a = e.querySelector(u(n)),
                  s = a.scrollHeight;
                e.classList.remove(r),
                  t
                    ? (o(e),
                      requestAnimationFrame(function () {
                        (a.style.height = "".concat(s, "px")),
                          requestAnimationFrame(function () {
                            a.style.height = 0;
                          });
                      }))
                    : (a.style.height = 0),
                  this.updateARIA(e, { ariaExpanded: !1, ariaDisabled: !1 });
              },
              toggleElement: function (e) {
                var t = this.options,
                  i = t.activeClass,
                  n = t.collapse,
                  r = e.classList.contains(i);
                if (!r || n)
                  return r ? this.closeElement(e) : this.showElement(e);
              },
              closeElements: function () {
                var e = this,
                  t = this.options,
                  i = t.activeClass;
                t.showMultiple ||
                  this.elements.forEach(function (t, n) {
                    t.classList.contains(i) &&
                      n !== e.currFocusedIdx &&
                      e.closeElement(t);
                  });
              },
              handleClick: function (e) {
                var t = this,
                  i = e.currentTarget;
                this.elements.forEach(function (n, r) {
                  n.contains(i) &&
                    "A" !== e.target.nodeName &&
                    ((t.currFocusedIdx = r),
                    t.closeElements(),
                    t.focus(e, n),
                    t.toggleElement(n));
                });
              },
              handleKeydown: function (e) {
                switch (e.key) {
                  case "ArrowUp":
                    return this.focusPrevElement(e);
                  case "ArrowDown":
                    return this.focusNextElement(e);
                  case "Home":
                    return this.focusFirstElement(e);
                  case "End":
                    return this.focusLastElement(e);
                  default:
                    return null;
                }
              },
              handleFocus: function (e) {
                var t = e.currentTarget,
                  i = this.elements.find(function (e) {
                    return e.contains(t);
                  });
                this.currFocusedIdx = this.elements.indexOf(i);
              },
              handleTransitionEnd: function (e) {
                if ((e.stopPropagation(), "height" === e.propertyName)) {
                  var t = this.options,
                    i = t.onOpen,
                    n = t.onClose,
                    r = e.currentTarget,
                    o = parseInt(r.style.height),
                    a = this.elements.find(function (e) {
                      return e.contains(r);
                    });
                  o > 0 ? ((r.style.height = "auto"), i(a)) : n(a);
                }
              },
            };
            (this.attachEvents = function () {
              if (!a) {
                var e = s.options,
                  t = e.triggerClass,
                  i = e.panelClass;
                (s.handleClick = s.handleClick.bind(s)),
                  (s.handleKeydown = s.handleKeydown.bind(s)),
                  (s.handleFocus = s.handleFocus.bind(s)),
                  (s.handleTransitionEnd = s.handleTransitionEnd.bind(s)),
                  s.elements.forEach(function (e) {
                    var n = e.querySelector(u(t)),
                      r = e.querySelector(u(i));
                    n.addEventListener("click", s.handleClick),
                      n.addEventListener("keydown", s.handleKeydown),
                      n.addEventListener("focus", s.handleFocus),
                      r.addEventListener(
                        "webkitTransitionEnd",
                        s.handleTransitionEnd
                      ),
                      r.addEventListener(
                        "transitionend",
                        s.handleTransitionEnd
                      );
                  }),
                  (a = !0);
              }
            }),
              (this.detachEvents = function () {
                if (a) {
                  var e = s.options,
                    t = e.triggerClass,
                    i = e.panelClass;
                  s.elements.forEach(function (e) {
                    var n = e.querySelector(u(t)),
                      r = e.querySelector(u(i));
                    n.removeEventListener("click", s.handleClick),
                      n.removeEventListener("keydown", s.handleKeydown),
                      n.removeEventListener("focus", s.handleFocus),
                      r.removeEventListener(
                        "webkitTransitionEnd",
                        s.handleTransitionEnd
                      ),
                      r.removeEventListener(
                        "transitionend",
                        s.handleTransitionEnd
                      );
                  }),
                    (a = !1);
                }
              }),
              (this.toggle = function (e) {
                var t = s.elements[e];
                t && s.toggleElement(t);
              }),
              (this.open = function (e) {
                var t = s.elements[e];
                t && s.showElement(t);
              }),
              (this.openAll = function () {
                var e = s.options,
                  t = e.activeClass,
                  i = e.onOpen;
                s.elements.forEach(function (e) {
                  e.classList.contains(t) || (s.showElement(e, !1), i(e));
                });
              }),
              (this.close = function (e) {
                var t = s.elements[e];
                t && s.closeElement(t);
              }),
              (this.closeAll = function () {
                var e = s.options,
                  t = e.activeClass,
                  i = e.onClose;
                s.elements.forEach(function (e) {
                  e.classList.contains(t) && (s.closeElement(e, !1), i(e));
                });
              }),
              (this.destroy = function () {
                r.detachEvents(),
                  r.openAll(),
                  s.elements.forEach(function (e) {
                    s.removeIDs(e), s.removeARIA(e), s.setTransition(e, !0);
                  }),
                  (a = !0);
              }),
              (this.update = function () {
                s.createDefinitions(), r.detachEvents(), r.attachEvents();
              });
            var l = function (e) {
                return "string" == typeof document.documentElement.style[e]
                  ? e
                  : ((e = c(e)), (e = "webkit".concat(e)));
              },
              c = function (e) {
                return e.charAt(0).toUpperCase() + e.slice(1);
              },
              u = function (e) {
                return ".".concat(CSS.escape(e));
              };
            s.init();
          }),
          void 0 !== e.exports ? (e.exports = n) : (t.Accordion = n);
      },
      1443: function (e, t, i) {
        "object" == typeof navigator &&
          (e.exports = (function () {
            "use strict";
            function e(e, t, i) {
              return (
                (t = (function (e) {
                  var t = (function (e, t) {
                    if ("object" != typeof e || null === e) return e;
                    var i = e[Symbol.toPrimitive];
                    if (void 0 !== i) {
                      var n = i.call(e, "string");
                      if ("object" != typeof n) return n;
                      throw new TypeError(
                        "@@toPrimitive must return a primitive value."
                      );
                    }
                    return String(e);
                  })(e);
                  return "symbol" == typeof t ? t : String(t);
                })(t)) in e
                  ? Object.defineProperty(e, t, {
                      value: i,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (e[t] = i),
                e
              );
            }
            function t(e, t) {
              for (var i = 0; i < t.length; i++) {
                var n = t[i];
                (n.enumerable = n.enumerable || !1),
                  (n.configurable = !0),
                  "value" in n && (n.writable = !0),
                  Object.defineProperty(e, n.key, n);
              }
            }
            function n(e, t, i) {
              return (
                t in e
                  ? Object.defineProperty(e, t, {
                      value: i,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (e[t] = i),
                e
              );
            }
            function r(e, t) {
              var i = Object.keys(e);
              if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t &&
                  (n = n.filter(function (t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                  })),
                  i.push.apply(i, n);
              }
              return i;
            }
            function o(e) {
              for (var t = 1; t < arguments.length; t++) {
                var i = null != arguments[t] ? arguments[t] : {};
                t % 2
                  ? r(Object(i), !0).forEach(function (t) {
                      n(e, t, i[t]);
                    })
                  : Object.getOwnPropertyDescriptors
                  ? Object.defineProperties(
                      e,
                      Object.getOwnPropertyDescriptors(i)
                    )
                  : r(Object(i)).forEach(function (t) {
                      Object.defineProperty(
                        e,
                        t,
                        Object.getOwnPropertyDescriptor(i, t)
                      );
                    });
              }
              return e;
            }
            var a = { addCSS: !0, thumbWidth: 15, watch: !0 },
              s = function (e) {
                return null != e ? e.constructor : null;
              },
              l = function (e, t) {
                return !!(e && t && e instanceof t);
              },
              c = function (e) {
                return null == e;
              },
              u = function (e) {
                return s(e) === Object;
              },
              d = function (e) {
                return s(e) === String;
              },
              h = function (e) {
                return Array.isArray(e);
              },
              p = function (e) {
                return l(e, NodeList);
              },
              f = {
                nullOrUndefined: c,
                object: u,
                number: function (e) {
                  return s(e) === Number && !Number.isNaN(e);
                },
                string: d,
                boolean: function (e) {
                  return s(e) === Boolean;
                },
                function: function (e) {
                  return s(e) === Function;
                },
                array: h,
                nodeList: p,
                element: function (e) {
                  return l(e, Element);
                },
                event: function (e) {
                  return l(e, Event);
                },
                empty: function (e) {
                  return (
                    c(e) ||
                    ((d(e) || h(e) || p(e)) && !e.length) ||
                    (u(e) && !Object.keys(e).length)
                  );
                },
              };
            var m = (function () {
              function e(t, i) {
                (function (e, t) {
                  if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function");
                })(this, e),
                  f.element(t)
                    ? (this.element = t)
                    : f.string(t) && (this.element = document.querySelector(t)),
                  f.element(this.element) &&
                    f.empty(this.element.rangeTouch) &&
                    ((this.config = o({}, a, {}, i)), this.init());
              }
              return (
                (function (e, i, n) {
                  i && t(e.prototype, i), n && t(e, n);
                })(
                  e,
                  [
                    {
                      key: "init",
                      value: function () {
                        e.enabled &&
                          (this.config.addCSS &&
                            ((this.element.style.userSelect = "none"),
                            (this.element.style.webKitUserSelect = "none"),
                            (this.element.style.touchAction = "manipulation")),
                          this.listeners(!0),
                          (this.element.rangeTouch = this));
                      },
                    },
                    {
                      key: "destroy",
                      value: function () {
                        e.enabled &&
                          (this.config.addCSS &&
                            ((this.element.style.userSelect = ""),
                            (this.element.style.webKitUserSelect = ""),
                            (this.element.style.touchAction = "")),
                          this.listeners(!1),
                          (this.element.rangeTouch = null));
                      },
                    },
                    {
                      key: "listeners",
                      value: function (e) {
                        var t = this,
                          i = e ? "addEventListener" : "removeEventListener";
                        ["touchstart", "touchmove", "touchend"].forEach(
                          function (e) {
                            t.element[i](
                              e,
                              function (e) {
                                return t.set(e);
                              },
                              !1
                            );
                          }
                        );
                      },
                    },
                    {
                      key: "get",
                      value: function (t) {
                        if (!e.enabled || !f.event(t)) return null;
                        var i,
                          n = t.target,
                          r = t.changedTouches[0],
                          o = parseFloat(n.getAttribute("min")) || 0,
                          a = parseFloat(n.getAttribute("max")) || 100,
                          s = parseFloat(n.getAttribute("step")) || 1,
                          l = n.getBoundingClientRect(),
                          c =
                            ((100 / l.width) * (this.config.thumbWidth / 2)) /
                            100;
                        return (
                          0 > (i = (100 / l.width) * (r.clientX - l.left))
                            ? (i = 0)
                            : 100 < i && (i = 100),
                          50 > i
                            ? (i -= (100 - 2 * i) * c)
                            : 50 < i && (i += 2 * (i - 50) * c),
                          o +
                            (function (e, t) {
                              if (1 > t) {
                                var i = (function (e) {
                                  var t = ""
                                    .concat(e)
                                    .match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
                                  return t
                                    ? Math.max(
                                        0,
                                        (t[1] ? t[1].length : 0) -
                                          (t[2] ? +t[2] : 0)
                                      )
                                    : 0;
                                })(t);
                                return parseFloat(e.toFixed(i));
                              }
                              return Math.round(e / t) * t;
                            })((i / 100) * (a - o), s)
                        );
                      },
                    },
                    {
                      key: "set",
                      value: function (t) {
                        e.enabled &&
                          f.event(t) &&
                          !t.target.disabled &&
                          (t.preventDefault(),
                          (t.target.value = this.get(t)),
                          (function (e, t) {
                            if (e && t) {
                              var i = new Event(t, { bubbles: !0 });
                              e.dispatchEvent(i);
                            }
                          })(
                            t.target,
                            "touchend" === t.type ? "change" : "input"
                          ));
                      },
                    },
                  ],
                  [
                    {
                      key: "setup",
                      value: function (t) {
                        var i =
                            1 < arguments.length && void 0 !== arguments[1]
                              ? arguments[1]
                              : {},
                          n = null;
                        if (
                          (f.empty(t) || f.string(t)
                            ? (n = Array.from(
                                document.querySelectorAll(
                                  f.string(t) ? t : 'input[type="range"]'
                                )
                              ))
                            : f.element(t)
                            ? (n = [t])
                            : f.nodeList(t)
                            ? (n = Array.from(t))
                            : f.array(t) && (n = t.filter(f.element)),
                          f.empty(n))
                        )
                          return null;
                        var r = o({}, a, {}, i);
                        if (f.string(t) && r.watch) {
                          var s = new MutationObserver(function (i) {
                            Array.from(i).forEach(function (i) {
                              Array.from(i.addedNodes).forEach(function (i) {
                                f.element(i) &&
                                  (function (e, t) {
                                    return function () {
                                      return Array.from(
                                        document.querySelectorAll(t)
                                      ).includes(this);
                                    }.call(e, t);
                                  })(i, t) &&
                                  new e(i, r);
                              });
                            });
                          });
                          s.observe(document.body, {
                            childList: !0,
                            subtree: !0,
                          });
                        }
                        return n.map(function (t) {
                          return new e(t, i);
                        });
                      },
                    },
                    {
                      key: "enabled",
                      get: function () {
                        return "ontouchstart" in document.documentElement;
                      },
                    },
                  ]
                ),
                e
              );
            })();
            const g = (e) => (null != e ? e.constructor : null),
              y = (e, t) => Boolean(e && t && e instanceof t),
              v = (e) => null == e,
              b = (e) => g(e) === Object,
              w = (e) => g(e) === String,
              S = (e) => "function" == typeof e,
              E = (e) => Array.isArray(e),
              k = (e) => y(e, NodeList),
              T = (e) =>
                v(e) ||
                ((w(e) || E(e) || k(e)) && !e.length) ||
                (b(e) && !Object.keys(e).length);
            var A = {
              nullOrUndefined: v,
              object: b,
              number: (e) => g(e) === Number && !Number.isNaN(e),
              string: w,
              boolean: (e) => g(e) === Boolean,
              function: S,
              array: E,
              weakMap: (e) => y(e, WeakMap),
              nodeList: k,
              element: (e) =>
                null !== e &&
                "object" == typeof e &&
                1 === e.nodeType &&
                "object" == typeof e.style &&
                "object" == typeof e.ownerDocument,
              textNode: (e) => g(e) === Text,
              event: (e) => y(e, Event),
              keyboardEvent: (e) => y(e, KeyboardEvent),
              cue: (e) => y(e, window.TextTrackCue) || y(e, window.VTTCue),
              track: (e) => y(e, TextTrack) || (!v(e) && w(e.kind)),
              promise: (e) => y(e, Promise) && S(e.then),
              url: (e) => {
                if (y(e, window.URL)) return !0;
                if (!w(e)) return !1;
                let t = e;
                (e.startsWith("http://") && e.startsWith("https://")) ||
                  (t = `http://${e}`);
                try {
                  return !T(new URL(t).hostname);
                } catch (e) {
                  return !1;
                }
              },
              empty: T,
            };
            const P = (() => {
              const e = document.createElement("span"),
                t = {
                  WebkitTransition: "webkitTransitionEnd",
                  MozTransition: "transitionend",
                  OTransition: "oTransitionEnd otransitionend",
                  transition: "transitionend",
                },
                i = Object.keys(t).find((t) => void 0 !== e.style[t]);
              return !!A.string(i) && t[i];
            })();
            function _(e, t) {
              setTimeout(() => {
                try {
                  (e.hidden = !0), e.offsetHeight, (e.hidden = !1);
                } catch (e) {}
              }, t);
            }
            var C = {
              isIE: Boolean(window.document.documentMode),
              isEdge: /Edge/g.test(navigator.userAgent),
              isWebKit:
                "WebkitAppearance" in document.documentElement.style &&
                !/Edge/g.test(navigator.userAgent),
              isIPhone:
                /iPhone|iPod/gi.test(navigator.userAgent) &&
                navigator.maxTouchPoints > 1,
              isIPadOS:
                "MacIntel" === navigator.platform &&
                navigator.maxTouchPoints > 1,
              isIos:
                /iPad|iPhone|iPod/gi.test(navigator.userAgent) &&
                navigator.maxTouchPoints > 1,
            };
            function x(e, t) {
              return t.split(".").reduce((e, t) => e && e[t], e);
            }
            function L(e = {}, ...t) {
              if (!t.length) return e;
              const i = t.shift();
              return A.object(i)
                ? (Object.keys(i).forEach((t) => {
                    A.object(i[t])
                      ? (Object.keys(e).includes(t) ||
                          Object.assign(e, { [t]: {} }),
                        L(e[t], i[t]))
                      : Object.assign(e, { [t]: i[t] });
                  }),
                  L(e, ...t))
                : e;
            }
            function I(e, t) {
              const i = e.length ? e : [e];
              Array.from(i)
                .reverse()
                .forEach((e, i) => {
                  const n = i > 0 ? t.cloneNode(!0) : t,
                    r = e.parentNode,
                    o = e.nextSibling;
                  n.appendChild(e), o ? r.insertBefore(n, o) : r.appendChild(n);
                });
            }
            function O(e, t) {
              A.element(e) &&
                !A.empty(t) &&
                Object.entries(t)
                  .filter(([, e]) => !A.nullOrUndefined(e))
                  .forEach(([t, i]) => e.setAttribute(t, i));
            }
            function q(e, t, i) {
              const n = document.createElement(e);
              return (
                A.object(t) && O(n, t), A.string(i) && (n.innerText = i), n
              );
            }
            function M(e, t, i, n) {
              A.element(t) && t.appendChild(q(e, i, n));
            }
            function N(e) {
              A.nodeList(e) || A.array(e)
                ? Array.from(e).forEach(N)
                : A.element(e) &&
                  A.element(e.parentNode) &&
                  e.parentNode.removeChild(e);
            }
            function j(e) {
              if (!A.element(e)) return;
              let { length: t } = e.childNodes;
              for (; t > 0; ) e.removeChild(e.lastChild), (t -= 1);
            }
            function V(e, t) {
              return A.element(t) && A.element(t.parentNode) && A.element(e)
                ? (t.parentNode.replaceChild(e, t), e)
                : null;
            }
            function D(e, t) {
              if (!A.string(e) || A.empty(e)) return {};
              const i = {},
                n = L({}, t);
              return (
                e.split(",").forEach((e) => {
                  const t = e.trim(),
                    r = t.replace(".", ""),
                    o = t.replace(/[[\]]/g, "").split("="),
                    [a] = o,
                    s = o.length > 1 ? o[1].replace(/["']/g, "") : "";
                  switch (t.charAt(0)) {
                    case ".":
                      A.string(n.class)
                        ? (i.class = `${n.class} ${r}`)
                        : (i.class = r);
                      break;
                    case "#":
                      i.id = t.replace("#", "");
                      break;
                    case "[":
                      i[a] = s;
                  }
                }),
                L(n, i)
              );
            }
            function B(e, t) {
              if (!A.element(e)) return;
              let i = t;
              A.boolean(i) || (i = !e.hidden), (e.hidden = i);
            }
            function F(e, t, i) {
              if (A.nodeList(e)) return Array.from(e).map((e) => F(e, t, i));
              if (A.element(e)) {
                let n = "toggle";
                return (
                  void 0 !== i && (n = i ? "add" : "remove"),
                  e.classList[n](t),
                  e.classList.contains(t)
                );
              }
              return !1;
            }
            function R(e, t) {
              return A.element(e) && e.classList.contains(t);
            }
            function H(e, t) {
              const { prototype: i } = Element;
              return (
                i.matches ||
                i.webkitMatchesSelector ||
                i.mozMatchesSelector ||
                i.msMatchesSelector ||
                function () {
                  return Array.from(document.querySelectorAll(t)).includes(
                    this
                  );
                }
              ).call(e, t);
            }
            function U(e) {
              return this.elements.container.querySelectorAll(e);
            }
            function $(e) {
              return this.elements.container.querySelector(e);
            }
            function W(e = null, t = !1) {
              A.element(e) && e.focus({ preventScroll: !0, focusVisible: t });
            }
            const z = {
                "audio/ogg": "vorbis",
                "audio/wav": "1",
                "video/webm": "vp8, vorbis",
                "video/mp4": "avc1.42E01E, mp4a.40.2",
                "video/ogg": "theora",
              },
              G = {
                audio: "canPlayType" in document.createElement("audio"),
                video: "canPlayType" in document.createElement("video"),
                check(e, t) {
                  const i = G[e] || "html5" !== t;
                  return { api: i, ui: i && G.rangeInput };
                },
                pip: !(
                  C.isIPhone ||
                  (!A.function(q("video").webkitSetPresentationMode) &&
                    (!document.pictureInPictureEnabled ||
                      q("video").disablePictureInPicture))
                ),
                airplay: A.function(
                  window.WebKitPlaybackTargetAvailabilityEvent
                ),
                playsinline: "playsInline" in document.createElement("video"),
                mime(e) {
                  if (A.empty(e)) return !1;
                  const [t] = e.split("/");
                  let i = e;
                  if (!this.isHTML5 || t !== this.type) return !1;
                  Object.keys(z).includes(i) && (i += `; codecs="${z[e]}"`);
                  try {
                    return Boolean(
                      i && this.media.canPlayType(i).replace(/no/, "")
                    );
                  } catch (e) {
                    return !1;
                  }
                },
                textTracks: "textTracks" in document.createElement("video"),
                rangeInput: (() => {
                  const e = document.createElement("input");
                  return (e.type = "range"), "range" === e.type;
                })(),
                touch: "ontouchstart" in document.documentElement,
                transitions: !1 !== P,
                reducedMotion:
                  "matchMedia" in window &&
                  window.matchMedia("(prefers-reduced-motion)").matches,
              },
              Q = (() => {
                let e = !1;
                try {
                  const t = Object.defineProperty({}, "passive", {
                    get: () => ((e = !0), null),
                  });
                  window.addEventListener("test", null, t),
                    window.removeEventListener("test", null, t);
                } catch (e) {}
                return e;
              })();
            function K(e, t, i, n = !1, r = !0, o = !1) {
              if (
                !e ||
                !("addEventListener" in e) ||
                A.empty(t) ||
                !A.function(i)
              )
                return;
              const a = t.split(" ");
              let s = o;
              Q && (s = { passive: r, capture: o }),
                a.forEach((t) => {
                  this &&
                    this.eventListeners &&
                    n &&
                    this.eventListeners.push({
                      element: e,
                      type: t,
                      callback: i,
                      options: s,
                    }),
                    e[n ? "addEventListener" : "removeEventListener"](t, i, s);
                });
            }
            function Y(e, t = "", i, n = !0, r = !1) {
              K.call(this, e, t, i, !0, n, r);
            }
            function X(e, t = "", i, n = !0, r = !1) {
              K.call(this, e, t, i, !1, n, r);
            }
            function J(e, t = "", i, n = !0, r = !1) {
              const o = (...a) => {
                X(e, t, o, n, r), i.apply(this, a);
              };
              K.call(this, e, t, o, !0, n, r);
            }
            function Z(e, t = "", i = !1, n = {}) {
              if (!A.element(e) || A.empty(t)) return;
              const r = new CustomEvent(t, {
                bubbles: i,
                detail: { ...n, plyr: this },
              });
              e.dispatchEvent(r);
            }
            function ee() {
              this &&
                this.eventListeners &&
                (this.eventListeners.forEach((e) => {
                  const { element: t, type: i, callback: n, options: r } = e;
                  t.removeEventListener(i, n, r);
                }),
                (this.eventListeners = []));
            }
            function te() {
              return new Promise((e) =>
                this.ready
                  ? setTimeout(e, 0)
                  : Y.call(this, this.elements.container, "ready", e)
              ).then(() => {});
            }
            function ie(e) {
              A.promise(e) && e.then(null, () => {});
            }
            function ne(e) {
              return A.array(e) ? e.filter((t, i) => e.indexOf(t) === i) : e;
            }
            function re(e, t) {
              return A.array(e) && e.length
                ? e.reduce((e, i) =>
                    Math.abs(i - t) < Math.abs(e - t) ? i : e
                  )
                : null;
            }
            function oe(e) {
              return !(!window || !window.CSS) && window.CSS.supports(e);
            }
            const ae = [
              [1, 1],
              [4, 3],
              [3, 4],
              [5, 4],
              [4, 5],
              [3, 2],
              [2, 3],
              [16, 10],
              [10, 16],
              [16, 9],
              [9, 16],
              [21, 9],
              [9, 21],
              [32, 9],
              [9, 32],
            ].reduce((e, [t, i]) => ({ ...e, [t / i]: [t, i] }), {});
            function se(e) {
              return (
                !!(A.array(e) || (A.string(e) && e.includes(":"))) &&
                (A.array(e) ? e : e.split(":")).map(Number).every(A.number)
              );
            }
            function le(e) {
              if (!A.array(e) || !e.every(A.number)) return null;
              const [t, i] = e,
                n = (e, t) => (0 === t ? e : n(t, e % t)),
                r = n(t, i);
              return [t / r, i / r];
            }
            function ce(e) {
              const t = (e) => (se(e) ? e.split(":").map(Number) : null);
              let i = t(e);
              if (
                (null === i && (i = t(this.config.ratio)),
                null === i &&
                  !A.empty(this.embed) &&
                  A.array(this.embed.ratio) &&
                  ({ ratio: i } = this.embed),
                null === i && this.isHTML5)
              ) {
                const { videoWidth: e, videoHeight: t } = this.media;
                i = [e, t];
              }
              return le(i);
            }
            function ue(e) {
              if (!this.isVideo) return {};
              const { wrapper: t } = this.elements,
                i = ce.call(this, e);
              if (!A.array(i)) return {};
              const [n, r] = le(i),
                o = (100 / n) * r;
              if (
                (oe(`aspect-ratio: ${n}/${r}`)
                  ? (t.style.aspectRatio = `${n}/${r}`)
                  : (t.style.paddingBottom = `${o}%`),
                this.isVimeo && !this.config.vimeo.premium && this.supported.ui)
              ) {
                const e =
                    (100 / this.media.offsetWidth) *
                    parseInt(
                      window.getComputedStyle(this.media).paddingBottom,
                      10
                    ),
                  i = (e - o) / (e / 50);
                this.fullscreen.active
                  ? (t.style.paddingBottom = null)
                  : (this.media.style.transform = `translateY(-${i}%)`);
              } else
                this.isHTML5 &&
                  t.classList.add(this.config.classNames.videoFixedRatio);
              return { padding: o, ratio: i };
            }
            function de(e, t, i = 0.05) {
              const n = e / t,
                r = re(Object.keys(ae), n);
              return Math.abs(r - n) <= i ? ae[r] : [e, t];
            }
            const he = {
              getSources() {
                return this.isHTML5
                  ? Array.from(this.media.querySelectorAll("source")).filter(
                      (e) => {
                        const t = e.getAttribute("type");
                        return !!A.empty(t) || G.mime.call(this, t);
                      }
                    )
                  : [];
              },
              getQualityOptions() {
                return this.config.quality.forced
                  ? this.config.quality.options
                  : he.getSources
                      .call(this)
                      .map((e) => Number(e.getAttribute("size")))
                      .filter(Boolean);
              },
              setup() {
                if (!this.isHTML5) return;
                const e = this;
                (e.options.speed = e.config.speed.options),
                  A.empty(this.config.ratio) || ue.call(e),
                  Object.defineProperty(e.media, "quality", {
                    get() {
                      const t = he.getSources
                        .call(e)
                        .find((t) => t.getAttribute("src") === e.source);
                      return t && Number(t.getAttribute("size"));
                    },
                    set(t) {
                      if (e.quality !== t) {
                        if (
                          e.config.quality.forced &&
                          A.function(e.config.quality.onChange)
                        )
                          e.config.quality.onChange(t);
                        else {
                          const i = he.getSources
                            .call(e)
                            .find((e) => Number(e.getAttribute("size")) === t);
                          if (!i) return;
                          const {
                            currentTime: n,
                            paused: r,
                            preload: o,
                            readyState: a,
                            playbackRate: s,
                          } = e.media;
                          (e.media.src = i.getAttribute("src")),
                            ("none" !== o || a) &&
                              (e.once("loadedmetadata", () => {
                                (e.speed = s),
                                  (e.currentTime = n),
                                  r || ie(e.play());
                              }),
                              e.media.load());
                        }
                        Z.call(e, e.media, "qualitychange", !1, { quality: t });
                      }
                    },
                  });
              },
              cancelRequests() {
                this.isHTML5 &&
                  (N(he.getSources.call(this)),
                  this.media.setAttribute("src", this.config.blankVideo),
                  this.media.load(),
                  this.debug.log("Cancelled network requests"));
              },
            };
            function pe(e, ...t) {
              return A.empty(e)
                ? e
                : e.toString().replace(/{(\d+)}/g, (e, i) => t[i].toString());
            }
            const fe = (e = "", t = "", i = "") =>
                e.replace(
                  new RegExp(
                    t.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1"),
                    "g"
                  ),
                  i.toString()
                ),
              me = (e = "") =>
                e
                  .toString()
                  .replace(
                    /\w\S*/g,
                    (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase()
                  );
            function ge(e) {
              const t = document.createElement("div");
              return t.appendChild(e), t.innerHTML;
            }
            const ye = {
                pip: "PIP",
                airplay: "AirPlay",
                html5: "HTML5",
                vimeo: "Vimeo",
                youtube: "YouTube",
              },
              ve = {
                get(e = "", t = {}) {
                  if (A.empty(e) || A.empty(t)) return "";
                  let i = x(t.i18n, e);
                  if (A.empty(i))
                    return Object.keys(ye).includes(e) ? ye[e] : "";
                  const n = { "{seektime}": t.seekTime, "{title}": t.title };
                  return (
                    Object.entries(n).forEach(([e, t]) => {
                      i = fe(i, e, t);
                    }),
                    i
                  );
                },
              };
            class be {
              constructor(t) {
                e(this, "get", (e) => {
                  if (!be.supported || !this.enabled) return null;
                  const t = window.localStorage.getItem(this.key);
                  if (A.empty(t)) return null;
                  const i = JSON.parse(t);
                  return A.string(e) && e.length ? i[e] : i;
                }),
                  e(this, "set", (e) => {
                    if (!be.supported || !this.enabled) return;
                    if (!A.object(e)) return;
                    let t = this.get();
                    A.empty(t) && (t = {}), L(t, e);
                    try {
                      window.localStorage.setItem(this.key, JSON.stringify(t));
                    } catch (e) {}
                  }),
                  (this.enabled = t.config.storage.enabled),
                  (this.key = t.config.storage.key);
              }
              static get supported() {
                try {
                  if (!("localStorage" in window)) return !1;
                  const e = "___test";
                  return (
                    window.localStorage.setItem(e, e),
                    window.localStorage.removeItem(e),
                    !0
                  );
                } catch (e) {
                  return !1;
                }
              }
            }
            function we(e, t = "text") {
              return new Promise((i, n) => {
                try {
                  const n = new XMLHttpRequest();
                  if (!("withCredentials" in n)) return;
                  n.addEventListener("load", () => {
                    if ("text" === t)
                      try {
                        i(JSON.parse(n.responseText));
                      } catch (e) {
                        i(n.responseText);
                      }
                    else i(n.response);
                  }),
                    n.addEventListener("error", () => {
                      throw new Error(n.status);
                    }),
                    n.open("GET", e, !0),
                    (n.responseType = t),
                    n.send();
                } catch (e) {
                  n(e);
                }
              });
            }
            function Se(e, t) {
              if (!A.string(e)) return;
              const i = "cache",
                n = A.string(t);
              let r = !1;
              const o = () => null !== document.getElementById(t),
                a = (e, t) => {
                  (e.innerHTML = t),
                    (n && o()) ||
                      document.body.insertAdjacentElement("afterbegin", e);
                };
              if (!n || !o()) {
                const o = be.supported,
                  s = document.createElement("div");
                if (
                  (s.setAttribute("hidden", ""),
                  n && s.setAttribute("id", t),
                  o)
                ) {
                  const e = window.localStorage.getItem(`${i}-${t}`);
                  if (((r = null !== e), r)) {
                    const t = JSON.parse(e);
                    a(s, t.content);
                  }
                }
                we(e)
                  .then((e) => {
                    if (!A.empty(e)) {
                      if (o)
                        try {
                          window.localStorage.setItem(
                            `${i}-${t}`,
                            JSON.stringify({ content: e })
                          );
                        } catch (e) {}
                      a(s, e);
                    }
                  })
                  .catch(() => {});
              }
            }
            const Ee = (e) => Math.trunc((e / 60 / 60) % 60, 10);
            function ke(e = 0, t = !1, i = !1) {
              if (!A.number(e)) return ke(void 0, t, i);
              const n = (e) => `0${e}`.slice(-2);
              let r = Ee(e);
              const o = ((e) => Math.trunc((e / 60) % 60, 10))(e),
                a = ((e) => Math.trunc(e % 60, 10))(e);
              return (
                (r = t || r > 0 ? `${r}:` : ""),
                `${i && e > 0 ? "-" : ""}${r}${n(o)}:${n(a)}`
              );
            }
            const Te = {
              getIconUrl() {
                const e = new URL(this.config.iconUrl, window.location),
                  t = window.location.host
                    ? window.location.host
                    : window.top.location.host,
                  i = e.host !== t || (C.isIE && !window.svg4everybody);
                return { url: this.config.iconUrl, cors: i };
              },
              findElements() {
                try {
                  return (
                    (this.elements.controls = $.call(
                      this,
                      this.config.selectors.controls.wrapper
                    )),
                    (this.elements.buttons = {
                      play: U.call(this, this.config.selectors.buttons.play),
                      pause: $.call(this, this.config.selectors.buttons.pause),
                      restart: $.call(
                        this,
                        this.config.selectors.buttons.restart
                      ),
                      rewind: $.call(
                        this,
                        this.config.selectors.buttons.rewind
                      ),
                      fastForward: $.call(
                        this,
                        this.config.selectors.buttons.fastForward
                      ),
                      mute: $.call(this, this.config.selectors.buttons.mute),
                      pip: $.call(this, this.config.selectors.buttons.pip),
                      airplay: $.call(
                        this,
                        this.config.selectors.buttons.airplay
                      ),
                      settings: $.call(
                        this,
                        this.config.selectors.buttons.settings
                      ),
                      captions: $.call(
                        this,
                        this.config.selectors.buttons.captions
                      ),
                      fullscreen: $.call(
                        this,
                        this.config.selectors.buttons.fullscreen
                      ),
                    }),
                    (this.elements.progress = $.call(
                      this,
                      this.config.selectors.progress
                    )),
                    (this.elements.inputs = {
                      seek: $.call(this, this.config.selectors.inputs.seek),
                      volume: $.call(this, this.config.selectors.inputs.volume),
                    }),
                    (this.elements.display = {
                      buffer: $.call(
                        this,
                        this.config.selectors.display.buffer
                      ),
                      currentTime: $.call(
                        this,
                        this.config.selectors.display.currentTime
                      ),
                      duration: $.call(
                        this,
                        this.config.selectors.display.duration
                      ),
                    }),
                    A.element(this.elements.progress) &&
                      (this.elements.display.seekTooltip =
                        this.elements.progress.querySelector(
                          `.${this.config.classNames.tooltip}`
                        )),
                    !0
                  );
                } catch (e) {
                  return (
                    this.debug.warn(
                      "It looks like there is a problem with your custom controls HTML",
                      e
                    ),
                    this.toggleNativeControls(!0),
                    !1
                  );
                }
              },
              createIcon(e, t) {
                const i = "http://www.w3.org/2000/svg",
                  n = Te.getIconUrl.call(this),
                  r = `${n.cors ? "" : n.url}#${this.config.iconPrefix}`,
                  o = document.createElementNS(i, "svg");
                O(o, L(t, { "aria-hidden": "true", focusable: "false" }));
                const a = document.createElementNS(i, "use"),
                  s = `${r}-${e}`;
                return (
                  "href" in a &&
                    a.setAttributeNS("http://www.w3.org/1999/xlink", "href", s),
                  a.setAttributeNS(
                    "http://www.w3.org/1999/xlink",
                    "xlink:href",
                    s
                  ),
                  o.appendChild(a),
                  o
                );
              },
              createLabel(e, t = {}) {
                const i = ve.get(e, this.config);
                return q(
                  "span",
                  {
                    ...t,
                    class: [t.class, this.config.classNames.hidden]
                      .filter(Boolean)
                      .join(" "),
                  },
                  i
                );
              },
              createBadge(e) {
                if (A.empty(e)) return null;
                const t = q("span", {
                  class: this.config.classNames.menu.value,
                });
                return (
                  t.appendChild(
                    q("span", { class: this.config.classNames.menu.badge }, e)
                  ),
                  t
                );
              },
              createButton(e, t) {
                const i = L({}, t);
                let n = (function (e = "") {
                  let t = e.toString();
                  return (
                    (t = (function (e = "") {
                      let t = e.toString();
                      return (
                        (t = fe(t, "-", " ")),
                        (t = fe(t, "_", " ")),
                        (t = me(t)),
                        fe(t, " ", "")
                      );
                    })(t)),
                    t.charAt(0).toLowerCase() + t.slice(1)
                  );
                })(e);
                const r = {
                  element: "button",
                  toggle: !1,
                  label: null,
                  icon: null,
                  labelPressed: null,
                  iconPressed: null,
                };
                switch (
                  (["element", "icon", "label"].forEach((e) => {
                    Object.keys(i).includes(e) && ((r[e] = i[e]), delete i[e]);
                  }),
                  "button" !== r.element ||
                    Object.keys(i).includes("type") ||
                    (i.type = "button"),
                  Object.keys(i).includes("class")
                    ? i.class
                        .split(" ")
                        .some((e) => e === this.config.classNames.control) ||
                      L(i, {
                        class: `${i.class} ${this.config.classNames.control}`,
                      })
                    : (i.class = this.config.classNames.control),
                  e)
                ) {
                  case "play":
                    (r.toggle = !0),
                      (r.label = "play"),
                      (r.labelPressed = "pause"),
                      (r.icon = "play"),
                      (r.iconPressed = "pause");
                    break;
                  case "mute":
                    (r.toggle = !0),
                      (r.label = "mute"),
                      (r.labelPressed = "unmute"),
                      (r.icon = "volume"),
                      (r.iconPressed = "muted");
                    break;
                  case "captions":
                    (r.toggle = !0),
                      (r.label = "enableCaptions"),
                      (r.labelPressed = "disableCaptions"),
                      (r.icon = "captions-off"),
                      (r.iconPressed = "captions-on");
                    break;
                  case "fullscreen":
                    (r.toggle = !0),
                      (r.label = "enterFullscreen"),
                      (r.labelPressed = "exitFullscreen"),
                      (r.icon = "enter-fullscreen"),
                      (r.iconPressed = "exit-fullscreen");
                    break;
                  case "play-large":
                    (i.class += ` ${this.config.classNames.control}--overlaid`),
                      (n = "play"),
                      (r.label = "play"),
                      (r.icon = "play");
                    break;
                  default:
                    A.empty(r.label) && (r.label = n),
                      A.empty(r.icon) && (r.icon = e);
                }
                const o = q(r.element);
                return (
                  r.toggle
                    ? (o.appendChild(
                        Te.createIcon.call(this, r.iconPressed, {
                          class: "icon--pressed",
                        })
                      ),
                      o.appendChild(
                        Te.createIcon.call(this, r.icon, {
                          class: "icon--not-pressed",
                        })
                      ),
                      o.appendChild(
                        Te.createLabel.call(this, r.labelPressed, {
                          class: "label--pressed",
                        })
                      ),
                      o.appendChild(
                        Te.createLabel.call(this, r.label, {
                          class: "label--not-pressed",
                        })
                      ))
                    : (o.appendChild(Te.createIcon.call(this, r.icon)),
                      o.appendChild(Te.createLabel.call(this, r.label))),
                  L(i, D(this.config.selectors.buttons[n], i)),
                  O(o, i),
                  "play" === n
                    ? (A.array(this.elements.buttons[n]) ||
                        (this.elements.buttons[n] = []),
                      this.elements.buttons[n].push(o))
                    : (this.elements.buttons[n] = o),
                  o
                );
              },
              createRange(e, t) {
                const i = q(
                  "input",
                  L(
                    D(this.config.selectors.inputs[e]),
                    {
                      type: "range",
                      min: 0,
                      max: 100,
                      step: 0.01,
                      value: 0,
                      autocomplete: "off",
                      role: "slider",
                      "aria-label": ve.get(e, this.config),
                      "aria-valuemin": 0,
                      "aria-valuemax": 100,
                      "aria-valuenow": 0,
                    },
                    t
                  )
                );
                return (
                  (this.elements.inputs[e] = i),
                  Te.updateRangeFill.call(this, i),
                  m.setup(i),
                  i
                );
              },
              createProgress(e, t) {
                const i = q(
                  "progress",
                  L(
                    D(this.config.selectors.display[e]),
                    {
                      min: 0,
                      max: 100,
                      value: 0,
                      role: "progressbar",
                      "aria-hidden": !0,
                    },
                    t
                  )
                );
                if ("volume" !== e) {
                  i.appendChild(q("span", null, "0"));
                  const t = { played: "played", buffer: "buffered" }[e],
                    n = t ? ve.get(t, this.config) : "";
                  i.innerText = `% ${n.toLowerCase()}`;
                }
                return (this.elements.display[e] = i), i;
              },
              createTime(e, t) {
                const i = D(this.config.selectors.display[e], t),
                  n = q(
                    "div",
                    L(i, {
                      class: `${i.class ? i.class : ""} ${
                        this.config.classNames.display.time
                      } `.trim(),
                      "aria-label": ve.get(e, this.config),
                      role: "timer",
                    }),
                    "00:00"
                  );
                return (this.elements.display[e] = n), n;
              },
              bindMenuItemShortcuts(e, t) {
                Y.call(
                  this,
                  e,
                  "keydown keyup",
                  (i) => {
                    if (
                      ![" ", "ArrowUp", "ArrowDown", "ArrowRight"].includes(
                        i.key
                      )
                    )
                      return;
                    if (
                      (i.preventDefault(),
                      i.stopPropagation(),
                      "keydown" === i.type)
                    )
                      return;
                    const n = H(e, '[role="menuitemradio"]');
                    if (!n && [" ", "ArrowRight"].includes(i.key))
                      Te.showMenuPanel.call(this, t, !0);
                    else {
                      let t;
                      " " !== i.key &&
                        ("ArrowDown" === i.key || (n && "ArrowRight" === i.key)
                          ? ((t = e.nextElementSibling),
                            A.element(t) ||
                              (t = e.parentNode.firstElementChild))
                          : ((t = e.previousElementSibling),
                            A.element(t) ||
                              (t = e.parentNode.lastElementChild)),
                        W.call(this, t, !0));
                    }
                  },
                  !1
                ),
                  Y.call(this, e, "keyup", (e) => {
                    "Return" === e.key &&
                      Te.focusFirstMenuItem.call(this, null, !0);
                  });
              },
              createMenuItem({
                value: e,
                list: t,
                type: i,
                title: n,
                badge: r = null,
                checked: o = !1,
              }) {
                const a = D(this.config.selectors.inputs[i]),
                  s = q(
                    "button",
                    L(a, {
                      type: "button",
                      role: "menuitemradio",
                      class: `${this.config.classNames.control} ${
                        a.class ? a.class : ""
                      }`.trim(),
                      "aria-checked": o,
                      value: e,
                    })
                  ),
                  l = q("span");
                (l.innerHTML = n),
                  A.element(r) && l.appendChild(r),
                  s.appendChild(l),
                  Object.defineProperty(s, "checked", {
                    enumerable: !0,
                    get: () => "true" === s.getAttribute("aria-checked"),
                    set(e) {
                      e &&
                        Array.from(s.parentNode.children)
                          .filter((e) => H(e, '[role="menuitemradio"]'))
                          .forEach((e) =>
                            e.setAttribute("aria-checked", "false")
                          ),
                        s.setAttribute("aria-checked", e ? "true" : "false");
                    },
                  }),
                  this.listeners.bind(
                    s,
                    "click keyup",
                    (t) => {
                      if (!A.keyboardEvent(t) || " " === t.key) {
                        switch (
                          (t.preventDefault(),
                          t.stopPropagation(),
                          (s.checked = !0),
                          i)
                        ) {
                          case "language":
                            this.currentTrack = Number(e);
                            break;
                          case "quality":
                            this.quality = e;
                            break;
                          case "speed":
                            this.speed = parseFloat(e);
                        }
                        Te.showMenuPanel.call(this, "home", A.keyboardEvent(t));
                      }
                    },
                    i,
                    !1
                  ),
                  Te.bindMenuItemShortcuts.call(this, s, i),
                  t.appendChild(s);
              },
              formatTime(e = 0, t = !1) {
                return A.number(e) ? ke(e, Ee(this.duration) > 0, t) : e;
              },
              updateTimeDisplay(e = null, t = 0, i = !1) {
                A.element(e) &&
                  A.number(t) &&
                  (e.innerText = Te.formatTime(t, i));
              },
              updateVolume() {
                this.supported.ui &&
                  (A.element(this.elements.inputs.volume) &&
                    Te.setRange.call(
                      this,
                      this.elements.inputs.volume,
                      this.muted ? 0 : this.volume
                    ),
                  A.element(this.elements.buttons.mute) &&
                    (this.elements.buttons.mute.pressed =
                      this.muted || 0 === this.volume));
              },
              setRange(e, t = 0) {
                A.element(e) &&
                  ((e.value = t), Te.updateRangeFill.call(this, e));
              },
              updateProgress(e) {
                if (!this.supported.ui || !A.event(e)) return;
                let t = 0;
                const i = (e, t) => {
                  const i = A.number(t) ? t : 0,
                    n = A.element(e) ? e : this.elements.display.buffer;
                  if (A.element(n)) {
                    n.value = i;
                    const e = n.getElementsByTagName("span")[0];
                    A.element(e) && (e.childNodes[0].nodeValue = i);
                  }
                };
                if (e)
                  switch (e.type) {
                    case "timeupdate":
                    case "seeking":
                    case "seeked":
                      (n = this.currentTime),
                        (r = this.duration),
                        (t =
                          0 === n ||
                          0 === r ||
                          Number.isNaN(n) ||
                          Number.isNaN(r)
                            ? 0
                            : ((n / r) * 100).toFixed(2)),
                        "timeupdate" === e.type &&
                          Te.setRange.call(this, this.elements.inputs.seek, t);
                      break;
                    case "playing":
                    case "progress":
                      i(this.elements.display.buffer, 100 * this.buffered);
                  }
                var n, r;
              },
              updateRangeFill(e) {
                const t = A.event(e) ? e.target : e;
                if (A.element(t) && "range" === t.getAttribute("type")) {
                  if (H(t, this.config.selectors.inputs.seek)) {
                    t.setAttribute("aria-valuenow", this.currentTime);
                    const e = Te.formatTime(this.currentTime),
                      i = Te.formatTime(this.duration),
                      n = ve.get("seekLabel", this.config);
                    t.setAttribute(
                      "aria-valuetext",
                      n.replace("{currentTime}", e).replace("{duration}", i)
                    );
                  } else if (H(t, this.config.selectors.inputs.volume)) {
                    const e = 100 * t.value;
                    t.setAttribute("aria-valuenow", e),
                      t.setAttribute("aria-valuetext", `${e.toFixed(1)}%`);
                  } else t.setAttribute("aria-valuenow", t.value);
                  (C.isWebKit || C.isIPadOS) &&
                    t.style.setProperty(
                      "--value",
                      (t.value / t.max) * 100 + "%"
                    );
                }
              },
              updateSeekTooltip(e) {
                var t, i;
                if (
                  !this.config.tooltips.seek ||
                  !A.element(this.elements.inputs.seek) ||
                  !A.element(this.elements.display.seekTooltip) ||
                  0 === this.duration
                )
                  return;
                const n = this.elements.display.seekTooltip,
                  r = `${this.config.classNames.tooltip}--visible`,
                  o = (e) => F(n, r, e);
                if (this.touch) return void o(!1);
                let a = 0;
                const s = this.elements.progress.getBoundingClientRect();
                if (A.event(e)) a = (100 / s.width) * (e.pageX - s.left);
                else {
                  if (!R(n, r)) return;
                  a = parseFloat(n.style.left, 10);
                }
                a < 0 ? (a = 0) : a > 100 && (a = 100);
                const l = (this.duration / 100) * a;
                n.innerText = Te.formatTime(l);
                const c =
                  null === (t = this.config.markers) ||
                  void 0 === t ||
                  null === (i = t.points) ||
                  void 0 === i
                    ? void 0
                    : i.find(({ time: e }) => e === Math.round(l));
                c && n.insertAdjacentHTML("afterbegin", `${c.label}<br>`),
                  (n.style.left = `${a}%`),
                  A.event(e) &&
                    ["mouseenter", "mouseleave"].includes(e.type) &&
                    o("mouseenter" === e.type);
              },
              timeUpdate(e) {
                const t =
                  !A.element(this.elements.display.duration) &&
                  this.config.invertTime;
                Te.updateTimeDisplay.call(
                  this,
                  this.elements.display.currentTime,
                  t ? this.duration - this.currentTime : this.currentTime,
                  t
                ),
                  (e && "timeupdate" === e.type && this.media.seeking) ||
                    Te.updateProgress.call(this, e);
              },
              durationUpdate() {
                if (
                  !this.supported.ui ||
                  (!this.config.invertTime && this.currentTime)
                )
                  return;
                if (this.duration >= 2 ** 32)
                  return (
                    B(this.elements.display.currentTime, !0),
                    void B(this.elements.progress, !0)
                  );
                A.element(this.elements.inputs.seek) &&
                  this.elements.inputs.seek.setAttribute(
                    "aria-valuemax",
                    this.duration
                  );
                const e = A.element(this.elements.display.duration);
                !e &&
                  this.config.displayDuration &&
                  this.paused &&
                  Te.updateTimeDisplay.call(
                    this,
                    this.elements.display.currentTime,
                    this.duration
                  ),
                  e &&
                    Te.updateTimeDisplay.call(
                      this,
                      this.elements.display.duration,
                      this.duration
                    ),
                  this.config.markers.enabled && Te.setMarkers.call(this),
                  Te.updateSeekTooltip.call(this);
              },
              toggleMenuButton(e, t) {
                B(this.elements.settings.buttons[e], !t);
              },
              updateSetting(e, t, i) {
                const n = this.elements.settings.panels[e];
                let r = null,
                  o = t;
                if ("captions" === e) r = this.currentTrack;
                else {
                  if (
                    ((r = A.empty(i) ? this[e] : i),
                    A.empty(r) && (r = this.config[e].default),
                    !A.empty(this.options[e]) && !this.options[e].includes(r))
                  )
                    return void this.debug.warn(
                      `Unsupported value of '${r}' for ${e}`
                    );
                  if (!this.config[e].options.includes(r))
                    return void this.debug.warn(
                      `Disabled value of '${r}' for ${e}`
                    );
                }
                if (
                  (A.element(o) || (o = n && n.querySelector('[role="menu"]')),
                  !A.element(o))
                )
                  return;
                this.elements.settings.buttons[e].querySelector(
                  `.${this.config.classNames.menu.value}`
                ).innerHTML = Te.getLabel.call(this, e, r);
                const a = o && o.querySelector(`[value="${r}"]`);
                A.element(a) && (a.checked = !0);
              },
              getLabel(e, t) {
                switch (e) {
                  case "speed":
                    return 1 === t
                      ? ve.get("normal", this.config)
                      : `${t}&times;`;
                  case "quality":
                    if (A.number(t)) {
                      const e = ve.get(`qualityLabel.${t}`, this.config);
                      return e.length ? e : `${t}p`;
                    }
                    return me(t);
                  case "captions":
                    return _e.getLabel.call(this);
                  default:
                    return null;
                }
              },
              setQualityMenu(e) {
                if (!A.element(this.elements.settings.panels.quality)) return;
                const t = "quality",
                  i =
                    this.elements.settings.panels.quality.querySelector(
                      '[role="menu"]'
                    );
                A.array(e) &&
                  (this.options.quality = ne(e).filter((e) =>
                    this.config.quality.options.includes(e)
                  ));
                const n =
                  !A.empty(this.options.quality) &&
                  this.options.quality.length > 1;
                if (
                  (Te.toggleMenuButton.call(this, t, n),
                  j(i),
                  Te.checkMenu.call(this),
                  !n)
                )
                  return;
                const r = (e) => {
                  const t = ve.get(`qualityBadge.${e}`, this.config);
                  return t.length ? Te.createBadge.call(this, t) : null;
                };
                this.options.quality
                  .sort((e, t) => {
                    const i = this.config.quality.options;
                    return i.indexOf(e) > i.indexOf(t) ? 1 : -1;
                  })
                  .forEach((e) => {
                    Te.createMenuItem.call(this, {
                      value: e,
                      list: i,
                      type: t,
                      title: Te.getLabel.call(this, "quality", e),
                      badge: r(e),
                    });
                  }),
                  Te.updateSetting.call(this, t, i);
              },
              setCaptionsMenu() {
                if (!A.element(this.elements.settings.panels.captions)) return;
                const e = "captions",
                  t =
                    this.elements.settings.panels.captions.querySelector(
                      '[role="menu"]'
                    ),
                  i = _e.getTracks.call(this),
                  n = Boolean(i.length);
                if (
                  (Te.toggleMenuButton.call(this, e, n),
                  j(t),
                  Te.checkMenu.call(this),
                  !n)
                )
                  return;
                const r = i.map((e, i) => ({
                  value: i,
                  checked: this.captions.toggled && this.currentTrack === i,
                  title: _e.getLabel.call(this, e),
                  badge:
                    e.language &&
                    Te.createBadge.call(this, e.language.toUpperCase()),
                  list: t,
                  type: "language",
                }));
                r.unshift({
                  value: -1,
                  checked: !this.captions.toggled,
                  title: ve.get("disabled", this.config),
                  list: t,
                  type: "language",
                }),
                  r.forEach(Te.createMenuItem.bind(this)),
                  Te.updateSetting.call(this, e, t);
              },
              setSpeedMenu() {
                if (!A.element(this.elements.settings.panels.speed)) return;
                const e = "speed",
                  t =
                    this.elements.settings.panels.speed.querySelector(
                      '[role="menu"]'
                    );
                this.options.speed = this.options.speed.filter(
                  (e) => e >= this.minimumSpeed && e <= this.maximumSpeed
                );
                const i =
                  !A.empty(this.options.speed) && this.options.speed.length > 1;
                Te.toggleMenuButton.call(this, e, i),
                  j(t),
                  Te.checkMenu.call(this),
                  i &&
                    (this.options.speed.forEach((i) => {
                      Te.createMenuItem.call(this, {
                        value: i,
                        list: t,
                        type: e,
                        title: Te.getLabel.call(this, "speed", i),
                      });
                    }),
                    Te.updateSetting.call(this, e, t));
              },
              checkMenu() {
                const { buttons: e } = this.elements.settings,
                  t = !A.empty(e) && Object.values(e).some((e) => !e.hidden);
                B(this.elements.settings.menu, !t);
              },
              focusFirstMenuItem(e, t = !1) {
                if (this.elements.settings.popup.hidden) return;
                let i = e;
                A.element(i) ||
                  (i = Object.values(this.elements.settings.panels).find(
                    (e) => !e.hidden
                  ));
                const n = i.querySelector('[role^="menuitem"]');
                W.call(this, n, t);
              },
              toggleMenu(e) {
                const { popup: t } = this.elements.settings,
                  i = this.elements.buttons.settings;
                if (!A.element(t) || !A.element(i)) return;
                const { hidden: n } = t;
                let r = n;
                if (A.boolean(e)) r = e;
                else if (A.keyboardEvent(e) && "Escape" === e.key) r = !1;
                else if (A.event(e)) {
                  const n = A.function(e.composedPath)
                      ? e.composedPath()[0]
                      : e.target,
                    o = t.contains(n);
                  if (o || (!o && e.target !== i && r)) return;
                }
                i.setAttribute("aria-expanded", r),
                  B(t, !r),
                  F(
                    this.elements.container,
                    this.config.classNames.menu.open,
                    r
                  ),
                  r && A.keyboardEvent(e)
                    ? Te.focusFirstMenuItem.call(this, null, !0)
                    : r || n || W.call(this, i, A.keyboardEvent(e));
              },
              getMenuSize(e) {
                const t = e.cloneNode(!0);
                (t.style.position = "absolute"),
                  (t.style.opacity = 0),
                  t.removeAttribute("hidden"),
                  e.parentNode.appendChild(t);
                const i = t.scrollWidth,
                  n = t.scrollHeight;
                return N(t), { width: i, height: n };
              },
              showMenuPanel(e = "", t = !1) {
                const i = this.elements.container.querySelector(
                  `#plyr-settings-${this.id}-${e}`
                );
                if (!A.element(i)) return;
                const n = i.parentNode,
                  r = Array.from(n.children).find((e) => !e.hidden);
                if (G.transitions && !G.reducedMotion) {
                  (n.style.width = `${r.scrollWidth}px`),
                    (n.style.height = `${r.scrollHeight}px`);
                  const e = Te.getMenuSize.call(this, i),
                    t = (e) => {
                      e.target === n &&
                        ["width", "height"].includes(e.propertyName) &&
                        ((n.style.width = ""),
                        (n.style.height = ""),
                        X.call(this, n, P, t));
                    };
                  Y.call(this, n, P, t),
                    (n.style.width = `${e.width}px`),
                    (n.style.height = `${e.height}px`);
                }
                B(r, !0), B(i, !1), Te.focusFirstMenuItem.call(this, i, t);
              },
              setDownloadUrl() {
                const e = this.elements.buttons.download;
                A.element(e) && e.setAttribute("href", this.download);
              },
              create(e) {
                const {
                  bindMenuItemShortcuts: t,
                  createButton: i,
                  createProgress: n,
                  createRange: r,
                  createTime: o,
                  setQualityMenu: a,
                  setSpeedMenu: s,
                  showMenuPanel: l,
                } = Te;
                (this.elements.controls = null),
                  A.array(this.config.controls) &&
                    this.config.controls.includes("play-large") &&
                    this.elements.container.appendChild(
                      i.call(this, "play-large")
                    );
                const c = q("div", D(this.config.selectors.controls.wrapper));
                this.elements.controls = c;
                const u = { class: "plyr__controls__item" };
                return (
                  ne(
                    A.array(this.config.controls) ? this.config.controls : []
                  ).forEach((a) => {
                    if (
                      ("restart" === a &&
                        c.appendChild(i.call(this, "restart", u)),
                      "rewind" === a &&
                        c.appendChild(i.call(this, "rewind", u)),
                      "play" === a && c.appendChild(i.call(this, "play", u)),
                      "fast-forward" === a &&
                        c.appendChild(i.call(this, "fast-forward", u)),
                      "progress" === a)
                    ) {
                      const t = q("div", {
                          class: `${u.class} plyr__progress__container`,
                        }),
                        i = q("div", D(this.config.selectors.progress));
                      if (
                        (i.appendChild(
                          r.call(this, "seek", { id: `plyr-seek-${e.id}` })
                        ),
                        i.appendChild(n.call(this, "buffer")),
                        this.config.tooltips.seek)
                      ) {
                        const e = q(
                          "span",
                          { class: this.config.classNames.tooltip },
                          "00:00"
                        );
                        i.appendChild(e),
                          (this.elements.display.seekTooltip = e);
                      }
                      (this.elements.progress = i),
                        t.appendChild(this.elements.progress),
                        c.appendChild(t);
                    }
                    if (
                      ("current-time" === a &&
                        c.appendChild(o.call(this, "currentTime", u)),
                      "duration" === a &&
                        c.appendChild(o.call(this, "duration", u)),
                      "mute" === a || "volume" === a)
                    ) {
                      let { volume: t } = this.elements;
                      if (
                        ((A.element(t) && c.contains(t)) ||
                          ((t = q(
                            "div",
                            L({}, u, {
                              class: `${u.class} plyr__volume`.trim(),
                            })
                          )),
                          (this.elements.volume = t),
                          c.appendChild(t)),
                        "mute" === a && t.appendChild(i.call(this, "mute")),
                        "volume" === a && !C.isIos && !C.isIPadOS)
                      ) {
                        const i = {
                          max: 1,
                          step: 0.05,
                          value: this.config.volume,
                        };
                        t.appendChild(
                          r.call(
                            this,
                            "volume",
                            L(i, { id: `plyr-volume-${e.id}` })
                          )
                        );
                      }
                    }
                    if (
                      ("captions" === a &&
                        c.appendChild(i.call(this, "captions", u)),
                      "settings" === a && !A.empty(this.config.settings))
                    ) {
                      const n = q(
                        "div",
                        L({}, u, {
                          class: `${u.class} plyr__menu`.trim(),
                          hidden: "",
                        })
                      );
                      n.appendChild(
                        i.call(this, "settings", {
                          "aria-haspopup": !0,
                          "aria-controls": `plyr-settings-${e.id}`,
                          "aria-expanded": !1,
                        })
                      );
                      const r = q("div", {
                          class: "plyr__menu__container",
                          id: `plyr-settings-${e.id}`,
                          hidden: "",
                        }),
                        o = q("div"),
                        a = q("div", { id: `plyr-settings-${e.id}-home` }),
                        s = q("div", { role: "menu" });
                      a.appendChild(s),
                        o.appendChild(a),
                        (this.elements.settings.panels.home = a),
                        this.config.settings.forEach((i) => {
                          const n = q(
                            "button",
                            L(D(this.config.selectors.buttons.settings), {
                              type: "button",
                              class: `${this.config.classNames.control} ${this.config.classNames.control}--forward`,
                              role: "menuitem",
                              "aria-haspopup": !0,
                              hidden: "",
                            })
                          );
                          t.call(this, n, i),
                            Y.call(this, n, "click", () => {
                              l.call(this, i, !1);
                            });
                          const r = q("span", null, ve.get(i, this.config)),
                            a = q("span", {
                              class: this.config.classNames.menu.value,
                            });
                          (a.innerHTML = e[i]),
                            r.appendChild(a),
                            n.appendChild(r),
                            s.appendChild(n);
                          const c = q("div", {
                              id: `plyr-settings-${e.id}-${i}`,
                              hidden: "",
                            }),
                            u = q("button", {
                              type: "button",
                              class: `${this.config.classNames.control} ${this.config.classNames.control}--back`,
                            });
                          u.appendChild(
                            q(
                              "span",
                              { "aria-hidden": !0 },
                              ve.get(i, this.config)
                            )
                          ),
                            u.appendChild(
                              q(
                                "span",
                                { class: this.config.classNames.hidden },
                                ve.get("menuBack", this.config)
                              )
                            ),
                            Y.call(
                              this,
                              c,
                              "keydown",
                              (e) => {
                                "ArrowLeft" === e.key &&
                                  (e.preventDefault(),
                                  e.stopPropagation(),
                                  l.call(this, "home", !0));
                              },
                              !1
                            ),
                            Y.call(this, u, "click", () => {
                              l.call(this, "home", !1);
                            }),
                            c.appendChild(u),
                            c.appendChild(q("div", { role: "menu" })),
                            o.appendChild(c),
                            (this.elements.settings.buttons[i] = n),
                            (this.elements.settings.panels[i] = c);
                        }),
                        r.appendChild(o),
                        n.appendChild(r),
                        c.appendChild(n),
                        (this.elements.settings.popup = r),
                        (this.elements.settings.menu = n);
                    }
                    if (
                      ("pip" === a &&
                        G.pip &&
                        c.appendChild(i.call(this, "pip", u)),
                      "airplay" === a &&
                        G.airplay &&
                        c.appendChild(i.call(this, "airplay", u)),
                      "download" === a)
                    ) {
                      const e = L({}, u, {
                        element: "a",
                        href: this.download,
                        target: "_blank",
                      });
                      this.isHTML5 && (e.download = "");
                      const { download: t } = this.config.urls;
                      !A.url(t) &&
                        this.isEmbed &&
                        L(e, {
                          icon: `logo-${this.provider}`,
                          label: this.provider,
                        }),
                        c.appendChild(i.call(this, "download", e));
                    }
                    "fullscreen" === a &&
                      c.appendChild(i.call(this, "fullscreen", u));
                  }),
                  this.isHTML5 && a.call(this, he.getQualityOptions.call(this)),
                  s.call(this),
                  c
                );
              },
              inject() {
                if (this.config.loadSprite) {
                  const e = Te.getIconUrl.call(this);
                  e.cors && Se(e.url, "sprite-plyr");
                }
                this.id = Math.floor(1e4 * Math.random());
                let e = null;
                this.elements.controls = null;
                const t = {
                  id: this.id,
                  seektime: this.config.seekTime,
                  title: this.config.title,
                };
                let i,
                  n = !0;
                if (
                  (A.function(this.config.controls) &&
                    (this.config.controls = this.config.controls.call(this, t)),
                  this.config.controls || (this.config.controls = []),
                  A.element(this.config.controls) ||
                  A.string(this.config.controls)
                    ? (e = this.config.controls)
                    : ((e = Te.create.call(this, {
                        id: this.id,
                        seektime: this.config.seekTime,
                        speed: this.speed,
                        quality: this.quality,
                        captions: _e.getLabel.call(this),
                      })),
                      (n = !1)),
                  n &&
                    A.string(this.config.controls) &&
                    (e = ((e) => {
                      let i = e;
                      return (
                        Object.entries(t).forEach(([e, t]) => {
                          i = fe(i, `{${e}}`, t);
                        }),
                        i
                      );
                    })(e)),
                  A.string(this.config.selectors.controls.container) &&
                    (i = document.querySelector(
                      this.config.selectors.controls.container
                    )),
                  A.element(i) || (i = this.elements.container),
                  i[
                    A.element(e)
                      ? "insertAdjacentElement"
                      : "insertAdjacentHTML"
                  ]("afterbegin", e),
                  A.element(this.elements.controls) ||
                    Te.findElements.call(this),
                  !A.empty(this.elements.buttons))
                ) {
                  const e = (e) => {
                    const t = this.config.classNames.controlPressed;
                    e.setAttribute("aria-pressed", "false"),
                      Object.defineProperty(e, "pressed", {
                        configurable: !0,
                        enumerable: !0,
                        get: () => R(e, t),
                        set(i = !1) {
                          F(e, t, i),
                            e.setAttribute(
                              "aria-pressed",
                              i ? "true" : "false"
                            );
                        },
                      });
                  };
                  Object.values(this.elements.buttons)
                    .filter(Boolean)
                    .forEach((t) => {
                      A.array(t) || A.nodeList(t)
                        ? Array.from(t).filter(Boolean).forEach(e)
                        : e(t);
                    });
                }
                if ((C.isEdge && _(i), this.config.tooltips.controls)) {
                  const { classNames: e, selectors: t } = this.config,
                    i = `${t.controls.wrapper} ${t.labels} .${e.hidden}`,
                    n = U.call(this, i);
                  Array.from(n).forEach((e) => {
                    F(e, this.config.classNames.hidden, !1),
                      F(e, this.config.classNames.tooltip, !0);
                  });
                }
              },
              setMediaMetadata() {
                try {
                  "mediaSession" in navigator &&
                    (navigator.mediaSession.metadata = new window.MediaMetadata(
                      {
                        title: this.config.mediaMetadata.title,
                        artist: this.config.mediaMetadata.artist,
                        album: this.config.mediaMetadata.album,
                        artwork: this.config.mediaMetadata.artwork,
                      }
                    ));
                } catch (e) {}
              },
              setMarkers() {
                var e, t;
                if (!this.duration || this.elements.markers) return;
                const i =
                  null === (e = this.config.markers) ||
                  void 0 === e ||
                  null === (t = e.points) ||
                  void 0 === t
                    ? void 0
                    : t.filter(({ time: e }) => e > 0 && e < this.duration);
                if (null == i || !i.length) return;
                const n = document.createDocumentFragment(),
                  r = document.createDocumentFragment();
                let o = null;
                const a = `${this.config.classNames.tooltip}--visible`,
                  s = (e) => F(o, a, e);
                i.forEach((e) => {
                  const t = q(
                      "span",
                      { class: this.config.classNames.marker },
                      ""
                    ),
                    i = (e.time / this.duration) * 100 + "%";
                  o &&
                    (t.addEventListener("mouseenter", () => {
                      e.label ||
                        ((o.style.left = i), (o.innerHTML = e.label), s(!0));
                    }),
                    t.addEventListener("mouseleave", () => {
                      s(!1);
                    })),
                    t.addEventListener("click", () => {
                      this.currentTime = e.time;
                    }),
                    (t.style.left = i),
                    r.appendChild(t);
                }),
                  n.appendChild(r),
                  this.config.tooltips.seek ||
                    ((o = q(
                      "span",
                      { class: this.config.classNames.tooltip },
                      ""
                    )),
                    n.appendChild(o)),
                  (this.elements.markers = { points: r, tip: o }),
                  this.elements.progress.appendChild(n);
              },
            };
            function Ae(e, t = !0) {
              let i = e;
              if (t) {
                const e = document.createElement("a");
                (e.href = i), (i = e.href);
              }
              try {
                return new URL(i);
              } catch (e) {
                return null;
              }
            }
            function Pe(e) {
              const t = new URLSearchParams();
              return (
                A.object(e) &&
                  Object.entries(e).forEach(([e, i]) => {
                    t.set(e, i);
                  }),
                t
              );
            }
            const _e = {
                setup() {
                  if (!this.supported.ui) return;
                  if (
                    !this.isVideo ||
                    this.isYouTube ||
                    (this.isHTML5 && !G.textTracks)
                  )
                    return void (
                      A.array(this.config.controls) &&
                      this.config.controls.includes("settings") &&
                      this.config.settings.includes("captions") &&
                      Te.setCaptionsMenu.call(this)
                    );
                  var e, t;
                  if (
                    (A.element(this.elements.captions) ||
                      ((this.elements.captions = q(
                        "div",
                        D(this.config.selectors.captions)
                      )),
                      this.elements.captions.setAttribute("dir", "auto"),
                      (e = this.elements.captions),
                      (t = this.elements.wrapper),
                      A.element(e) &&
                        A.element(t) &&
                        t.parentNode.insertBefore(e, t.nextSibling)),
                    C.isIE && window.URL)
                  ) {
                    const e = this.media.querySelectorAll("track");
                    Array.from(e).forEach((e) => {
                      const t = e.getAttribute("src"),
                        i = Ae(t);
                      null !== i &&
                        i.hostname !== window.location.href.hostname &&
                        ["http:", "https:"].includes(i.protocol) &&
                        we(t, "blob")
                          .then((t) => {
                            e.setAttribute(
                              "src",
                              window.URL.createObjectURL(t)
                            );
                          })
                          .catch(() => {
                            N(e);
                          });
                    });
                  }
                  const i = ne(
                    (
                      navigator.languages || [
                        navigator.language || navigator.userLanguage || "en",
                      ]
                    ).map((e) => e.split("-")[0])
                  );
                  let n = (
                    this.storage.get("language") ||
                    this.config.captions.language ||
                    "auto"
                  ).toLowerCase();
                  "auto" === n && ([n] = i);
                  let r = this.storage.get("captions");
                  if (
                    (A.boolean(r) || ({ active: r } = this.config.captions),
                    Object.assign(this.captions, {
                      toggled: !1,
                      active: r,
                      language: n,
                      languages: i,
                    }),
                    this.isHTML5)
                  ) {
                    const e = this.config.captions.update
                      ? "addtrack removetrack"
                      : "removetrack";
                    Y.call(
                      this,
                      this.media.textTracks,
                      e,
                      _e.update.bind(this)
                    );
                  }
                  setTimeout(_e.update.bind(this), 0);
                },
                update() {
                  const e = _e.getTracks.call(this, !0),
                    {
                      active: t,
                      language: i,
                      meta: n,
                      currentTrackNode: r,
                    } = this.captions,
                    o = Boolean(e.find((e) => e.language === i));
                  this.isHTML5 &&
                    this.isVideo &&
                    e
                      .filter((e) => !n.get(e))
                      .forEach((e) => {
                        this.debug.log("Track added", e),
                          n.set(e, { default: "showing" === e.mode }),
                          "showing" === e.mode && (e.mode = "hidden"),
                          Y.call(this, e, "cuechange", () =>
                            _e.updateCues.call(this)
                          );
                      }),
                    ((o && this.language !== i) || !e.includes(r)) &&
                      (_e.setLanguage.call(this, i),
                      _e.toggle.call(this, t && o)),
                    this.elements &&
                      F(
                        this.elements.container,
                        this.config.classNames.captions.enabled,
                        !A.empty(e)
                      ),
                    A.array(this.config.controls) &&
                      this.config.controls.includes("settings") &&
                      this.config.settings.includes("captions") &&
                      Te.setCaptionsMenu.call(this);
                },
                toggle(e, t = !0) {
                  if (!this.supported.ui) return;
                  const { toggled: i } = this.captions,
                    n = this.config.classNames.captions.active,
                    r = A.nullOrUndefined(e) ? !i : e;
                  if (r !== i) {
                    if (
                      (t ||
                        ((this.captions.active = r),
                        this.storage.set({ captions: r })),
                      !this.language && r && !t)
                    ) {
                      const e = _e.getTracks.call(this),
                        t = _e.findTrack.call(
                          this,
                          [this.captions.language, ...this.captions.languages],
                          !0
                        );
                      return (
                        (this.captions.language = t.language),
                        void _e.set.call(this, e.indexOf(t))
                      );
                    }
                    this.elements.buttons.captions &&
                      (this.elements.buttons.captions.pressed = r),
                      F(this.elements.container, n, r),
                      (this.captions.toggled = r),
                      Te.updateSetting.call(this, "captions"),
                      Z.call(
                        this,
                        this.media,
                        r ? "captionsenabled" : "captionsdisabled"
                      );
                  }
                  setTimeout(() => {
                    r &&
                      this.captions.toggled &&
                      (this.captions.currentTrackNode.mode = "hidden");
                  });
                },
                set(e, t = !0) {
                  const i = _e.getTracks.call(this);
                  if (-1 !== e)
                    if (A.number(e))
                      if (e in i) {
                        if (this.captions.currentTrack !== e) {
                          this.captions.currentTrack = e;
                          const n = i[e],
                            { language: r } = n || {};
                          (this.captions.currentTrackNode = n),
                            Te.updateSetting.call(this, "captions"),
                            t ||
                              ((this.captions.language = r),
                              this.storage.set({ language: r })),
                            this.isVimeo && this.embed.enableTextTrack(r),
                            Z.call(this, this.media, "languagechange");
                        }
                        _e.toggle.call(this, !0, t),
                          this.isHTML5 &&
                            this.isVideo &&
                            _e.updateCues.call(this);
                      } else this.debug.warn("Track not found", e);
                    else this.debug.warn("Invalid caption argument", e);
                  else _e.toggle.call(this, !1, t);
                },
                setLanguage(e, t = !0) {
                  if (!A.string(e))
                    return void this.debug.warn("Invalid language argument", e);
                  const i = e.toLowerCase();
                  this.captions.language = i;
                  const n = _e.getTracks.call(this),
                    r = _e.findTrack.call(this, [i]);
                  _e.set.call(this, n.indexOf(r), t);
                },
                getTracks(e = !1) {
                  return Array.from((this.media || {}).textTracks || [])
                    .filter(
                      (t) => !this.isHTML5 || e || this.captions.meta.has(t)
                    )
                    .filter((e) => ["captions", "subtitles"].includes(e.kind));
                },
                findTrack(e, t = !1) {
                  const i = _e.getTracks.call(this),
                    n = (e) =>
                      Number((this.captions.meta.get(e) || {}).default),
                    r = Array.from(i).sort((e, t) => n(t) - n(e));
                  let o;
                  return (
                    e.every((e) => ((o = r.find((t) => t.language === e)), !o)),
                    o || (t ? r[0] : void 0)
                  );
                },
                getCurrentTrack() {
                  return _e.getTracks.call(this)[this.currentTrack];
                },
                getLabel(e) {
                  let t = e;
                  return (
                    !A.track(t) &&
                      G.textTracks &&
                      this.captions.toggled &&
                      (t = _e.getCurrentTrack.call(this)),
                    A.track(t)
                      ? A.empty(t.label)
                        ? A.empty(t.language)
                          ? ve.get("enabled", this.config)
                          : e.language.toUpperCase()
                        : t.label
                      : ve.get("disabled", this.config)
                  );
                },
                updateCues(e) {
                  if (!this.supported.ui) return;
                  if (!A.element(this.elements.captions))
                    return void this.debug.warn(
                      "No captions element to render to"
                    );
                  if (!A.nullOrUndefined(e) && !Array.isArray(e))
                    return void this.debug.warn("updateCues: Invalid input", e);
                  let t = e;
                  if (!t) {
                    const e = _e.getCurrentTrack.call(this);
                    t = Array.from((e || {}).activeCues || [])
                      .map((e) => e.getCueAsHTML())
                      .map(ge);
                  }
                  const i = t.map((e) => e.trim()).join("\n");
                  if (i !== this.elements.captions.innerHTML) {
                    j(this.elements.captions);
                    const e = q("span", D(this.config.selectors.caption));
                    (e.innerHTML = i),
                      this.elements.captions.appendChild(e),
                      Z.call(this, this.media, "cuechange");
                  }
                },
              },
              Ce = {
                enabled: !0,
                title: "",
                debug: !1,
                autoplay: !1,
                autopause: !0,
                playsinline: !0,
                seekTime: 10,
                volume: 1,
                muted: !1,
                duration: null,
                displayDuration: !0,
                invertTime: !0,
                toggleInvert: !0,
                ratio: null,
                clickToPlay: !0,
                hideControls: !0,
                resetOnEnd: !1,
                disableContextMenu: !0,
                loadSprite: !0,
                iconPrefix: "plyr",
                iconUrl: "https://cdn.plyr.io/3.7.8/plyr.svg",
                blankVideo: "https://cdn.plyr.io/static/blank.mp4",
                quality: {
                  default: 576,
                  options: [
                    4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240,
                  ],
                  forced: !1,
                  onChange: null,
                },
                loop: { active: !1 },
                speed: {
                  selected: 1,
                  options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 4],
                },
                keyboard: { focused: !0, global: !1 },
                tooltips: { controls: !1, seek: !0 },
                captions: { active: !1, language: "auto", update: !1 },
                fullscreen: { enabled: !0, fallback: !0, iosNative: !1 },
                storage: { enabled: !0, key: "plyr" },
                controls: [
                  "play-large",
                  "play",
                  "progress",
                  "current-time",
                  "mute",
                  "volume",
                  "captions",
                  "settings",
                  "pip",
                  "airplay",
                  "fullscreen",
                ],
                settings: ["captions", "quality", "speed"],
                i18n: {
                  restart: "Restart",
                  rewind: "Rewind {seektime}s",
                  play: "Play",
                  pause: "Pause",
                  fastForward: "Forward {seektime}s",
                  seek: "Seek",
                  seekLabel: "{currentTime} of {duration}",
                  played: "Played",
                  buffered: "Buffered",
                  currentTime: "Current time",
                  duration: "Duration",
                  volume: "Volume",
                  mute: "Mute",
                  unmute: "Unmute",
                  enableCaptions: "Enable captions",
                  disableCaptions: "Disable captions",
                  download: "Download",
                  enterFullscreen: "Enter fullscreen",
                  exitFullscreen: "Exit fullscreen",
                  frameTitle: "Player for {title}",
                  captions: "Captions",
                  settings: "Settings",
                  pip: "PIP",
                  menuBack: "Go back to previous menu",
                  speed: "Speed",
                  normal: "Normal",
                  quality: "Quality",
                  loop: "Loop",
                  start: "Start",
                  end: "End",
                  all: "All",
                  reset: "Reset",
                  disabled: "Disabled",
                  enabled: "Enabled",
                  advertisement: "Ad",
                  qualityBadge: {
                    2160: "4K",
                    1440: "HD",
                    1080: "HD",
                    720: "HD",
                    576: "SD",
                    480: "SD",
                  },
                },
                urls: {
                  download: null,
                  vimeo: {
                    sdk: "https://player.vimeo.com/api/player.js",
                    iframe: "https://player.vimeo.com/video/{0}?{1}",
                    api: "https://vimeo.com/api/oembed.json?url={0}",
                  },
                  youtube: {
                    sdk: "https://www.youtube.com/iframe_api",
                    api: "https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}",
                  },
                  googleIMA: {
                    sdk: "https://imasdk.googleapis.com/js/sdkloader/ima3.js",
                  },
                },
                listeners: {
                  seek: null,
                  play: null,
                  pause: null,
                  restart: null,
                  rewind: null,
                  fastForward: null,
                  mute: null,
                  volume: null,
                  captions: null,
                  download: null,
                  fullscreen: null,
                  pip: null,
                  airplay: null,
                  speed: null,
                  quality: null,
                  loop: null,
                  language: null,
                },
                events: [
                  "ended",
                  "progress",
                  "stalled",
                  "playing",
                  "waiting",
                  "canplay",
                  "canplaythrough",
                  "loadstart",
                  "loadeddata",
                  "loadedmetadata",
                  "timeupdate",
                  "volumechange",
                  "play",
                  "pause",
                  "error",
                  "seeking",
                  "seeked",
                  "emptied",
                  "ratechange",
                  "cuechange",
                  "download",
                  "enterfullscreen",
                  "exitfullscreen",
                  "captionsenabled",
                  "captionsdisabled",
                  "languagechange",
                  "controlshidden",
                  "controlsshown",
                  "ready",
                  "statechange",
                  "qualitychange",
                  "adsloaded",
                  "adscontentpause",
                  "adscontentresume",
                  "adstarted",
                  "adsmidpoint",
                  "adscomplete",
                  "adsallcomplete",
                  "adsimpression",
                  "adsclick",
                ],
                selectors: {
                  editable: "input, textarea, select, [contenteditable]",
                  container: ".plyr",
                  controls: { container: null, wrapper: ".plyr__controls" },
                  labels: "[data-plyr]",
                  buttons: {
                    play: '[data-plyr="play"]',
                    pause: '[data-plyr="pause"]',
                    restart: '[data-plyr="restart"]',
                    rewind: '[data-plyr="rewind"]',
                    fastForward: '[data-plyr="fast-forward"]',
                    mute: '[data-plyr="mute"]',
                    captions: '[data-plyr="captions"]',
                    download: '[data-plyr="download"]',
                    fullscreen: '[data-plyr="fullscreen"]',
                    pip: '[data-plyr="pip"]',
                    airplay: '[data-plyr="airplay"]',
                    settings: '[data-plyr="settings"]',
                    loop: '[data-plyr="loop"]',
                  },
                  inputs: {
                    seek: '[data-plyr="seek"]',
                    volume: '[data-plyr="volume"]',
                    speed: '[data-plyr="speed"]',
                    language: '[data-plyr="language"]',
                    quality: '[data-plyr="quality"]',
                  },
                  display: {
                    currentTime: ".plyr__time--current",
                    duration: ".plyr__time--duration",
                    buffer: ".plyr__progress__buffer",
                    loop: ".plyr__progress__loop",
                    volume: ".plyr__volume--display",
                  },
                  progress: ".plyr__progress",
                  captions: ".plyr__captions",
                  caption: ".plyr__caption",
                },
                classNames: {
                  type: "plyr--{0}",
                  provider: "plyr--{0}",
                  video: "plyr__video-wrapper",
                  embed: "plyr__video-embed",
                  videoFixedRatio: "plyr__video-wrapper--fixed-ratio",
                  embedContainer: "plyr__video-embed__container",
                  poster: "plyr__poster",
                  posterEnabled: "plyr__poster-enabled",
                  ads: "plyr__ads",
                  control: "plyr__control",
                  controlPressed: "plyr__control--pressed",
                  playing: "plyr--playing",
                  paused: "plyr--paused",
                  stopped: "plyr--stopped",
                  loading: "plyr--loading",
                  hover: "plyr--hover",
                  tooltip: "plyr__tooltip",
                  cues: "plyr__cues",
                  marker: "plyr__progress__marker",
                  hidden: "plyr__sr-only",
                  hideControls: "plyr--hide-controls",
                  isTouch: "plyr--is-touch",
                  uiSupported: "plyr--full-ui",
                  noTransition: "plyr--no-transition",
                  display: { time: "plyr__time" },
                  menu: {
                    value: "plyr__menu__value",
                    badge: "plyr__badge",
                    open: "plyr--menu-open",
                  },
                  captions: {
                    enabled: "plyr--captions-enabled",
                    active: "plyr--captions-active",
                  },
                  fullscreen: {
                    enabled: "plyr--fullscreen-enabled",
                    fallback: "plyr--fullscreen-fallback",
                  },
                  pip: {
                    supported: "plyr--pip-supported",
                    active: "plyr--pip-active",
                  },
                  airplay: {
                    supported: "plyr--airplay-supported",
                    active: "plyr--airplay-active",
                  },
                  previewThumbnails: {
                    thumbContainer: "plyr__preview-thumb",
                    thumbContainerShown: "plyr__preview-thumb--is-shown",
                    imageContainer: "plyr__preview-thumb__image-container",
                    timeContainer: "plyr__preview-thumb__time-container",
                    scrubbingContainer: "plyr__preview-scrubbing",
                    scrubbingContainerShown:
                      "plyr__preview-scrubbing--is-shown",
                  },
                },
                attributes: {
                  embed: {
                    provider: "data-plyr-provider",
                    id: "data-plyr-embed-id",
                    hash: "data-plyr-embed-hash",
                  },
                },
                ads: { enabled: !1, publisherId: "", tagUrl: "" },
                previewThumbnails: { enabled: !1, src: "" },
                vimeo: {
                  byline: !1,
                  portrait: !1,
                  title: !1,
                  speed: !0,
                  transparent: !1,
                  customControls: !0,
                  referrerPolicy: null,
                  premium: !1,
                },
                youtube: {
                  rel: 0,
                  showinfo: 0,
                  iv_load_policy: 3,
                  modestbranding: 1,
                  customControls: !0,
                  noCookie: !1,
                },
                mediaMetadata: {
                  title: "",
                  artist: "",
                  album: "",
                  artwork: [],
                },
                markers: { enabled: !1, points: [] },
              },
              xe = "picture-in-picture",
              Le = { html5: "html5", youtube: "youtube", vimeo: "vimeo" },
              Ie = "video",
              Oe = () => {};
            class qe {
              constructor(e = !1) {
                (this.enabled = window.console && e),
                  this.enabled && this.log("Debugging enabled");
              }
              get log() {
                return this.enabled
                  ? Function.prototype.bind.call(console.log, console)
                  : Oe;
              }
              get warn() {
                return this.enabled
                  ? Function.prototype.bind.call(console.warn, console)
                  : Oe;
              }
              get error() {
                return this.enabled
                  ? Function.prototype.bind.call(console.error, console)
                  : Oe;
              }
            }
            class Me {
              constructor(t) {
                e(this, "onChange", () => {
                  if (!this.supported) return;
                  const e = this.player.elements.buttons.fullscreen;
                  A.element(e) && (e.pressed = this.active);
                  const t =
                    this.target === this.player.media
                      ? this.target
                      : this.player.elements.container;
                  Z.call(
                    this.player,
                    t,
                    this.active ? "enterfullscreen" : "exitfullscreen",
                    !0
                  );
                }),
                  e(this, "toggleFallback", (e = !1) => {
                    if (
                      (e
                        ? (this.scrollPosition = {
                            x: window.scrollX ?? 0,
                            y: window.scrollY ?? 0,
                          })
                        : window.scrollTo(
                            this.scrollPosition.x,
                            this.scrollPosition.y
                          ),
                      (document.body.style.overflow = e ? "hidden" : ""),
                      F(
                        this.target,
                        this.player.config.classNames.fullscreen.fallback,
                        e
                      ),
                      C.isIos)
                    ) {
                      let t = document.head.querySelector(
                        'meta[name="viewport"]'
                      );
                      const i = "viewport-fit=cover";
                      t ||
                        ((t = document.createElement("meta")),
                        t.setAttribute("name", "viewport"));
                      const n = A.string(t.content) && t.content.includes(i);
                      e
                        ? ((this.cleanupViewport = !n),
                          n || (t.content += `,${i}`))
                        : this.cleanupViewport &&
                          (t.content = t.content
                            .split(",")
                            .filter((e) => e.trim() !== i)
                            .join(","));
                    }
                    this.onChange();
                  }),
                  e(this, "trapFocus", (e) => {
                    if (
                      C.isIos ||
                      C.isIPadOS ||
                      !this.active ||
                      "Tab" !== e.key
                    )
                      return;
                    const t = document.activeElement,
                      i = U.call(
                        this.player,
                        "a[href], button:not(:disabled), input:not(:disabled), [tabindex]"
                      ),
                      [n] = i,
                      r = i[i.length - 1];
                    t !== r || e.shiftKey
                      ? t === n && e.shiftKey && (r.focus(), e.preventDefault())
                      : (n.focus(), e.preventDefault());
                  }),
                  e(this, "update", () => {
                    if (this.supported) {
                      let e;
                      (e = this.forceFallback
                        ? "Fallback (forced)"
                        : Me.nativeSupported
                        ? "Native"
                        : "Fallback"),
                        this.player.debug.log(`${e} fullscreen enabled`);
                    } else
                      this.player.debug.log(
                        "Fullscreen not supported and fallback disabled"
                      );
                    F(
                      this.player.elements.container,
                      this.player.config.classNames.fullscreen.enabled,
                      this.supported
                    );
                  }),
                  e(this, "enter", () => {
                    this.supported &&
                      (C.isIos && this.player.config.fullscreen.iosNative
                        ? this.player.isVimeo
                          ? this.player.embed.requestFullscreen()
                          : this.target.webkitEnterFullscreen()
                        : !Me.nativeSupported || this.forceFallback
                        ? this.toggleFallback(!0)
                        : this.prefix
                        ? A.empty(this.prefix) ||
                          this.target[`${this.prefix}Request${this.property}`]()
                        : this.target.requestFullscreen({
                            navigationUI: "hide",
                          }));
                  }),
                  e(this, "exit", () => {
                    if (this.supported)
                      if (C.isIos && this.player.config.fullscreen.iosNative)
                        this.player.isVimeo
                          ? this.player.embed.exitFullscreen()
                          : this.target.webkitEnterFullscreen(),
                          ie(this.player.play());
                      else if (!Me.nativeSupported || this.forceFallback)
                        this.toggleFallback(!1);
                      else if (this.prefix) {
                        if (!A.empty(this.prefix)) {
                          const e = "moz" === this.prefix ? "Cancel" : "Exit";
                          document[`${this.prefix}${e}${this.property}`]();
                        }
                      } else
                        (
                          document.cancelFullScreen || document.exitFullscreen
                        ).call(document);
                  }),
                  e(this, "toggle", () => {
                    this.active ? this.exit() : this.enter();
                  }),
                  (this.player = t),
                  (this.prefix = Me.prefix),
                  (this.property = Me.property),
                  (this.scrollPosition = { x: 0, y: 0 }),
                  (this.forceFallback =
                    "force" === t.config.fullscreen.fallback),
                  (this.player.elements.fullscreen =
                    t.config.fullscreen.container &&
                    (function (e, t) {
                      const { prototype: i } = Element;
                      return (
                        i.closest ||
                        function () {
                          let e = this;
                          do {
                            if (H.matches(e, t)) return e;
                            e = e.parentElement || e.parentNode;
                          } while (null !== e && 1 === e.nodeType);
                          return null;
                        }
                      ).call(e, t);
                    })(
                      this.player.elements.container,
                      t.config.fullscreen.container
                    )),
                  Y.call(
                    this.player,
                    document,
                    "ms" === this.prefix
                      ? "MSFullscreenChange"
                      : `${this.prefix}fullscreenchange`,
                    () => {
                      this.onChange();
                    }
                  ),
                  Y.call(
                    this.player,
                    this.player.elements.container,
                    "dblclick",
                    (e) => {
                      (A.element(this.player.elements.controls) &&
                        this.player.elements.controls.contains(e.target)) ||
                        this.player.listeners.proxy(
                          e,
                          this.toggle,
                          "fullscreen"
                        );
                    }
                  ),
                  Y.call(this, this.player.elements.container, "keydown", (e) =>
                    this.trapFocus(e)
                  ),
                  this.update();
              }
              static get nativeSupported() {
                return !!(
                  document.fullscreenEnabled ||
                  document.webkitFullscreenEnabled ||
                  document.mozFullScreenEnabled ||
                  document.msFullscreenEnabled
                );
              }
              get useNative() {
                return Me.nativeSupported && !this.forceFallback;
              }
              static get prefix() {
                if (A.function(document.exitFullscreen)) return "";
                let e = "";
                return (
                  ["webkit", "moz", "ms"].some(
                    (t) =>
                      !(
                        (!A.function(document[`${t}ExitFullscreen`]) &&
                          !A.function(document[`${t}CancelFullScreen`])) ||
                        ((e = t), 0)
                      )
                  ),
                  e
                );
              }
              static get property() {
                return "moz" === this.prefix ? "FullScreen" : "Fullscreen";
              }
              get supported() {
                return [
                  this.player.config.fullscreen.enabled,
                  this.player.isVideo,
                  Me.nativeSupported || this.player.config.fullscreen.fallback,
                  !this.player.isYouTube ||
                    Me.nativeSupported ||
                    !C.isIos ||
                    (this.player.config.playsinline &&
                      !this.player.config.fullscreen.iosNative),
                ].every(Boolean);
              }
              get active() {
                if (!this.supported) return !1;
                if (!Me.nativeSupported || this.forceFallback)
                  return R(
                    this.target,
                    this.player.config.classNames.fullscreen.fallback
                  );
                const e = this.prefix
                  ? this.target.getRootNode()[
                      `${this.prefix}${this.property}Element`
                    ]
                  : this.target.getRootNode().fullscreenElement;
                return e && e.shadowRoot
                  ? e === this.target.getRootNode().host
                  : e === this.target;
              }
              get target() {
                return C.isIos && this.player.config.fullscreen.iosNative
                  ? this.player.media
                  : this.player.elements.fullscreen ??
                      this.player.elements.container;
              }
            }
            function Ne(e, t = 1) {
              return new Promise((i, n) => {
                const r = new Image(),
                  o = () => {
                    delete r.onload,
                      delete r.onerror,
                      (r.naturalWidth >= t ? i : n)(r);
                  };
                Object.assign(r, { onload: o, onerror: o, src: e });
              });
            }
            const je = {
              addStyleHook() {
                F(
                  this.elements.container,
                  this.config.selectors.container.replace(".", ""),
                  !0
                ),
                  F(
                    this.elements.container,
                    this.config.classNames.uiSupported,
                    this.supported.ui
                  );
              },
              toggleNativeControls(e = !1) {
                e && this.isHTML5
                  ? this.media.setAttribute("controls", "")
                  : this.media.removeAttribute("controls");
              },
              build() {
                if ((this.listeners.media(), !this.supported.ui))
                  return (
                    this.debug.warn(
                      `Basic support only for ${this.provider} ${this.type}`
                    ),
                    void je.toggleNativeControls.call(this, !0)
                  );
                A.element(this.elements.controls) ||
                  (Te.inject.call(this), this.listeners.controls()),
                  je.toggleNativeControls.call(this),
                  this.isHTML5 && _e.setup.call(this),
                  (this.volume = null),
                  (this.muted = null),
                  (this.loop = null),
                  (this.quality = null),
                  (this.speed = null),
                  Te.updateVolume.call(this),
                  Te.timeUpdate.call(this),
                  Te.durationUpdate.call(this),
                  je.checkPlaying.call(this),
                  F(
                    this.elements.container,
                    this.config.classNames.pip.supported,
                    G.pip && this.isHTML5 && this.isVideo
                  ),
                  F(
                    this.elements.container,
                    this.config.classNames.airplay.supported,
                    G.airplay && this.isHTML5
                  ),
                  F(
                    this.elements.container,
                    this.config.classNames.isTouch,
                    this.touch
                  ),
                  (this.ready = !0),
                  setTimeout(() => {
                    Z.call(this, this.media, "ready");
                  }, 0),
                  je.setTitle.call(this),
                  this.poster &&
                    je.setPoster.call(this, this.poster, !1).catch(() => {}),
                  this.config.duration && Te.durationUpdate.call(this),
                  this.config.mediaMetadata && Te.setMediaMetadata.call(this);
              },
              setTitle() {
                let e = ve.get("play", this.config);
                if (
                  (A.string(this.config.title) &&
                    !A.empty(this.config.title) &&
                    (e += `, ${this.config.title}`),
                  Array.from(this.elements.buttons.play || []).forEach((t) => {
                    t.setAttribute("aria-label", e);
                  }),
                  this.isEmbed)
                ) {
                  const e = $.call(this, "iframe");
                  if (!A.element(e)) return;
                  const t = A.empty(this.config.title)
                      ? "video"
                      : this.config.title,
                    i = ve.get("frameTitle", this.config);
                  e.setAttribute("title", i.replace("{title}", t));
                }
              },
              togglePoster(e) {
                F(
                  this.elements.container,
                  this.config.classNames.posterEnabled,
                  e
                );
              },
              setPoster(e, t = !0) {
                return t && this.poster
                  ? Promise.reject(new Error("Poster already set"))
                  : (this.media.setAttribute("data-poster", e),
                    this.elements.poster.removeAttribute("hidden"),
                    te
                      .call(this)
                      .then(() => Ne(e))
                      .catch((t) => {
                        throw (
                          (e === this.poster && je.togglePoster.call(this, !1),
                          t)
                        );
                      })
                      .then(() => {
                        if (e !== this.poster)
                          throw new Error(
                            "setPoster cancelled by later call to setPoster"
                          );
                      })
                      .then(
                        () => (
                          Object.assign(this.elements.poster.style, {
                            backgroundImage: `url('${e}')`,
                            backgroundSize: "",
                          }),
                          je.togglePoster.call(this, !0),
                          e
                        )
                      ));
              },
              checkPlaying(e) {
                F(
                  this.elements.container,
                  this.config.classNames.playing,
                  this.playing
                ),
                  F(
                    this.elements.container,
                    this.config.classNames.paused,
                    this.paused
                  ),
                  F(
                    this.elements.container,
                    this.config.classNames.stopped,
                    this.stopped
                  ),
                  Array.from(this.elements.buttons.play || []).forEach((e) => {
                    Object.assign(e, { pressed: this.playing }),
                      e.setAttribute(
                        "aria-label",
                        ve.get(this.playing ? "pause" : "play", this.config)
                      );
                  }),
                  (A.event(e) && "timeupdate" === e.type) ||
                    je.toggleControls.call(this);
              },
              checkLoading(e) {
                (this.loading = ["stalled", "waiting"].includes(e.type)),
                  clearTimeout(this.timers.loading),
                  (this.timers.loading = setTimeout(
                    () => {
                      F(
                        this.elements.container,
                        this.config.classNames.loading,
                        this.loading
                      ),
                        je.toggleControls.call(this);
                    },
                    this.loading ? 250 : 0
                  ));
              },
              toggleControls(e) {
                const { controls: t } = this.elements;
                if (t && this.config.hideControls) {
                  const i = this.touch && this.lastSeekTime + 2e3 > Date.now();
                  this.toggleControls(
                    Boolean(
                      e ||
                        this.loading ||
                        this.paused ||
                        t.pressed ||
                        t.hover ||
                        i
                    )
                  );
                }
              },
              migrateStyles() {
                Object.values({ ...this.media.style })
                  .filter(
                    (e) => !A.empty(e) && A.string(e) && e.startsWith("--plyr")
                  )
                  .forEach((e) => {
                    this.elements.container.style.setProperty(
                      e,
                      this.media.style.getPropertyValue(e)
                    ),
                      this.media.style.removeProperty(e);
                  }),
                  A.empty(this.media.style) &&
                    this.media.removeAttribute("style");
              },
            };
            class Ve {
              constructor(t) {
                e(this, "firstTouch", () => {
                  const { player: e } = this,
                    { elements: t } = e;
                  (e.touch = !0),
                    F(t.container, e.config.classNames.isTouch, !0);
                }),
                  e(this, "global", (e = !0) => {
                    const { player: t } = this;
                    t.config.keyboard.global &&
                      K.call(t, window, "keydown keyup", this.handleKey, e, !1),
                      K.call(t, document.body, "click", this.toggleMenu, e),
                      J.call(t, document.body, "touchstart", this.firstTouch);
                  }),
                  e(this, "container", () => {
                    const { player: e } = this,
                      { config: t, elements: i, timers: n } = e;
                    !t.keyboard.global &&
                      t.keyboard.focused &&
                      Y.call(
                        e,
                        i.container,
                        "keydown keyup",
                        this.handleKey,
                        !1
                      ),
                      Y.call(
                        e,
                        i.container,
                        "mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen",
                        (t) => {
                          const { controls: r } = i;
                          r &&
                            "enterfullscreen" === t.type &&
                            ((r.pressed = !1), (r.hover = !1));
                          let o = 0;
                          ["touchstart", "touchmove", "mousemove"].includes(
                            t.type
                          ) &&
                            (je.toggleControls.call(e, !0),
                            (o = e.touch ? 3e3 : 2e3)),
                            clearTimeout(n.controls),
                            (n.controls = setTimeout(
                              () => je.toggleControls.call(e, !1),
                              o
                            ));
                        }
                      );
                    const r = () => {
                        if (!e.isVimeo || e.config.vimeo.premium) return;
                        const t = i.wrapper,
                          { active: n } = e.fullscreen,
                          [r, o] = ce.call(e),
                          a = oe(`aspect-ratio: ${r} / ${o}`);
                        if (!n)
                          return void (a
                            ? ((t.style.width = null), (t.style.height = null))
                            : ((t.style.maxWidth = null),
                              (t.style.margin = null)));
                        const [s, l] = [
                            Math.max(
                              document.documentElement.clientWidth || 0,
                              window.innerWidth || 0
                            ),
                            Math.max(
                              document.documentElement.clientHeight || 0,
                              window.innerHeight || 0
                            ),
                          ],
                          c = s / l > r / o;
                        a
                          ? ((t.style.width = c ? "auto" : "100%"),
                            (t.style.height = c ? "100%" : "auto"))
                          : ((t.style.maxWidth = c ? (l / o) * r + "px" : null),
                            (t.style.margin = c ? "0 auto" : null));
                      },
                      o = () => {
                        clearTimeout(n.resized),
                          (n.resized = setTimeout(r, 50));
                      };
                    Y.call(
                      e,
                      i.container,
                      "enterfullscreen exitfullscreen",
                      (t) => {
                        const { target: n } = e.fullscreen;
                        n === i.container &&
                          ((!e.isEmbed && A.empty(e.config.ratio)) ||
                            (r(),
                            ("enterfullscreen" === t.type ? Y : X).call(
                              e,
                              window,
                              "resize",
                              o
                            )));
                      }
                    );
                  }),
                  e(this, "media", () => {
                    const { player: e } = this,
                      { elements: t } = e;
                    if (
                      (Y.call(e, e.media, "timeupdate seeking seeked", (t) =>
                        Te.timeUpdate.call(e, t)
                      ),
                      Y.call(
                        e,
                        e.media,
                        "durationchange loadeddata loadedmetadata",
                        (t) => Te.durationUpdate.call(e, t)
                      ),
                      Y.call(e, e.media, "ended", () => {
                        e.isHTML5 &&
                          e.isVideo &&
                          e.config.resetOnEnd &&
                          (e.restart(), e.pause());
                      }),
                      Y.call(
                        e,
                        e.media,
                        "progress playing seeking seeked",
                        (t) => Te.updateProgress.call(e, t)
                      ),
                      Y.call(e, e.media, "volumechange", (t) =>
                        Te.updateVolume.call(e, t)
                      ),
                      Y.call(
                        e,
                        e.media,
                        "playing play pause ended emptied timeupdate",
                        (t) => je.checkPlaying.call(e, t)
                      ),
                      Y.call(
                        e,
                        e.media,
                        "waiting canplay seeked playing",
                        (t) => je.checkLoading.call(e, t)
                      ),
                      e.supported.ui && e.config.clickToPlay && !e.isAudio)
                    ) {
                      const i = $.call(e, `.${e.config.classNames.video}`);
                      if (!A.element(i)) return;
                      Y.call(e, t.container, "click", (n) => {
                        ([t.container, i].includes(n.target) ||
                          i.contains(n.target)) &&
                          ((e.touch && e.config.hideControls) ||
                            (e.ended
                              ? (this.proxy(n, e.restart, "restart"),
                                this.proxy(
                                  n,
                                  () => {
                                    ie(e.play());
                                  },
                                  "play"
                                ))
                              : this.proxy(
                                  n,
                                  () => {
                                    ie(e.togglePlay());
                                  },
                                  "play"
                                )));
                      });
                    }
                    e.supported.ui &&
                      e.config.disableContextMenu &&
                      Y.call(
                        e,
                        t.wrapper,
                        "contextmenu",
                        (e) => {
                          e.preventDefault();
                        },
                        !1
                      ),
                      Y.call(e, e.media, "volumechange", () => {
                        e.storage.set({ volume: e.volume, muted: e.muted });
                      }),
                      Y.call(e, e.media, "ratechange", () => {
                        Te.updateSetting.call(e, "speed"),
                          e.storage.set({ speed: e.speed });
                      }),
                      Y.call(e, e.media, "qualitychange", (t) => {
                        Te.updateSetting.call(
                          e,
                          "quality",
                          null,
                          t.detail.quality
                        );
                      }),
                      Y.call(e, e.media, "ready qualitychange", () => {
                        Te.setDownloadUrl.call(e);
                      });
                    const i = e.config.events
                      .concat(["keyup", "keydown"])
                      .join(" ");
                    Y.call(e, e.media, i, (i) => {
                      let { detail: n = {} } = i;
                      "error" === i.type && (n = e.media.error),
                        Z.call(e, t.container, i.type, !0, n);
                    });
                  }),
                  e(this, "proxy", (e, t, i) => {
                    const { player: n } = this,
                      r = n.config.listeners[i];
                    let o = !0;
                    A.function(r) && (o = r.call(n, e)),
                      !1 !== o && A.function(t) && t.call(n, e);
                  }),
                  e(this, "bind", (e, t, i, n, r = !0) => {
                    const { player: o } = this,
                      a = o.config.listeners[n],
                      s = A.function(a);
                    Y.call(o, e, t, (e) => this.proxy(e, i, n), r && !s);
                  }),
                  e(this, "controls", () => {
                    const { player: e } = this,
                      { elements: t } = e,
                      i = C.isIE ? "change" : "input";
                    if (
                      (t.buttons.play &&
                        Array.from(t.buttons.play).forEach((t) => {
                          this.bind(
                            t,
                            "click",
                            () => {
                              ie(e.togglePlay());
                            },
                            "play"
                          );
                        }),
                      this.bind(
                        t.buttons.restart,
                        "click",
                        e.restart,
                        "restart"
                      ),
                      this.bind(
                        t.buttons.rewind,
                        "click",
                        () => {
                          (e.lastSeekTime = Date.now()), e.rewind();
                        },
                        "rewind"
                      ),
                      this.bind(
                        t.buttons.fastForward,
                        "click",
                        () => {
                          (e.lastSeekTime = Date.now()), e.forward();
                        },
                        "fastForward"
                      ),
                      this.bind(
                        t.buttons.mute,
                        "click",
                        () => {
                          e.muted = !e.muted;
                        },
                        "mute"
                      ),
                      this.bind(t.buttons.captions, "click", () =>
                        e.toggleCaptions()
                      ),
                      this.bind(
                        t.buttons.download,
                        "click",
                        () => {
                          Z.call(e, e.media, "download");
                        },
                        "download"
                      ),
                      this.bind(
                        t.buttons.fullscreen,
                        "click",
                        () => {
                          e.fullscreen.toggle();
                        },
                        "fullscreen"
                      ),
                      this.bind(
                        t.buttons.pip,
                        "click",
                        () => {
                          e.pip = "toggle";
                        },
                        "pip"
                      ),
                      this.bind(
                        t.buttons.airplay,
                        "click",
                        e.airplay,
                        "airplay"
                      ),
                      this.bind(
                        t.buttons.settings,
                        "click",
                        (t) => {
                          t.stopPropagation(),
                            t.preventDefault(),
                            Te.toggleMenu.call(e, t);
                        },
                        null,
                        !1
                      ),
                      this.bind(
                        t.buttons.settings,
                        "keyup",
                        (t) => {
                          [" ", "Enter"].includes(t.key) &&
                            ("Enter" !== t.key
                              ? (t.preventDefault(),
                                t.stopPropagation(),
                                Te.toggleMenu.call(e, t))
                              : Te.focusFirstMenuItem.call(e, null, !0));
                        },
                        null,
                        !1
                      ),
                      this.bind(t.settings.menu, "keydown", (t) => {
                        "Escape" === t.key && Te.toggleMenu.call(e, t);
                      }),
                      this.bind(t.inputs.seek, "mousedown mousemove", (e) => {
                        const i = t.progress.getBoundingClientRect(),
                          n = (100 / i.width) * (e.pageX - i.left);
                        e.currentTarget.setAttribute("seek-value", n);
                      }),
                      this.bind(
                        t.inputs.seek,
                        "mousedown mouseup keydown keyup touchstart touchend",
                        (t) => {
                          const i = t.currentTarget,
                            n = "play-on-seeked";
                          if (
                            A.keyboardEvent(t) &&
                            !["ArrowLeft", "ArrowRight"].includes(t.key)
                          )
                            return;
                          e.lastSeekTime = Date.now();
                          const r = i.hasAttribute(n),
                            o = ["mouseup", "touchend", "keyup"].includes(
                              t.type
                            );
                          r && o
                            ? (i.removeAttribute(n), ie(e.play()))
                            : !o &&
                              e.playing &&
                              (i.setAttribute(n, ""), e.pause());
                        }
                      ),
                      C.isIos)
                    ) {
                      const t = U.call(e, 'input[type="range"]');
                      Array.from(t).forEach((e) =>
                        this.bind(e, i, (e) => _(e.target))
                      );
                    }
                    this.bind(
                      t.inputs.seek,
                      i,
                      (t) => {
                        const i = t.currentTarget;
                        let n = i.getAttribute("seek-value");
                        A.empty(n) && (n = i.value),
                          i.removeAttribute("seek-value"),
                          (e.currentTime = (n / i.max) * e.duration);
                      },
                      "seek"
                    ),
                      this.bind(
                        t.progress,
                        "mouseenter mouseleave mousemove",
                        (t) => Te.updateSeekTooltip.call(e, t)
                      ),
                      this.bind(t.progress, "mousemove touchmove", (t) => {
                        const { previewThumbnails: i } = e;
                        i && i.loaded && i.startMove(t);
                      }),
                      this.bind(t.progress, "mouseleave touchend click", () => {
                        const { previewThumbnails: t } = e;
                        t && t.loaded && t.endMove(!1, !0);
                      }),
                      this.bind(t.progress, "mousedown touchstart", (t) => {
                        const { previewThumbnails: i } = e;
                        i && i.loaded && i.startScrubbing(t);
                      }),
                      this.bind(t.progress, "mouseup touchend", (t) => {
                        const { previewThumbnails: i } = e;
                        i && i.loaded && i.endScrubbing(t);
                      }),
                      C.isWebKit &&
                        Array.from(U.call(e, 'input[type="range"]')).forEach(
                          (t) => {
                            this.bind(t, "input", (t) =>
                              Te.updateRangeFill.call(e, t.target)
                            );
                          }
                        ),
                      e.config.toggleInvert &&
                        !A.element(t.display.duration) &&
                        this.bind(t.display.currentTime, "click", () => {
                          0 !== e.currentTime &&
                            ((e.config.invertTime = !e.config.invertTime),
                            Te.timeUpdate.call(e));
                        }),
                      this.bind(
                        t.inputs.volume,
                        i,
                        (t) => {
                          e.volume = t.target.value;
                        },
                        "volume"
                      ),
                      this.bind(t.controls, "mouseenter mouseleave", (i) => {
                        t.controls.hover = !e.touch && "mouseenter" === i.type;
                      }),
                      t.fullscreen &&
                        Array.from(t.fullscreen.children)
                          .filter((e) => !e.contains(t.container))
                          .forEach((i) => {
                            this.bind(i, "mouseenter mouseleave", (i) => {
                              t.controls &&
                                (t.controls.hover =
                                  !e.touch && "mouseenter" === i.type);
                            });
                          }),
                      this.bind(
                        t.controls,
                        "mousedown mouseup touchstart touchend touchcancel",
                        (e) => {
                          t.controls.pressed = [
                            "mousedown",
                            "touchstart",
                          ].includes(e.type);
                        }
                      ),
                      this.bind(t.controls, "focusin", () => {
                        const { config: i, timers: n } = e;
                        F(t.controls, i.classNames.noTransition, !0),
                          je.toggleControls.call(e, !0),
                          setTimeout(() => {
                            F(t.controls, i.classNames.noTransition, !1);
                          }, 0);
                        const r = this.touch ? 3e3 : 4e3;
                        clearTimeout(n.controls),
                          (n.controls = setTimeout(
                            () => je.toggleControls.call(e, !1),
                            r
                          ));
                      }),
                      this.bind(
                        t.inputs.volume,
                        "wheel",
                        (t) => {
                          const i = t.webkitDirectionInvertedFromDevice,
                            [n, r] = [t.deltaX, -t.deltaY].map((e) =>
                              i ? -e : e
                            ),
                            o = Math.sign(Math.abs(n) > Math.abs(r) ? n : r);
                          e.increaseVolume(o / 50);
                          const { volume: a } = e.media;
                          ((1 === o && a < 1) || (-1 === o && a > 0)) &&
                            t.preventDefault();
                        },
                        "volume",
                        !1
                      );
                  }),
                  (this.player = t),
                  (this.lastKey = null),
                  (this.focusTimer = null),
                  (this.lastKeyDown = null),
                  (this.handleKey = this.handleKey.bind(this)),
                  (this.toggleMenu = this.toggleMenu.bind(this)),
                  (this.firstTouch = this.firstTouch.bind(this));
              }
              handleKey(e) {
                const { player: t } = this,
                  { elements: i } = t,
                  {
                    key: n,
                    type: r,
                    altKey: o,
                    ctrlKey: a,
                    metaKey: s,
                    shiftKey: l,
                  } = e,
                  c = "keydown" === r,
                  u = c && n === this.lastKey;
                var d;
                if (!(o || a || s || l) && n)
                  if (c) {
                    const r = document.activeElement;
                    if (A.element(r)) {
                      const { editable: n } = t.config.selectors,
                        { seek: o } = i.inputs;
                      if (r !== o && H(r, n)) return;
                      if (" " === e.key && H(r, 'button, [role^="menuitem"]'))
                        return;
                    }
                    switch (
                      ([
                        " ",
                        "ArrowLeft",
                        "ArrowUp",
                        "ArrowRight",
                        "ArrowDown",
                        "0",
                        "1",
                        "2",
                        "3",
                        "4",
                        "5",
                        "6",
                        "7",
                        "8",
                        "9",
                        "c",
                        "f",
                        "k",
                        "l",
                        "m",
                      ].includes(n) &&
                        (e.preventDefault(), e.stopPropagation()),
                      n)
                    ) {
                      case "0":
                      case "1":
                      case "2":
                      case "3":
                      case "4":
                      case "5":
                      case "6":
                      case "7":
                      case "8":
                      case "9":
                        u ||
                          ((d = parseInt(n, 10)),
                          (t.currentTime = (t.duration / 10) * d));
                        break;
                      case " ":
                      case "k":
                        u || ie(t.togglePlay());
                        break;
                      case "ArrowUp":
                        t.increaseVolume(0.1);
                        break;
                      case "ArrowDown":
                        t.decreaseVolume(0.1);
                        break;
                      case "m":
                        u || (t.muted = !t.muted);
                        break;
                      case "ArrowRight":
                        t.forward();
                        break;
                      case "ArrowLeft":
                        t.rewind();
                        break;
                      case "f":
                        t.fullscreen.toggle();
                        break;
                      case "c":
                        u || t.toggleCaptions();
                        break;
                      case "l":
                        t.loop = !t.loop;
                    }
                    "Escape" === n &&
                      !t.fullscreen.usingNative &&
                      t.fullscreen.active &&
                      t.fullscreen.toggle(),
                      (this.lastKey = n);
                  } else this.lastKey = null;
              }
              toggleMenu(e) {
                Te.toggleMenu.call(this.player, e);
              }
            }
            "undefined" != typeof globalThis
              ? globalThis
              : "undefined" != typeof window
              ? window
              : void 0 !== i.g
              ? i.g
              : "undefined" != typeof self && self;
            var De = (function (e, t) {
              return (
                (function (e, t) {
                  e.exports = (function () {
                    var e = function () {},
                      t = {},
                      i = {},
                      n = {};
                    function r(e, t) {
                      e = e.push ? e : [e];
                      var r,
                        o,
                        a,
                        s = [],
                        l = e.length,
                        c = l;
                      for (
                        r = function (e, i) {
                          i.length && s.push(e), --c || t(s);
                        };
                        l--;

                      )
                        (o = e[l]),
                          (a = i[o]) ? r(o, a) : (n[o] = n[o] || []).push(r);
                    }
                    function o(e, t) {
                      if (e) {
                        var r = n[e];
                        if (((i[e] = t), r))
                          for (; r.length; ) r[0](e, t), r.splice(0, 1);
                      }
                    }
                    function a(t, i) {
                      t.call && (t = { success: t }),
                        i.length ? (t.error || e)(i) : (t.success || e)(t);
                    }
                    function s(t, i, n, r) {
                      var o,
                        a,
                        l = document,
                        c = n.async,
                        u = (n.numRetries || 0) + 1,
                        d = n.before || e,
                        h = t.replace(/[\?|#].*$/, ""),
                        p = t.replace(/^(css|img)!/, "");
                      (r = r || 0),
                        /(^css!|\.css$)/.test(h)
                          ? (((a = l.createElement("link")).rel = "stylesheet"),
                            (a.href = p),
                            (o = "hideFocus" in a) &&
                              a.relList &&
                              ((o = 0), (a.rel = "preload"), (a.as = "style")))
                          : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(h)
                          ? ((a = l.createElement("img")).src = p)
                          : (((a = l.createElement("script")).src = t),
                            (a.async = void 0 === c || c)),
                        (a.onload =
                          a.onerror =
                          a.onbeforeload =
                            function (e) {
                              var l = e.type[0];
                              if (o)
                                try {
                                  a.sheet.cssText.length || (l = "e");
                                } catch (e) {
                                  18 != e.code && (l = "e");
                                }
                              if ("e" == l) {
                                if ((r += 1) < u) return s(t, i, n, r);
                              } else if ("preload" == a.rel && "style" == a.as)
                                return (a.rel = "stylesheet");
                              i(t, l, e.defaultPrevented);
                            }),
                        !1 !== d(t, a) && l.head.appendChild(a);
                    }
                    function l(e, t, i) {
                      var n,
                        r,
                        o = (e = e.push ? e : [e]).length,
                        a = o,
                        l = [];
                      for (
                        n = function (e, i, n) {
                          if (("e" == i && l.push(e), "b" == i)) {
                            if (!n) return;
                            l.push(e);
                          }
                          --o || t(l);
                        },
                          r = 0;
                        r < a;
                        r++
                      )
                        s(e[r], n, i);
                    }
                    function c(e, i, n) {
                      var r, s;
                      if (
                        (i && i.trim && (r = i), (s = (r ? n : i) || {}), r)
                      ) {
                        if (r in t) throw "LoadJS";
                        t[r] = !0;
                      }
                      function c(t, i) {
                        l(
                          e,
                          function (e) {
                            a(s, e),
                              t && a({ success: t, error: i }, e),
                              o(r, e);
                          },
                          s
                        );
                      }
                      if (s.returnPromise) return new Promise(c);
                      c();
                    }
                    return (
                      (c.ready = function (e, t) {
                        return (
                          r(e, function (e) {
                            a(t, e);
                          }),
                          c
                        );
                      }),
                      (c.done = function (e) {
                        o(e, []);
                      }),
                      (c.reset = function () {
                        (t = {}), (i = {}), (n = {});
                      }),
                      (c.isDefined = function (e) {
                        return e in t;
                      }),
                      c
                    );
                  })();
                })((t = { exports: {} })),
                t.exports
              );
            })();
            function Be(e) {
              return new Promise((t, i) => {
                De(e, { success: t, error: i });
              });
            }
            function Fe(e) {
              e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0),
                this.media.paused === e &&
                  ((this.media.paused = !e),
                  Z.call(this, this.media, e ? "play" : "pause"));
            }
            const Re = {
              setup() {
                const e = this;
                F(e.elements.wrapper, e.config.classNames.embed, !0),
                  (e.options.speed = e.config.speed.options),
                  ue.call(e),
                  A.object(window.Vimeo)
                    ? Re.ready.call(e)
                    : Be(e.config.urls.vimeo.sdk)
                        .then(() => {
                          Re.ready.call(e);
                        })
                        .catch((t) => {
                          e.debug.warn(
                            "Vimeo SDK (player.js) failed to load",
                            t
                          );
                        });
              },
              ready() {
                const e = this,
                  t = e.config.vimeo,
                  { premium: i, referrerPolicy: n, ...r } = t;
                let o = e.media.getAttribute("src"),
                  a = "";
                A.empty(o)
                  ? ((o = e.media.getAttribute(e.config.attributes.embed.id)),
                    (a = e.media.getAttribute(e.config.attributes.embed.hash)))
                  : (a = (function (e) {
                      const t = e.match(
                        /^.*(vimeo.com\/|video\/)(\d+)(\?.*&*h=|\/)+([\d,a-f]+)/
                      );
                      return t && 5 === t.length ? t[4] : null;
                    })(o));
                const s = a ? { h: a } : {};
                i && Object.assign(r, { controls: !1, sidedock: !1 });
                const l = Pe({
                    loop: e.config.loop.active,
                    autoplay: e.autoplay,
                    muted: e.muted,
                    gesture: "media",
                    playsinline: e.config.playsinline,
                    ...s,
                    ...r,
                  }),
                  c =
                    ((u = o),
                    A.empty(u)
                      ? null
                      : A.number(Number(u))
                      ? u
                      : u.match(/^.*(vimeo.com\/|video\/)(\d+).*/)
                      ? RegExp.$2
                      : u);
                var u;
                const d = q("iframe"),
                  h = pe(e.config.urls.vimeo.iframe, c, l);
                if (
                  (d.setAttribute("src", h),
                  d.setAttribute("allowfullscreen", ""),
                  d.setAttribute(
                    "allow",
                    [
                      "autoplay",
                      "fullscreen",
                      "picture-in-picture",
                      "encrypted-media",
                      "accelerometer",
                      "gyroscope",
                    ].join("; ")
                  ),
                  A.empty(n) || d.setAttribute("referrerPolicy", n),
                  i || !t.customControls)
                )
                  d.setAttribute("data-poster", e.poster),
                    (e.media = V(d, e.media));
                else {
                  const t = q("div", {
                    class: e.config.classNames.embedContainer,
                    "data-poster": e.poster,
                  });
                  t.appendChild(d), (e.media = V(t, e.media));
                }
                t.customControls ||
                  we(pe(e.config.urls.vimeo.api, h)).then((t) => {
                    !A.empty(t) &&
                      t.thumbnail_url &&
                      je.setPoster.call(e, t.thumbnail_url).catch(() => {});
                  }),
                  (e.embed = new window.Vimeo.Player(d, {
                    autopause: e.config.autopause,
                    muted: e.muted,
                  })),
                  (e.media.paused = !0),
                  (e.media.currentTime = 0),
                  e.supported.ui && e.embed.disableTextTrack(),
                  (e.media.play = () => (Fe.call(e, !0), e.embed.play())),
                  (e.media.pause = () => (Fe.call(e, !1), e.embed.pause())),
                  (e.media.stop = () => {
                    e.pause(), (e.currentTime = 0);
                  });
                let { currentTime: p } = e.media;
                Object.defineProperty(e.media, "currentTime", {
                  get: () => p,
                  set(t) {
                    const { embed: i, media: n, paused: r, volume: o } = e,
                      a = r && !i.hasPlayed;
                    (n.seeking = !0),
                      Z.call(e, n, "seeking"),
                      Promise.resolve(a && i.setVolume(0))
                        .then(() => i.setCurrentTime(t))
                        .then(() => a && i.pause())
                        .then(() => a && i.setVolume(o))
                        .catch(() => {});
                  },
                });
                let f = e.config.speed.selected;
                Object.defineProperty(e.media, "playbackRate", {
                  get: () => f,
                  set(t) {
                    e.embed
                      .setPlaybackRate(t)
                      .then(() => {
                        (f = t), Z.call(e, e.media, "ratechange");
                      })
                      .catch(() => {
                        e.options.speed = [1];
                      });
                  },
                });
                let { volume: m } = e.config;
                Object.defineProperty(e.media, "volume", {
                  get: () => m,
                  set(t) {
                    e.embed.setVolume(t).then(() => {
                      (m = t), Z.call(e, e.media, "volumechange");
                    });
                  },
                });
                let { muted: g } = e.config;
                Object.defineProperty(e.media, "muted", {
                  get: () => g,
                  set(t) {
                    const i = !!A.boolean(t) && t;
                    e.embed.setMuted(!!i || e.config.muted).then(() => {
                      (g = i), Z.call(e, e.media, "volumechange");
                    });
                  },
                });
                let y,
                  { loop: v } = e.config;
                Object.defineProperty(e.media, "loop", {
                  get: () => v,
                  set(t) {
                    const i = A.boolean(t) ? t : e.config.loop.active;
                    e.embed.setLoop(i).then(() => {
                      v = i;
                    });
                  },
                }),
                  e.embed
                    .getVideoUrl()
                    .then((t) => {
                      (y = t), Te.setDownloadUrl.call(e);
                    })
                    .catch((e) => {
                      this.debug.warn(e);
                    }),
                  Object.defineProperty(e.media, "currentSrc", {
                    get: () => y,
                  }),
                  Object.defineProperty(e.media, "ended", {
                    get: () => e.currentTime === e.duration,
                  }),
                  Promise.all([
                    e.embed.getVideoWidth(),
                    e.embed.getVideoHeight(),
                  ]).then((t) => {
                    const [i, n] = t;
                    (e.embed.ratio = de(i, n)), ue.call(this);
                  }),
                  e.embed.setAutopause(e.config.autopause).then((t) => {
                    e.config.autopause = t;
                  }),
                  e.embed.getVideoTitle().then((t) => {
                    (e.config.title = t), je.setTitle.call(this);
                  }),
                  e.embed.getCurrentTime().then((t) => {
                    (p = t), Z.call(e, e.media, "timeupdate");
                  }),
                  e.embed.getDuration().then((t) => {
                    (e.media.duration = t),
                      Z.call(e, e.media, "durationchange");
                  }),
                  e.embed.getTextTracks().then((t) => {
                    (e.media.textTracks = t), _e.setup.call(e);
                  }),
                  e.embed.on("cuechange", ({ cues: t = [] }) => {
                    const i = t.map((e) =>
                      (function (e) {
                        const t = document.createDocumentFragment(),
                          i = document.createElement("div");
                        return (
                          t.appendChild(i),
                          (i.innerHTML = e),
                          t.firstChild.innerText
                        );
                      })(e.text)
                    );
                    _e.updateCues.call(e, i);
                  }),
                  e.embed.on("loaded", () => {
                    e.embed.getPaused().then((t) => {
                      Fe.call(e, !t), t || Z.call(e, e.media, "playing");
                    }),
                      A.element(e.embed.element) &&
                        e.supported.ui &&
                        e.embed.element.setAttribute("tabindex", -1);
                  }),
                  e.embed.on("bufferstart", () => {
                    Z.call(e, e.media, "waiting");
                  }),
                  e.embed.on("bufferend", () => {
                    Z.call(e, e.media, "playing");
                  }),
                  e.embed.on("play", () => {
                    Fe.call(e, !0), Z.call(e, e.media, "playing");
                  }),
                  e.embed.on("pause", () => {
                    Fe.call(e, !1);
                  }),
                  e.embed.on("timeupdate", (t) => {
                    (e.media.seeking = !1),
                      (p = t.seconds),
                      Z.call(e, e.media, "timeupdate");
                  }),
                  e.embed.on("progress", (t) => {
                    (e.media.buffered = t.percent),
                      Z.call(e, e.media, "progress"),
                      1 === parseInt(t.percent, 10) &&
                        Z.call(e, e.media, "canplaythrough"),
                      e.embed.getDuration().then((t) => {
                        t !== e.media.duration &&
                          ((e.media.duration = t),
                          Z.call(e, e.media, "durationchange"));
                      });
                  }),
                  e.embed.on("seeked", () => {
                    (e.media.seeking = !1), Z.call(e, e.media, "seeked");
                  }),
                  e.embed.on("ended", () => {
                    (e.media.paused = !0), Z.call(e, e.media, "ended");
                  }),
                  e.embed.on("error", (t) => {
                    (e.media.error = t), Z.call(e, e.media, "error");
                  }),
                  t.customControls && setTimeout(() => je.build.call(e), 0);
              },
            };
            function He(e) {
              e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0),
                this.media.paused === e &&
                  ((this.media.paused = !e),
                  Z.call(this, this.media, e ? "play" : "pause"));
            }
            function Ue(e) {
              return e.noCookie
                ? "https://www.youtube-nocookie.com"
                : "http:" === window.location.protocol
                ? "http://www.youtube.com"
                : void 0;
            }
            const $e = {
                setup() {
                  if (
                    (F(this.elements.wrapper, this.config.classNames.embed, !0),
                    A.object(window.YT) && A.function(window.YT.Player))
                  )
                    $e.ready.call(this);
                  else {
                    const e = window.onYouTubeIframeAPIReady;
                    (window.onYouTubeIframeAPIReady = () => {
                      A.function(e) && e(), $e.ready.call(this);
                    }),
                      Be(this.config.urls.youtube.sdk).catch((e) => {
                        this.debug.warn("YouTube API failed to load", e);
                      });
                  }
                },
                getTitle(e) {
                  we(pe(this.config.urls.youtube.api, e))
                    .then((e) => {
                      if (A.object(e)) {
                        const { title: t, height: i, width: n } = e;
                        (this.config.title = t),
                          je.setTitle.call(this),
                          (this.embed.ratio = de(n, i));
                      }
                      ue.call(this);
                    })
                    .catch(() => {
                      ue.call(this);
                    });
                },
                ready() {
                  const e = this,
                    t = e.config.youtube,
                    i = e.media && e.media.getAttribute("id");
                  if (!A.empty(i) && i.startsWith("youtube-")) return;
                  let n = e.media.getAttribute("src");
                  A.empty(n) &&
                    (n = e.media.getAttribute(this.config.attributes.embed.id));
                  const r =
                    ((o = n),
                    A.empty(o)
                      ? null
                      : o.match(
                          /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
                        )
                      ? RegExp.$2
                      : o);
                  var o;
                  const a = q("div", {
                    id: `${e.provider}-${Math.floor(1e4 * Math.random())}`,
                    "data-poster": t.customControls ? e.poster : void 0,
                  });
                  if (((e.media = V(a, e.media)), t.customControls)) {
                    const t = (e) =>
                      `https://i.ytimg.com/vi/${r}/${e}default.jpg`;
                    Ne(t("maxres"), 121)
                      .catch(() => Ne(t("sd"), 121))
                      .catch(() => Ne(t("hq")))
                      .then((t) => je.setPoster.call(e, t.src))
                      .then((t) => {
                        t.includes("maxres") ||
                          (e.elements.poster.style.backgroundSize = "cover");
                      })
                      .catch(() => {});
                  }
                  e.embed = new window.YT.Player(e.media, {
                    videoId: r,
                    host: Ue(t),
                    playerVars: L(
                      {},
                      {
                        autoplay: e.config.autoplay ? 1 : 0,
                        hl: e.config.hl,
                        controls: e.supported.ui && t.customControls ? 0 : 1,
                        disablekb: 1,
                        playsinline:
                          e.config.playsinline && !e.config.fullscreen.iosNative
                            ? 1
                            : 0,
                        cc_load_policy: e.captions.active ? 1 : 0,
                        cc_lang_pref: e.config.captions.language,
                        widget_referrer: window ? window.location.href : null,
                      },
                      t
                    ),
                    events: {
                      onError(t) {
                        if (!e.media.error) {
                          const i = t.data,
                            n =
                              {
                                2: "The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.",
                                5: "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.",
                                100: "The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.",
                                101: "The owner of the requested video does not allow it to be played in embedded players.",
                                150: "The owner of the requested video does not allow it to be played in embedded players.",
                              }[i] || "An unknown error occurred";
                          (e.media.error = { code: i, message: n }),
                            Z.call(e, e.media, "error");
                        }
                      },
                      onPlaybackRateChange(t) {
                        const i = t.target;
                        (e.media.playbackRate = i.getPlaybackRate()),
                          Z.call(e, e.media, "ratechange");
                      },
                      onReady(i) {
                        if (A.function(e.media.play)) return;
                        const n = i.target;
                        $e.getTitle.call(e, r),
                          (e.media.play = () => {
                            He.call(e, !0), n.playVideo();
                          }),
                          (e.media.pause = () => {
                            He.call(e, !1), n.pauseVideo();
                          }),
                          (e.media.stop = () => {
                            n.stopVideo();
                          }),
                          (e.media.duration = n.getDuration()),
                          (e.media.paused = !0),
                          (e.media.currentTime = 0),
                          Object.defineProperty(e.media, "currentTime", {
                            get: () => Number(n.getCurrentTime()),
                            set(t) {
                              e.paused && !e.embed.hasPlayed && e.embed.mute(),
                                (e.media.seeking = !0),
                                Z.call(e, e.media, "seeking"),
                                n.seekTo(t);
                            },
                          }),
                          Object.defineProperty(e.media, "playbackRate", {
                            get: () => n.getPlaybackRate(),
                            set(e) {
                              n.setPlaybackRate(e);
                            },
                          });
                        let { volume: o } = e.config;
                        Object.defineProperty(e.media, "volume", {
                          get: () => o,
                          set(t) {
                            (o = t),
                              n.setVolume(100 * o),
                              Z.call(e, e.media, "volumechange");
                          },
                        });
                        let { muted: a } = e.config;
                        Object.defineProperty(e.media, "muted", {
                          get: () => a,
                          set(t) {
                            const i = A.boolean(t) ? t : a;
                            (a = i),
                              n[i ? "mute" : "unMute"](),
                              n.setVolume(100 * o),
                              Z.call(e, e.media, "volumechange");
                          },
                        }),
                          Object.defineProperty(e.media, "currentSrc", {
                            get: () => n.getVideoUrl(),
                          }),
                          Object.defineProperty(e.media, "ended", {
                            get: () => e.currentTime === e.duration,
                          });
                        const s = n.getAvailablePlaybackRates();
                        (e.options.speed = s.filter((t) =>
                          e.config.speed.options.includes(t)
                        )),
                          e.supported.ui &&
                            t.customControls &&
                            e.media.setAttribute("tabindex", -1),
                          Z.call(e, e.media, "timeupdate"),
                          Z.call(e, e.media, "durationchange"),
                          clearInterval(e.timers.buffering),
                          (e.timers.buffering = setInterval(() => {
                            (e.media.buffered = n.getVideoLoadedFraction()),
                              (null === e.media.lastBuffered ||
                                e.media.lastBuffered < e.media.buffered) &&
                                Z.call(e, e.media, "progress"),
                              (e.media.lastBuffered = e.media.buffered),
                              1 === e.media.buffered &&
                                (clearInterval(e.timers.buffering),
                                Z.call(e, e.media, "canplaythrough"));
                          }, 200)),
                          t.customControls &&
                            setTimeout(() => je.build.call(e), 50);
                      },
                      onStateChange(i) {
                        const n = i.target;
                        switch (
                          (clearInterval(e.timers.playing),
                          e.media.seeking &&
                            [1, 2].includes(i.data) &&
                            ((e.media.seeking = !1),
                            Z.call(e, e.media, "seeked")),
                          i.data)
                        ) {
                          case -1:
                            Z.call(e, e.media, "timeupdate"),
                              (e.media.buffered = n.getVideoLoadedFraction()),
                              Z.call(e, e.media, "progress");
                            break;
                          case 0:
                            He.call(e, !1),
                              e.media.loop
                                ? (n.stopVideo(), n.playVideo())
                                : Z.call(e, e.media, "ended");
                            break;
                          case 1:
                            t.customControls &&
                            !e.config.autoplay &&
                            e.media.paused &&
                            !e.embed.hasPlayed
                              ? e.media.pause()
                              : (He.call(e, !0),
                                Z.call(e, e.media, "playing"),
                                (e.timers.playing = setInterval(() => {
                                  Z.call(e, e.media, "timeupdate");
                                }, 50)),
                                e.media.duration !== n.getDuration() &&
                                  ((e.media.duration = n.getDuration()),
                                  Z.call(e, e.media, "durationchange")));
                            break;
                          case 2:
                            e.muted || e.embed.unMute(), He.call(e, !1);
                            break;
                          case 3:
                            Z.call(e, e.media, "waiting");
                        }
                        Z.call(e, e.elements.container, "statechange", !1, {
                          code: i.data,
                        });
                      },
                    },
                  });
                },
              },
              We = {
                setup() {
                  this.media
                    ? (F(
                        this.elements.container,
                        this.config.classNames.type.replace("{0}", this.type),
                        !0
                      ),
                      F(
                        this.elements.container,
                        this.config.classNames.provider.replace(
                          "{0}",
                          this.provider
                        ),
                        !0
                      ),
                      this.isEmbed &&
                        F(
                          this.elements.container,
                          this.config.classNames.type.replace("{0}", "video"),
                          !0
                        ),
                      this.isVideo &&
                        ((this.elements.wrapper = q("div", {
                          class: this.config.classNames.video,
                        })),
                        I(this.media, this.elements.wrapper),
                        (this.elements.poster = q("div", {
                          class: this.config.classNames.poster,
                        })),
                        this.elements.wrapper.appendChild(
                          this.elements.poster
                        )),
                      this.isHTML5
                        ? he.setup.call(this)
                        : this.isYouTube
                        ? $e.setup.call(this)
                        : this.isVimeo && Re.setup.call(this))
                    : this.debug.warn("No media element found!");
                },
              };
            class ze {
              constructor(t) {
                e(this, "load", () => {
                  this.enabled &&
                    (A.object(window.google) && A.object(window.google.ima)
                      ? this.ready()
                      : Be(this.player.config.urls.googleIMA.sdk)
                          .then(() => {
                            this.ready();
                          })
                          .catch(() => {
                            this.trigger(
                              "error",
                              new Error("Google IMA SDK failed to load")
                            );
                          }));
                }),
                  e(this, "ready", () => {
                    var e;
                    this.enabled ||
                      ((e = this).manager && e.manager.destroy(),
                      e.elements.displayContainer &&
                        e.elements.displayContainer.destroy(),
                      e.elements.container.remove()),
                      this.startSafetyTimer(12e3, "ready()"),
                      this.managerPromise.then(() => {
                        this.clearSafetyTimer("onAdsManagerLoaded()");
                      }),
                      this.listeners(),
                      this.setupIMA();
                  }),
                  e(this, "setupIMA", () => {
                    (this.elements.container = q("div", {
                      class: this.player.config.classNames.ads,
                    })),
                      this.player.elements.container.appendChild(
                        this.elements.container
                      ),
                      google.ima.settings.setVpaidMode(
                        google.ima.ImaSdkSettings.VpaidMode.ENABLED
                      ),
                      google.ima.settings.setLocale(
                        this.player.config.ads.language
                      ),
                      google.ima.settings.setDisableCustomPlaybackForIOS10Plus(
                        this.player.config.playsinline
                      ),
                      (this.elements.displayContainer =
                        new google.ima.AdDisplayContainer(
                          this.elements.container,
                          this.player.media
                        )),
                      (this.loader = new google.ima.AdsLoader(
                        this.elements.displayContainer
                      )),
                      this.loader.addEventListener(
                        google.ima.AdsManagerLoadedEvent.Type
                          .ADS_MANAGER_LOADED,
                        (e) => this.onAdsManagerLoaded(e),
                        !1
                      ),
                      this.loader.addEventListener(
                        google.ima.AdErrorEvent.Type.AD_ERROR,
                        (e) => this.onAdError(e),
                        !1
                      ),
                      this.requestAds();
                  }),
                  e(this, "requestAds", () => {
                    const { container: e } = this.player.elements;
                    try {
                      const t = new google.ima.AdsRequest();
                      (t.adTagUrl = this.tagUrl),
                        (t.linearAdSlotWidth = e.offsetWidth),
                        (t.linearAdSlotHeight = e.offsetHeight),
                        (t.nonLinearAdSlotWidth = e.offsetWidth),
                        (t.nonLinearAdSlotHeight = e.offsetHeight),
                        (t.forceNonLinearFullSlot = !1),
                        t.setAdWillPlayMuted(!this.player.muted),
                        this.loader.requestAds(t);
                    } catch (e) {
                      this.onAdError(e);
                    }
                  }),
                  e(this, "pollCountdown", (e = !1) => {
                    if (!e)
                      return (
                        clearInterval(this.countdownTimer),
                        void this.elements.container.removeAttribute(
                          "data-badge-text"
                        )
                      );
                    this.countdownTimer = setInterval(() => {
                      const e = ke(
                          Math.max(this.manager.getRemainingTime(), 0)
                        ),
                        t = `${ve.get(
                          "advertisement",
                          this.player.config
                        )} - ${e}`;
                      this.elements.container.setAttribute(
                        "data-badge-text",
                        t
                      );
                    }, 100);
                  }),
                  e(this, "onAdsManagerLoaded", (e) => {
                    if (!this.enabled) return;
                    const t = new google.ima.AdsRenderingSettings();
                    (t.restoreCustomPlaybackStateOnAdBreakComplete = !0),
                      (t.enablePreloading = !0),
                      (this.manager = e.getAdsManager(this.player, t)),
                      (this.cuePoints = this.manager.getCuePoints()),
                      this.manager.addEventListener(
                        google.ima.AdErrorEvent.Type.AD_ERROR,
                        (e) => this.onAdError(e)
                      ),
                      Object.keys(google.ima.AdEvent.Type).forEach((e) => {
                        this.manager.addEventListener(
                          google.ima.AdEvent.Type[e],
                          (e) => this.onAdEvent(e)
                        );
                      }),
                      this.trigger("loaded");
                  }),
                  e(this, "addCuePoints", () => {
                    A.empty(this.cuePoints) ||
                      this.cuePoints.forEach((e) => {
                        if (0 !== e && -1 !== e && e < this.player.duration) {
                          const t = this.player.elements.progress;
                          if (A.element(t)) {
                            const i = (100 / this.player.duration) * e,
                              n = q("span", {
                                class: this.player.config.classNames.cues,
                              });
                            (n.style.left = `${i.toString()}%`),
                              t.appendChild(n);
                          }
                        }
                      });
                  }),
                  e(this, "onAdEvent", (e) => {
                    const { container: t } = this.player.elements,
                      i = e.getAd(),
                      n = e.getAdData();
                    switch (
                      (((e) => {
                        Z.call(
                          this.player,
                          this.player.media,
                          `ads${e.replace(/_/g, "").toLowerCase()}`
                        );
                      })(e.type),
                      e.type)
                    ) {
                      case google.ima.AdEvent.Type.LOADED:
                        this.trigger("loaded"),
                          this.pollCountdown(!0),
                          i.isLinear() ||
                            ((i.width = t.offsetWidth),
                            (i.height = t.offsetHeight));
                        break;
                      case google.ima.AdEvent.Type.STARTED:
                        this.manager.setVolume(this.player.volume);
                        break;
                      case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                        this.player.ended
                          ? this.loadAds()
                          : this.loader.contentComplete();
                        break;
                      case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
                        this.pauseContent();
                        break;
                      case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                        this.pollCountdown(), this.resumeContent();
                        break;
                      case google.ima.AdEvent.Type.LOG:
                        n.adError &&
                          this.player.debug.warn(
                            `Non-fatal ad error: ${n.adError.getMessage()}`
                          );
                    }
                  }),
                  e(this, "onAdError", (e) => {
                    this.cancel(), this.player.debug.warn("Ads error", e);
                  }),
                  e(this, "listeners", () => {
                    const { container: e } = this.player.elements;
                    let t;
                    this.player.on("canplay", () => {
                      this.addCuePoints();
                    }),
                      this.player.on("ended", () => {
                        this.loader.contentComplete();
                      }),
                      this.player.on("timeupdate", () => {
                        t = this.player.currentTime;
                      }),
                      this.player.on("seeked", () => {
                        const e = this.player.currentTime;
                        A.empty(this.cuePoints) ||
                          this.cuePoints.forEach((i, n) => {
                            t < i &&
                              i < e &&
                              (this.manager.discardAdBreak(),
                              this.cuePoints.splice(n, 1));
                          });
                      }),
                      window.addEventListener("resize", () => {
                        this.manager &&
                          this.manager.resize(
                            e.offsetWidth,
                            e.offsetHeight,
                            google.ima.ViewMode.NORMAL
                          );
                      });
                  }),
                  e(this, "play", () => {
                    const { container: e } = this.player.elements;
                    this.managerPromise || this.resumeContent(),
                      this.managerPromise
                        .then(() => {
                          this.manager.setVolume(this.player.volume),
                            this.elements.displayContainer.initialize();
                          try {
                            this.initialized ||
                              (this.manager.init(
                                e.offsetWidth,
                                e.offsetHeight,
                                google.ima.ViewMode.NORMAL
                              ),
                              this.manager.start()),
                              (this.initialized = !0);
                          } catch (e) {
                            this.onAdError(e);
                          }
                        })
                        .catch(() => {});
                  }),
                  e(this, "resumeContent", () => {
                    (this.elements.container.style.zIndex = ""),
                      (this.playing = !1),
                      ie(this.player.media.play());
                  }),
                  e(this, "pauseContent", () => {
                    (this.elements.container.style.zIndex = 3),
                      (this.playing = !0),
                      this.player.media.pause();
                  }),
                  e(this, "cancel", () => {
                    this.initialized && this.resumeContent(),
                      this.trigger("error"),
                      this.loadAds();
                  }),
                  e(this, "loadAds", () => {
                    this.managerPromise
                      .then(() => {
                        this.manager && this.manager.destroy(),
                          (this.managerPromise = new Promise((e) => {
                            this.on("loaded", e),
                              this.player.debug.log(this.manager);
                          })),
                          (this.initialized = !1),
                          this.requestAds();
                      })
                      .catch(() => {});
                  }),
                  e(this, "trigger", (e, ...t) => {
                    const i = this.events[e];
                    A.array(i) &&
                      i.forEach((e) => {
                        A.function(e) && e.apply(this, t);
                      });
                  }),
                  e(
                    this,
                    "on",
                    (e, t) => (
                      A.array(this.events[e]) || (this.events[e] = []),
                      this.events[e].push(t),
                      this
                    )
                  ),
                  e(this, "startSafetyTimer", (e, t) => {
                    this.player.debug.log(`Safety timer invoked from: ${t}`),
                      (this.safetyTimer = setTimeout(() => {
                        this.cancel(),
                          this.clearSafetyTimer("startSafetyTimer()");
                      }, e));
                  }),
                  e(this, "clearSafetyTimer", (e) => {
                    A.nullOrUndefined(this.safetyTimer) ||
                      (this.player.debug.log(`Safety timer cleared from: ${e}`),
                      clearTimeout(this.safetyTimer),
                      (this.safetyTimer = null));
                  }),
                  (this.player = t),
                  (this.config = t.config.ads),
                  (this.playing = !1),
                  (this.initialized = !1),
                  (this.elements = { container: null, displayContainer: null }),
                  (this.manager = null),
                  (this.loader = null),
                  (this.cuePoints = null),
                  (this.events = {}),
                  (this.safetyTimer = null),
                  (this.countdownTimer = null),
                  (this.managerPromise = new Promise((e, t) => {
                    this.on("loaded", e), this.on("error", t);
                  })),
                  this.load();
              }
              get enabled() {
                const { config: e } = this;
                return (
                  this.player.isHTML5 &&
                  this.player.isVideo &&
                  e.enabled &&
                  (!A.empty(e.publisherId) || A.url(e.tagUrl))
                );
              }
              get tagUrl() {
                const { config: e } = this;
                return A.url(e.tagUrl)
                  ? e.tagUrl
                  : `https://go.aniview.com/api/adserver6/vast/?${Pe({
                      AV_PUBLISHERID: "58c25bb0073ef448b1087ad6",
                      AV_CHANNELID: "5a0458dc28a06145e4519d21",
                      AV_URL: window.location.hostname,
                      cb: Date.now(),
                      AV_WIDTH: 640,
                      AV_HEIGHT: 480,
                      AV_CDIM2: e.publisherId,
                    })}`;
              }
            }
            function Ge(e = 0, t = 0, i = 255) {
              return Math.min(Math.max(e, t), i);
            }
            const Qe = (e) => {
                const t = [];
                return (
                  e.split(/\r\n\r\n|\n\n|\r\r/).forEach((e) => {
                    const i = {};
                    e.split(/\r\n|\n|\r/).forEach((e) => {
                      if (A.number(i.startTime)) {
                        if (!A.empty(e.trim()) && A.empty(i.text)) {
                          const t = e.trim().split("#xywh=");
                          ([i.text] = t),
                            t[1] && ([i.x, i.y, i.w, i.h] = t[1].split(","));
                        }
                      } else {
                        const t = e.match(
                          /([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/
                        );
                        t &&
                          ((i.startTime =
                            60 * Number(t[1] || 0) * 60 +
                            60 * Number(t[2]) +
                            Number(t[3]) +
                            Number(`0.${t[4]}`)),
                          (i.endTime =
                            60 * Number(t[6] || 0) * 60 +
                            60 * Number(t[7]) +
                            Number(t[8]) +
                            Number(`0.${t[9]}`)));
                      }
                    }),
                      i.text && t.push(i);
                  }),
                  t
                );
              },
              Ke = (e, t) => {
                const i = {};
                return (
                  e > t.width / t.height
                    ? ((i.width = t.width), (i.height = (1 / e) * t.width))
                    : ((i.height = t.height), (i.width = e * t.height)),
                  i
                );
              };
            class Ye {
              constructor(t) {
                e(this, "load", () => {
                  this.player.elements.display.seekTooltip &&
                    (this.player.elements.display.seekTooltip.hidden =
                      this.enabled),
                    this.enabled &&
                      this.getThumbnails().then(() => {
                        this.enabled &&
                          (this.render(),
                          this.determineContainerAutoSizing(),
                          this.listeners(),
                          (this.loaded = !0));
                      });
                }),
                  e(
                    this,
                    "getThumbnails",
                    () =>
                      new Promise((e) => {
                        const { src: t } = this.player.config.previewThumbnails;
                        if (A.empty(t))
                          throw new Error(
                            "Missing previewThumbnails.src config attribute"
                          );
                        const i = () => {
                          this.thumbnails.sort((e, t) => e.height - t.height),
                            this.player.debug.log(
                              "Preview thumbnails",
                              this.thumbnails
                            ),
                            e();
                        };
                        if (A.function(t))
                          t((e) => {
                            (this.thumbnails = e), i();
                          });
                        else {
                          const e = (A.string(t) ? [t] : t).map((e) =>
                            this.getThumbnail(e)
                          );
                          Promise.all(e).then(i);
                        }
                      })
                  ),
                  e(
                    this,
                    "getThumbnail",
                    (e) =>
                      new Promise((t) => {
                        we(e).then((i) => {
                          const n = {
                            frames: Qe(i),
                            height: null,
                            urlPrefix: "",
                          };
                          n.frames[0].text.startsWith("/") ||
                            n.frames[0].text.startsWith("http://") ||
                            n.frames[0].text.startsWith("https://") ||
                            (n.urlPrefix = e.substring(
                              0,
                              e.lastIndexOf("/") + 1
                            ));
                          const r = new Image();
                          (r.onload = () => {
                            (n.height = r.naturalHeight),
                              (n.width = r.naturalWidth),
                              this.thumbnails.push(n),
                              t();
                          }),
                            (r.src = n.urlPrefix + n.frames[0].text);
                        });
                      })
                  ),
                  e(this, "startMove", (e) => {
                    if (
                      this.loaded &&
                      A.event(e) &&
                      ["touchmove", "mousemove"].includes(e.type) &&
                      this.player.media.duration
                    ) {
                      if ("touchmove" === e.type)
                        this.seekTime =
                          this.player.media.duration *
                          (this.player.elements.inputs.seek.value / 100);
                      else {
                        var t, i;
                        const n =
                            this.player.elements.progress.getBoundingClientRect(),
                          r = (100 / n.width) * (e.pageX - n.left);
                        (this.seekTime =
                          this.player.media.duration * (r / 100)),
                          this.seekTime < 0 && (this.seekTime = 0),
                          this.seekTime > this.player.media.duration - 1 &&
                            (this.seekTime = this.player.media.duration - 1),
                          (this.mousePosX = e.pageX),
                          (this.elements.thumb.time.innerText = ke(
                            this.seekTime
                          ));
                        const o =
                          null === (t = this.player.config.markers) ||
                          void 0 === t ||
                          null === (i = t.points) ||
                          void 0 === i
                            ? void 0
                            : i.find(
                                ({ time: e }) => e === Math.round(this.seekTime)
                              );
                        o &&
                          this.elements.thumb.time.insertAdjacentHTML(
                            "afterbegin",
                            `${o.label}<br>`
                          );
                      }
                      this.showImageAtCurrentTime();
                    }
                  }),
                  e(this, "endMove", () => {
                    this.toggleThumbContainer(!1, !0);
                  }),
                  e(this, "startScrubbing", (e) => {
                    (A.nullOrUndefined(e.button) ||
                      !1 === e.button ||
                      0 === e.button) &&
                      ((this.mouseDown = !0),
                      this.player.media.duration &&
                        (this.toggleScrubbingContainer(!0),
                        this.toggleThumbContainer(!1, !0),
                        this.showImageAtCurrentTime()));
                  }),
                  e(this, "endScrubbing", () => {
                    (this.mouseDown = !1),
                      Math.ceil(this.lastTime) ===
                      Math.ceil(this.player.media.currentTime)
                        ? this.toggleScrubbingContainer(!1)
                        : J.call(
                            this.player,
                            this.player.media,
                            "timeupdate",
                            () => {
                              this.mouseDown ||
                                this.toggleScrubbingContainer(!1);
                            }
                          );
                  }),
                  e(this, "listeners", () => {
                    this.player.on("play", () => {
                      this.toggleThumbContainer(!1, !0);
                    }),
                      this.player.on("seeked", () => {
                        this.toggleThumbContainer(!1);
                      }),
                      this.player.on("timeupdate", () => {
                        this.lastTime = this.player.media.currentTime;
                      });
                  }),
                  e(this, "render", () => {
                    (this.elements.thumb.container = q("div", {
                      class:
                        this.player.config.classNames.previewThumbnails
                          .thumbContainer,
                    })),
                      (this.elements.thumb.imageContainer = q("div", {
                        class:
                          this.player.config.classNames.previewThumbnails
                            .imageContainer,
                      })),
                      this.elements.thumb.container.appendChild(
                        this.elements.thumb.imageContainer
                      );
                    const e = q("div", {
                      class:
                        this.player.config.classNames.previewThumbnails
                          .timeContainer,
                    });
                    (this.elements.thumb.time = q("span", {}, "00:00")),
                      e.appendChild(this.elements.thumb.time),
                      this.elements.thumb.imageContainer.appendChild(e),
                      A.element(this.player.elements.progress) &&
                        this.player.elements.progress.appendChild(
                          this.elements.thumb.container
                        ),
                      (this.elements.scrubbing.container = q("div", {
                        class:
                          this.player.config.classNames.previewThumbnails
                            .scrubbingContainer,
                      })),
                      this.player.elements.wrapper.appendChild(
                        this.elements.scrubbing.container
                      );
                  }),
                  e(this, "destroy", () => {
                    this.elements.thumb.container &&
                      this.elements.thumb.container.remove(),
                      this.elements.scrubbing.container &&
                        this.elements.scrubbing.container.remove();
                  }),
                  e(this, "showImageAtCurrentTime", () => {
                    this.mouseDown
                      ? this.setScrubbingContainerSize()
                      : this.setThumbContainerSizeAndPos();
                    const e = this.thumbnails[0].frames.findIndex(
                        (e) =>
                          this.seekTime >= e.startTime &&
                          this.seekTime <= e.endTime
                      ),
                      t = e >= 0;
                    let i = 0;
                    this.mouseDown || this.toggleThumbContainer(t),
                      t &&
                        (this.thumbnails.forEach((t, n) => {
                          this.loadedImages.includes(t.frames[e].text) &&
                            (i = n);
                        }),
                        e !== this.showingThumb &&
                          ((this.showingThumb = e), this.loadImage(i)));
                  }),
                  e(this, "loadImage", (e = 0) => {
                    const t = this.showingThumb,
                      i = this.thumbnails[e],
                      { urlPrefix: n } = i,
                      r = i.frames[t],
                      o = i.frames[t].text,
                      a = n + o;
                    if (
                      this.currentImageElement &&
                      this.currentImageElement.dataset.filename === o
                    )
                      this.showImage(this.currentImageElement, r, e, t, o, !1),
                        (this.currentImageElement.dataset.index = t),
                        this.removeOldImages(this.currentImageElement);
                    else {
                      this.loadingImage &&
                        this.usingSprites &&
                        (this.loadingImage.onload = null);
                      const i = new Image();
                      (i.src = a),
                        (i.dataset.index = t),
                        (i.dataset.filename = o),
                        (this.showingThumbFilename = o),
                        this.player.debug.log(`Loading image: ${a}`),
                        (i.onload = () => this.showImage(i, r, e, t, o, !0)),
                        (this.loadingImage = i),
                        this.removeOldImages(i);
                    }
                  }),
                  e(this, "showImage", (e, t, i, n, r, o = !0) => {
                    this.player.debug.log(
                      `Showing thumb: ${r}. num: ${n}. qual: ${i}. newimg: ${o}`
                    ),
                      this.setImageSizeAndOffset(e, t),
                      o &&
                        (this.currentImageContainer.appendChild(e),
                        (this.currentImageElement = e),
                        this.loadedImages.includes(r) ||
                          this.loadedImages.push(r)),
                      this.preloadNearby(n, !0)
                        .then(this.preloadNearby(n, !1))
                        .then(this.getHigherQuality(i, e, t, r));
                  }),
                  e(this, "removeOldImages", (e) => {
                    Array.from(this.currentImageContainer.children).forEach(
                      (t) => {
                        if ("img" !== t.tagName.toLowerCase()) return;
                        const i = this.usingSprites ? 500 : 1e3;
                        if (
                          t.dataset.index !== e.dataset.index &&
                          !t.dataset.deleting
                        ) {
                          t.dataset.deleting = !0;
                          const { currentImageContainer: e } = this;
                          setTimeout(() => {
                            e.removeChild(t),
                              this.player.debug.log(
                                `Removing thumb: ${t.dataset.filename}`
                              );
                          }, i);
                        }
                      }
                    );
                  }),
                  e(
                    this,
                    "preloadNearby",
                    (e, t = !0) =>
                      new Promise((i) => {
                        setTimeout(() => {
                          const n = this.thumbnails[0].frames[e].text;
                          if (this.showingThumbFilename === n) {
                            let r;
                            r = t
                              ? this.thumbnails[0].frames.slice(e)
                              : this.thumbnails[0].frames.slice(0, e).reverse();
                            let o = !1;
                            r.forEach((e) => {
                              const t = e.text;
                              if (t !== n && !this.loadedImages.includes(t)) {
                                (o = !0),
                                  this.player.debug.log(
                                    `Preloading thumb filename: ${t}`
                                  );
                                const { urlPrefix: e } = this.thumbnails[0],
                                  n = e + t,
                                  r = new Image();
                                (r.src = n),
                                  (r.onload = () => {
                                    this.player.debug.log(
                                      `Preloaded thumb filename: ${t}`
                                    ),
                                      this.loadedImages.includes(t) ||
                                        this.loadedImages.push(t),
                                      i();
                                  });
                              }
                            }),
                              o || i();
                          }
                        }, 300);
                      })
                  ),
                  e(this, "getHigherQuality", (e, t, i, n) => {
                    if (e < this.thumbnails.length - 1) {
                      let r = t.naturalHeight;
                      this.usingSprites && (r = i.h),
                        r < this.thumbContainerHeight &&
                          setTimeout(() => {
                            this.showingThumbFilename === n &&
                              (this.player.debug.log(
                                `Showing higher quality thumb for: ${n}`
                              ),
                              this.loadImage(e + 1));
                          }, 300);
                    }
                  }),
                  e(this, "toggleThumbContainer", (e = !1, t = !1) => {
                    const i =
                      this.player.config.classNames.previewThumbnails
                        .thumbContainerShown;
                    this.elements.thumb.container.classList.toggle(i, e),
                      !e &&
                        t &&
                        ((this.showingThumb = null),
                        (this.showingThumbFilename = null));
                  }),
                  e(this, "toggleScrubbingContainer", (e = !1) => {
                    const t =
                      this.player.config.classNames.previewThumbnails
                        .scrubbingContainerShown;
                    this.elements.scrubbing.container.classList.toggle(t, e),
                      e ||
                        ((this.showingThumb = null),
                        (this.showingThumbFilename = null));
                  }),
                  e(this, "determineContainerAutoSizing", () => {
                    (this.elements.thumb.imageContainer.clientHeight > 20 ||
                      this.elements.thumb.imageContainer.clientWidth > 20) &&
                      (this.sizeSpecifiedInCSS = !0);
                  }),
                  e(this, "setThumbContainerSizeAndPos", () => {
                    const { imageContainer: e } = this.elements.thumb;
                    if (this.sizeSpecifiedInCSS) {
                      if (e.clientHeight > 20 && e.clientWidth < 20) {
                        const t = Math.floor(
                          e.clientHeight * this.thumbAspectRatio
                        );
                        e.style.width = `${t}px`;
                      } else if (e.clientHeight < 20 && e.clientWidth > 20) {
                        const t = Math.floor(
                          e.clientWidth / this.thumbAspectRatio
                        );
                        e.style.height = `${t}px`;
                      }
                    } else {
                      const t = Math.floor(
                        this.thumbContainerHeight * this.thumbAspectRatio
                      );
                      (e.style.height = `${this.thumbContainerHeight}px`),
                        (e.style.width = `${t}px`);
                    }
                    this.setThumbContainerPos();
                  }),
                  e(this, "setThumbContainerPos", () => {
                    const e =
                        this.player.elements.progress.getBoundingClientRect(),
                      t =
                        this.player.elements.container.getBoundingClientRect(),
                      { container: i } = this.elements.thumb,
                      n = t.left - e.left + 10,
                      r = t.right - e.left - i.clientWidth - 10,
                      o = this.mousePosX - e.left - i.clientWidth / 2,
                      a = Ge(o, n, r);
                    (i.style.left = `${a}px`),
                      i.style.setProperty(
                        "--preview-arrow-offset",
                        o - a + "px"
                      );
                  }),
                  e(this, "setScrubbingContainerSize", () => {
                    const { width: e, height: t } = Ke(this.thumbAspectRatio, {
                      width: this.player.media.clientWidth,
                      height: this.player.media.clientHeight,
                    });
                    (this.elements.scrubbing.container.style.width = `${e}px`),
                      (this.elements.scrubbing.container.style.height = `${t}px`);
                  }),
                  e(this, "setImageSizeAndOffset", (e, t) => {
                    if (!this.usingSprites) return;
                    const i = this.thumbContainerHeight / t.h;
                    (e.style.height = e.naturalHeight * i + "px"),
                      (e.style.width = e.naturalWidth * i + "px"),
                      (e.style.left = `-${t.x * i}px`),
                      (e.style.top = `-${t.y * i}px`);
                  }),
                  (this.player = t),
                  (this.thumbnails = []),
                  (this.loaded = !1),
                  (this.lastMouseMoveTime = Date.now()),
                  (this.mouseDown = !1),
                  (this.loadedImages = []),
                  (this.elements = { thumb: {}, scrubbing: {} }),
                  this.load();
              }
              get enabled() {
                return (
                  this.player.isHTML5 &&
                  this.player.isVideo &&
                  this.player.config.previewThumbnails.enabled
                );
              }
              get currentImageContainer() {
                return this.mouseDown
                  ? this.elements.scrubbing.container
                  : this.elements.thumb.imageContainer;
              }
              get usingSprites() {
                return Object.keys(this.thumbnails[0].frames[0]).includes("w");
              }
              get thumbAspectRatio() {
                return this.usingSprites
                  ? this.thumbnails[0].frames[0].w /
                      this.thumbnails[0].frames[0].h
                  : this.thumbnails[0].width / this.thumbnails[0].height;
              }
              get thumbContainerHeight() {
                if (this.mouseDown) {
                  const { height: e } = Ke(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight,
                  });
                  return e;
                }
                return this.sizeSpecifiedInCSS
                  ? this.elements.thumb.imageContainer.clientHeight
                  : Math.floor(
                      this.player.media.clientWidth / this.thumbAspectRatio / 4
                    );
              }
              get currentImageElement() {
                return this.mouseDown
                  ? this.currentScrubbingImageElement
                  : this.currentThumbnailImageElement;
              }
              set currentImageElement(e) {
                this.mouseDown
                  ? (this.currentScrubbingImageElement = e)
                  : (this.currentThumbnailImageElement = e);
              }
            }
            const Xe = {
              insertElements(e, t) {
                A.string(t)
                  ? M(e, this.media, { src: t })
                  : A.array(t) &&
                    t.forEach((t) => {
                      M(e, this.media, t);
                    });
              },
              change(e) {
                x(e, "sources.length")
                  ? (he.cancelRequests.call(this),
                    this.destroy.call(
                      this,
                      () => {
                        (this.options.quality = []),
                          N(this.media),
                          (this.media = null),
                          A.element(this.elements.container) &&
                            this.elements.container.removeAttribute("class");
                        const { sources: t, type: i } = e,
                          [{ provider: n = Le.html5, src: r }] = t,
                          o = "html5" === n ? i : "div",
                          a = "html5" === n ? {} : { src: r };
                        Object.assign(this, {
                          provider: n,
                          type: i,
                          supported: G.check(i, n, this.config.playsinline),
                          media: q(o, a),
                        }),
                          this.elements.container.appendChild(this.media),
                          A.boolean(e.autoplay) &&
                            (this.config.autoplay = e.autoplay),
                          this.isHTML5 &&
                            (this.config.crossorigin &&
                              this.media.setAttribute("crossorigin", ""),
                            this.config.autoplay &&
                              this.media.setAttribute("autoplay", ""),
                            A.empty(e.poster) || (this.poster = e.poster),
                            this.config.loop.active &&
                              this.media.setAttribute("loop", ""),
                            this.config.muted &&
                              this.media.setAttribute("muted", ""),
                            this.config.playsinline &&
                              this.media.setAttribute("playsinline", "")),
                          je.addStyleHook.call(this),
                          this.isHTML5 &&
                            Xe.insertElements.call(this, "source", t),
                          (this.config.title = e.title),
                          We.setup.call(this),
                          this.isHTML5 &&
                            Object.keys(e).includes("tracks") &&
                            Xe.insertElements.call(this, "track", e.tracks),
                          (this.isHTML5 ||
                            (this.isEmbed && !this.supported.ui)) &&
                            je.build.call(this),
                          this.isHTML5 && this.media.load(),
                          A.empty(e.previewThumbnails) ||
                            (Object.assign(
                              this.config.previewThumbnails,
                              e.previewThumbnails
                            ),
                            this.previewThumbnails &&
                              this.previewThumbnails.loaded &&
                              (this.previewThumbnails.destroy(),
                              (this.previewThumbnails = null)),
                            this.config.previewThumbnails.enabled &&
                              (this.previewThumbnails = new Ye(this))),
                          this.fullscreen.update();
                      },
                      !0
                    ))
                  : this.debug.warn("Invalid source format");
              },
            };
            class Je {
              constructor(t, i) {
                if (
                  (e(this, "play", () =>
                    A.function(this.media.play)
                      ? (this.ads &&
                          this.ads.enabled &&
                          this.ads.managerPromise
                            .then(() => this.ads.play())
                            .catch(() => ie(this.media.play())),
                        this.media.play())
                      : null
                  ),
                  e(this, "pause", () =>
                    this.playing && A.function(this.media.pause)
                      ? this.media.pause()
                      : null
                  ),
                  e(this, "togglePlay", (e) =>
                    (A.boolean(e) ? e : !this.playing)
                      ? this.play()
                      : this.pause()
                  ),
                  e(this, "stop", () => {
                    this.isHTML5
                      ? (this.pause(), this.restart())
                      : A.function(this.media.stop) && this.media.stop();
                  }),
                  e(this, "restart", () => {
                    this.currentTime = 0;
                  }),
                  e(this, "rewind", (e) => {
                    this.currentTime -= A.number(e) ? e : this.config.seekTime;
                  }),
                  e(this, "forward", (e) => {
                    this.currentTime += A.number(e) ? e : this.config.seekTime;
                  }),
                  e(this, "increaseVolume", (e) => {
                    const t = this.media.muted ? 0 : this.volume;
                    this.volume = t + (A.number(e) ? e : 0);
                  }),
                  e(this, "decreaseVolume", (e) => {
                    this.increaseVolume(-e);
                  }),
                  e(this, "airplay", () => {
                    G.airplay && this.media.webkitShowPlaybackTargetPicker();
                  }),
                  e(this, "toggleControls", (e) => {
                    if (this.supported.ui && !this.isAudio) {
                      const t = R(
                          this.elements.container,
                          this.config.classNames.hideControls
                        ),
                        i = void 0 === e ? void 0 : !e,
                        n = F(
                          this.elements.container,
                          this.config.classNames.hideControls,
                          i
                        );
                      if (
                        (n &&
                          A.array(this.config.controls) &&
                          this.config.controls.includes("settings") &&
                          !A.empty(this.config.settings) &&
                          Te.toggleMenu.call(this, !1),
                        n !== t)
                      ) {
                        const e = n ? "controlshidden" : "controlsshown";
                        Z.call(this, this.media, e);
                      }
                      return !n;
                    }
                    return !1;
                  }),
                  e(this, "on", (e, t) => {
                    Y.call(this, this.elements.container, e, t);
                  }),
                  e(this, "once", (e, t) => {
                    J.call(this, this.elements.container, e, t);
                  }),
                  e(this, "off", (e, t) => {
                    X(this.elements.container, e, t);
                  }),
                  e(this, "destroy", (e, t = !1) => {
                    if (!this.ready) return;
                    const i = () => {
                      (document.body.style.overflow = ""),
                        (this.embed = null),
                        t
                          ? (Object.keys(this.elements).length &&
                              (N(this.elements.buttons.play),
                              N(this.elements.captions),
                              N(this.elements.controls),
                              N(this.elements.wrapper),
                              (this.elements.buttons.play = null),
                              (this.elements.captions = null),
                              (this.elements.controls = null),
                              (this.elements.wrapper = null)),
                            A.function(e) && e())
                          : (ee.call(this),
                            he.cancelRequests.call(this),
                            V(this.elements.original, this.elements.container),
                            Z.call(
                              this,
                              this.elements.original,
                              "destroyed",
                              !0
                            ),
                            A.function(e) && e.call(this.elements.original),
                            (this.ready = !1),
                            setTimeout(() => {
                              (this.elements = null), (this.media = null);
                            }, 200));
                    };
                    this.stop(),
                      clearTimeout(this.timers.loading),
                      clearTimeout(this.timers.controls),
                      clearTimeout(this.timers.resized),
                      this.isHTML5
                        ? (je.toggleNativeControls.call(this, !0), i())
                        : this.isYouTube
                        ? (clearInterval(this.timers.buffering),
                          clearInterval(this.timers.playing),
                          null !== this.embed &&
                            A.function(this.embed.destroy) &&
                            this.embed.destroy(),
                          i())
                        : this.isVimeo &&
                          (null !== this.embed && this.embed.unload().then(i),
                          setTimeout(i, 200));
                  }),
                  e(this, "supports", (e) => G.mime.call(this, e)),
                  (this.timers = {}),
                  (this.ready = !1),
                  (this.loading = !1),
                  (this.failed = !1),
                  (this.touch = G.touch),
                  (this.media = t),
                  A.string(this.media) &&
                    (this.media = document.querySelectorAll(this.media)),
                  ((window.jQuery && this.media instanceof jQuery) ||
                    A.nodeList(this.media) ||
                    A.array(this.media)) &&
                    (this.media = this.media[0]),
                  (this.config = L(
                    {},
                    Ce,
                    Je.defaults,
                    i || {},
                    (() => {
                      try {
                        return JSON.parse(
                          this.media.getAttribute("data-plyr-config")
                        );
                      } catch (e) {
                        return {};
                      }
                    })()
                  )),
                  (this.elements = {
                    container: null,
                    fullscreen: null,
                    captions: null,
                    buttons: {},
                    display: {},
                    progress: {},
                    inputs: {},
                    settings: {
                      popup: null,
                      menu: null,
                      panels: {},
                      buttons: {},
                    },
                  }),
                  (this.captions = {
                    active: null,
                    currentTrack: -1,
                    meta: new WeakMap(),
                  }),
                  (this.fullscreen = { active: !1 }),
                  (this.options = { speed: [], quality: [] }),
                  (this.debug = new qe(this.config.debug)),
                  this.debug.log("Config", this.config),
                  this.debug.log("Support", G),
                  A.nullOrUndefined(this.media) || !A.element(this.media))
                )
                  return void this.debug.error(
                    "Setup failed: no suitable element passed"
                  );
                if (this.media.plyr)
                  return void this.debug.warn("Target already setup");
                if (!this.config.enabled)
                  return void this.debug.error(
                    "Setup failed: disabled by config"
                  );
                if (!G.check().api)
                  return void this.debug.error("Setup failed: no support");
                const n = this.media.cloneNode(!0);
                (n.autoplay = !1), (this.elements.original = n);
                const r = this.media.tagName.toLowerCase();
                let o = null,
                  a = null;
                switch (r) {
                  case "div":
                    if (
                      ((o = this.media.querySelector("iframe")), A.element(o))
                    ) {
                      if (
                        ((a = Ae(o.getAttribute("src"))),
                        (this.provider = (function (e) {
                          return /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
                            e
                          )
                            ? Le.youtube
                            : /^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(
                                e
                              )
                            ? Le.vimeo
                            : null;
                        })(a.toString())),
                        (this.elements.container = this.media),
                        (this.media = o),
                        (this.elements.container.className = ""),
                        a.search.length)
                      ) {
                        const e = ["1", "true"];
                        e.includes(a.searchParams.get("autoplay")) &&
                          (this.config.autoplay = !0),
                          e.includes(a.searchParams.get("loop")) &&
                            (this.config.loop.active = !0),
                          this.isYouTube
                            ? ((this.config.playsinline = e.includes(
                                a.searchParams.get("playsinline")
                              )),
                              (this.config.youtube.hl =
                                a.searchParams.get("hl")))
                            : (this.config.playsinline = !0);
                      }
                    } else
                      (this.provider = this.media.getAttribute(
                        this.config.attributes.embed.provider
                      )),
                        this.media.removeAttribute(
                          this.config.attributes.embed.provider
                        );
                    if (
                      A.empty(this.provider) ||
                      !Object.values(Le).includes(this.provider)
                    )
                      return void this.debug.error(
                        "Setup failed: Invalid provider"
                      );
                    this.type = Ie;
                    break;
                  case "video":
                  case "audio":
                    (this.type = r),
                      (this.provider = Le.html5),
                      this.media.hasAttribute("crossorigin") &&
                        (this.config.crossorigin = !0),
                      this.media.hasAttribute("autoplay") &&
                        (this.config.autoplay = !0),
                      (this.media.hasAttribute("playsinline") ||
                        this.media.hasAttribute("webkit-playsinline")) &&
                        (this.config.playsinline = !0),
                      this.media.hasAttribute("muted") &&
                        (this.config.muted = !0),
                      this.media.hasAttribute("loop") &&
                        (this.config.loop.active = !0);
                    break;
                  default:
                    return void this.debug.error(
                      "Setup failed: unsupported type"
                    );
                }
                (this.supported = G.check(this.type, this.provider)),
                  this.supported.api
                    ? ((this.eventListeners = []),
                      (this.listeners = new Ve(this)),
                      (this.storage = new be(this)),
                      (this.media.plyr = this),
                      A.element(this.elements.container) ||
                        ((this.elements.container = q("div")),
                        I(this.media, this.elements.container)),
                      je.migrateStyles.call(this),
                      je.addStyleHook.call(this),
                      We.setup.call(this),
                      this.config.debug &&
                        Y.call(
                          this,
                          this.elements.container,
                          this.config.events.join(" "),
                          (e) => {
                            this.debug.log(`event: ${e.type}`);
                          }
                        ),
                      (this.fullscreen = new Me(this)),
                      (this.isHTML5 || (this.isEmbed && !this.supported.ui)) &&
                        je.build.call(this),
                      this.listeners.container(),
                      this.listeners.global(),
                      this.config.ads.enabled && (this.ads = new ze(this)),
                      this.isHTML5 &&
                        this.config.autoplay &&
                        this.once("canplay", () => ie(this.play())),
                      (this.lastSeekTime = 0),
                      this.config.previewThumbnails.enabled &&
                        (this.previewThumbnails = new Ye(this)))
                    : this.debug.error("Setup failed: no support");
              }
              get isHTML5() {
                return this.provider === Le.html5;
              }
              get isEmbed() {
                return this.isYouTube || this.isVimeo;
              }
              get isYouTube() {
                return this.provider === Le.youtube;
              }
              get isVimeo() {
                return this.provider === Le.vimeo;
              }
              get isVideo() {
                return this.type === Ie;
              }
              get isAudio() {
                return "audio" === this.type;
              }
              get playing() {
                return Boolean(this.ready && !this.paused && !this.ended);
              }
              get paused() {
                return Boolean(this.media.paused);
              }
              get stopped() {
                return Boolean(this.paused && 0 === this.currentTime);
              }
              get ended() {
                return Boolean(this.media.ended);
              }
              set currentTime(e) {
                if (!this.duration) return;
                const t = A.number(e) && e > 0;
                (this.media.currentTime = t ? Math.min(e, this.duration) : 0),
                  this.debug.log(`Seeking to ${this.currentTime} seconds`);
              }
              get currentTime() {
                return Number(this.media.currentTime);
              }
              get buffered() {
                const { buffered: e } = this.media;
                return A.number(e)
                  ? e
                  : e && e.length && this.duration > 0
                  ? e.end(0) / this.duration
                  : 0;
              }
              get seeking() {
                return Boolean(this.media.seeking);
              }
              get duration() {
                const e = parseFloat(this.config.duration),
                  t = (this.media || {}).duration,
                  i = A.number(t) && t !== 1 / 0 ? t : 0;
                return e || i;
              }
              set volume(e) {
                let t = e;
                A.string(t) && (t = Number(t)),
                  A.number(t) || (t = this.storage.get("volume")),
                  A.number(t) || ({ volume: t } = this.config),
                  t > 1 && (t = 1),
                  t < 0 && (t = 0),
                  (this.config.volume = t),
                  (this.media.volume = t),
                  !A.empty(e) && this.muted && t > 0 && (this.muted = !1);
              }
              get volume() {
                return Number(this.media.volume);
              }
              set muted(e) {
                let t = e;
                A.boolean(t) || (t = this.storage.get("muted")),
                  A.boolean(t) || (t = this.config.muted),
                  (this.config.muted = t),
                  (this.media.muted = t);
              }
              get muted() {
                return Boolean(this.media.muted);
              }
              get hasAudio() {
                return (
                  !this.isHTML5 ||
                  !!this.isAudio ||
                  Boolean(this.media.mozHasAudio) ||
                  Boolean(this.media.webkitAudioDecodedByteCount) ||
                  Boolean(
                    this.media.audioTracks && this.media.audioTracks.length
                  )
                );
              }
              set speed(e) {
                let t = null;
                A.number(e) && (t = e),
                  A.number(t) || (t = this.storage.get("speed")),
                  A.number(t) || (t = this.config.speed.selected);
                const { minimumSpeed: i, maximumSpeed: n } = this;
                (t = Ge(t, i, n)),
                  (this.config.speed.selected = t),
                  setTimeout(() => {
                    this.media && (this.media.playbackRate = t);
                  }, 0);
              }
              get speed() {
                return Number(this.media.playbackRate);
              }
              get minimumSpeed() {
                return this.isYouTube
                  ? Math.min(...this.options.speed)
                  : this.isVimeo
                  ? 0.5
                  : 0.0625;
              }
              get maximumSpeed() {
                return this.isYouTube
                  ? Math.max(...this.options.speed)
                  : this.isVimeo
                  ? 2
                  : 16;
              }
              set quality(e) {
                const t = this.config.quality,
                  i = this.options.quality;
                if (!i.length) return;
                let n = [
                    !A.empty(e) && Number(e),
                    this.storage.get("quality"),
                    t.selected,
                    t.default,
                  ].find(A.number),
                  r = !0;
                if (!i.includes(n)) {
                  const e = re(i, n);
                  this.debug.warn(
                    `Unsupported quality option: ${n}, using ${e} instead`
                  ),
                    (n = e),
                    (r = !1);
                }
                (t.selected = n),
                  (this.media.quality = n),
                  r && this.storage.set({ quality: n });
              }
              get quality() {
                return this.media.quality;
              }
              set loop(e) {
                const t = A.boolean(e) ? e : this.config.loop.active;
                (this.config.loop.active = t), (this.media.loop = t);
              }
              get loop() {
                return Boolean(this.media.loop);
              }
              set source(e) {
                Xe.change.call(this, e);
              }
              get source() {
                return this.media.currentSrc;
              }
              get download() {
                const { download: e } = this.config.urls;
                return A.url(e) ? e : this.source;
              }
              set download(e) {
                A.url(e) &&
                  ((this.config.urls.download = e),
                  Te.setDownloadUrl.call(this));
              }
              set poster(e) {
                this.isVideo
                  ? je.setPoster.call(this, e, !1).catch(() => {})
                  : this.debug.warn("Poster can only be set for video");
              }
              get poster() {
                return this.isVideo
                  ? this.media.getAttribute("poster") ||
                      this.media.getAttribute("data-poster")
                  : null;
              }
              get ratio() {
                if (!this.isVideo) return null;
                const e = le(ce.call(this));
                return A.array(e) ? e.join(":") : e;
              }
              set ratio(e) {
                this.isVideo
                  ? A.string(e) && se(e)
                    ? ((this.config.ratio = le(e)), ue.call(this))
                    : this.debug.error(`Invalid aspect ratio specified (${e})`)
                  : this.debug.warn("Aspect ratio can only be set for video");
              }
              set autoplay(e) {
                this.config.autoplay = A.boolean(e) ? e : this.config.autoplay;
              }
              get autoplay() {
                return Boolean(this.config.autoplay);
              }
              toggleCaptions(e) {
                _e.toggle.call(this, e, !1);
              }
              set currentTrack(e) {
                _e.set.call(this, e, !1), _e.setup.call(this);
              }
              get currentTrack() {
                const { toggled: e, currentTrack: t } = this.captions;
                return e ? t : -1;
              }
              set language(e) {
                _e.setLanguage.call(this, e, !1);
              }
              get language() {
                return (_e.getCurrentTrack.call(this) || {}).language;
              }
              set pip(e) {
                if (!G.pip) return;
                const t = A.boolean(e) ? e : !this.pip;
                A.function(this.media.webkitSetPresentationMode) &&
                  this.media.webkitSetPresentationMode(t ? xe : "inline"),
                  A.function(this.media.requestPictureInPicture) &&
                    (!this.pip && t
                      ? this.media.requestPictureInPicture()
                      : this.pip && !t && document.exitPictureInPicture());
              }
              get pip() {
                return G.pip
                  ? A.empty(this.media.webkitPresentationMode)
                    ? this.media === document.pictureInPictureElement
                    : this.media.webkitPresentationMode === xe
                  : null;
              }
              setPreviewThumbnails(e) {
                this.previewThumbnails &&
                  this.previewThumbnails.loaded &&
                  (this.previewThumbnails.destroy(),
                  (this.previewThumbnails = null)),
                  Object.assign(this.config.previewThumbnails, e),
                  this.config.previewThumbnails.enabled &&
                    (this.previewThumbnails = new Ye(this));
              }
              static supported(e, t) {
                return G.check(e, t);
              }
              static loadSprite(e, t) {
                return Se(e, t);
              }
              static setup(e, t = {}) {
                let i = null;
                return (
                  A.string(e)
                    ? (i = Array.from(document.querySelectorAll(e)))
                    : A.nodeList(e)
                    ? (i = Array.from(e))
                    : A.array(e) && (i = e.filter(A.element)),
                  A.empty(i) ? null : i.map((e) => new Je(e, t))
                );
              }
            }
            var Ze;
            return (
              (Je.defaults = ((Ze = Ce), JSON.parse(JSON.stringify(Ze)))), Je
            );
          })());
      },
      394: function (e, t, i) {
        var n, r;
        Element.prototype.matches ||
          (Element.prototype.matches =
            Element.prototype.msMatchesSelector ||
            Element.prototype.webkitMatchesSelector),
          (r =
            void 0 !== i.g
              ? i.g
              : "undefined" != typeof window
              ? window
              : this),
          (n = function () {
            return (function (e) {
              "use strict";
              var t = {
                  idPrefix: "tabby-toggle_",
                  default: "[data-tabby-default]",
                },
                i = function (t) {
                  if (t && "true" != t.getAttribute("aria-selected")) {
                    var i = document.querySelector(t.hash);
                    if (i) {
                      var n = (function (e) {
                        var t = e.closest('[role="tablist"]');
                        if (!t) return {};
                        var i = t.querySelector(
                          '[role="tab"][aria-selected="true"]'
                        );
                        if (!i) return {};
                        var n = document.querySelector(i.hash);
                        return (
                          i.setAttribute("aria-selected", "false"),
                          i.setAttribute("tabindex", "-1"),
                          n
                            ? (n.setAttribute("hidden", "hidden"),
                              { previousTab: i, previousContent: n })
                            : { previousTab: i }
                        );
                      })(t);
                      !(function (e, t) {
                        e.setAttribute("aria-selected", "true"),
                          e.setAttribute("tabindex", "0"),
                          t.removeAttribute("hidden"),
                          e.focus();
                      })(t, i),
                        (n.tab = t),
                        (n.content = i),
                        (function (t, i) {
                          var n;
                          "function" == typeof e.CustomEvent
                            ? (n = new CustomEvent("tabby", {
                                bubbles: !0,
                                cancelable: !0,
                                detail: i,
                              }))
                            : (n =
                                document.createEvent(
                                  "CustomEvent"
                                )).initCustomEvent("tabby", !0, !0, i),
                            t.dispatchEvent(n);
                        })(t, n);
                    }
                  }
                };
              return function (n, r) {
                var o,
                  a,
                  s = {
                    destroy: function () {
                      var e = a.querySelectorAll("a");
                      Array.prototype.forEach.call(e, function (e) {
                        var t = document.querySelector(e.hash);
                        t &&
                          (function (e, t, i) {
                            e.id.slice(0, i.idPrefix.length) === i.idPrefix &&
                              (e.id = ""),
                              e.removeAttribute("role"),
                              e.removeAttribute("aria-controls"),
                              e.removeAttribute("aria-selected"),
                              e.removeAttribute("tabindex"),
                              e.closest("li").removeAttribute("role"),
                              t.removeAttribute("role"),
                              t.removeAttribute("aria-labelledby"),
                              t.removeAttribute("hidden");
                          })(e, t, o);
                      }),
                        a.removeAttribute("role"),
                        document.documentElement.removeEventListener(
                          "click",
                          l,
                          !0
                        ),
                        a.removeEventListener("keydown", c, !0),
                        (o = null),
                        (a = null);
                    },
                    setup: function () {
                      if ((a = document.querySelector(n))) {
                        var e = a.querySelectorAll("a");
                        a.setAttribute("role", "tablist"),
                          Array.prototype.forEach.call(e, function (e) {
                            var t = document.querySelector(e.hash);
                            t &&
                              (function (e, t, i) {
                                e.id || (e.id = i.idPrefix + t.id),
                                  e.setAttribute("role", "tab"),
                                  e.setAttribute("aria-controls", t.id),
                                  e
                                    .closest("li")
                                    .setAttribute("role", "presentation"),
                                  t.setAttribute("role", "tabpanel"),
                                  t.setAttribute("aria-labelledby", e.id),
                                  e.matches(i.default)
                                    ? e.setAttribute("aria-selected", "true")
                                    : (e.setAttribute("aria-selected", "false"),
                                      e.setAttribute("tabindex", "-1"),
                                      t.setAttribute("hidden", "hidden"));
                              })(e, t, o);
                          });
                      }
                    },
                    toggle: function (e) {
                      var t = e;
                      "string" == typeof e &&
                        (t = document.querySelector(
                          n + ' [role="tab"][href*="' + e + '"]'
                        )),
                        i(t);
                    },
                  },
                  l = function (e) {
                    var t = e.target.closest(n + ' [role="tab"]');
                    t && (e.preventDefault(), i(t));
                  },
                  c = function (e) {
                    var t = document.activeElement;
                    t.matches(n + ' [role="tab"]') &&
                      ([
                        "ArrowUp",
                        "ArrowDown",
                        "ArrowLeft",
                        "ArrowRight",
                        "Up",
                        "Down",
                        "Left",
                        "Right",
                        "Home",
                        "End",
                      ].indexOf(e.key) < 0 ||
                        (function (e, t) {
                          var n = (function (e) {
                            var t = e.closest('[role="tablist"]'),
                              i = t ? t.querySelectorAll('[role="tab"]') : null;
                            if (i)
                              return {
                                tabs: i,
                                index: Array.prototype.indexOf.call(i, e),
                              };
                          })(e);
                          if (n) {
                            var r,
                              o = n.tabs.length - 1;
                            ["ArrowUp", "ArrowLeft", "Up", "Left"].indexOf(t) >
                            -1
                              ? (r = n.index < 1 ? o : n.index - 1)
                              : [
                                  "ArrowDown",
                                  "ArrowRight",
                                  "Down",
                                  "Right",
                                ].indexOf(t) > -1
                              ? (r = n.index === o ? 0 : n.index + 1)
                              : "Home" === t
                              ? (r = 0)
                              : "End" === t && (r = o),
                              i(n.tabs[r]);
                          }
                        })(t, e.key));
                  };
                return (
                  (o = (function () {
                    var e = {};
                    return (
                      Array.prototype.forEach.call(arguments, function (t) {
                        for (var i in t) {
                          if (!t.hasOwnProperty(i)) return;
                          e[i] = t[i];
                        }
                      }),
                      e
                    );
                  })(t, r || {})),
                  s.setup(),
                  (function (t) {
                    if (!(e.location.hash.length < 1)) {
                      var n = document.querySelector(
                        t + ' [role="tab"][href*="' + e.location.hash + '"]'
                      );
                      i(n);
                    }
                  })(n),
                  document.documentElement.addEventListener("click", l, !0),
                  a.addEventListener("keydown", c, !0),
                  s
                );
              };
            })(r);
          }.apply(t, [])),
          void 0 === n || (e.exports = n);
      },
    },
    s = {};
  function l(e) {
    var t = s[e];
    if (void 0 !== t) return t.exports;
    var i = (s[e] = { exports: {} });
    return a[e].call(i.exports, i, i.exports, l), i.exports;
  }
  (l.m = a),
    (l.n = (e) => {
      var t = e && e.__esModule ? () => e.default : () => e;
      return l.d(t, { a: t }), t;
    }),
    (t = Object.getPrototypeOf
      ? (e) => Object.getPrototypeOf(e)
      : (e) => e.__proto__),
    (l.t = function (i, n) {
      if ((1 & n && (i = this(i)), 8 & n)) return i;
      if ("object" == typeof i && i) {
        if (4 & n && i.__esModule) return i;
        if (16 & n && "function" == typeof i.then) return i;
      }
      var r = Object.create(null);
      l.r(r);
      var o = {};
      e = e || [null, t({}), t([]), t(t)];
      for (var a = 2 & n && i; "object" == typeof a && !~e.indexOf(a); a = t(a))
        Object.getOwnPropertyNames(a).forEach((e) => (o[e] = () => i[e]));
      return (o.default = () => i), l.d(r, o), r;
    }),
    (l.d = (e, t) => {
      for (var i in t)
        l.o(t, i) &&
          !l.o(e, i) &&
          Object.defineProperty(e, i, { enumerable: !0, get: t[i] });
    }),
    (l.f = {}),
    (l.e = (e) =>
      Promise.all(Object.keys(l.f).reduce((t, i) => (l.f[i](e, t), t), []))),
    (l.u = (e) =>
      "chunk." +
      { 220: "90b0a", 252: "a05ac", 443: "3e0e3", 961: "ba2d5" }[e] +
      ".js"),
    (l.miniCssF = (e) =>
      961 === e ? "chunk.961.css" : 220 === e ? "chunk.220.css" : void 0),
    (l.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    })()),
    (l.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
    (i = {}),
    (n = "original:"),
    (l.l = (e, t, r, o) => {
      if (i[e]) i[e].push(t);
      else {
        var a, s;
        if (void 0 !== r)
          for (
            var c = document.getElementsByTagName("script"), u = 0;
            u < c.length;
            u++
          ) {
            var d = c[u];
            if (
              d.getAttribute("src") == e ||
              d.getAttribute("data-webpack") == n + r
            ) {
              a = d;
              break;
            }
          }
        a ||
          ((s = !0),
          ((a = document.createElement("script")).charset = "utf-8"),
          (a.timeout = 120),
          l.nc && a.setAttribute("nonce", l.nc),
          a.setAttribute("data-webpack", n + r),
          (a.src = e)),
          (i[e] = [t]);
        var h = (t, n) => {
            (a.onerror = a.onload = null), clearTimeout(p);
            var r = i[e];
            if (
              (delete i[e],
              a.parentNode && a.parentNode.removeChild(a),
              r && r.forEach((e) => e(n)),
              t)
            )
              return t(n);
          },
          p = setTimeout(
            h.bind(null, void 0, { type: "timeout", target: a }),
            12e4
          );
        (a.onerror = h.bind(null, a.onerror)),
          (a.onload = h.bind(null, a.onload)),
          s && document.head.appendChild(a);
      }
    }),
    (l.r = (e) => {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(e, "__esModule", { value: !0 });
    }),
    (() => {
      var e;
      l.g.importScripts && (e = l.g.location + "");
      var t = l.g.document;
      if (!e && t && (t.currentScript && (e = t.currentScript.src), !e)) {
        var i = t.getElementsByTagName("script");
        if (i.length) for (var n = i.length - 1; n > -1 && !e; ) e = i[n--].src;
      }
      if (!e)
        throw new Error(
          "Automatic publicPath is not supported in this browser"
        );
      (e = e
        .replace(/#.*$/, "")
        .replace(/\?.*$/, "")
        .replace(/\/[^\/]+$/, "/")),
        (l.p = e);
    })(),
    (r = (e) =>
      new Promise((t, i) => {
        var n = l.miniCssF(e),
          r = l.p + n;
        if (
          ((e, t) => {
            for (
              var i = document.getElementsByTagName("link"), n = 0;
              n < i.length;
              n++
            ) {
              var r =
                (a = i[n]).getAttribute("data-href") || a.getAttribute("href");
              if ("stylesheet" === a.rel && (r === e || r === t)) return a;
            }
            var o = document.getElementsByTagName("style");
            for (n = 0; n < o.length; n++) {
              var a;
              if ((r = (a = o[n]).getAttribute("data-href")) === e || r === t)
                return a;
            }
          })(n, r)
        )
          return t();
        ((e, t, i, n) => {
          var r = document.createElement("link");
          (r.rel = "stylesheet"),
            (r.type = "text/css"),
            (r.onerror = r.onload =
              (o) => {
                if (((r.onerror = r.onload = null), "load" === o.type)) i();
                else {
                  var a = o && ("load" === o.type ? "missing" : o.type),
                    s = (o && o.target && o.target.href) || t,
                    l = new Error(
                      "Loading CSS chunk " + e + " failed.\n(" + s + ")"
                    );
                  (l.code = "CSS_CHUNK_LOAD_FAILED"),
                    (l.type = a),
                    (l.request = s),
                    r.parentNode.removeChild(r),
                    n(l);
                }
              }),
            (r.href = t),
            document.head.appendChild(r);
        })(e, r, t, i);
      })),
    (o = { 685: 0, 443: 0 }),
    (l.f.miniCss = (e, t) => {
      o[e]
        ? t.push(o[e])
        : 0 !== o[e] &&
          { 220: 1, 961: 1 }[e] &&
          t.push(
            (o[e] = r(e).then(
              () => {
                o[e] = 0;
              },
              (t) => {
                throw (delete o[e], t);
              }
            ))
          );
    }),
    (() => {
      var e = { 685: 0, 443: 0 };
      l.f.j = (t, i) => {
        var n = l.o(e, t) ? e[t] : void 0;
        if (0 !== n)
          if (n) i.push(n[2]);
          else {
            var r = new Promise((i, r) => (n = e[t] = [i, r]));
            i.push((n[2] = r));
            var o = l.p + l.u(t),
              a = new Error();
            l.l(
              o,
              (i) => {
                if (l.o(e, t) && (0 !== (n = e[t]) && (e[t] = void 0), n)) {
                  var r = i && ("load" === i.type ? "missing" : i.type),
                    o = i && i.target && i.target.src;
                  (a.message =
                    "Loading chunk " + t + " failed.\n(" + r + ": " + o + ")"),
                    (a.name = "ChunkLoadError"),
                    (a.type = r),
                    (a.request = o),
                    n[1](a);
                }
              },
              "chunk-" + t,
              t
            );
          }
      };
      var t = (t, i) => {
          var n,
            r,
            [o, a, s] = i,
            c = 0;
          if (o.some((t) => 0 !== e[t])) {
            for (n in a) l.o(a, n) && (l.m[n] = a[n]);
            s && s(l);
          }
          for (t && t(i); c < o.length; c++)
            (r = o[c]), l.o(e, r) && e[r] && e[r][0](), (e[r] = 0);
        },
        i = (self.webpackChunkoriginal = self.webpackChunkoriginal || []);
      i.forEach(t.bind(null, 0)), (i.push = t.bind(null, i.push.bind(i)));
    })(),
    (() => {
      "use strict";
      var e = "data-section-id";
      function t(t, i) {
        (this.container = (function (t) {
          if (!(t instanceof Element))
            throw new TypeError(
              "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
            );
          if (null === t.getAttribute(e))
            throw new Error(
              "Theme Sections: The section container provided does not have an id assigned to the " +
                e +
                " attribute."
            );
          return t;
        })(t)),
          (this.id = t.getAttribute(e)),
          (this.extensions = []),
          Object.assign(
            this,
            (function (e) {
              if ((void 0 !== e && "object" != typeof e) || null === e)
                throw new TypeError(
                  "Theme Sections: The properties object provided is not a valid"
                );
              return e;
            })(i)
          ),
          this.onLoad();
      }
      (t.prototype = {
        onLoad: Function.prototype,
        onUnload: Function.prototype,
        onSelect: Function.prototype,
        onDeselect: Function.prototype,
        onBlockSelect: Function.prototype,
        onBlockDeselect: Function.prototype,
        extend: function (e) {
          this.extensions.push(e);
          var t = Object.assign({}, e);
          delete t.init,
            Object.assign(this, t),
            "function" == typeof e.init && e.init.apply(this);
        },
      }),
        "function" != typeof Object.assign &&
          Object.defineProperty(Object, "assign", {
            value: function (e) {
              if (null == e)
                throw new TypeError(
                  "Cannot convert undefined or null to object"
                );
              for (var t = Object(e), i = 1; i < arguments.length; i++) {
                var n = arguments[i];
                if (null != n)
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
              }
              return t;
            },
            writable: !0,
            configurable: !0,
          });
      var i = "data-section-type",
        n = "data-section-id";
      (window.Shopify = window.Shopify || {}),
        (window.Shopify.theme = window.Shopify.theme || {}),
        (window.Shopify.theme.sections = window.Shopify.theme.sections || {});
      var r = (window.Shopify.theme.sections.registered =
          window.Shopify.theme.sections.registered || {}),
        o = (window.Shopify.theme.sections.instances =
          window.Shopify.theme.sections.instances || []);
      function a(e, i) {
        if ("string" != typeof e)
          throw new TypeError(
            "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
          );
        if (void 0 !== r[e])
          throw new Error(
            'Theme Sections: A section of type "' +
              e +
              '" has already been registered. You cannot register the same section type twice'
          );
        function n(e) {
          t.call(this, e, i);
        }
        return (
          (n.constructor = t),
          (n.prototype = Object.create(t.prototype)),
          (n.prototype.type = e),
          (r[e] = n)
        );
      }
      function s(e, t) {
        (e = d(e)),
          void 0 === t && (t = document.querySelectorAll("[" + i + "]")),
          (t = h(t)),
          e.forEach(function (e) {
            var n = r[e];
            void 0 !== n &&
              (t = t.filter(function (t) {
                return !(
                  c(t).length > 0 ||
                  null === t.getAttribute(i) ||
                  (t.getAttribute(i) === e && (o.push(new n(t)), 1))
                );
              }));
          });
      }
      function c(e) {
        var t = [];
        if (NodeList.prototype.isPrototypeOf(e) || Array.isArray(e))
          var i = e[0];
        return (
          e instanceof Element || i instanceof Element
            ? h(e).forEach(function (e) {
                t = t.concat(
                  o.filter(function (t) {
                    return t.container === e;
                  })
                );
              })
            : ("string" != typeof e && "string" != typeof i) ||
              d(e).forEach(function (e) {
                t = t.concat(
                  o.filter(function (t) {
                    return t.type === e;
                  })
                );
              }),
          t
        );
      }
      function u(e) {
        for (var t, i = 0; i < o.length; i++)
          if (o[i].id === e) {
            t = o[i];
            break;
          }
        return t;
      }
      function d(e) {
        return (
          "*" === e
            ? (e = Object.keys(r))
            : "string" == typeof e
            ? (e = [e])
            : e.constructor === t
            ? (e = [e.prototype.type])
            : Array.isArray(e) &&
              e[0].constructor === t &&
              (e = e.map(function (e) {
                return e.prototype.type;
              })),
          e.map(function (e) {
            return e.toLowerCase();
          })
        );
      }
      function h(e) {
        return (
          NodeList.prototype.isPrototypeOf(e) && e.length > 0
            ? (e = Array.prototype.slice.call(e))
            : (NodeList.prototype.isPrototypeOf(e) && 0 === e.length) ||
              null === e
            ? (e = [])
            : !Array.isArray(e) && e instanceof Element && (e = [e]),
          e
        );
      }
      window.Shopify.designMode &&
        (document.addEventListener("shopify:section:load", function (e) {
          var t = e.detail.sectionId,
            r = e.target.querySelector("[" + n + '="' + t + '"]');
          null !== r && s(r.getAttribute(i), r);
        }),
        document.addEventListener("shopify:section:unload", function (e) {
          var t = e.detail.sectionId,
            i = e.target.querySelector("[" + n + '="' + t + '"]');
          "object" == typeof c(i)[0] &&
            c(i).forEach(function (e) {
              var t = o
                .map(function (e) {
                  return e.id;
                })
                .indexOf(e.id);
              o.splice(t, 1), e.onUnload();
            });
        }),
        document.addEventListener("shopify:section:select", function (e) {
          var t = u(e.detail.sectionId);
          "object" == typeof t && t.onSelect(e);
        }),
        document.addEventListener("shopify:section:deselect", function (e) {
          var t = u(e.detail.sectionId);
          "object" == typeof t && t.onDeselect(e);
        }),
        document.addEventListener("shopify:block:select", function (e) {
          var t = u(e.detail.sectionId);
          "object" == typeof t && t.onBlockSelect(e);
        }),
        document.addEventListener("shopify:block:deselect", function (e) {
          var t = u(e.detail.sectionId);
          "object" == typeof t && t.onBlockDeselect(e);
        }));
      var p = l(2800);
      function f(e) {
        return (function (e, t, i, n) {
          return new (i || (i = Promise))(function (r, o) {
            function a(e) {
              try {
                l(n.next(e));
              } catch (e) {
                o(e);
              }
            }
            function s(e) {
              try {
                l(n.throw(e));
              } catch (e) {
                o(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? r(e.value)
                : ((t = e.value),
                  t instanceof i
                    ? t
                    : new i(function (e) {
                        e(t);
                      })).then(a, s);
            }
            l((n = n.apply(e, t || [])).next());
          });
        })(this, void 0, void 0, function () {
          var t;
          return (function (e, t) {
            var i,
              n,
              r,
              o,
              a = {
                label: 0,
                sent: function () {
                  if (1 & r[0]) throw r[1];
                  return r[1];
                },
                trys: [],
                ops: [],
              };
            return (
              (o = { next: s(0), throw: s(1), return: s(2) }),
              "function" == typeof Symbol &&
                (o[Symbol.iterator] = function () {
                  return this;
                }),
              o
            );
            function s(s) {
              return function (l) {
                return (function (s) {
                  if (i) throw new TypeError("Generator is already executing.");
                  for (; o && ((o = 0), s[0] && (a = 0)), a; )
                    try {
                      if (
                        ((i = 1),
                        n &&
                          (r =
                            2 & s[0]
                              ? n.return
                              : s[0]
                              ? n.throw || ((r = n.return) && r.call(n), 0)
                              : n.next) &&
                          !(r = r.call(n, s[1])).done)
                      )
                        return r;
                      switch (((n = 0), r && (s = [2 & s[0], r.value]), s[0])) {
                        case 0:
                        case 1:
                          r = s;
                          break;
                        case 4:
                          return a.label++, { value: s[1], done: !1 };
                        case 5:
                          a.label++, (n = s[1]), (s = [0]);
                          continue;
                        case 7:
                          (s = a.ops.pop()), a.trys.pop();
                          continue;
                        default:
                          if (
                            !(
                              (r =
                                (r = a.trys).length > 0 && r[r.length - 1]) ||
                              (6 !== s[0] && 2 !== s[0])
                            )
                          ) {
                            a = 0;
                            continue;
                          }
                          if (
                            3 === s[0] &&
                            (!r || (s[1] > r[0] && s[1] < r[3]))
                          ) {
                            a.label = s[1];
                            break;
                          }
                          if (6 === s[0] && a.label < r[1]) {
                            (a.label = r[1]), (r = s);
                            break;
                          }
                          if (r && a.label < r[2]) {
                            (a.label = r[2]), a.ops.push(s);
                            break;
                          }
                          r[2] && a.ops.pop(), a.trys.pop();
                          continue;
                      }
                      s = t.call(e, a);
                    } catch (e) {
                      (s = [6, e]), (n = 0);
                    } finally {
                      i = r = 0;
                    }
                  if (5 & s[0]) throw s[1];
                  return { value: s[0] ? s[1] : void 0, done: !0 };
                })([s, l]);
              };
            }
          })(this, function (i) {
            switch (i.label) {
              case 0:
                return (
                  (t = {
                    method: "POST",
                    body: JSON.stringify(e),
                    headers: { "Content-Type": "application/json" },
                  }),
                  [
                    4,
                    fetch("/cart/add.js", t)
                      .then(function (e) {
                        return e.json();
                      })
                      .catch(function (e) {
                        return console.log(e);
                      }),
                  ]
                );
              case 1:
                return [2, i.sent()];
            }
          });
        });
      }
      function m(e) {
        for (
          var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), n = 1;
          n < t;
          n++
        )
          i[n - 1] = arguments[n];
        throw Error(
          "[Immer] minified error nr: " +
            e +
            (i.length
              ? " " +
                i
                  .map(function (e) {
                    return "'" + e + "'";
                  })
                  .join(",")
              : "") +
            ". Find the full error at: https://bit.ly/3cXEKWf"
        );
      }
      function g(e) {
        return !!e && !!e[ie];
      }
      function y(e) {
        return (
          !!e &&
          ((function (e) {
            if (!e || "object" != typeof e) return !1;
            var t = Object.getPrototypeOf(e);
            if (null === t) return !0;
            var i =
              Object.hasOwnProperty.call(t, "constructor") && t.constructor;
            return (
              i === Object ||
              ("function" == typeof i && Function.toString.call(i) === ne)
            );
          })(e) ||
            Array.isArray(e) ||
            !!e[te] ||
            !!e.constructor[te] ||
            k(e) ||
            T(e))
        );
      }
      function v(e, t, i) {
        void 0 === i && (i = !1),
          0 === b(e)
            ? (i ? Object.keys : re)(e).forEach(function (n) {
                (i && "symbol" == typeof n) || t(n, e[n], e);
              })
            : e.forEach(function (i, n) {
                return t(n, i, e);
              });
      }
      function b(e) {
        var t = e[ie];
        return t
          ? t.i > 3
            ? t.i - 4
            : t.i
          : Array.isArray(e)
          ? 1
          : k(e)
          ? 2
          : T(e)
          ? 3
          : 0;
      }
      function w(e, t) {
        return 2 === b(e)
          ? e.has(t)
          : Object.prototype.hasOwnProperty.call(e, t);
      }
      function S(e, t, i) {
        var n = b(e);
        2 === n ? e.set(t, i) : 3 === n ? (e.delete(t), e.add(i)) : (e[t] = i);
      }
      function E(e, t) {
        return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
      }
      function k(e) {
        return X && e instanceof Map;
      }
      function T(e) {
        return J && e instanceof Set;
      }
      function A(e) {
        return e.o || e.t;
      }
      function P(e) {
        if (Array.isArray(e)) return Array.prototype.slice.call(e);
        var t = oe(e);
        delete t[ie];
        for (var i = re(t), n = 0; n < i.length; n++) {
          var r = i[n],
            o = t[r];
          !1 === o.writable && ((o.writable = !0), (o.configurable = !0)),
            (o.get || o.set) &&
              (t[r] = {
                configurable: !0,
                writable: !0,
                enumerable: o.enumerable,
                value: e[r],
              });
        }
        return Object.create(Object.getPrototypeOf(e), t);
      }
      function _(e, t) {
        return (
          void 0 === t && (t = !1),
          x(e) ||
            g(e) ||
            !y(e) ||
            (b(e) > 1 && (e.set = e.add = e.clear = e.delete = C),
            Object.freeze(e),
            t &&
              v(
                e,
                function (e, t) {
                  return _(t, !0);
                },
                !0
              )),
          e
        );
      }
      function C() {
        m(2);
      }
      function x(e) {
        return null == e || "object" != typeof e || Object.isFrozen(e);
      }
      function L(e) {
        var t = ae[e];
        return t || m(18, e), t;
      }
      function I() {
        return K;
      }
      function O(e, t) {
        t && (L("Patches"), (e.u = []), (e.s = []), (e.v = t));
      }
      function q(e) {
        M(e), e.p.forEach(j), (e.p = null);
      }
      function M(e) {
        e === K && (K = e.l);
      }
      function N(e) {
        return (K = { p: [], l: K, h: e, m: !0, _: 0 });
      }
      function j(e) {
        var t = e[ie];
        0 === t.i || 1 === t.i ? t.j() : (t.O = !0);
      }
      function V(e, t) {
        t._ = t.p.length;
        var i = t.p[0],
          n = void 0 !== e && e !== i;
        return (
          t.h.g || L("ES5").S(t, e, n),
          n
            ? (i[ie].P && (q(t), m(4)),
              y(e) && ((e = D(t, e)), t.l || F(t, e)),
              t.u && L("Patches").M(i[ie].t, e, t.u, t.s))
            : (e = D(t, i, [])),
          q(t),
          t.u && t.v(t.u, t.s),
          e !== ee ? e : void 0
        );
      }
      function D(e, t, i) {
        if (x(t)) return t;
        var n = t[ie];
        if (!n)
          return (
            v(
              t,
              function (r, o) {
                return B(e, n, t, r, o, i);
              },
              !0
            ),
            t
          );
        if (n.A !== e) return t;
        if (!n.P) return F(e, n.t, !0), n.t;
        if (!n.I) {
          (n.I = !0), n.A._--;
          var r = 4 === n.i || 5 === n.i ? (n.o = P(n.k)) : n.o;
          v(3 === n.i ? new Set(r) : r, function (t, o) {
            return B(e, n, r, t, o, i);
          }),
            F(e, r, !1),
            i && e.u && L("Patches").R(n, i, e.u, e.s);
        }
        return n.o;
      }
      function B(e, t, i, n, r, o) {
        if (g(r)) {
          var a = D(
            e,
            r,
            o && t && 3 !== t.i && !w(t.D, n) ? o.concat(n) : void 0
          );
          if ((S(i, n, a), !g(a))) return;
          e.m = !1;
        }
        if (y(r) && !x(r)) {
          if (!e.h.F && e._ < 1) return;
          D(e, r), (t && t.A.l) || F(e, r);
        }
      }
      function F(e, t, i) {
        void 0 === i && (i = !1), e.h.F && e.m && _(t, i);
      }
      function R(e, t) {
        var i = e[ie];
        return (i ? A(i) : e)[t];
      }
      function H(e, t) {
        if (t in e)
          for (var i = Object.getPrototypeOf(e); i; ) {
            var n = Object.getOwnPropertyDescriptor(i, t);
            if (n) return n;
            i = Object.getPrototypeOf(i);
          }
      }
      function U(e) {
        e.P || ((e.P = !0), e.l && U(e.l));
      }
      function $(e) {
        e.o || (e.o = P(e.t));
      }
      function W(e, t, i) {
        var n = k(t)
          ? L("MapSet").N(t, i)
          : T(t)
          ? L("MapSet").T(t, i)
          : e.g
          ? (function (e, t) {
              var i = Array.isArray(e),
                n = {
                  i: i ? 1 : 0,
                  A: t ? t.A : I(),
                  P: !1,
                  I: !1,
                  D: {},
                  l: t,
                  t: e,
                  k: null,
                  o: null,
                  j: null,
                  C: !1,
                },
                r = n,
                o = se;
              i && ((r = [n]), (o = le));
              var a = Proxy.revocable(r, o),
                s = a.revoke,
                l = a.proxy;
              return (n.k = l), (n.j = s), l;
            })(t, i)
          : L("ES5").J(t, i);
        return (i ? i.A : I()).p.push(n), n;
      }
      function z(e) {
        return (
          g(e) || m(22, e),
          (function e(t) {
            if (!y(t)) return t;
            var i,
              n = t[ie],
              r = b(t);
            if (n) {
              if (!n.P && (n.i < 4 || !L("ES5").K(n))) return n.t;
              (n.I = !0), (i = G(t, r)), (n.I = !1);
            } else i = G(t, r);
            return (
              v(i, function (t, r) {
                (n &&
                  (function (e, t) {
                    return 2 === b(e) ? e.get(t) : e[t];
                  })(n.t, t) === r) ||
                  S(i, t, e(r));
              }),
              3 === r ? new Set(i) : i
            );
          })(e)
        );
      }
      function G(e, t) {
        switch (t) {
          case 2:
            return new Map(e);
          case 3:
            return Array.from(e);
        }
        return P(e);
      }
      var Q,
        K,
        Y = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"),
        X = "undefined" != typeof Map,
        J = "undefined" != typeof Set,
        Z =
          "undefined" != typeof Proxy &&
          void 0 !== Proxy.revocable &&
          "undefined" != typeof Reflect,
        ee = Y
          ? Symbol.for("immer-nothing")
          : (((Q = {})["immer-nothing"] = !0), Q),
        te = Y ? Symbol.for("immer-draftable") : "__$immer_draftable",
        ie = Y ? Symbol.for("immer-state") : "__$immer_state",
        ne =
          ("undefined" != typeof Symbol && Symbol.iterator,
          "" + Object.prototype.constructor),
        re =
          "undefined" != typeof Reflect && Reflect.ownKeys
            ? Reflect.ownKeys
            : void 0 !== Object.getOwnPropertySymbols
            ? function (e) {
                return Object.getOwnPropertyNames(e).concat(
                  Object.getOwnPropertySymbols(e)
                );
              }
            : Object.getOwnPropertyNames,
        oe =
          Object.getOwnPropertyDescriptors ||
          function (e) {
            var t = {};
            return (
              re(e).forEach(function (i) {
                t[i] = Object.getOwnPropertyDescriptor(e, i);
              }),
              t
            );
          },
        ae = {},
        se = {
          get: function (e, t) {
            if (t === ie) return e;
            var i = A(e);
            if (!w(i, t))
              return (function (e, t, i) {
                var n,
                  r = H(t, i);
                return r
                  ? "value" in r
                    ? r.value
                    : null === (n = r.get) || void 0 === n
                    ? void 0
                    : n.call(e.k)
                  : void 0;
              })(e, i, t);
            var n = i[t];
            return e.I || !y(n)
              ? n
              : n === R(e.t, t)
              ? ($(e), (e.o[t] = W(e.A.h, n, e)))
              : n;
          },
          has: function (e, t) {
            return t in A(e);
          },
          ownKeys: function (e) {
            return Reflect.ownKeys(A(e));
          },
          set: function (e, t, i) {
            var n = H(A(e), t);
            if (null == n ? void 0 : n.set) return n.set.call(e.k, i), !0;
            if (!e.P) {
              var r = R(A(e), t),
                o = null == r ? void 0 : r[ie];
              if (o && o.t === i) return (e.o[t] = i), (e.D[t] = !1), !0;
              if (E(i, r) && (void 0 !== i || w(e.t, t))) return !0;
              $(e), U(e);
            }
            return (
              (e.o[t] === i &&
                "number" != typeof i &&
                (void 0 !== i || t in e.o)) ||
              ((e.o[t] = i), (e.D[t] = !0), !0)
            );
          },
          deleteProperty: function (e, t) {
            return (
              void 0 !== R(e.t, t) || t in e.t
                ? ((e.D[t] = !1), $(e), U(e))
                : delete e.D[t],
              e.o && delete e.o[t],
              !0
            );
          },
          getOwnPropertyDescriptor: function (e, t) {
            var i = A(e),
              n = Reflect.getOwnPropertyDescriptor(i, t);
            return n
              ? {
                  writable: !0,
                  configurable: 1 !== e.i || "length" !== t,
                  enumerable: n.enumerable,
                  value: i[t],
                }
              : n;
          },
          defineProperty: function () {
            m(11);
          },
          getPrototypeOf: function (e) {
            return Object.getPrototypeOf(e.t);
          },
          setPrototypeOf: function () {
            m(12);
          },
        },
        le = {};
      v(se, function (e, t) {
        le[e] = function () {
          return (arguments[0] = arguments[0][0]), t.apply(this, arguments);
        };
      }),
        (le.deleteProperty = function (e, t) {
          return le.set.call(this, e, t, void 0);
        }),
        (le.set = function (e, t, i) {
          return se.set.call(this, e[0], t, i, e[0]);
        });
      var ce = (function () {
          function e(e) {
            var t = this;
            (this.g = Z),
              (this.F = !0),
              (this.produce = function (e, i, n) {
                if ("function" == typeof e && "function" != typeof i) {
                  var r = i;
                  i = e;
                  var o = t;
                  return function (e) {
                    var t = this;
                    void 0 === e && (e = r);
                    for (
                      var n = arguments.length,
                        a = Array(n > 1 ? n - 1 : 0),
                        s = 1;
                      s < n;
                      s++
                    )
                      a[s - 1] = arguments[s];
                    return o.produce(e, function (e) {
                      var n;
                      return (n = i).call.apply(n, [t, e].concat(a));
                    });
                  };
                }
                var a;
                if (
                  ("function" != typeof i && m(6),
                  void 0 !== n && "function" != typeof n && m(7),
                  y(e))
                ) {
                  var s = N(t),
                    l = W(t, e, void 0),
                    c = !0;
                  try {
                    (a = i(l)), (c = !1);
                  } finally {
                    c ? q(s) : M(s);
                  }
                  return "undefined" != typeof Promise && a instanceof Promise
                    ? a.then(
                        function (e) {
                          return O(s, n), V(e, s);
                        },
                        function (e) {
                          throw (q(s), e);
                        }
                      )
                    : (O(s, n), V(a, s));
                }
                if (!e || "object" != typeof e) {
                  if (
                    (void 0 === (a = i(e)) && (a = e),
                    a === ee && (a = void 0),
                    t.F && _(a, !0),
                    n)
                  ) {
                    var u = [],
                      d = [];
                    L("Patches").M(e, a, u, d), n(u, d);
                  }
                  return a;
                }
                m(21, e);
              }),
              (this.produceWithPatches = function (e, i) {
                if ("function" == typeof e)
                  return function (i) {
                    for (
                      var n = arguments.length,
                        r = Array(n > 1 ? n - 1 : 0),
                        o = 1;
                      o < n;
                      o++
                    )
                      r[o - 1] = arguments[o];
                    return t.produceWithPatches(i, function (t) {
                      return e.apply(void 0, [t].concat(r));
                    });
                  };
                var n,
                  r,
                  o = t.produce(e, i, function (e, t) {
                    (n = e), (r = t);
                  });
                return "undefined" != typeof Promise && o instanceof Promise
                  ? o.then(function (e) {
                      return [e, n, r];
                    })
                  : [o, n, r];
              }),
              "boolean" == typeof (null == e ? void 0 : e.useProxies) &&
                this.setUseProxies(e.useProxies),
              "boolean" == typeof (null == e ? void 0 : e.autoFreeze) &&
                this.setAutoFreeze(e.autoFreeze);
          }
          var t = e.prototype;
          return (
            (t.createDraft = function (e) {
              y(e) || m(8), g(e) && (e = z(e));
              var t = N(this),
                i = W(this, e, void 0);
              return (i[ie].C = !0), M(t), i;
            }),
            (t.finishDraft = function (e, t) {
              var i = (e && e[ie]).A;
              return O(i, t), V(void 0, i);
            }),
            (t.setAutoFreeze = function (e) {
              this.F = e;
            }),
            (t.setUseProxies = function (e) {
              e && !Z && m(20), (this.g = e);
            }),
            (t.applyPatches = function (e, t) {
              var i;
              for (i = t.length - 1; i >= 0; i--) {
                var n = t[i];
                if (0 === n.path.length && "replace" === n.op) {
                  e = n.value;
                  break;
                }
              }
              i > -1 && (t = t.slice(i + 1));
              var r = L("Patches").$;
              return g(e)
                ? r(e, t)
                : this.produce(e, function (e) {
                    return r(e, t);
                  });
            }),
            e
          );
        })(),
        ue = new ce(),
        de = ue.produce;
      ue.produceWithPatches.bind(ue),
        ue.setAutoFreeze.bind(ue),
        ue.setUseProxies.bind(ue),
        ue.applyPatches.bind(ue),
        ue.createDraft.bind(ue),
        ue.finishDraft.bind(ue);
      const he = de;
      "function" == typeof Symbol && Symbol.observable;
      var pe = function () {
        return Math.random().toString(36).substring(7).split("").join(".");
      };
      pe(), pe();
      var fe,
        me =
          ((fe = function (e, t) {
            return (
              (fe =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                  function (e, t) {
                    e.__proto__ = t;
                  }) ||
                function (e, t) {
                  for (var i in t)
                    Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                }),
              fe(e, t)
            );
          }),
          function (e, t) {
            if ("function" != typeof t && null !== t)
              throw new TypeError(
                "Class extends value " +
                  String(t) +
                  " is not a constructor or null"
              );
            function i() {
              this.constructor = e;
            }
            fe(e, t),
              (e.prototype =
                null === t
                  ? Object.create(t)
                  : ((i.prototype = t.prototype), new i()));
          }),
        ge = function (e, t) {
          for (var i = 0, n = t.length, r = e.length; i < n; i++, r++)
            e[r] = t[i];
          return e;
        },
        ye = Object.defineProperty,
        ve = Object.defineProperties,
        be = Object.getOwnPropertyDescriptors,
        we = Object.getOwnPropertySymbols,
        Se = Object.prototype.hasOwnProperty,
        Ee = Object.prototype.propertyIsEnumerable,
        ke = function (e, t, i) {
          return t in e
            ? ye(e, t, {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: i,
              })
            : (e[t] = i);
        },
        Te = function (e, t) {
          for (var i in t || (t = {})) Se.call(t, i) && ke(e, i, t[i]);
          if (we)
            for (var n = 0, r = we(t); n < r.length; n++)
              (i = r[n]), Ee.call(t, i) && ke(e, i, t[i]);
          return e;
        },
        Ae = function (e, t) {
          return ve(e, be(t));
        };
      function Pe(e, t) {
        function i() {
          for (var i = [], n = 0; n < arguments.length; n++)
            i[n] = arguments[n];
          if (t) {
            var r = t.apply(void 0, i);
            if (!r) throw new Error("prepareAction did not return an object");
            return Te(
              Te(
                { type: e, payload: r.payload },
                "meta" in r && { meta: r.meta }
              ),
              "error" in r && { error: r.error }
            );
          }
          return { type: e, payload: i[0] };
        }
        return (
          (i.toString = function () {
            return "" + e;
          }),
          (i.type = e),
          (i.match = function (t) {
            return t.type === e;
          }),
          i
        );
      }
      function _e(e) {
        var t,
          i = {},
          n = [],
          r = {
            addCase: function (e, t) {
              var n = "string" == typeof e ? e : e.type;
              if (n in i)
                throw new Error(
                  "addCase cannot be called with two reducers for the same action type"
                );
              return (i[n] = t), r;
            },
            addMatcher: function (e, t) {
              return n.push({ matcher: e, reducer: t }), r;
            },
            addDefaultCase: function (e) {
              return (t = e), r;
            },
          };
        return e(r), [i, n, t];
      }
      "undefined" != typeof window &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__,
        "undefined" != typeof window &&
          window.__REDUX_DEVTOOLS_EXTENSION__ &&
          window.__REDUX_DEVTOOLS_EXTENSION__,
        (function (e) {
          function t() {
            for (var i = [], n = 0; n < arguments.length; n++)
              i[n] = arguments[n];
            var r = e.apply(this, i) || this;
            return Object.setPrototypeOf(r, t.prototype), r;
          }
          me(t, e),
            Object.defineProperty(t, Symbol.species, {
              get: function () {
                return t;
              },
              enumerable: !1,
              configurable: !0,
            }),
            (t.prototype.concat = function () {
              for (var t = [], i = 0; i < arguments.length; i++)
                t[i] = arguments[i];
              return e.prototype.concat.apply(this, t);
            }),
            (t.prototype.prepend = function () {
              for (var e = [], i = 0; i < arguments.length; i++)
                e[i] = arguments[i];
              return 1 === e.length && Array.isArray(e[0])
                ? new (t.bind.apply(t, ge([void 0], e[0].concat(this))))()
                : new (t.bind.apply(t, ge([void 0], e.concat(this))))();
            });
        })(Array);
      var Ce = ["name", "message", "stack", "code"],
        xe = function (e, t) {
          (this.payload = e), (this.meta = t);
        },
        Le = function (e, t) {
          (this.payload = e), (this.meta = t);
        },
        Ie = function (e) {
          if ("object" == typeof e && null !== e) {
            for (var t = {}, i = 0, n = Ce; i < n.length; i++) {
              var r = n[i];
              "string" == typeof e[r] && (t[r] = e[r]);
            }
            return t;
          }
          return { message: String(e) };
        };
      function Oe(e, t, i) {
        var n = Pe(e + "/fulfilled", function (e, t, i, n) {
            return {
              payload: e,
              meta: Ae(Te({}, n || {}), {
                arg: i,
                requestId: t,
                requestStatus: "fulfilled",
              }),
            };
          }),
          r = Pe(e + "/pending", function (e, t, i) {
            return {
              payload: void 0,
              meta: Ae(Te({}, i || {}), {
                arg: t,
                requestId: e,
                requestStatus: "pending",
              }),
            };
          }),
          o = Pe(e + "/rejected", function (e, t, n, r, o) {
            return {
              payload: r,
              error: ((i && i.serializeError) || Ie)(e || "Rejected"),
              meta: Ae(Te({}, o || {}), {
                arg: n,
                requestId: t,
                rejectedWithValue: !!r,
                requestStatus: "rejected",
                aborted: "AbortError" === (null == e ? void 0 : e.name),
                condition: "ConditionError" === (null == e ? void 0 : e.name),
              }),
            };
          }),
          a =
            "undefined" != typeof AbortController
              ? AbortController
              : (function () {
                  function e() {
                    this.signal = {
                      aborted: !1,
                      addEventListener: function () {},
                      dispatchEvent: function () {
                        return !1;
                      },
                      onabort: function () {},
                      removeEventListener: function () {},
                    };
                  }
                  return (e.prototype.abort = function () {}), e;
                })();
        return Object.assign(
          function (e) {
            return function (s, l, c) {
              var u,
                d = (null == i ? void 0 : i.idGenerator)
                  ? i.idGenerator(e)
                  : (function (e) {
                      void 0 === e && (e = 21);
                      for (var t = "", i = e; i--; )
                        t +=
                          "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW"[
                            (64 * Math.random()) | 0
                          ];
                      return t;
                    })(),
                h = new a(),
                p = new Promise(function (e, t) {
                  return h.signal.addEventListener("abort", function () {
                    return t({ name: "AbortError", message: u || "Aborted" });
                  });
                }),
                f = !1,
                m = (function () {
                  return (
                    (a = this),
                    (u = null),
                    (m = function () {
                      var a, u, m, g, y;
                      return (function (e, t) {
                        var i,
                          n,
                          r,
                          o,
                          a = {
                            label: 0,
                            sent: function () {
                              if (1 & r[0]) throw r[1];
                              return r[1];
                            },
                            trys: [],
                            ops: [],
                          };
                        return (
                          (o = { next: s(0), throw: s(1), return: s(2) }),
                          "function" == typeof Symbol &&
                            (o[Symbol.iterator] = function () {
                              return this;
                            }),
                          o
                        );
                        function s(o) {
                          return function (s) {
                            return (function (o) {
                              if (i)
                                throw new TypeError(
                                  "Generator is already executing."
                                );
                              for (; a; )
                                try {
                                  if (
                                    ((i = 1),
                                    n &&
                                      (r =
                                        2 & o[0]
                                          ? n.return
                                          : o[0]
                                          ? n.throw ||
                                            ((r = n.return) && r.call(n), 0)
                                          : n.next) &&
                                      !(r = r.call(n, o[1])).done)
                                  )
                                    return r;
                                  switch (
                                    ((n = 0),
                                    r && (o = [2 & o[0], r.value]),
                                    o[0])
                                  ) {
                                    case 0:
                                    case 1:
                                      r = o;
                                      break;
                                    case 4:
                                      return (
                                        a.label++, { value: o[1], done: !1 }
                                      );
                                    case 5:
                                      a.label++, (n = o[1]), (o = [0]);
                                      continue;
                                    case 7:
                                      (o = a.ops.pop()), a.trys.pop();
                                      continue;
                                    default:
                                      if (
                                        !(
                                          (r =
                                            (r = a.trys).length > 0 &&
                                            r[r.length - 1]) ||
                                          (6 !== o[0] && 2 !== o[0])
                                        )
                                      ) {
                                        a = 0;
                                        continue;
                                      }
                                      if (
                                        3 === o[0] &&
                                        (!r || (o[1] > r[0] && o[1] < r[3]))
                                      ) {
                                        a.label = o[1];
                                        break;
                                      }
                                      if (6 === o[0] && a.label < r[1]) {
                                        (a.label = r[1]), (r = o);
                                        break;
                                      }
                                      if (r && a.label < r[2]) {
                                        (a.label = r[2]), a.ops.push(o);
                                        break;
                                      }
                                      r[2] && a.ops.pop(), a.trys.pop();
                                      continue;
                                  }
                                  o = t.call(e, a);
                                } catch (e) {
                                  (o = [6, e]), (n = 0);
                                } finally {
                                  i = r = 0;
                                }
                              if (5 & o[0]) throw o[1];
                              return { value: o[0] ? o[1] : void 0, done: !0 };
                            })([o, s]);
                          };
                        }
                      })(this, function (v) {
                        switch (v.label) {
                          case 0:
                            return (
                              v.trys.push([0, 4, , 5]),
                              null ===
                                (b = g =
                                  null == (a = null == i ? void 0 : i.condition)
                                    ? void 0
                                    : a.call(i, e, {
                                        getState: l,
                                        extra: c,
                                      })) ||
                              "object" != typeof b ||
                              "function" != typeof b.then
                                ? [3, 2]
                                : [4, g]
                            );
                          case 1:
                            (g = v.sent()), (v.label = 2);
                          case 2:
                            if (!1 === g)
                              throw {
                                name: "ConditionError",
                                message:
                                  "Aborted due to condition callback returning false.",
                              };
                            return (
                              (f = !0),
                              s(
                                r(
                                  d,
                                  e,
                                  null ==
                                    (u = null == i ? void 0 : i.getPendingMeta)
                                    ? void 0
                                    : u.call(
                                        i,
                                        { requestId: d, arg: e },
                                        { getState: l, extra: c }
                                      )
                                )
                              ),
                              [
                                4,
                                Promise.race([
                                  p,
                                  Promise.resolve(
                                    t(e, {
                                      dispatch: s,
                                      getState: l,
                                      extra: c,
                                      requestId: d,
                                      signal: h.signal,
                                      rejectWithValue: function (e, t) {
                                        return new xe(e, t);
                                      },
                                      fulfillWithValue: function (e, t) {
                                        return new Le(e, t);
                                      },
                                    })
                                  ).then(function (t) {
                                    if (t instanceof xe) throw t;
                                    return t instanceof Le
                                      ? n(t.payload, d, e, t.meta)
                                      : n(t, d, e);
                                  }),
                                ]),
                              ]
                            );
                          case 3:
                            return (m = v.sent()), [3, 5];
                          case 4:
                            return (
                              (y = v.sent()),
                              (m =
                                y instanceof xe
                                  ? o(null, d, e, y.payload, y.meta)
                                  : o(y, d, e)),
                              [3, 5]
                            );
                          case 5:
                            return (
                              (i &&
                                !i.dispatchConditionRejection &&
                                o.match(m) &&
                                m.meta.condition) ||
                                s(m),
                              [2, m]
                            );
                        }
                        var b;
                      });
                    }),
                    new Promise(function (e, t) {
                      var i = function (e) {
                          try {
                            r(m.next(e));
                          } catch (e) {
                            t(e);
                          }
                        },
                        n = function (e) {
                          try {
                            r(m.throw(e));
                          } catch (e) {
                            t(e);
                          }
                        },
                        r = function (t) {
                          return t.done
                            ? e(t.value)
                            : Promise.resolve(t.value).then(i, n);
                        };
                      r((m = m.apply(a, u)).next());
                    })
                  );
                  var a, u, m;
                })();
              return Object.assign(m, {
                abort: function (e) {
                  f && ((u = e), h.abort());
                },
                requestId: d,
                arg: e,
                unwrap: function () {
                  return m.then(qe);
                },
              });
            };
          },
          { pending: r, rejected: o, fulfilled: n, typePrefix: e }
        );
      }
      function qe(e) {
        if (e.meta && e.meta.rejectedWithValue) throw e.payload;
        if (e.error) throw e.error;
        return e.payload;
      }
      Object.assign;
      var Me = "listenerMiddleware";
      function Ne() {
        return JSON.parse(
          JSON.stringify({
            credentials: "same-origin",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Content-Type": "application/json;",
            },
          })
        );
      }
      function je(e, t) {
        return fetch(e, t).then(function (e) {
          if (!e.ok) throw e;
          return e.json();
        });
      }
      function Ve() {
        return je("/cart.js", Ne());
      }
      function De(e, t) {
        var i = Ne();
        return (
          (t = t || {}),
          (i.method = "POST"),
          (i.body = JSON.stringify({
            line: e,
            quantity: t.quantity,
            properties: t.properties,
          })),
          je("/cart/change.js", i)
        );
      }
      function Be(e) {
        if ("string" != typeof e || 2 !== e.split(":").length)
          throw new TypeError(
            "Theme Cart: Provided key value is not a string with the format xxx:xxx"
          );
      }
      function Fe() {
        return Ve();
      }
      function Re(e) {
        return (
          Be(e),
          Ve().then(function (t) {
            var i = -1;
            return (
              t.items.forEach(function (t, n) {
                i = t.key === e ? n + 1 : i;
              }),
              -1 === i
                ? Promise.reject(
                    new Error(
                      "Theme Cart: Unable to match line item with provided key"
                    )
                  )
                : i
            );
          })
        );
      }
      function He(e, t) {
        return (
          (t = t || {}),
          (function (e) {
            if ("number" != typeof e || isNaN(e))
              throw new TypeError("Theme Cart: Variant ID must be a number");
          })(e),
          (function (e, t, i) {
            var n = Ne();
            return (
              (n.method = "POST"),
              (n.body = JSON.stringify({ id: e, quantity: t, properties: i })),
              je("/cart/add.js", n)
            );
          })(e, t.quantity, t.properties)
        );
      }
      function Ue(e, t) {
        return (
          Be(e),
          (function (e) {
            if ("object" != typeof e)
              throw new TypeError("Theme Cart: Options must be an object");
            if (void 0 === e.quantity && void 0 === e.properties)
              throw new Error(
                "Theme Cart: You muse define a value for quantity or properties"
              );
            void 0 !== e.quantity &&
              (function (e) {
                if ("number" != typeof e || isNaN(e))
                  throw new TypeError(
                    "Theme Cart: An object which specifies a quantity or properties value is required"
                  );
              })(e.quantity),
              void 0 !== e.properties &&
                (function (e) {
                  if ("object" != typeof e)
                    throw new TypeError(
                      "Theme Cart: Properties must be an object"
                    );
                })(e.properties);
          })(t),
          Re(e).then(function (e) {
            return De(e, t);
          })
        );
      }
      function $e(e) {
        return (
          Be(e),
          Re(e).then(function (e) {
            return De(e, { quantity: 0 });
          })
        );
      }
      Pe(Me + "/add"),
        Pe(Me + "/removeAll"),
        Pe(Me + "/remove"),
        (function () {
          function e(e, t) {
            var i = r[e];
            return (
              i
                ? (i.enumerable = t)
                : (r[e] = i =
                    {
                      configurable: !0,
                      enumerable: t,
                      get: function () {
                        var t = this[ie];
                        return se.get(t, e);
                      },
                      set: function (t) {
                        var i = this[ie];
                        se.set(i, e, t);
                      },
                    }),
              i
            );
          }
          function t(e) {
            for (var t = e.length - 1; t >= 0; t--) {
              var r = e[t][ie];
              if (!r.P)
                switch (r.i) {
                  case 5:
                    n(r) && U(r);
                    break;
                  case 4:
                    i(r) && U(r);
                }
            }
          }
          function i(e) {
            for (
              var t = e.t, i = e.k, n = re(i), r = n.length - 1;
              r >= 0;
              r--
            ) {
              var o = n[r];
              if (o !== ie) {
                var a = t[o];
                if (void 0 === a && !w(t, o)) return !0;
                var s = i[o],
                  l = s && s[ie];
                if (l ? l.t !== a : !E(s, a)) return !0;
              }
            }
            var c = !!t[ie];
            return n.length !== re(t).length + (c ? 0 : 1);
          }
          function n(e) {
            var t = e.k;
            if (t.length !== e.t.length) return !0;
            var i = Object.getOwnPropertyDescriptor(t, t.length - 1);
            if (i && !i.get) return !0;
            for (var n = 0; n < t.length; n++)
              if (!t.hasOwnProperty(n)) return !0;
            return !1;
          }
          var r = {};
          !(function (e, t) {
            ae[e] || (ae[e] = t);
          })("ES5", {
            J: function (t, i) {
              var n = Array.isArray(t),
                r = (function (t, i) {
                  if (t) {
                    for (var n = Array(i.length), r = 0; r < i.length; r++)
                      Object.defineProperty(n, "" + r, e(r, !0));
                    return n;
                  }
                  var o = oe(i);
                  delete o[ie];
                  for (var a = re(o), s = 0; s < a.length; s++) {
                    var l = a[s];
                    o[l] = e(l, t || !!o[l].enumerable);
                  }
                  return Object.create(Object.getPrototypeOf(i), o);
                })(n, t),
                o = {
                  i: n ? 5 : 4,
                  A: i ? i.A : I(),
                  P: !1,
                  I: !1,
                  D: {},
                  l: i,
                  t,
                  k: r,
                  o: null,
                  O: !1,
                  C: !1,
                };
              return (
                Object.defineProperty(r, ie, { value: o, writable: !0 }), r
              );
            },
            S: function (e, i, r) {
              r
                ? g(i) && i[ie].A === e && t(e.p)
                : (e.u &&
                    (function e(t) {
                      if (t && "object" == typeof t) {
                        var i = t[ie];
                        if (i) {
                          var r = i.t,
                            o = i.k,
                            a = i.D,
                            s = i.i;
                          if (4 === s)
                            v(o, function (t) {
                              t !== ie &&
                                (void 0 !== r[t] || w(r, t)
                                  ? a[t] || e(o[t])
                                  : ((a[t] = !0), U(i)));
                            }),
                              v(r, function (e) {
                                void 0 !== o[e] ||
                                  w(o, e) ||
                                  ((a[e] = !1), U(i));
                              });
                          else if (5 === s) {
                            if (
                              (n(i) && (U(i), (a.length = !0)),
                              o.length < r.length)
                            )
                              for (var l = o.length; l < r.length; l++)
                                a[l] = !1;
                            else
                              for (var c = r.length; c < o.length; c++)
                                a[c] = !0;
                            for (
                              var u = Math.min(o.length, r.length), d = 0;
                              d < u;
                              d++
                            )
                              o.hasOwnProperty(d) || (a[d] = !0),
                                void 0 === a[d] && e(o[d]);
                          }
                        }
                      }
                    })(e.p[0]),
                  t(e.p));
            },
            K: function (e) {
              return 4 === e.i ? i(e) : n(e);
            },
          });
        })();
      const We = window.theme;
      var ze,
        Ge = function () {
          return (
            (Ge =
              Object.assign ||
              function (e) {
                for (var t, i = 1, n = arguments.length; i < n; i++)
                  for (var r in (t = arguments[i]))
                    Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                return e;
              }),
            Ge.apply(this, arguments)
          );
        },
        Qe = function (e, t, i, n) {
          return new (i || (i = Promise))(function (r, o) {
            function a(e) {
              try {
                l(n.next(e));
              } catch (e) {
                o(e);
              }
            }
            function s(e) {
              try {
                l(n.throw(e));
              } catch (e) {
                o(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? r(e.value)
                : ((t = e.value),
                  t instanceof i
                    ? t
                    : new i(function (e) {
                        e(t);
                      })).then(a, s);
            }
            l((n = n.apply(e, t || [])).next());
          });
        },
        Ke = function (e, t) {
          var i,
            n,
            r,
            o,
            a = {
              label: 0,
              sent: function () {
                if (1 & r[0]) throw r[1];
                return r[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (o = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (o[Symbol.iterator] = function () {
                return this;
              }),
            o
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (i) throw new TypeError("Generator is already executing.");
                for (; o && ((o = 0), s[0] && (a = 0)), a; )
                  try {
                    if (
                      ((i = 1),
                      n &&
                        (r =
                          2 & s[0]
                            ? n.return
                            : s[0]
                            ? n.throw || ((r = n.return) && r.call(n), 0)
                            : n.next) &&
                        !(r = r.call(n, s[1])).done)
                    )
                      return r;
                    switch (((n = 0), r && (s = [2 & s[0], r.value]), s[0])) {
                      case 0:
                      case 1:
                        r = s;
                        break;
                      case 4:
                        return a.label++, { value: s[1], done: !1 };
                      case 5:
                        a.label++, (n = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = a.ops.pop()), a.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (r = (r = a.trys).length > 0 && r[r.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          a = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!r || (s[1] > r[0] && s[1] < r[3]))
                        ) {
                          a.label = s[1];
                          break;
                        }
                        if (6 === s[0] && a.label < r[1]) {
                          (a.label = r[1]), (r = s);
                          break;
                        }
                        if (r && a.label < r[2]) {
                          (a.label = r[2]), a.ops.push(s);
                          break;
                        }
                        r[2] && a.ops.pop(), a.trys.pop();
                        continue;
                    }
                    s = t.call(e, a);
                  } catch (e) {
                    (s = [6, e]), (n = 0);
                  } finally {
                    i = r = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        Ye = We.cartState,
        Xe = Ye.items,
        Je = Ye.item_count,
        Ze = {
          cart: We.cartState,
          items: Xe,
          item_count: Je,
          justAdded: null,
          loading: !1,
          popupActive: !1,
          error: null,
        },
        et = Oe("cart/addItem", function (e) {
          var t = e.id,
            i = e.quantity;
          return Qe(void 0, void 0, void 0, function () {
            var e, n, r;
            return Ke(this, function (o) {
              switch (o.label) {
                case 0:
                  return o.trys.push([0, 3, , 4]), [4, He(t, i)];
                case 1:
                  return (e = o.sent()), [4, Fe()];
                case 2:
                  return (n = o.sent()), [2, { item: e, cartData: n }];
                case 3:
                  return (r = o.sent()), console.log(r), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }),
        tt = Oe("cart/updateItem", function (e, t) {
          var i = e.id,
            n = e.options,
            r = t.rejectWithValue;
          return Qe(void 0, void 0, void 0, function () {
            var e;
            return Ke(this, function (t) {
              switch (t.label) {
                case 0:
                  return t.trys.push([0, 2, , 4]), [4, Ue(i, n)];
                case 1:
                  return [2, t.sent()];
                case 2:
                  return [4, t.sent().json()];
                case 3:
                  return (e = t.sent()), [2, r(e)];
                case 4:
                  return [2];
              }
            });
          });
        }),
        it = Oe("cart/removeItem", function (e) {
          var t = e.key;
          return Qe(void 0, void 0, void 0, function () {
            var e;
            return Ke(this, function (i) {
              switch (i.label) {
                case 0:
                  return i.trys.push([0, 2, , 3]), [4, $e(t)];
                case 1:
                  return [2, i.sent()];
                case 2:
                  return (e = i.sent()), console.log(e), [3, 3];
                case 3:
                  return [2];
              }
            });
          });
        }),
        nt = Oe("cart/getCart", function () {
          return Qe(void 0, void 0, void 0, function () {
            var e;
            return Ke(this, function (t) {
              switch (t.label) {
                case 0:
                  return t.trys.push([0, 2, , 3]), [4, Fe()];
                case 1:
                  return [2, t.sent()];
                case 2:
                  return (e = t.sent()), console.log(e), [3, 3];
                case 3:
                  return [2];
              }
            });
          });
        }),
        rt = (function (e) {
          var t = e.name;
          if (!t)
            throw new Error("`name` is a required option for createSlice");
          var i,
            n =
              "function" == typeof e.initialState
                ? e.initialState
                : he(e.initialState, function () {}),
            r = e.reducers || {},
            o = Object.keys(r),
            a = {},
            s = {},
            l = {};
          function c() {
            var t =
                "function" == typeof e.extraReducers
                  ? _e(e.extraReducers)
                  : [e.extraReducers],
              i = t[0],
              r = void 0 === i ? {} : i,
              o = t[1],
              a = void 0 === o ? [] : o,
              l = t[2],
              c = void 0 === l ? void 0 : l,
              u = Te(Te({}, r), s);
            return (function (e, t, i, n) {
              void 0 === i && (i = []);
              var r,
                o = "function" == typeof t ? _e(t) : [t, i, n],
                a = o[0],
                s = o[1],
                l = o[2];
              if (
                (function (e) {
                  return "function" == typeof e;
                })(e)
              )
                r = function () {
                  return he(e(), function () {});
                };
              else {
                var c = he(e, function () {});
                r = function () {
                  return c;
                };
              }
              function u(e, t) {
                void 0 === e && (e = r());
                var i = ge(
                  [a[t.type]],
                  s
                    .filter(function (e) {
                      return (0, e.matcher)(t);
                    })
                    .map(function (e) {
                      return e.reducer;
                    })
                );
                return (
                  0 ===
                    i.filter(function (e) {
                      return !!e;
                    }).length && (i = [l]),
                  i.reduce(function (e, i) {
                    if (i) {
                      var n;
                      if (g(e)) return void 0 === (n = i(e, t)) ? e : n;
                      if (y(e))
                        return he(e, function (e) {
                          return i(e, t);
                        });
                      if (void 0 === (n = i(e, t))) {
                        if (null === e) return e;
                        throw Error(
                          "A case reducer on a non-draftable value must not return undefined"
                        );
                      }
                      return n;
                    }
                    return e;
                  }, e)
                );
              }
              return (u.getInitialState = r), u;
            })(n, u, a, c);
          }
          return (
            o.forEach(function (e) {
              var i,
                n,
                o = r[e],
                c = t + "/" + e;
              "reducer" in o ? ((i = o.reducer), (n = o.prepare)) : (i = o),
                (a[e] = i),
                (s[c] = i),
                (l[e] = n ? Pe(c, n) : Pe(c));
            }),
            {
              name: t,
              reducer: function (e, t) {
                return i || (i = c()), i(e, t);
              },
              actions: l,
              caseReducers: a,
              getInitialState: function () {
                return i || (i = c()), i.getInitialState();
              },
            }
          );
        })({
          name: "cart",
          initialState: Ze,
          reducers: {
            closePopup: function (e) {
              return Ge(Ge({}, e), { popupActive: !1 });
            },
            openPopup: function (e) {
              return Ge(Ge({}, e), { popupActive: !0 });
            },
            openDrawer: function (e) {
              return Ge(Ge({}, e), { drawerActive: !0 });
            },
            addJustAdded: function (e, t) {
              var i = t.payload;
              return Ge(Ge({}, e), { justAdded: i });
            },
          },
          extraReducers: function (e) {
            e.addCase(et.pending, function (e) {
              e.loading = !0;
            }),
              e.addCase(et.fulfilled, function (e, t) {
                var i,
                  n,
                  r = t.payload;
                return Ge(Ge({}, e), {
                  cart: null == r ? void 0 : r.cartData,
                  justAdded: null == r ? void 0 : r.item,
                  item_count:
                    null === (i = null == r ? void 0 : r.cartData) ||
                    void 0 === i
                      ? void 0
                      : i.item_count,
                  items:
                    null === (n = null == r ? void 0 : r.cartData) ||
                    void 0 === n
                      ? void 0
                      : n.items,
                  popupActive: !0,
                });
              }),
              e.addCase(et.rejected, function (e) {
                e.loading = !1;
              }),
              e.addCase(it.pending, function (e) {
                e.loading = !0;
              }),
              e.addCase(it.fulfilled, function (e, t) {
                var i = t.payload;
                return Ge(Ge({}, e), {
                  cart: i,
                  items: i.items,
                  item_count: i.item_count,
                  loading: !1,
                });
              }),
              e.addCase(it.rejected, function (e) {
                e.loading = !1;
              }),
              e.addCase(tt.pending, function (e) {
                (e.loading = !0), (e.error = null);
              }),
              e.addCase(tt.fulfilled, function (e, t) {
                var i,
                  n = t.payload;
                return Ge(Ge({}, e), {
                  cart: n || e.cart,
                  items: (null == n ? void 0 : n.items) || e.items,
                  item_count:
                    null !== (i = null == n ? void 0 : n.item_count) &&
                    void 0 !== i
                      ? i
                      : e.item_count,
                  loading: !1,
                  error: null,
                });
              }),
              e.addCase(tt.rejected, function (e, t) {
                var i = t.payload;
                (e.loading = !1), (e.error = i.message);
              }),
              e.addCase(nt.pending, function (e) {
                e.loading = !1;
              }),
              e.addCase(nt.fulfilled, function (e, t) {
                var i = t.payload;
                return Ge(Ge({}, e), {
                  cart: i,
                  items: (null == i ? void 0 : i.items) || e.items,
                  loading: !1,
                  item_count: i.item_count,
                });
              }),
              e.addCase(nt.rejected, function (e) {
                e.loading = !1;
              });
          },
        }),
        ot = ((ze = rt.actions).closePopup, ze.openPopup),
        at = (ze.openDrawer, ze.addJustAdded),
        st =
          (rt.reducer,
          function (e, t, i, n) {
            return new (i || (i = Promise))(function (r, o) {
              function a(e) {
                try {
                  l(n.next(e));
                } catch (e) {
                  o(e);
                }
              }
              function s(e) {
                try {
                  l(n.throw(e));
                } catch (e) {
                  o(e);
                }
              }
              function l(e) {
                var t;
                e.done
                  ? r(e.value)
                  : ((t = e.value),
                    t instanceof i
                      ? t
                      : new i(function (e) {
                          e(t);
                        })).then(a, s);
              }
              l((n = n.apply(e, t || [])).next());
            });
          });
      function lt(e, t, i) {
        var n = t.split("x")[0],
          r = t.split("x")[1] || Math.floor(n / i);
        return e
          ? e
              .replace(
                /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g,
                "."
              )
              .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (e) {
                return "_".concat(n, "x").concat(r).concat(e);
              })
          : "";
      }
      function ct(e, t, i) {
        var n = t.split("x")[0],
          r = t.split("x")[1] || Math.floor(n / i),
          o = e
            .replace(
              /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g,
              "."
            )
            .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (e) {
              return "_".concat(n, "x").concat(r).concat(e);
            }),
          a = r ? "".concat(2 * n, "x").concat(2 * r) : "".concat(2 * n, "x"),
          s = e
            .replace(
              /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g,
              "."
            )
            .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (e) {
              return "_".concat(a).concat(e);
            });
        return "".concat(o, ", ").concat(s, " 2x");
      }
      function ut(e, t, i, n, r, o) {
        var a, s;
        void 0 === r && (r = [767, 1199]), void 0 === o && (o = 1);
        var l = null === (a = t[0]) || void 0 === a ? void 0 : a.split("x")[0],
          c =
            (null === (s = t[0]) || void 0 === s ? void 0 : s.split("x")[1]) ||
            Math.floor(+l / o),
          u = r.map(function (e) {
            return "(max-width: ".concat(e, "px)");
          }),
          d = n ? "lazy" : "eager",
          h = t
            .map(function (i, n) {
              return "<source srcset='"
                .concat(ct(e, i), "' ")
                .concat(
                  t.length - 1 !== n ? "media='".concat(u[n], "'") : "",
                  "></source>"
                );
            })
            .join("");
        return "\n    <picture>\n      "
          .concat(h, "\n      <img\n        loading=")
          .concat(d, "\n        width=")
          .concat(l, "\n        height=")
          .concat(c, "\n        alt=")
          .concat(null != i ? i : "image alt", "\n        src=")
          .concat(lt(e, t[0]), "\n      />\n    </picture>\n    ");
      }
      function dt(e, t) {
        new IntersectionObserver(
          function (i, n) {
            i[0].isIntersecting && (n.unobserve(e), t());
          },
          { rootMargin: "0px 0px 200px 0px" }
        ).observe(e);
      }
      function ht(e, t) {
        var i = t.querySelector("[data-unit-price-wrapper]");
        if (i) {
          for (; i.firstChild; ) i.removeChild(i.firstChild);
          if (e && e.unit_price_measurement) {
            var n = "".concat((0, p.l)(e.unit_price, theme.moneyFormat), " / "),
              r =
                1 !== e.unit_price_measurement.reference_value
                  ? ""
                      .concat(e.unit_price_measurement.reference_value, " ")
                      .concat(e.unit_price_measurement.reference_unit)
                  : "".concat(e.unit_price_measurement.reference_unit);
            i.innerHTML = n + r;
          }
        }
      }
      function pt(e, t, i) {
        return st(this, void 0, void 0, function () {
          return (function (e, t) {
            var i,
              n,
              r,
              o,
              a = {
                label: 0,
                sent: function () {
                  if (1 & r[0]) throw r[1];
                  return r[1];
                },
                trys: [],
                ops: [],
              };
            return (
              (o = { next: s(0), throw: s(1), return: s(2) }),
              "function" == typeof Symbol &&
                (o[Symbol.iterator] = function () {
                  return this;
                }),
              o
            );
            function s(s) {
              return function (l) {
                return (function (s) {
                  if (i) throw new TypeError("Generator is already executing.");
                  for (; o && ((o = 0), s[0] && (a = 0)), a; )
                    try {
                      if (
                        ((i = 1),
                        n &&
                          (r =
                            2 & s[0]
                              ? n.return
                              : s[0]
                              ? n.throw || ((r = n.return) && r.call(n), 0)
                              : n.next) &&
                          !(r = r.call(n, s[1])).done)
                      )
                        return r;
                      switch (((n = 0), r && (s = [2 & s[0], r.value]), s[0])) {
                        case 0:
                        case 1:
                          r = s;
                          break;
                        case 4:
                          return a.label++, { value: s[1], done: !1 };
                        case 5:
                          a.label++, (n = s[1]), (s = [0]);
                          continue;
                        case 7:
                          (s = a.ops.pop()), a.trys.pop();
                          continue;
                        default:
                          if (
                            !(
                              (r =
                                (r = a.trys).length > 0 && r[r.length - 1]) ||
                              (6 !== s[0] && 2 !== s[0])
                            )
                          ) {
                            a = 0;
                            continue;
                          }
                          if (
                            3 === s[0] &&
                            (!r || (s[1] > r[0] && s[1] < r[3]))
                          ) {
                            a.label = s[1];
                            break;
                          }
                          if (6 === s[0] && a.label < r[1]) {
                            (a.label = r[1]), (r = s);
                            break;
                          }
                          if (r && a.label < r[2]) {
                            (a.label = r[2]), a.ops.push(s);
                            break;
                          }
                          r[2] && a.ops.pop(), a.trys.pop();
                          continue;
                      }
                      s = t.call(e, a);
                    } catch (e) {
                      (s = [6, e]), (n = 0);
                    } finally {
                      i = r = 0;
                    }
                  if (5 & s[0]) throw s[1];
                  return { value: s[0] ? s[1] : void 0, done: !0 };
                })([s, l]);
              };
            }
          })(this, function (n) {
            switch (n.label) {
              case 0:
                return (
                  performance.mark("".concat(e, "-Start")),
                  i ? [4, t()] : [3, 2]
                );
              case 1:
                return n.sent(), [3, 3];
              case 2:
                t(), (n.label = 3);
              case 3:
                return (
                  performance.mark("".concat(e, "-End")),
                  performance.measure(
                    e,
                    "".concat(e, "-Start"),
                    "".concat(e, "-End")
                  ),
                  [2]
                );
            }
          });
        });
      }
      (window.resizeImage = lt),
        (window.resizeImageSrcset = ct),
        (theme.utils = {});
      var ft = l(8171),
        mt = l.n(ft),
        gt = l(394),
        yt = l.n(gt),
        vt = l(8595);
      const bt = (function () {
        function e(e) {
          (this.product = e), this.initVariantSelects();
        }
        return (
          (e.prototype.initVariantSelects = function () {
            var e = this;
            this.product.querySelector("[data-complemented-product-add-button]")
              .disabled
              ? this.product.addEventListener("change", function (t) {
                  (e.variantsOptions = e.product.querySelectorAll(
                    "[data-variants-option]"
                  )),
                    (e.variantsImage = e.product.querySelector(
                      "[data-complemented-product-image]"
                    )),
                    (e.variantsPrice = e.product.querySelector(
                      "[data-complemented-product-price]"
                    )),
                    (e.addButton = e.product.querySelector(
                      "[data-complemented-product-add-button]"
                    )),
                    e.changeImage(e.variantsOptions, e.variantsImage),
                    e.changePrice(e.variantsOptions, e.variantsPrice),
                    e.changeDisableStatus(e.addButton),
                    e.addIdToButton(e.addButton, t.target.value),
                    e.initSubmit(e.addButton);
                })
              : this.initSubmit(
                  this.product.querySelector(
                    "[data-complemented-product-add-button]"
                  )
                );
          }),
          (e.prototype.changeImage = function (e, t) {
            var i = Array.from(e).find(function (e) {
              return e.selected;
            });
            if (i) {
              var n = t.querySelectorAll("source"),
                r = i.dataset.image;
              if (!r) return;
              n.forEach(function (e) {
                e.srcset = r;
              }),
                (t.querySelector("img").src = r);
            }
          }),
          (e.prototype.changePrice = function (e, t) {
            var i = Array.from(e).find(function (e) {
              return e.selected;
            });
            i &&
              (i.dataset.compare > i.dataset.price
                ? (t.innerHTML =
                    '<ins class="text-base-sale-price no-underline">'
                      .concat(
                        i.dataset.price,
                        '</ins>\n        <del class="text-base-secondary">'
                      )
                      .concat(i.dataset.compare, "</del>"))
                : (t.innerHTML = "<div>".concat(i.dataset.price, "</div>")));
          }),
          (e.prototype.changeDisableStatus = function (e) {
            e.disabled = !1;
          }),
          (e.prototype.addIdToButton = function (e, t) {
            e.setAttribute("data-complemented-product-add-button", t);
          }),
          (e.prototype.initSubmit = function (e) {
            e.addEventListener("click", function () {
              f({
                id: e.getAttribute("data-complemented-product-add-button"),
              }).then(function (e) {
                window.Store.dispatch(at(e)),
                  window.Store.dispatch(nt()),
                  "popup" === theme.cart.cartDrawer
                    ? window.Store.dispatch(ot())
                    : window.dispatchEvent(
                        new CustomEvent("productAddedOpenDrawer")
                      );
              });
            });
          }),
          e
        );
      })();
      var wt = function () {
          return (
            (wt =
              Object.assign ||
              function (e) {
                for (var t, i = 1, n = arguments.length; i < n; i++)
                  for (var r in (t = arguments[i]))
                    Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                return e;
              }),
            wt.apply(this, arguments)
          );
        },
        St = (function () {
          function e(e, t) {
            (this.windowSize = function () {
              return window.innerWidth <= 768 ? 2 : 4;
            }),
              (this.wrapper = t),
              (this.arrayWithHandles = e),
              (this.bundleList = document.getElementById(
                "container-for-bundle-products"
              )),
              (this.products = new Array(this.arrayWithHandles.length).fill(
                null
              )),
              (this.loadedCount = 0),
              this.initVariantSelects(),
              (this.variantsObjectsById = {}),
              (this.productsMediaById = {}),
              (this.ObjectsWithFirstAvailableVariantsId = []),
              (this.productListData = []);
          }
          return (
            (e.prototype.initVariantSelects = function () {
              this.arrayWithHandles &&
                this.renderBundleProducts(this.arrayWithHandles);
            }),
            (e.prototype.renderBundleProducts = function () {
              var e = this;
              this.arrayWithHandles.forEach(function (t, i) {
                (e.currentUrl = window.location.href),
                  (e.urlObject = new URL(e.currentUrl)),
                  (e.baseUrl = ""
                    .concat(e.urlObject.protocol, "//")
                    .concat(e.urlObject.host)),
                  fetch("".concat(e.baseUrl, "/products/").concat(t))
                    .then(function (e) {
                      return e.text();
                    })
                    .then(function (t) {
                      var n,
                        r = new DOMParser().parseFromString(t, "text/html"),
                        o = e.getProduct(r),
                        a = e.productsMediaById;
                      if (
                        ((e.productsMediaById = wt(
                          wt({}, a),
                          (((n = {})[o.id] = o.media), n)
                        )),
                        (e.products[i] = e.renderProduct(o, i + 1)),
                        e.productListData.push(o),
                        (e.loadedCount += 1),
                        e.loadedCount === e.arrayWithHandles.length)
                      ) {
                        e.bundleList.insertAdjacentHTML(
                          "beforeend",
                          e.products.join("")
                        );
                        var s = document.querySelectorAll(
                          ".product-bandle-variants"
                        );
                        if (!s) return;
                        Array.from(s).forEach(function (t) {
                          var i,
                            n =
                              null ===
                                (i = t.querySelectorAll("[data-product-id]")) ||
                              void 0 === i
                                ? void 0
                                : i.length;
                          e.splide = new vt.default(t, {
                            type: n > 6 ? "loop" : "slide",
                            speed: 800,
                            perPage: 6,
                            perMove: 1,
                            gap: "6px",
                            pagination: !1,
                            arrows: n > 6,
                            keyboard: "focused",
                            drag: "free",
                            updateOnMove: !1,
                            mediaQuery: "min",
                            breakpoints: { 768: { gap: "8px" } },
                          }).mount();
                        });
                      }
                    })
                    .then(function () {
                      (e.ellemetsWithVarants =
                        e.wrapper.querySelectorAll("[data-product-id]")),
                        (e.ellemetsImage = e.wrapper.querySelectorAll(
                          "[data-variant-main-image-id]"
                        )),
                        e.arrayWithHandles.length ===
                          e.ObjectsWithFirstAvailableVariantsId.length &&
                          ((e.buyButton = e.wrapper.querySelector(
                            "[data-submit-button]"
                          )),
                          e.buyButton.setAttribute(
                            "data-buy-button-array-with-variants-ids",
                            e.ObjectsWithFirstAvailableVariantsId
                          )),
                        e.ellemetsWithVarants &&
                          e.ellemetsImage &&
                          e.ellemetsWithVarants.forEach(function (t) {
                            t.addEventListener("click", function (i) {
                              i.preventDefault(), e.changeVariant(t);
                            });
                          });
                    });
              });
            }),
            (e.prototype.changeVariant = function (e, t) {
              var i = e.dataset,
                n = i.productId,
                r = i.variantId,
                o = i.variantIndex,
                a = this.variantsObjectsById[n][r];
              if (
                a &&
                (this.changeVariantSelect(r, n, e, o),
                this.changeVariantTitle(n, r),
                this.changeShadeDescription(n, r),
                this.changeImagesInMainSlider(n, a),
                this.changeVariantsInArray(n, r),
                this.ellemetsImage)
              ) {
                this.arrayOfImages = Array.from(this.ellemetsImage);
                var s = this.arrayOfImages.find(function (e) {
                    return e.dataset.variantMainImageId === n;
                  }),
                  l = s.dataset.variantMainImageId;
                this.changeVariantImage(n, r, l, s);
              }
            }),
            (e.prototype.changeVariantsInArray = function (e, t) {
              var i = this;
              this.ObjectsWithFirstAvailableVariantsId < 1 ||
                !this.buyButton ||
                (Object.keys(this.variantsObjectsById).forEach(function (n, r) {
                  n === e &&
                    (i.ObjectsWithFirstAvailableVariantsId[r] = Number(t));
                }),
                this.buyButton.setAttribute(
                  "data-buy-button-array-with-variants-ids",
                  this.ObjectsWithFirstAvailableVariantsId
                ));
            }),
            (e.prototype.changeImagesInMainSlider = function (e, t) {
              var i = this,
                n = this.replaceHighfand(t.variant.image.alt),
                r = this.productsMediaById[e].filter(function (e) {
                  return e.alt && i.replaceHighfand(e.alt) === n ? e : "";
                });
              this.wrapper
                .querySelector("#splide01-list")
                .querySelectorAll(".product-gallery-slider__img")
                .forEach(function (e, t) {
                  var n,
                    o,
                    a = null === (n = r[t]) || void 0 === n ? void 0 : n.src;
                  if (a) {
                    i.preloadImage(a), (e.innerHTML = "");
                    var s = '\n        <picture>\n          <source srcset="'
                      .concat(a, "&amp;height=323&amp;width=350, ")
                      .concat(
                        a,
                        '&amp;height=646&amp;width=700 2x" media="(max-width: 767px)">\n          <source srcset="'
                      )
                      .concat(a, "&amp;height=588&amp;width=637, ")
                      .concat(
                        a,
                        '&amp;height=1176&amp;width=1274 2x">\n          <img src="'
                      )
                      .concat(
                        a,
                        '&amp;height=323&amp;width=350" class="w-full h-full object-contain" width="350" height="323" loading="eager" alt="'
                      )
                      .concat(
                        null === (o = r[t]) || void 0 === o ? void 0 : o.alt,
                        '" fetchpriority="high">\n        </picture>\n      '
                      );
                    e.insertAdjacentHTML("beforeend", s);
                  }
                });
            }),
            (e.prototype.preloadImage = function (e) {
              new Image().src = e;
            }),
            (e.prototype.changeShadeDescription = function (e, t) {
              var i =
                this.variantsObjectsById[e][t].variant.variant_metafields
                  .metafield_text;
              "" !== i &&
                (this.wrapper.querySelector(
                  '[data-product-shade-description="'.concat(e, '"]')
                ).innerHTML = "<p>".concat(i, "</p>"));
            }),
            (e.prototype.changeVariantTitle = function (e, t) {
              var i = this.variantsObjectsById[e][t].variant;
              this.wrapper.querySelector(
                '[data-product-title-id="'.concat(e, '"]')
              ).innerHTML = "".concat(i.title);
            }),
            (e.prototype.changeVariantSelect = function (e, t, i) {
              if (this.ellemetsWithVarants) {
                var n = this.variantsObjectsById,
                  r = Object.keys(n[t]).length;
                this.ellemetsWithVarants.forEach(function (e) {
                  e.dataset.productId === t && e.classList.remove("is-active1");
                }),
                  r > 6 &&
                    document
                      .querySelectorAll('[data-variant-id="'.concat(e, '"]'))
                      .forEach(function (e) {
                        e.classList.add("is-active1");
                      }),
                  i.classList.add("is-active1");
              }
            }),
            (e.prototype.changeVariantImage = function (e, t, i, n) {
              var r, o, a, s, l, c;
              if (this.variantsObjectsById[e][t]) {
                var u =
                    null ===
                      (a =
                        null ===
                          (o =
                            null === (r = this.variantsObjectsById[e][t]) ||
                            void 0 === r
                              ? void 0
                              : r.variant) || void 0 === o
                          ? void 0
                          : o.image) || void 0 === a
                      ? void 0
                      : a.src,
                  d =
                    null ===
                      (c =
                        null ===
                          (l =
                            null === (s = this.variantsObjectsById[e][t]) ||
                            void 0 === s
                              ? void 0
                              : s.variant) || void 0 === l
                          ? void 0
                          : l.image) || void 0 === c
                      ? void 0
                      : c.alt;
                if ((this.preloadImage(u), i === e)) {
                  n.innerHTML = "";
                  var h = '\n        <picture>\n          <source srcset="'
                    .concat(u, ", ")
                    .concat(
                      u,
                      ' 2x" media="(max-width: 767px)">\n          <source srcset="'
                    )
                    .concat(u, ", ")
                    .concat(u, ' 2x">\n          <img src="')
                    .concat(
                      u,
                      '" class="w-full h-full object-contain" width="160" height="160" loading="lazy" alt="'
                    )
                    .concat(
                      d,
                      '" fetchpriority="auto">\n        </picture>\n      '
                    );
                  n.insertAdjacentHTML("beforeend", h);
                }
              }
            }),
            (e.prototype.getProduct = function (e) {
              var t;
              try {
                t = JSON.parse(e.querySelector("#product-json").innerHTML);
              } catch (e) {
                console.warn(e);
              }
              return t;
            }),
            (e.prototype.replaceHighfand = function (e) {
              return e.replaceAll(" ", "-").replaceAll(".", "").toLowerCase();
            }),
            (e.prototype.createItemsMarkup = function (e) {
              var t,
                i = this;
              if (!e) return "";
              var n = {},
                r = this.variantsObjectsById;
              (this.variantsObjectsById = wt(
                wt({}, r),
                (((t = {})[e.id] = n), t)
              )),
                this.ObjectsWithFirstAvailableVariantsId.push(
                  e.selected_or_first_available_variant.id
                );
              var o = !1,
                a = 0,
                s = 0;
              return e.variants
                .filter(function (e) {
                  return e.available;
                })
                .map(function (t, r) {
                  n[t.id] = { variant: t, index: r };
                  var l = i.replaceHighfand(t.title);
                  return 0 === t.quantity
                    ? (!1 === o && (a = r + 1), "")
                    : (t.quantity > 0 && ((s += 1), (o = !0)),
                      "\n        <li data-product-id="
                        .concat(e.id, ' data-variant-id="')
                        .concat(t.id, '" data-variant-index="')
                        .concat(s, '" class="')
                        .concat(
                          Number(r) === Number(a) ? "is-active1" : "",
                          ' splide__slide max-h-[24px] min-h-[24px] min-w-[24px] max-w-[24px] rounded-full border border-white lg:max-h-[32px] lg:min-h-[32px] lg:min-w-[32px] lg:max-w-[32px] [&.is-active1]:border-[#00263a]" id="product-thumbnails-splider-slide02" role="group" aria-roledescription="slide" aria-label="2 of 2" style="margin-right: 8px; width: calc(16.6667% - 6.66667px);">\n          <img src="'
                        )
                        .concat(i.baseUrl, "/cdn/shop/files/")
                        .concat(
                          l,
                          '.png?v=10900282933165239638"  class="h-[22px] w-[22px] !rounded-full lg:h-[30px] lg:w-[30px]" width="22" height="22" loading="lazy" fetchpriority="low" alt="'
                        )
                        .concat(t.title, '">\n        </li>\n      '));
                })
                .join("");
            }),
            (e.prototype.returnSlider = function (e) {
              var t, i;
              if (!e) return "";
              var n = this.createItemsMarkup(e);
              if ("" === n) return "";
              var r = (
                null === (t = null == n ? void 0 : n.split("</li>")) ||
                void 0 === t
                  ? void 0
                  : t.length
              )
                ? null === (i = null == n ? void 0 : n.split("</li>")) ||
                  void 0 === i
                  ? void 0
                  : i.length
                : 0;
              return '\n      <div class="splide product-bandle-variants relative\n      max-w-[174px]\n      md:max-w-[184px]\n      '
                .concat(
                  r > 7 ? "lg:mx-4" : "lg:mx-0",
                  '\n      lg:max-w-[240px]" id="splide01" role="region" aria-roledescription="carousel">\n        <div class="splide__track splide__track--loop splide__track--ltr splide__track--draggable" id="splide01-track" aria-live="polite" aria-atomic="true" style="padding-left: 0px; padding-right: 0px;">\n          <ul class="splide__list" id="splide01-list" role="presentation" style="transform: translateX(-523.969px);">\n            '
                )
                .concat(
                  n,
                  '\n          </ul>\n        </div>\n\n        <div class="splide__arrows pointer-events-none absolute -left-4 -right-4 bottom-0 top-0 flex items-center justify-between text-black lg:-left-6 lg:-right-6 splide__arrows--ltr">\n          <button type="button" class="\n              splide__arrow\n              splide__arrow--prev\n              pointer-events-auto\n              !static\n              !transform-none\n              !bg-transparent\n              !opacity-100\n            " aria-label="Go to last slide" tabindex="0" aria-controls="splide01-track">\n            &lt;\n          </button>\n\n          <button type="button" class="\n              splide__arrow\n              splide__arrow--next\n              pointer-events-auto\n              !static\n              !transform-none\n              !bg-transparent\n              !opacity-100\n            " aria-label="Next slide" tabindex="0" aria-controls="splide01-track">\n            &gt;\n          </button>\n        </div>\n      </div>\n    '
                );
            }),
            (e.prototype.returnShadeDescription = function (e) {
              var t, i;
              if (!e) return "";
              var n =
                null ===
                  (i =
                    null === (t = null == e ? void 0 : e.variants[0]) ||
                    void 0 === t
                      ? void 0
                      : t.variant_metafields) || void 0 === i
                  ? void 0
                  : i.metafield_text;
              return "" !== n
                ? '<div data-product-shade-description="'
                    .concat(
                      e.id,
                      '" class="prose text-body-alt-1 lg:text-body-desktop"><p>'
                    )
                    .concat(n, "</p></div>")
                : "";
            }),
            (e.prototype.renderProduct = function (e, t) {
              var i = this.windowSize();
              if (!this.bundleList || !e) return "";
              var n = e.selected_or_first_available_variant.featured_image.src,
                r = e.selected_or_first_available_variant.featured_image.alt;
              return '\n      <li class="flex items-center gap-4 lg:min-w-[224px] lg:min-h-[278px] md:min-w-[160px] md:min-h-[199px]">\n        <a data-variant-main-image-id="'
                .concat(
                  e.id,
                  '" href="#" class="block w-40 shrink-0 lg:w-56">\n          <picture>\n            <source srcset="'
                )
                .concat(n, ", ")
                .concat(
                  n,
                  ' 2x" media="(max-width: 767px)">\n            <source srcset="'
                )
                .concat(n, ", ")
                .concat(n, ' 2x">\n            <img src="')
                .concat(
                  n,
                  '" class="w-full h-full object-contain" width="160" height="199" alt="'
                )
                .concat(r, '" loading="')
                .concat(t < i ? "eager" : "lazy", '" fetchpriority="')
                .concat(
                  t < i ? "high" : "low",
                  '">\n          </picture>\n        </a>\n\n        <div class="grid place-content-start gap-3 text-[10px] lg:text-[15px]">\n          <h3 class="uppercase font-heading-alt text-h3-alt-2 lg:text-h4-desktop">\n            <a href="'
                )
                .concat(
                  null == e ? void 0 : e.url,
                  '" class="inline-flex">\n              '
                )
                .concat(t, ". ")
                .concat(
                  null == e ? void 0 : e.title,
                  "\n            </a>\n          </h3>\n          "
                )
                .concat(
                  (
                    null == e
                      ? void 0
                      : e.selected_or_first_available_variant.title
                  )
                    ? '<div class="font-heading-alt text-h3-alt-2 lg:text-h4-desktop" data-product-title-id="'
                        .concat(e.id, '">')
                        .concat(
                          null == e
                            ? void 0
                            : e.selected_or_first_available_variant.title,
                          "</div>"
                        )
                    : "",
                  "\n\n          "
                )
                .concat(this.returnSlider(e), "\n\n          ")
                .concat(
                  this.returnShadeDescription(e),
                  "\n        </div>\n      </li>"
                );
            }),
            e
          );
        })();
      const Et = St;
      var kt = function () {
          return (
            (kt =
              Object.assign ||
              function (e) {
                for (var t, i = 1, n = arguments.length; i < n; i++)
                  for (var r in (t = arguments[i]))
                    Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                return e;
              }),
            kt.apply(this, arguments)
          );
        },
        Tt = function (e) {
          var t = "function" == typeof Symbol && Symbol.iterator,
            i = t && e[t],
            n = 0;
          if (i) return i.call(e);
          if (e && "number" == typeof e.length)
            return {
              next: function () {
                return (
                  e && n >= e.length && (e = void 0),
                  { value: e && e[n++], done: !e }
                );
              },
            };
          throw new TypeError(
            t ? "Object is not iterable." : "Symbol.iterator is not defined."
          );
        },
        At = function (e, t) {
          var i = "function" == typeof Symbol && e[Symbol.iterator];
          if (!i) return e;
          var n,
            r,
            o = i.call(e),
            a = [];
          try {
            for (; (void 0 === t || t-- > 0) && !(n = o.next()).done; )
              a.push(n.value);
          } catch (e) {
            r = { error: e };
          } finally {
            try {
              n && !n.done && (i = o.return) && i.call(o);
            } finally {
              if (r) throw r.error;
            }
          }
          return a;
        },
        Pt = function (e, t, i) {
          if (i || 2 === arguments.length)
            for (var n, r = 0, o = t.length; r < o; r++)
              (!n && r in t) ||
                (n || (n = Array.prototype.slice.call(t, 0, r)), (n[r] = t[r]));
          return e.concat(n || Array.prototype.slice.call(t));
        };
      function _t(e) {
        var t = document.querySelector("[data-product-price]"),
          i = document.querySelector("[data-price-wrapper]");
        if (t)
          for (var n = 0; n < t.textContent.length; n += 1) {
            var r = t.textContent[n];
            if (Number(r)) {
              if (Number(r) > 0) {
                var o = (0, p.l)(e);
                return void (t.textContent = ""
                  .concat(t.textContent[n - 1])
                  .concat(o.slice(1)));
              }
              return;
            }
          }
        if (!t && i) {
          for (n = 0; n < t.textContent.length; n += 1)
            if (((r = t.textContent[n]), Number(r)))
              return Number(r) > 0
                ? ((o = (0, p.l)(e)),
                  void (t.textContent = ""
                    .concat(t.textContent[n - 1])
                    .concat(o.slice(1))))
                : void 0;
          i.textContent = (0, p.l)(e);
        }
      }
      var Ct = (function () {
        function e(e) {
          var t,
            i,
            n,
            r,
            o,
            a,
            s = this;
          (this.getGallaryMarkup = function (e, t) {
            e.innerHTML = "";
            var i = "",
              n = !1;
            return (
              s.allSlides.forEach(function (e) {
                var r = e
                  .querySelector("[data-image-alt]")
                  .getAttribute("data-image-alt");
                "Default Title" === t && ((i += e.outerHTML), (n = !0)),
                  r === t && ((i += e.outerHTML), (n = !0));
              }),
              n ||
                s.allSlides.forEach(function (e) {
                  i += e.outerHTML;
                }),
              i
            );
          }),
            (this.waitForElement = function (e) {
              return new Promise(function (t) {
                var i = s.wrapper.querySelector(e);
                if (!i || i.disabled) {
                  var n = new MutationObserver(function (i) {
                    i.forEach(function (i) {
                      var r,
                        o,
                        a = Array.from(i.addedNodes);
                      try {
                        for (
                          var s = Tt(a), l = s.next();
                          !l.done;
                          l = s.next()
                        ) {
                          var c = l.value,
                            u = c.querySelector(e);
                          if (c.classList.contains(e.replace(".", "")))
                            return t(c), void n.disconnect();
                          if (u && !u.disabled)
                            return n.disconnect(), void t(u);
                        }
                      } catch (e) {
                        r = { error: e };
                      } finally {
                        try {
                          l && !l.done && (o = s.return) && o.call(s);
                        } finally {
                          if (r) throw r.error;
                        }
                      }
                    });
                  });
                  s.wrapper.querySelectorAll(".shopify-payment-button")[0] &&
                    n.observe(
                      s.wrapper.querySelectorAll(".shopify-payment-button")[0],
                      { subtree: !0, attributes: !0, childList: !0 }
                    );
                } else t(i);
              });
            }),
            (this.wrapper = e),
            (this.sectionId = this.wrapper.getAttribute("data-section-id")),
            (this.handle = this.wrapper.getAttribute("data-handle")),
            (this.submitButton = this.wrapper.querySelector(
              "[data-submit-button]"
            )),
            (this.submitButtonText = this.wrapper.querySelector(
              "[data-submit-button]"
            )),
            (this.priceContainer = this.wrapper.querySelector(
              "[data-price-wrapper]"
            )),
            (this.shopifyButtons = this.wrapper.querySelector(
              '[data-shopify="payment-button"]'
            )),
            (this.sizeChart = this.wrapper.querySelector(".size-chart-link")),
            (this.selectElement = this.wrapper.querySelector("[data-select]")),
            (this.discountPercentageSellingPlanContainer =
              this.wrapper.querySelector("[data-discount-percentage]")),
            (this.priceSellingPlanContainer =
              this.wrapper.querySelector("[data-price]")),
            (this.compareAtPriceSellingPlanContainer =
              this.wrapper.querySelector("[data-compare-at-price]")),
            (this.sellingPlanInput = this.wrapper.querySelector(
              '[name="selling_plan"]'
            )),
            (this.selects = this.wrapper.querySelectorAll(
              "#variant-selects select"
            )),
            (this.selectedVariant = null),
            (this.variantId = null),
            (this.increseButton = this.wrapper.querySelector(
              "[data-increase-button]"
            )),
            (this.decreaseButton = this.wrapper.querySelector(
              "[data-decrease-button]"
            )),
            (this.variantQuantity = 0),
            (this.currentVariantId = null),
            (this.sellingPlanEnabled = !1),
            (this.currenDiscount =
              null ===
                (t = this.wrapper.querySelector(
                  "[data-current-discounts-percents]"
                )) || void 0 === t
                ? void 0
                : t.textContent),
            (this.allSlides = this.wrapper.querySelectorAll(
              ".product-gallery .splide__slide"
            )),
            this.initPickupAvailability(),
            this.sizeChartInit(),
            (this.product = this.getProduct()),
            (this.productPercentDiscountPlan =
              null ===
                (r =
                  null ===
                    (n =
                      null === (i = this.product.selling_plan_groups[0]) ||
                      void 0 === i
                        ? void 0
                        : i.selling_plans[0]) || void 0 === n
                    ? void 0
                    : n.price_adjustments[0]) || void 0 === r
                ? void 0
                : r.value),
            (this.sellingPlanId = null),
            (this.customSellingPlanForm = this.wrapper.querySelectorAll(
              "[data-custom-selling-plan-form]"
            )),
            (this.arrayOfVariants = this.product.variants),
            (this.isActiveSlide = 1),
            this.initVariantSelects(),
            this.initQuantitySelector(),
            this.getVariantData(
              null !== (o = this.variantSelects) && void 0 !== o
                ? o
                : this.variantRadios
            ),
            this.updateOptions(
              null !== (a = this.variantSelects) && void 0 !== a
                ? a
                : this.variantRadios
            ),
            this.updateSellingPlan(),
            this.initModelViewer(),
            this.initSubmit(),
            this.initProductRecommendations(),
            this.updateDynamicButton(),
            this.initFancyboxZoomImage(),
            this.initTabs(),
            this.initSpliderSwatcher(),
            this.initReadMoreButton(),
            this.initClassForBundles(),
            this.initControllsForBuyButton(),
            this.initSellingPlan(),
            this.initTestimonialsSlider(),
            this.initRatingPositioner(),
            this.iniMainImageSlider(
              this.product.selected_or_first_available_variant.title
            ),
            (this.tabsSettings = JSON.parse(
              document.querySelector("#product-tabs-settings").innerHTML
            )),
            console.log(this.tabsSettings);
        }
        return (
          (e.prototype.initRatingPositioner = function () {
            var e = this;
            this.widgetsWrappers = this.wrapper.querySelectorAll(
              ".block-for-widget-blocks"
            );
            var t = this.wrapper.querySelector(
              "#product-rating-mobile-position-block"
            );
            window.innerWidth < 1024 &&
              this.widgetsWrappers &&
              setTimeout(function () {
                e.widgetsWrappers.forEach(function (e) {
                  var i = e.querySelector(
                    '[id^="shopify-block-okendo_star_rating"]'
                  );
                  i && ((t.innerHTML = ""), t.appendChild(i));
                });
              }, 0);
          }),
          (e.prototype.iniMainImageSlider = function (e) {
            var t = this,
              i = this.wrapper.querySelector(".product-gallery .splide__list");
            i &&
              e &&
              (i.insertAdjacentHTML("afterbegin", this.getGallaryMarkup(i, e)),
              (this.mainSplide = new vt.default(
                this.wrapper.querySelector(".product-gallery"),
                {
                  type: "slide",
                  speed: 800,
                  perPage: 1,
                  gap: "5px",
                  padding: { right: "40px" },
                  pagination: !0,
                  arrows: !1,
                  keyboard: "focused",
                  mediaQuery: "min",
                  breakpoints: { 1024: { padding: { right: "0" } } },
                }
              ).mount()),
              this.mainSplide.on("moved", function () {
                var e = t.wrapper
                  .querySelector(".splide__slide.is-active")
                  .querySelector("video");
                e &&
                  (e.setAttribute("autoplay", !0),
                  e.play().catch(function (e) {
                    console.error("Video Error ", e);
                  }));
              }));
          }),
          (e.prototype.updateImagesMainSlider = function (e) {
            this.mainSplide.destroy(), this.iniMainImageSlider(e.title);
          }),
          (e.prototype.initTestimonialsSlider = function () {
            var e = this.wrapper.querySelectorAll(
              ".products-testimonials-slider"
            );
            e &&
              e.forEach(function (e) {
                new vt.default(e, {
                  type: "loop",
                  speed: 800,
                  perPage: 1,
                  gap: 0,
                  pagination: !0,
                  arrows: !1,
                  keyboard: "focused",
                }).mount();
              });
          }),
          (e.prototype.initControllsForBuyButton = function () {
            var e = this;
            (this.increseButton || this.decreaseButton) &&
              (this.increseButton.previousElementSibling.addEventListener(
                "change",
                function (t) {
                  var i = t.target.value;
                  e.changequantityOnAddButton("input", i);
                }
              ),
              this.increseButton.addEventListener("click", function () {
                e.changequantityOnAddButton("increase");
              }),
              this.decreaseButton.addEventListener("click", function () {
                e.changequantityOnAddButton("decrease");
              }));
          }),
          (e.prototype.initClassForBundles = function () {
            var e = document.querySelectorAll("[data-handle-for-fetch]");
            if (e && 0 !== e.length) {
              var t = Array.from(e).map(function (e) {
                  return e.dataset.handleForFetch;
                }),
                i = new Et(t, this.wrapper);
              this.bundleProducts = i;
            }
          }),
          (e.prototype.initReadMoreButton = function () {
            var e = this;
            this.wrapper
              .querySelectorAll("[data-information-tabs-content]")
              .forEach(function (t) {
                t.querySelectorAll('[id^="tab-"]').forEach(function (t) {
                  var i = t.querySelector("[data-read-more-button]"),
                    n = t.querySelector("[data-read-less-button]");
                  (e.readMoreButton = i), (e.readLessButton = n);
                  var r = t.querySelector("[data-short-wrapper]"),
                    o = t.querySelector("[data-full-wrapper]");
                  i &&
                    n &&
                    r &&
                    o &&
                    (i.addEventListener("click", function () {
                      r.innerHTML,
                        o.innerHTML,
                        r.classList.add("hidden"),
                        o.classList.remove("hidden");
                    }),
                    n.addEventListener("click", function () {
                      r.classList.remove("hidden"), o.classList.add("hidden");
                    }));
                });
              });
          }),
          (e.prototype.initSpliderSwatcher = function () {
            var e = this;
            if (this.isAnElementExistsOnThePage(".product-thumbnails")) {
              (this.availableOptions = 0),
                this.arrayOfVariants.forEach(function (t) {
                  t.available && (e.availableOptions += 1);
                }),
                (this.splide = new vt.default(".product-thumbnails", {
                  type: this.availableOptions > 6 ? "loop" : "slide",
                  speed: 800,
                  perPage: 6,
                  perMove: 1,
                  gap: "6px",
                  pagination: !1,
                  arrows: this.availableOptions > 6,
                  keyboard: "focused",
                  destroy: this.availableOptions < 6,
                  mediaQuery: "min",
                  breakpoints: { 768: { gap: "8px" } },
                }).mount());
              var t = document
                .getElementById("product-thumbnails-splider")
                .querySelectorAll(".splide__slide");
              this.selectcurrentSlide(t),
                t.forEach(function (i, n) {
                  i.addEventListener("click", function () {
                    var r, o, a, s;
                    e._slideToBlock(n, t);
                    var l,
                      c = i.querySelector("button");
                    if (
                      ((e.variantId = c.getAttribute("data-variant-id")),
                      (e.sellingPlanEnabled = (
                        null === (r = e.customSellingPlanForm) || void 0 === r
                          ? void 0
                          : r.length
                      )
                        ? e.sellingPlanId
                        : !!e.getSellingPlanFromUrl()),
                      e.selectedVariant && e.selectedVariant.length > 0)
                    )
                      l = e.sellingPlanEnabled
                        ? (null === (o = e.selectedVariant[0]) || void 0 === o
                            ? void 0
                            : o.price) -
                          (e.selectedVariant[0].price *
                            e.productPercentDiscountPlan) /
                            100
                        : null === (a = e.selectedVariant[0]) || void 0 === a
                        ? void 0
                        : a.price;
                    else {
                      e.currentVariantId = e.product.first_available_variant.id;
                      var u = e.productPercentDiscountPlan
                          ? e.productPercentDiscountPlan
                          : 1,
                        d =
                          e.product.first_available_variant.price -
                          (e.product.first_available_variant.price * u) / 100;
                      l = e.sellingPlanEnabled
                        ? d
                        : e.product.first_available_variant.price;
                    }
                    e.findCurrentVariant(),
                      e.changeVariantTitle(),
                      (e.currentVariant = e.selectedVariant[0]),
                      e.changeThumbnailText(e.currentVariant),
                      e.onOptionChange.apply(
                        e,
                        Pt(Pt([], At(e.selectedVariant), !1), ["splider"], !1)
                      ),
                      e.removeErrorMessage(),
                      e.updateVariantInput(e.currentVariant),
                      e.updateDynamicButton(),
                      e.updateBuyButton(
                        null === (s = null == e ? void 0 : e.currentVariant) ||
                          void 0 === s
                          ? void 0
                          : s.id
                      ),
                      e.changeTabsInformation(e.currentVariant),
                      _t(l);
                  });
                });
            }
          }),
          (e.prototype.changeTabsInformation = function (e) {
            var t = this;
            if (e) {
              for (
                var i = this.wrapper.querySelector(
                    "[data-information-tabs-labels]"
                  ),
                  n = this.wrapper.querySelector(
                    "[data-information-tabs-content]"
                  ),
                  r = document.querySelectorAll("[data-read-less-button]"),
                  o = document.querySelectorAll("[data-read-more-button]"),
                  a = 0;
                a < r.length;

              )
                (r[a].style.display = "block"), (a += 1);
              for (a = 0; a < o.length; )
                (o[a].style.display = "block"), (a += 1);
              i &&
                i.querySelectorAll("a").forEach(function (i) {
                  var a = i.dataset.tabType,
                    s = i.getAttribute("href"),
                    l = Number(i.id.split("-")[i.id.split("-").length - 2]) - 1,
                    c = (function () {
                      var i, n, r, o, s, l, c, u, d, h, p, f, m;
                      return "description" === a
                        ? (m = {
                            value:
                              null ===
                                (i =
                                  null == e ? void 0 : e.variant_metafields) ||
                              void 0 === i
                                ? void 0
                                : i.description,
                            shortValue:
                              null ===
                                (n =
                                  null == e ? void 0 : e.variant_metafields) ||
                              void 0 === n
                                ? void 0
                                : n.description_short,
                            fullValueSize:
                              null ===
                                (r =
                                  null == e ? void 0 : e.variant_metafields) ||
                              void 0 === r
                                ? void 0
                                : r.description_size,
                          }).value
                          ? m
                          : (m = {
                              value: t.product.description,
                              shortValue: t.product.description_short,
                              fullValueSize: t.product.description_size,
                            })
                        : "how_to" === a
                        ? (m = {
                            value:
                              null ===
                                (o =
                                  null == e ? void 0 : e.variant_metafields) ||
                              void 0 === o
                                ? void 0
                                : o.how_to_use,
                            shortValue:
                              null ===
                                (s =
                                  null == e ? void 0 : e.variant_metafields) ||
                              void 0 === s
                                ? void 0
                                : s.how_to_use_short,
                            fullValueSize:
                              null ===
                                (l =
                                  null == e ? void 0 : e.variant_metafields) ||
                              void 0 === l
                                ? void 0
                                : l.how_to_use_size,
                          }).value
                          ? m
                          : (m = {
                              value: t.tabsSettings.product_tab_2_content,
                              shortValue:
                                t.tabsSettings.product_tab_2_content_short,
                              fullValueSize:
                                t.tabsSettings.product_tab_2_content_size,
                            })
                        : "ingredients" === a
                        ? (m = {
                            value:
                              null ===
                                (c =
                                  null == e ? void 0 : e.variant_metafields) ||
                              void 0 === c
                                ? void 0
                                : c.ingredients,
                            shortValue:
                              null ===
                                (u =
                                  null == e ? void 0 : e.variant_metafields) ||
                              void 0 === u
                                ? void 0
                                : u.ingredients_short,
                            fullValueSize:
                              null ===
                                (d =
                                  null == e ? void 0 : e.variant_metafields) ||
                              void 0 === d
                                ? void 0
                                : d.ingredients_size,
                          }).value
                          ? m
                          : (m = {
                              value: t.tabsSettings.product_tab_3_content,
                              shortValue:
                                t.tabsSettings.product_tab_3_content_short,
                              fullValueSize:
                                t.tabsSettings.product_tab_3_content_size,
                            })
                        : "sustainability" === a
                        ? (m = {
                            value:
                              null ===
                                (h =
                                  null == e ? void 0 : e.variant_metafields) ||
                              void 0 === h
                                ? void 0
                                : h.sustainability,
                            shortValue:
                              null ===
                                (p =
                                  null == e ? void 0 : e.variant_metafields) ||
                              void 0 === p
                                ? void 0
                                : p.sustainability_short,
                            fullValueSize:
                              null ===
                                (f =
                                  null == e ? void 0 : e.variant_metafields) ||
                              void 0 === f
                                ? void 0
                                : f.sustainability_size,
                          }).value
                          ? m
                          : (m = {
                              value: t.tabsSettings.product_tab_4_content,
                              shortValue:
                                t.tabsSettings.product_tab_4_content_short,
                              fullValueSize:
                                t.tabsSettings.product_tab_4_content_size,
                            })
                        : void 0;
                    })(),
                    u = c.value,
                    d = c.shortValue,
                    h = c.fullValueSize;
                  if (u) {
                    var p = n
                        .querySelector("".concat(s))
                        .querySelector("[data-read-more-content]"),
                      f = p.querySelector("[data-short-content]"),
                      m = p.querySelector("[data-full-content]");
                    if (!m)
                      throw new Error(
                        "Full tab's content not found in product wrapper ([data-full-content])"
                      );
                    if (!f)
                      throw new Error(
                        "Short tab's content not found in product wrapper ([data-short-content])"
                      );
                    h < t.tabsSettings.product_tab_read_more_length &&
                      ((d = u),
                      r[l],
                      o[l],
                      (r[l].style.display = "none"),
                      (o[l].style.display = "none")),
                      (u = u.replaceAll(/&lt;/g, "<").replaceAll(/&gt;/g, ">")),
                      (d = d.replaceAll(/&lt;/g, "<").replaceAll(/&gt;/g, ">")),
                      (m.innerHTML = u),
                      (f.innerHTML = d);
                  }
                });
            }
          }),
          (e.prototype.decodeHtml = function (e) {
            var t = document.createElement("textarea");
            return (t.innerHTML = e), t.value;
          }),
          (e.prototype.getSellingPlanFromUrl = function () {
            return new URLSearchParams(window.location.search).get(
              "selling_plan"
            );
          }),
          (e.prototype.getVariantIdFromUrl = function () {
            return new URLSearchParams(window.location.search).get("variant");
          }),
          (e.prototype.addVariantToHistopry = function (e) {
            if (!this.getVariantIdFromUrl()) {
              var t = new URL(window.location.href);
              t.searchParams.append("variant", "".concat(e)),
                window.history.replaceState({}, "", t);
            }
          }),
          (e.prototype.initSellingPlan = function () {
            var e = this,
              t = this.wrapper,
              i = this.wrapper.querySelector("#add-to-cart-button-id");
            if ((this.findCurrentVariant(), t)) {
              var n = new MutationObserver(function (t, n) {
                var r, o, a, s, l, c, u;
                try {
                  for (var d = Tt(t), h = d.next(); !h.done; h = d.next()) {
                    var p = h.value;
                    if ("childList" === p.type)
                      try {
                        for (
                          var f = ((a = void 0), Tt(p.addedNodes)),
                            m = f.next();
                          !m.done;
                          m = f.next()
                        ) {
                          var g = m.value;
                          if (1 === g.nodeType && g.matches(".rc-widget")) {
                            var y = e.wrapper.querySelector(".rc-widget"),
                              v = e.wrapper.querySelector(
                                ".rc-radio.onetime-radio"
                              );
                            return (
                              (e.sellingPlanEnabled = !0),
                              e.initRcWidget(v, i),
                              e.getSellingPlanFromUrl() &&
                              (null === (l = e.selectedVariant[0]) ||
                              void 0 === l
                                ? void 0
                                : l.price)
                                ? Number(e.productPercentDiscountPlan) > 0 &&
                                  Number(
                                    null === (c = e.selectedVariant[0]) ||
                                      void 0 === c
                                      ? void 0
                                      : c.price
                                  ) > 0 &&
                                  _t(
                                    (null === (u = e.selectedVariant[0]) ||
                                    void 0 === u
                                      ? void 0
                                      : u.price) -
                                      (e.selectedVariant[0].price *
                                        e.productPercentDiscountPlan) /
                                        100
                                  )
                                : e.getSellingPlanFromUrl() &&
                                  e.product.first_available_variant.price &&
                                  (Number(
                                    e.product.first_available_variant.price
                                  ) > 0 &&
                                    _t(
                                      e.product.first_available_variant.price -
                                        (e.product.first_available_variant
                                          .price *
                                          e.productPercentDiscountPlan) /
                                          100
                                    ),
                                  e.getVariantIdFromUrl() ||
                                    e.addVariantToHistopry(
                                      e.product.first_available_variant.id
                                    )),
                              y.addEventListener("change", function (t) {
                                var n,
                                  r,
                                  o = (
                                    null === (n = e.selectedVariant[0]) ||
                                    void 0 === n
                                      ? void 0
                                      : n.price
                                  )
                                    ? null === (r = e.selectedVariant[0]) ||
                                      void 0 === r
                                      ? void 0
                                      : r.price
                                    : e.product.first_available_variant.price;
                                "INPUT" === t.target.nodeName &&
                                  e.getSellingPlanFromUrl() &&
                                  ((e.sellingPlanEnabled = !0),
                                  e.updateSellingPlanId(
                                    e.getSellingPlanFromUrl()
                                  ),
                                  e.disableBuyButtonOnLoadSellingPlan(
                                    i,
                                    "enable"
                                  )),
                                  "onetime" === t.target._value
                                    ? (e.updateSellingPlanId(""),
                                      (e.sellingPlanEnabled = !1),
                                      (e.sellingPlanId = null),
                                      e.updateBuyButton(e.currentVariantId),
                                      Number(o) && _t(o))
                                    : (e.updateSellingPlanId(
                                        e.getSellingPlanFromUrl()
                                      ),
                                      (e.sellingPlanEnabled = !0),
                                      e.updateBuyButton(e.currentVariantId),
                                      Number(o) &&
                                        _t(
                                          o -
                                            (o * e.productPercentDiscountPlan) /
                                              100
                                        ),
                                      e.getVariantIdFromUrl() ||
                                        e.addVariantToHistopry(
                                          e.product.first_available_variant.id
                                        )),
                                  "SELECT" === t.target.nodeName &&
                                    Number.isInteger(Number(t.target.value)) &&
                                    (e.updateSellingPlanId(t.target.value),
                                    e.updateBuyButton(e.currentVariantId));
                              }),
                              void n.disconnect()
                            );
                          }
                        }
                      } catch (e) {
                        a = { error: e };
                      } finally {
                        try {
                          m && !m.done && (s = f.return) && s.call(f);
                        } finally {
                          if (a) throw a.error;
                        }
                      }
                  }
                } catch (e) {
                  r = { error: e };
                } finally {
                  try {
                    h && !h.done && (o = d.return) && o.call(d);
                  } finally {
                    if (r) throw r.error;
                  }
                }
              });
              n.observe(t, { childList: !0, subtree: !0 }),
                this.initCustomSellingPlan();
            } else console.error("Target node not found");
          }),
          (e.prototype.initCustomSellingPlan = function () {
            var e,
              t = this;
            (null === (e = this.customSellingPlanForm) || void 0 === e
              ? void 0
              : e.length) &&
              this.product.first_available_variant &&
              (this.addVariantToHistopry(
                this.product.first_available_variant.id
              ),
              this.customSellingPlanForm.forEach(function (e) {
                e.addEventListener("change", function (e) {
                  var i, n;
                  if (Number(e.target.value)) {
                    (t.sellingPlanId = e.target.value),
                      t.updateSellingPlanId(e.target.value),
                      (t.sellingPlanEnabled = !0);
                    var r = (
                      null === (i = t.selectedVariant[0]) || void 0 === i
                        ? void 0
                        : i.price
                    )
                      ? null === (n = t.selectedVariant[0]) || void 0 === n
                        ? void 0
                        : n.price
                      : t.product.first_available_variant.price;
                    _t(
                      t.sellingPlanEnabled
                        ? r - (r * t.productPercentDiscountPlan) / 100
                        : r
                    ),
                      t.updateBuyButton(t.getVariantIdFromUrl());
                  }
                });
              }));
          }),
          (e.prototype.initRcWidget = function (e, t) {
            e &&
              (e.classList.contains("rc-radio--active")
                ? this.updateSellingPlanId("")
                : this.updateSellingPlanId(this.getSellingPlanFromUrl())),
              e ||
                (this.disableBuyButtonOnLoadSellingPlan(t, "disable"),
                this.getSellingPlanFromUrl(window.location.search) &&
                  (this.updateSellingPlanId(this.getSellingPlanFromUrl()),
                  this.disableBuyButtonOnLoadSellingPlan(t, "enable")));
          }),
          (e.prototype.disableBuyButtonOnLoadSellingPlan = function (e, t) {
            e &&
              ("enable" === t
                ? e.removeAttribute("disabled")
                : "disable" === t && e.setAttribute("disabled", "true"));
          }),
          (e.prototype.findCurrentVariantSellingPlanPrice = function (e, t) {
            if (e && t)
              return e.find(function (e) {
                return Number(null == e ? void 0 : e.id) === Number(t);
              });
          }),
          (e.prototype.updateSellingPlanId = function (e) {
            this.sellingPlanId = e;
          }),
          (e.prototype.isAnElementExistsOnThePage = function (e) {
            return !!this.wrapper.querySelector(e);
          }),
          (e.prototype.changequantityOnAddButton = function (e, t) {
            var i = this,
              n = new URLSearchParams(window.location.search),
              r = n.get("variant")
                ? n.get("variant")
                : this.product.first_available_variant.id,
              o = function (e, t, n) {
                var r = { line: t, quantity: e };
                fetch("".concat(window.Shopify.routes.root, "cart/change.js"), {
                  method: "POST",
                  body: JSON.stringify(r),
                  headers: { "Content-Type": "application/json" },
                })
                  .then(function (e) {
                    return (
                      window.Store.dispatch(nt()),
                      i.updateBuyButton(n),
                      "popup" === theme.cart.cartDrawer
                        ? window.Store.dispatch(ot())
                        : window.dispatchEvent(
                            new CustomEvent("productAddedOpenDrawer")
                          ),
                      e.json()
                    );
                  })
                  .catch(function (e) {
                    console.error("Error:", e);
                  });
              };
            window.Store.dispatch(nt()).then(function (n) {
              n.payload.items.forEach(function (a, s) {
                var l,
                  c = a.quantity;
                (i.variantQuantity = c),
                  Array.isArray(
                    null === (l = null == n ? void 0 : n.payload) ||
                      void 0 === l
                      ? void 0
                      : l.items
                  ) &&
                    Number(a.id) === Number(r) &&
                    ("increase" === e &&
                      ((i.variantQuantity += 1),
                      o(i.variantQuantity, s + 1, a.id)),
                    "decrease" === e &&
                      ((i.variantQuantity -= 1),
                      o(i.variantQuantity, s + 1, a.id)),
                    "input" === e && o(t, s + 1, a.id));
              });
            });
          }),
          (e.prototype.selectcurrentSlide = function (e) {
            var t,
              i = new URLSearchParams(window.location.search).get("variant");
            if (i && (this.updateBuyButton(i), i)) {
              var n = document.querySelector(
                '.splide__slide[data-variant-id-pdp="'.concat(i, '"]')
              );
              if (n) {
                var r = Array.from(n.parentNode.children).indexOf(n);
                if (this.availableOptions > 6)
                  return (
                    e[r - 1 + this.availableOptions].classList.add(
                      "is-active1"
                    ),
                    null === (t = e[r - 1]) ||
                      void 0 === t ||
                      t.classList.add("is-active1"),
                    void this.splide.go(r - 1)
                  );
                e[r].classList.add("is-active1"), this.splide.go(r);
              }
            }
          }),
          (e.prototype._slideToBlock = function (e, t) {
            if (this.availableOptions <= 6)
              return (
                t.forEach(function (e) {
                  return e.classList.remove("is-active1");
                }),
                void t[e].classList.add("is-active1")
              );
            var i = e - this.availableOptions;
            t.forEach(function (e) {
              return e.classList.remove("is-active1");
            }),
              t[i].classList.add("is-active1"),
              t[e].classList.add("is-active1");
          }),
          (e.prototype.onLoad = function () {
            pt(
              this.id,
              this._initProduct.bind(this, this.wrapper.dataset.handle)
            ),
              pt(this.id, this.initSpliderSwatcher.bind(this));
          }),
          (e.prototype.onUnload = function () {
            this.splide && this.splide.destroy();
          }),
          (e.prototype.onDeselect = function () {
            this.splide.go(0);
          }),
          (e.prototype.onBlockDeselect = function () {
            this.splide.go(0);
          }),
          (e.prototype._initProduct = function (t) {
            t && (window.Product = new e(this.wrapper));
          }),
          (e.prototype.updateBuyButton = function (e) {
            var t = this;
            if (((this.currentVariantId = e), !this.buttonWithProperties)) {
              this.sellingPlanEnabled = this.customSellingPlanForm
                ? this.sellingPlanId
                : !!this.getSellingPlanFromUrl();
              var i = this.wrapper.querySelector("[data-price-show-button]"),
                n = this.wrapper.querySelector("[data-quantity-show-button]"),
                r = this.wrapper.querySelector('[aria-label="Quantity"]');
              window.Store.dispatch(nt()).then(function (o) {
                var a, s;
                if (
                  Array.isArray(
                    null === (a = null == o ? void 0 : o.payload) ||
                      void 0 === a
                      ? void 0
                      : a.items
                  )
                ) {
                  var l = void 0;
                  t.sellingPlanEnabled
                    ? (l = o.payload.items.find(function (i) {
                        var n,
                          r,
                          o =
                            null ===
                              (r =
                                null ===
                                  (n =
                                    null == i
                                      ? void 0
                                      : i.selling_plan_allocation) ||
                                void 0 === n
                                  ? void 0
                                  : n.selling_plan) || void 0 === r
                              ? void 0
                              : r.id;
                        return (
                          Number(i.id) === Number(e) &&
                          Number(o) === Number(t.sellingPlanId) &&
                          i
                        );
                      }))
                    : ((l = o.payload.items.find(function (t) {
                        return Number(t.id) === Number(e);
                      })),
                      t.product.variants.forEach(function (i) {
                        Number(i.id) === Number(e) && (t.currentVariant = i);
                      }),
                      Number(
                        null === (s = t.currentVariant) || void 0 === s
                          ? void 0
                          : s.price
                      ) !== Number(null == l ? void 0 : l.price) && (l = !1)),
                    l
                      ? (i.classList.add("hidden"),
                        n.classList.remove("hidden"),
                        (r.value = l.quantity))
                      : (i.classList.remove("hidden"),
                        n.classList.add("hidden"));
                }
              });
            }
          }),
          (e.prototype.changeThumbnailText = function (e) {
            var t;
            if (e) {
              var i =
                null === (t = null == e ? void 0 : e.variant_metafields) ||
                void 0 === t
                  ? void 0
                  : t.metafield_text;
              if (i) {
                var n =
                    '\n      <div class="\n          mb-8\n          text-center\n          text-[10px]\n          font-extralight\n          lg:text-left\n          lg:text-[15px]\n        ">\n        '.concat(
                      i,
                      "\n      </div>"
                    ),
                  r = this.wrapper.querySelector("[data-thumbnails-text]");
                (r.innerHTML = ""), r.insertAdjacentHTML("afterbegin", n);
              }
            }
          }),
          (e.prototype.findCurrentVariant = function () {
            var e = this;
            this.selectedVariant = this.arrayOfVariants.filter(function (t) {
              return (
                Number(t.id) ===
                Number(e.variantId ? e.variantId : e.currentVariantId)
              );
            });
          }),
          (e.prototype.changeVariantTitle = function () {
            this.wrapper.querySelector("[data-variant-title]").textContent =
              this.selectedVariant[0].title;
          }),
          (e.prototype.updateDynamicButton = function () {
            this.waitForElement(
              ".shopify-payment-button__button--unbranded"
            ).then(function (e) {
              var t = window.theme.dynamic_button_placeholder;
              setTimeout(function () {
                (e.innerHTML = t), (e.style.display = "block");
              }, 0);
            });
          }),
          (e.prototype.updatePickupAvailability = function (e) {
            var t = this;
            if (!e) return !1;
            var i = this.wrapper.querySelector(
              "[data-store-availability-container]"
            );
            if (!i) return !1;
            fetch(
              "".concat(window.Shopify.routes.root, "variants/").concat(e.id)
            )
              .then(function (e) {
                return e.text();
              })
              .then(function (e) {
                var n = t.wrapper.querySelector(".pickup-availability-drawer"),
                  r = new DOMParser().parseFromString(e, "text/html"),
                  o = r.querySelector("[data-store-availability-container]"),
                  a = r.querySelector(".pickup-availability-drawer");
                (i.innerHTML = ""),
                  o &&
                    i.insertAdjacentHTML(
                      "afterbegin",
                      null == o ? void 0 : o.innerHTML
                    ),
                  (n.innerHTML = ""),
                  a &&
                    n.insertAdjacentHTML(
                      "afterbegin",
                      null == a ? void 0 : a.innerHTML
                    ),
                  t.initPickupAvailability();
              })
              .catch(function (e) {
                console.error(e);
              });
          }),
          (e.prototype.initPickupAvailability = function () {
            if (
              ((this.buttonPickupAvailability = this.wrapper.querySelector(
                ".pickup-availability-button"
              )),
              !this.buttonPickupAvailability)
            )
              return !1;
            this._openButton(), this._closeButton();
          }),
          (e.prototype._openButton = function () {
            this.buttonPickupAvailability.addEventListener(
              "click",
              function () {
                document
                  .querySelector("html")
                  .classList.add("pickup-availability-active");
              }
            );
          }),
          (e.prototype._closeButton = function () {
            this.wrapper
              .querySelector(".btn-closer")
              .addEventListener("click", function () {
                document
                  .querySelector("html")
                  .classList.remove("pickup-availability-active");
              });
          }),
          (e.prototype.initModelViewer = function () {
            var e = new CustomEvent("activeModelSlide"),
              t = this.wrapper.querySelector(".product-gallery-slider");
            if (!t) return !1;
            t.querySelectorAll(".product-gallery-slider__item").forEach(
              function (t) {
                (t.querySelector("product-model") ||
                  t.querySelector("deferred-media")) &&
                  t
                    .querySelector(".deferred-media__poster")
                    .addEventListener("click", function () {
                      window.dispatchEvent(e);
                    });
              }
            );
          }),
          (e.prototype.initVariantSelects = function () {
            if (
              ((this.variantSelects =
                this.wrapper.querySelector("#variant-selects")),
              (this.variantRadios =
                this.wrapper.querySelector("#variant-radios")),
              this.variantSelects)
            ) {
              if (
                ((this.productForm = this.wrapper.querySelector(
                  "#product-form-".concat(this.variantSelects.dataset.section)
                )),
                !this.productForm)
              )
                return;
              (this.inputName =
                this.productForm.querySelector('input[name="id"]')),
                (this.inputName.disabled = !1),
                this.variantSelects.addEventListener(
                  "change",
                  this.onVariantChange.bind(this, this.variantSelects, "select")
                );
            }
            if (this.variantRadios) {
              if (
                ((this.productForm = this.wrapper.querySelector(
                  "#product-form-".concat(this.variantRadios.dataset.section)
                )),
                !this.productForm)
              )
                return;
              (this.inputName =
                this.productForm.querySelector('input[name="id"]')),
                (this.inputName.disabled = !1),
                this.variantRadios.addEventListener(
                  "change",
                  this.onVariantChange.bind(this, this.variantRadios, "input")
                );
            }
            this.variantRadios ||
              this.variantSelects ||
              ((this.inputName = this.wrapper.querySelector("#product-id")),
              (this.inputName.disabled = !1));
          }),
          (e.prototype.initSelects = function () {
            this.selects.forEach(function (e) {
              e.addEventListener("change", function (e) {
                e.target
                  .closest("[data-select-holder]")
                  .querySelector("[data-option-value]").innerHTML =
                  e.target.value;
              });
            });
          }),
          (e.prototype.initQuantitySelector = function () {
            var e = this.wrapper.querySelector("#Quantity");
            if (e) {
              e.addEventListener("change", function (t) {
                var i = Math.max(1, t.target.value);
                e.value = i;
              });
              var t = this.wrapper.querySelector(".jcf-btn-dec"),
                i = this.wrapper.querySelector(".jcf-btn-inc");
              t.addEventListener("click", function (t) {
                e.value > 1 && (e.value = +e.value - 1);
              }),
                i.addEventListener("click", function (t) {
                  e.value = +e.value + 1;
                });
            }
          }),
          (e.prototype.changeVariantForSellingPlan = function () {
            this.variantSelects &&
              this.onVariantChange(this.variantSelects, "select"),
              this.variantRadios &&
                this.onVariantChange(this.variantRadios, "input"),
              this.variantRadios ||
                this.variantSelects ||
                this.onVariantChange();
          }),
          (e.prototype.updateSellingPlan = function () {
            var e,
              t = this,
              i =
                null === (e = this.wrapper) || void 0 === e
                  ? void 0
                  : e.querySelector("[data-selling-plan-fieldset]"),
              n = this.wrapper.querySelector("[data-select-container]");
            (this.labelText =
              null == i ? void 0 : i.querySelector("[data-label-text]")),
              (this.radioSellingPlan = this.wrapper.querySelector(
                "[data-selling-plan-input]"
              )),
              (this.radioWithoutSellingPlan = this.wrapper.querySelector(
                "[data-without-selling-plan-input]"
              )),
              this.radioSellingPlan &&
                (this.changeVariantForSellingPlan(),
                this.radioWithoutSellingPlan.checked &&
                  (n.classList.toggle(
                    "hidden",
                    this.radioWithoutSellingPlan.checked
                  ),
                  (this.sellingPlanInput.value = "")),
                this.radioSellingPlan.addEventListener("change", function () {
                  t.radioSellingPlan.checked &&
                    (n.classList.toggle(
                      "hidden",
                      t.radioWithoutSellingPlan.checked
                    ),
                    t.updateSellingPlanId()),
                    t.changeVariantForSellingPlan();
                }),
                this.radioWithoutSellingPlan.addEventListener(
                  "change",
                  function () {
                    t.radioWithoutSellingPlan.checked &&
                      (n.classList.toggle(
                        "hidden",
                        t.radioWithoutSellingPlan.checked
                      ),
                      (t.sellingPlanInput.value = ""),
                      t.changeVariantForSellingPlan());
                  }
                ),
                i.querySelectorAll("select").forEach(function (e) {
                  e.addEventListener("change", function () {
                    t.updateSellingPlanId(), t.changeVariantForSellingPlan();
                  });
                }));
          }),
          (e.prototype.handleErrorMessage = function (e) {
            void 0 === e && (e = !1),
              (this.errorMessageElement = this.wrapper.querySelector(
                ".product-form__error-message"
              )),
              this.errorMessageElement &&
                ((this.errorMessage =
                  this.errorMessage || this.errorMessageElement),
                this.errorMessage.classList.toggle("hidden", !e),
                e && (this.errorMessage.textContent = e));
          }),
          (e.prototype.removeErrorMessage = function () {
            this.wrapper.querySelector(".product-form__error-message") &&
              this.handleErrorMessage();
          }),
          (e.prototype.onVariantChange = function (e, t) {
            this.updateOptions(e, t),
              this.updateMasterId(),
              this.onOptionChange(this.currentVariant),
              this.removeErrorMessage(),
              this.updateVariantInput(this.currentVariant),
              this.updateDynamicButton();
          }),
          (e.prototype.updateOptions = function (e, t) {
            var i = this;
            if (e) {
              if ("input" === t) {
                var n = [];
                (this.optionsValues = Array.from(e.querySelectorAll(t)).reduce(
                  function (e, t) {
                    return (
                      t.checked && (n = Pt(Pt([], At(e), !1), [t.value], !1)), n
                    );
                  },
                  []
                )),
                  Array.from(
                    this.wrapper.querySelectorAll(".product__variant-label-box")
                  )
                    .reduce(function (e, t) {
                      return Pt(
                        Pt([], At(e), !1),
                        [t.querySelector("span:last-child")],
                        !1
                      );
                    }, [])
                    .forEach(function (e, t) {
                      e.innerText = i.optionsValues[t];
                    });
              }
              "select" === t &&
                (this.optionsValues = Array.from(
                  e.querySelectorAll(t),
                  function (e) {
                    return e.value;
                  }
                ));
            }
          }),
          (e.prototype.updateMasterId = function () {
            var e = this;
            this.variantData &&
              (this.currentVariant = this.variantData.find(function (t) {
                return !t.options
                  .map(function (t, i) {
                    return e.optionsValues[i] === t;
                  })
                  .includes(!1);
              }));
          }),
          (e.prototype.updateVariantInput = function (e) {
            if (!e) return !1;
            (this.inputName.value = e.id),
              this.inputName.dispatchEvent(
                new Event("change", { bubbles: !0 })
              );
          }),
          (e.prototype.getUrlWithVariant = function (e, t, i) {
            var n = new URL(e),
              r = new URLSearchParams(n.search);
            return (
              r.set("variant", t),
              this.radioSellingPlan &&
                (r.set("selling_plan", i),
                this.radioWithoutSellingPlan.checked &&
                  r.delete("selling_plan")),
              (n.search = r.toString()),
              n.toString()
            );
          }),
          (e.prototype.updateVariantUrl = function (e) {
            if (e) {
              var t = this.getUrlWithVariant(
                window.location.href,
                e.id,
                this.selectedSellingPlanId
              );
              window.history.replaceState({ path: t }, "", t);
            }
          }),
          (e.prototype.onOptionChange = function (e, t) {
            if ("splider" === t)
              return (
                this.updateImagesMainSlider(e),
                this.updatePickupAvailability(e),
                void this.updateVariantUrl(e)
              );
            this.updatePickupAvailability(e),
              this.updateVariantPrice(e),
              this.updateVariantUnitPrice(e),
              this.updateSubmitButton(e),
              this.updateVariantUrl(e),
              this.updateGallery(e);
          }),
          (e.prototype.getProduct = function () {
            var e;
            try {
              e = JSON.parse(
                this.wrapper.querySelector("#product-json").innerHTML
              );
            } catch (e) {
              console.warn(e);
            }
            return e;
          }),
          (e.prototype.updateSubmitButton = function (e) {
            var t, i, n;
            (this.submitButtonText = this.wrapper.querySelector(
              "#product-price-id-slider"
            )),
              e
                ? e.available
                  ? (this.submitButton.classList.remove("disabled"),
                    this.submitButton.removeAttribute("disabled"),
                    (this.submitButtonText.innerText = theme.strings.addToCart),
                    null === (i = this.shopifyButtons) ||
                      void 0 === i ||
                      i.classList.remove("hidden"))
                  : ((this.submitButtonText.innerText = theme.strings.soldOut),
                    this.submitButton.classList.add("disabled"),
                    this.submitButton.setAttribute("disabled", "disabled"),
                    null === (n = this.shopifyButtons) ||
                      void 0 === n ||
                      n.classList.add("hidden"))
                : (this.submitButton.classList.add("disabled"),
                  this.submitButton.setAttribute("disabled", "disabled"),
                  (this.submitButtonText.innerText = theme.strings.unavailable),
                  null === (t = this.shopifyButtons) ||
                    void 0 === t ||
                    t.classList.add("hidden"));
          }),
          (e.prototype.updateVariantPrice = function (e) {
            for (; this.priceContainer.firstChild; )
              this.priceContainer.removeChild(this.priceContainer.firstChild);
            if (
              ((this.radioSellingPlanCheck =
                !!this.radioSellingPlan && this.radioSellingPlan.checked),
              e)
            ) {
              var t = this.radioSellingPlanCheck
                ? e.selling_plan_allocations[this.selectElement.selectedIndex]
                    .price
                : e.price;
              if (
                (e.compare_at_price > t
                  ? (this.priceContainer.innerHTML =
                      '<ins class="text-base-sale-price no-underline">'
                        .concat(
                          (0, p.l)(t, theme.moneyFormat),
                          "</ins>\n          <del>"
                        )
                        .concat(
                          (0, p.l)(e.compare_at_price, theme.moneyFormat),
                          "</del>"
                        ))
                  : (this.priceContainer.innerHTML = "<div>".concat(
                      (0, p.l)(t, theme.moneyFormat),
                      "</div>"
                    )),
                !this.radioSellingPlan)
              )
                return;
              (this.sellingPlanPrice =
                e.selling_plan_allocations[
                  this.selectElement.selectedIndex
                ].price),
                (this.compareAtPriceSellingPlan =
                  e.selling_plan_allocations[
                    this.selectElement.selectedIndex
                  ].compare_at_price);
              var i =
                  ((this.compareAtPriceSellingPlan - this.sellingPlanPrice) /
                    this.compareAtPriceSellingPlan) *
                  100,
                n = Math.round(10 * i) / 10;
              (this.discountPercentageSellingPlanContainer.innerHTML =
                "".concat(n, "%")),
                (this.priceSellingPlanContainer.innerHTML = (0, p.l)(
                  this.sellingPlanPrice,
                  theme.moneyFormat
                )),
                (this.compareAtPriceSellingPlanContainer.innerHTML = (0, p.l)(
                  this.compareAtPriceSellingPlan,
                  theme.moneyFormat
                ));
            }
          }),
          (e.prototype.updateVariantUnitPrice = function (e) {
            ht(e, this.wrapper);
          }),
          (e.prototype.updateGallery = function (e) {
            var t;
            if (!e) return !1;
            var i = this.wrapper.querySelector(".product-gallery-slider");
            if (!i) return !1;
            var n = i.querySelector(
              '.product-gallery-slider__img[data-position="'.concat(
                null === (t = e.featured_image) || void 0 === t
                  ? void 0
                  : t.position,
                '"]'
              )
            );
            n &&
              window.ResponsiveHelper.addRange({
                "..767": {
                  on: function () {
                    var t = n.getBoundingClientRect().width,
                      r = getComputedStyle(n.parentElement).marginRight.split(
                        "px"
                      )[0],
                      o = e.featured_image.position,
                      a = Array.from(i.children).findIndex(function (e) {
                        return (
                          +e.querySelector(".product-gallery-slider__img")
                            .dataset.position === o
                        );
                      });
                    o && i.scrollTo((+r + t) * a, 0);
                  },
                },
                "768..": {
                  on: function () {
                    if (
                      i.firstElementChild
                        .querySelector(".product-gallery-slider__img")
                        .getAttribute("data-position") ===
                      n.getAttribute("data-position")
                    )
                      return !1;
                    i.prepend(n.parentElement);
                  },
                },
              });
          }),
          (e.prototype.initSubmit = function () {
            var e = this;
            this.variantSelects ||
              this.variantRadios ||
              (this.productForm =
                this.wrapper.querySelector("#product-id").form),
              this.productForm &&
                this.productForm.addEventListener("submit", function (t) {
                  t.preventDefault(), e.initAddToBag(t);
                });
          }),
          (e.prototype.initAddToBag = function (e) {
            var t,
              i,
              n,
              r = this;
            e.preventDefault(),
              (this.buttonWithProperties = this.wrapper.querySelector(
                "[data-buy-button-array-with-variants-ids]"
              ));
            var o,
              a,
              s,
              l,
              c =
                ((s = e.target),
                (l = []),
                Array.prototype.slice.call(s.elements).forEach(function (e) {
                  !e.name ||
                    e.disabled ||
                    ["file", "reset", "submit", "button"].indexOf(e.type) >
                      -1 ||
                    ("select-multiple" !== e.type
                      ? (["checkbox", "radio"].indexOf(e.type) > -1 &&
                          !e.checked) ||
                        l.push({ name: e.name, value: e.value })
                      : Array.prototype.slice
                          .call(e.options)
                          .forEach(function (t) {
                            t.selected &&
                              l.push({ name: e.name, value: t.value });
                          }));
                }),
                l),
              u =
                null ===
                  (t = c.find(function (e) {
                    return "id" === e.name;
                  })) || void 0 === t
                  ? void 0
                  : t.value,
              d =
                (null ===
                  (i = c.find(function (e) {
                    return "selling_plan" === e.name;
                  })) ||
                  void 0 === i ||
                  i.value,
                (null === (n = this.wrapper.querySelector("#Quantity")) ||
                void 0 === n
                  ? void 0
                  : n.value) || 1);
            if (this.buttonWithProperties) {
              var h = this.buttonWithProperties
                .getAttribute("data-buy-button-array-with-variants-ids")
                .split(",");
              (this.buttonWithProperties.mutationObserver =
                new MutationObserver(function () {
                  var e = r.buttonWithProperties
                    .getAttribute("data-buy-button-array-with-variants-ids")
                    .split(",");
                  o = { _bundleId: e };
                })),
                (o = { _bundleId: h });
              var p = window.Product.bundleProducts.productListData
                  .flatMap(function (e) {
                    return e.variants.filter(function (e) {
                      return o._bundleId.includes(String(e.id));
                    });
                  })
                  .reduce(function (e, t) {
                    return e + t.price;
                  }, 0),
                m = this.product.variants[0].id;
              var g = ((p - this.product.price) / p) * 100;
              a = {
                items: o._bundleId.map(function (e, t) {
                  if (
                    !r.bundleProducts.productListData.find(function (t) {
                      return t.variants.some(function (t) {
                        return t.id == e;
                      });
                    })
                  )
                    throw new Error(
                      "Product with variant ".concat(
                        e,
                        " not found within bundle products"
                      )
                    );
                  return {
                    id: e,
                    quantity: 1,
                    properties: {
                      _setId: m,
                      _priceTotal: r.product.price,
                      _timestamp: Date.now(),
                      _discount: g,
                    },
                  };
                }),
              };
            } else
              (o = c.reduce(function (e, t) {
                var i, n;
                if (t.name.includes("properties")) {
                  var r = t.name.split("[")[1].split("]")[0];
                  n = kt(kt({}, e), (((i = {})[r] = t.value), i));
                }
                return n;
              }, {})),
                (a = {
                  items: [
                    {
                      quantity: d,
                      id: u,
                      selling_plan: this.sellingPlanId,
                      properties: o,
                    },
                  ],
                });
            f(a).then(function (e) {
              var t = e.items;
              r.handleErrorMessage(e.description),
                t &&
                  (window.Store.dispatch(at(t[0])),
                  window.Store.dispatch(nt()),
                  r.updateBuyButton(t[0].id),
                  "popup" === theme.cart.cartDrawer
                    ? window.Store.dispatch(ot())
                    : window.dispatchEvent(
                        new CustomEvent("productAddedOpenDrawer")
                      ));
            });
          }),
          (e.prototype.getVariantData = function (e) {
            e &&
              (this.variantData =
                this.variantData ||
                JSON.parse(
                  e.querySelector('[type="application/json"]').textContent
                ));
          }),
          (e.prototype.sizeChartInit = function () {
            if (!this.sizeChart) return !1;
            l.e(961).then(l.t.bind(l, 1950, 23)),
              l
                .e(252)
                .then(l.bind(l, 8252))
                .then(function (e) {
                  e.Fancybox.bind(".size-chart-link", {
                    closeButton: "outside",
                    showClass: "size-chart",
                    dragToClose: !1,
                    on: {
                      reveal: function () {
                        var e = document.querySelector("[data-table] table");
                        null == e ||
                          e.parentElement.classList.add("table-holder");
                      },
                    },
                  });
                });
          }),
          (e.prototype.initProductRecommendations = function () {
            var e = this,
              t = this.wrapper.querySelector(
                "#complementary-products-container"
              );
            if (!t) return !1;
            fetch(t.dataset.url)
              .then(function (e) {
                return e.text();
              })
              .then(function (i) {
                var n = document.createElement("div");
                n.innerHTML = i;
                var r = n.querySelector("#complementary-products-container");
                if (r && r.innerHTML.trim().length) {
                  t.innerHTML = r.innerHTML;
                  var o = t.querySelector(".js-complementary-accordion");
                  e.accordion &&
                    (e.accordion = new (mt())(o, {
                      duration: 400,
                      collapse: !0,
                      showMultiple: !1,
                    })),
                    t &&
                      t
                        .querySelectorAll("[data-complemented-product]")
                        .forEach(function (e) {
                          new bt(e);
                        });
                }
              })
              .catch(function (e) {
                console.error(e);
              });
          }),
          (e.prototype.initFancyboxZoomImage = function () {
            l.e(961).then(l.t.bind(l, 1950, 23)),
              l
                .e(252)
                .then(l.bind(l, 8252))
                .then(function (e) {
                  e.Fancybox.bind('[data-fancybox="zoom-image"]', {
                    type: "image",
                    trapFocus: !1,
                    autoFocus: !1,
                    click: "close",
                    dragToClose: !1,
                    Toolbar: !1,
                    Thumbs: !1,
                    groupAttr: !1,
                  });
                });
          }),
          (e.prototype.initTabs = function () {
            var e,
              t,
              i = document.querySelectorAll(".tabset");
            if (i)
              try {
                for (
                  var n = Tt(Pt([], At(i), !1).entries()), r = n.next();
                  !r.done;
                  r = n.next()
                ) {
                  var o = At(r.value, 2),
                    a = o[0];
                  o[1].setAttribute("data-tabs", a),
                    new (yt())('[data-tabs="'.concat(a, '"]'));
                }
              } catch (t) {
                e = { error: t };
              } finally {
                try {
                  r && !r.done && (t = n.return) && t.call(n);
                } finally {
                  if (e) throw e.error;
                }
              }
          }),
          e
        );
      })();
      a("product", {
        _initProduct: function (e) {
          e && (window.Product = new Ct(this.container));
        },
        onLoad: function () {
          pt(
            this.id,
            this._initProduct.bind(this, this.container.dataset.handle)
          );
        },
        onBlockSelect: function () {
          this._initProduct(this.container.dataset.handle);
        },
      }),
        a("testimonials", {
          _slideToBlock: function (e) {
            this.splide.go(e);
          },
          initTestimonialsSlider: function () {
            var e = this;
            Promise.resolve()
              .then(l.bind(l, 8595))
              .then(function (t) {
                var i = t.Splide,
                  n = Number(e.container.dataset.blockSize),
                  r = n < 3 ? n : 3,
                  o = n >= 3;
                e.splide = new i(
                  e.container.querySelector(".testimonials-slider"),
                  {
                    type: "loop",
                    speed: 800,
                    perPage: r,
                    gap: 60,
                    pagination: o,
                    arrows: !1,
                    keyboard: "focused",
                    breakpoints: {
                      840: { perPage: 2, gap: 20 },
                      567: { perPage: 1, gap: 0 },
                    },
                  }
                ).mount();
              });
          },
          onLoad: function () {
            pt(this.id, this.initTestimonialsSlider.bind(this));
          },
          onUnload: function () {
            this.splide.destroy();
          },
          onDeselect: function () {
            this.splide.go(1);
          },
          onBlockSelect: function (e) {
            this._slideToBlock(+e.target.dataset.index);
          },
          onBlockDeselect: function () {
            this.splide.go(1);
          },
        });
      var xt = function (e, t) {
        var i = "function" == typeof Symbol && e[Symbol.iterator];
        if (!i) return e;
        var n,
          r,
          o = i.call(e),
          a = [];
        try {
          for (; (void 0 === t || t-- > 0) && !(n = o.next()).done; )
            a.push(n.value);
        } catch (e) {
          r = { error: e };
        } finally {
          try {
            n && !n.done && (i = o.return) && i.call(o);
          } finally {
            if (r) throw r.error;
          }
        }
        return a;
      };
      a("testimonials-project", {
        _slideToBlock: function (e) {
          this.splide.go(e);
        },
        initTestimonialsProjectSlider: function () {
          var e = this,
            t = this.container.querySelectorAll(".testimonials-project-slider");
          Promise.resolve()
            .then(l.bind(l, 8595))
            .then(function (i) {
              var n = i.Splide,
                r = Number(e.container.dataset.blockSize) >= 3;
              t.forEach(function (e) {
                new n(e, {
                  type: "loop",
                  speed: 800,
                  perPage: 1,
                  gap: 0,
                  pagination: r,
                  arrows: !1,
                  keyboard: "focused",
                }).mount();
              });
            });
        },
        initTabs: function () {
          var e,
            t,
            i = document.querySelectorAll(".tabset");
          if (i)
            try {
              for (
                var n = (function (e) {
                    var t = "function" == typeof Symbol && Symbol.iterator,
                      i = t && e[t],
                      n = 0;
                    if (i) return i.call(e);
                    if (e && "number" == typeof e.length)
                      return {
                        next: function () {
                          return (
                            e && n >= e.length && (e = void 0),
                            { value: e && e[n++], done: !e }
                          );
                        },
                      };
                    throw new TypeError(
                      t
                        ? "Object is not iterable."
                        : "Symbol.iterator is not defined."
                    );
                  })(
                    (function (e, t, i) {
                      if (i || 2 === arguments.length)
                        for (var n, r = 0, o = t.length; r < o; r++)
                          (!n && (r in t)) ||
                            (n || (n = Array.prototype.slice.call(t, 0, r)),
                            (n[r] = t[r]));
                      return e.concat(n || Array.prototype.slice.call(t));
                    })([], xt(i), !1).entries()
                  ),
                  r = n.next();
                !r.done;
                r = n.next()
              ) {
                var o = xt(r.value, 2),
                  a = o[0];
                o[1].setAttribute("data-tabs", a),
                  new (yt())('[data-tabs="'.concat(a, '"]'));
              }
            } catch (t) {
              e = { error: t };
            } finally {
              try {
                r && !r.done && (t = n.return) && t.call(n);
              } finally {
                if (e) throw e.error;
              }
            }
        },
        onLoad: function () {
          pt(this.id, this.initTestimonialsProjectSlider.bind(this)),
            pt(this.id, this.initTabs.bind(this));
        },
        onUnload: function () {
          this.splide.destroy();
        },
        onDeselect: function () {
          this.splide.go(1);
        },
        onBlockSelect: function (e) {
          this._slideToBlock(+e.target.dataset.index);
        },
        onBlockDeselect: function () {
          this.splide.go(1);
        },
      }),
        a("sets", {
          _slideToBlock: function (e) {
            this.splide.go(e);
          },
          initSetsSlider: function () {
            var e = this;
            Promise.resolve()
              .then(l.bind(l, 8595))
              .then(function (t) {
                var i = t.Splide;
                e.splide = new i(e.container.querySelector(".sets-slider"), {
                  type: "slide",
                  speed: 800,
                  perPage: 2,
                  perMove: 1,
                  gap: 10,
                  pagination: !1,
                  arrows: !0,
                  keyboard: "focused",
                  mediaQuery: "min",
                  breakpoints: {
                    768: { gap: 20, padding: { right: "45px" } },
                    1024: { gap: 30, padding: { right: "90px" } },
                  },
                }).mount();
              });
          },
          removeEventListeners: function () {
            document.removeEventListener("mousemove", this.handleMouseMove),
              document.removeEventListener("scroll", this.handleScroll);
          },
          onLoad: function () {
            pt(this.id, this.initSetsSlider.bind(this));
          },
          onBlockSelect: function (e) {
            this._slideToBlock(+e.target.dataset.index);
          },
          onBlockDeselect: function () {
            this.splide.go(1);
          },
        }),
        a("featured-collections", {
          _slideToBlock: function (e) {
            this.splide.go(e);
          },
          initFeaturedCollectionsSlider: function () {
            var e = this;
            Promise.resolve()
              .then(l.bind(l, 8595))
              .then(function (t) {
                var i = t.Splide;
                e.splide = new i(
                  e.container.querySelector(".featured-collections-slider"),
                  {
                    type: "slide",
                    speed: 800,
                    perPage: 2,
                    perMove: 1,
                    gap: 10,
                    pagination: !1,
                    arrows: !0,
                    keyboard: "focused",
                    mediaQuery: "min",
                    breakpoints: {
                      768: { gap: 20, perPage: 3, padding: { right: "45px" } },
                      1024: { gap: 30, perPage: 4, padding: { right: "90px" } },
                    },
                  }
                ).mount();
              });
          },
          onLoad: function () {
            pt(this.id, this.initFeaturedCollectionsSlider.bind(this));
          },
          onUnload: function () {
            this.splide.destroy();
          },
          onDeselect: function () {
            this.splide.go(1);
          },
          onBlockSelect: function (e) {
            this._slideToBlock(+e.target.dataset.index);
          },
          onBlockDeselect: function () {
            this.splide.go(1);
          },
        });
      var Lt = (function () {
        function e(e, t, i, n) {
          (this.slides = e),
            (this.index = t),
            (this.container = i),
            (this.selectedVariantsId = n),
            this.onVariantChange(this.slides, this.index);
        }
        return (
          (e.prototype.onVariantChange = function (e, t) {
            var i,
              n,
              r,
              o = this,
              a = e[t].dataset,
              s = a.variantId,
              l = a.productId,
              c = this.container.querySelector(
                '[data-product-gallery-object="'.concat(l, '"]')
              );
            e.forEach(function (e) {
              e.classList.remove("is-active1");
            }),
              e[t].classList.add("is-active1");
            var u = this.getProduct(c);
            (this.currenDiscount =
              (100 -
                Number(
                  null ===
                    (r =
                      null ===
                        (n =
                          null === (i = u.selling_plan_groups[0]) ||
                          void 0 === i
                            ? void 0
                            : i.selling_plans[0]) || void 0 === n
                        ? void 0
                        : n.price_adjustments[0]) || void 0 === r
                    ? void 0
                    : r.value
                )) /
              100),
              u.variants.forEach(function (e) {
                if (Number(e.id) === Number(s)) {
                  var t = e.title,
                    i = e.price,
                    n = e.variant_metafields.metafield_text,
                    r =
                      "true" ===
                      o.container.querySelector(
                        '[data-product-card-wrapper="'.concat(u.id, '"]')
                      ).dataset.sellingPlanPrice,
                    a = "".concat(
                      (0, p.l)(r ? i * o.currenDiscount : i, theme.moneyFormat)
                    );
                  o.changeVariantTitle(l, t),
                    o.changeShadeDescription(l, n),
                    o.changePrice(l, a),
                    o.updateImagesMainSlider(e, l),
                    o.changeSeclectedVariantId(l, s);
                }
              });
          }),
          (e.prototype.changeSeclectedVariantId = function (e, t) {
            var i;
            e &&
              t &&
              this.selectedVariantsId[e] &&
              ("object" != typeof this.selectedVariantsId[e]
                ? (this.selectedVariantsId[e] = t)
                : null === (i = this.selectedVariantsId[e]) ||
                  void 0 === i ||
                  (i.variantId = t));
          }),
          (e.prototype.updateImagesMainSlider = function (e, t) {
            var i = this.container
                .querySelector('[data-product-card-wrapper="'.concat(t, '"]'))
                .querySelector("[data-all-product-media]")
                .content.cloneNode(!0)
                .querySelectorAll("a"),
              n = this.findCurrentImagesArr(e, i);
            this.changeImagesInsideMainSlider(n, t);
          }),
          (e.prototype.changeImagesInsideMainSlider = function (e, t) {
            var i = this.container.querySelector(
                '[data-product-splide-list="'.concat(t, '"]')
              ),
              n = [];
            e.forEach(function (e, t) {
              var i =
                '\n        <li class="splide__slide" id="splide02-slide01" role="tabpanel" aria-roledescription="slide" aria-label="1 of 6" style="width: calc(100%);">\n          <a href="/products/cruelty-free-eyeshadow-crayon" class="block">\n            '.concat(
                  e.outerHTML,
                  "\n          </a>\n        </li>"
                );
              n.push(i);
            }),
              n.length > 0 &&
                ((i.innerHTML = ""),
                i.insertAdjacentHTML("afterbegin", n.join(",")));
          }),
          (e.prototype.findCurrentImagesArr = function (e, t) {
            if (e && t) {
              var i = [];
              return (
                t.forEach(function (t, n) {
                  var r = t.getAttribute("data-alt-of-product-media");
                  e.title === r && i.push(t);
                }),
                i
              );
            }
          }),
          (e.prototype.preloadImage = function (e) {
            new Image().src = e;
          }),
          (e.prototype.changePrice = function (e, t) {
            var i = this.container.querySelector(
              '[data-product-button-wrapper-id="'.concat(e, '"]')
            );
            i && (i.querySelector("[data-price]").innerHTML = t.slice(0, -3));
          }),
          (e.prototype.changeVariantTitle = function (e, t) {
            var i = this.container.querySelector(
              '[data-variant-title-id="'.concat(e, '"]')
            );
            i && (i.innerHTML = t);
          }),
          (e.prototype.changeShadeDescription = function (e, t) {
            var i = this.container.querySelector(
              '[data-variant-shade-description-id="'.concat(e, '"]')
            );
            i && (i.innerHTML = t);
          }),
          (e.prototype.getProduct = function (e) {
            var t;
            try {
              t = JSON.parse(e.innerHTML);
            } catch (e) {
              console.warn(e);
            }
            return t;
          }),
          e
        );
      })();
      const It = Lt;
      var Ot = (function () {
        function e(e, t, i, n) {
          (this.isSellingPlanEnabled = t),
            (this.currentSellingPlanId = i),
            (this.selectedVariantsId = n),
            (this.productCard = e),
            this.initProductButtons();
        }
        return (
          (e.prototype.initProductButtons = function () {
            var e = this,
              t = this.productCard.querySelector(
                "[data-current-variant-button-id]"
              ),
              i = this.productCard.querySelectorAll("[data-select-container]");
            i.length > 0 && (this.isSellingPlanEnabled = !0);
            var n = t.getAttribute("data-current-variant-button-id"),
              r = t.getAttribute("data-product-button-wrapper-id"),
              o = t.querySelector("button");
            this.isSellingPlanEnabled
              ? (i.forEach(function (t, i) {
                  var n,
                    a = t.querySelector("input");
                  e.updateSubmitButton(
                    null === (n = e.selectedVariantsId[r]) || void 0 === n
                      ? void 0
                      : n.sellingPlanId,
                    o
                  ),
                    a.addEventListener("change", function () {
                      (e.selectedVariantsId[r].sellingPlanId = a.value),
                        e.updateSubmitButton(
                          e.selectedVariantsId[r].sellingPlanId,
                          o
                        );
                    });
                }),
                (this.selectedVariantsId[r] = {
                  variantId: n,
                  sellingPlanId: null,
                }))
              : (this.selectedVariantsId[r] = n),
              o.closest("form").addEventListener("submit", function () {
                event.preventDefault(), e.initAddToBag(t);
              });
          }),
          (e.prototype.updateSubmitButton = function (e, t) {
            e
              ? (t.classList.remove("disabled"), t.removeAttribute("disabled"))
              : (t.classList.add("disabled"),
                t.setAttribute("disabled", "disabled"));
          }),
          (e.prototype.initAddToBag = function (e) {
            var t = e.getAttribute("data-product-button-wrapper-id");
            f(this.formDataBuilder(t)).then(function (e) {
              var t = e.items;
              t &&
                (window.Store.dispatch(at(t[0])),
                window.Store.dispatch(nt()),
                "popup" === theme.cart.cartDrawer
                  ? window.Store.dispatch(ot())
                  : window.dispatchEvent(
                      new CustomEvent("productAddedOpenDrawer")
                    ));
            });
          }),
          (e.prototype.formDataBuilder = function (e) {
            if (this.selectedVariantsId[e]) {
              var t = { items: [] };
              return "object" == typeof this.selectedVariantsId[e]
                ? (t.items.push({
                    quantity: 1,
                    id: this.selectedVariantsId[e].variantId,
                    selling_plan: this.selectedVariantsId[e].sellingPlanId,
                  }),
                  t)
                : (t.items.push({
                    quantity: 1,
                    id: this.selectedVariantsId[e],
                  }),
                  t);
            }
          }),
          e
        );
      })();
      const qt = Ot;
      a("bestsellers", {
        sliders: [],
        _slideToBlock: function (e) {
          this.splide.go(e);
        },
        initBestsellersSlider: function (dragEnabled = true, startIndex = 0) {
          try {
                if (this.splide) {
                  this.splide.destroy();
                }
            this.splide = new vt.default(
              this.container.querySelector(".bestsellers-slider"),
              {
                type: "slide",
                speed: 800,
                perPage: 2,
                perMove: 2,
                gap: 0,
                pagination: !1,
                arrows: !0,
                keyboard: "focused",
                mediaQuery: "min",
                drag: dragEnabled ? 1 : 0,
                breakpoints: { 1024: { destroy: !0 } },
                start: startIndex,
              }
            ).mount();
          } catch (e) {
            console.error("An error occurred in initBestsellersSlider:", e);
          }
        },
        initBestsellersItemSlider: function () {
          var e = this;
          this.container
            .querySelectorAll(".product-card-gallery")
            .forEach(function (t) {
              e.initOneGallery(t);
              t.addEventListener("mousedown", function () {
                const currentIndex = e.splide.index; // Salva o índice atual
                e.initBestsellersSlider(false, currentIndex); // Reinicia mantendo o índice
            });

            t.addEventListener("touchstart", function () {
                const currentIndex = e.splide.index; // Salva o índice atual
                e.initBestsellersSlider(false, currentIndex); // Reinicia mantendo o índice
            });

            t.addEventListener("mouseleave", function () {
                const currentIndex = e.splide.index; // Salva o índice atual
                e.initBestsellersSlider(true, currentIndex); // Reinicia mantendo o índice
            });

            t.addEventListener("touchend", function () {
                const currentIndex = e.splide.index; // Salva o índice atual
                e.initBestsellersSlider(true, currentIndex); // Reinicia mantendo o índice
            });
            });
        },
        initOneGallery: function (e) {
          var t,
            i =
              null === (t = e.dataset) || void 0 === t
                ? void 0
                : t.productSpliderId,
            n = new vt.default(e, {
              type: "slide",
              speed: 800,
              perPage: 1,
              perMove: 1,
              gap: 0,
              pagination: !0,
              arrows: !1,
              keyboard: "focused",
            }).mount();
          this.sliders.push({ id: i, splide: n }), (e.splide = n);
        },
        initBestSellerProductSwatcher: function () {
          var e = this;
          this.container
            .querySelectorAll(".product-card-thumbnails")
            .forEach(function (t) {
              var i = t.querySelectorAll(".splide__slide"),
                n = i.length,
                r = {
                  type: n < 6 ? "slide" : "loop",
                  speed: 800,
                  perPage: 6,
                  perMove: 1,
                  gap: "6px",
                  pagination: !1,
                  arrows: n >= 6,
                  keyboard: "focused",
                  mediaQuery: "min",
                  breakpoints: { 768: { gap: "8px" } },
                },
                o = new vt.default(t, r);
              o.on("mounted", function () {
                var n = t.querySelectorAll(".splide__slide");
                i.forEach(function (t, i) {
                  if (0 === i) {
                    var n = t.dataset.variantId;
                    e.container
                      .querySelectorAll('[data-variant-id="'.concat(n, '"]'))
                      .forEach(function (e) {
                        e.classList.add("is-active1");
                      });
                  }
                }),
                  n.forEach(function (t, i) {
                    t.addEventListener("click", function () {
                      var r,
                        o =
                          null === (r = t.dataset) || void 0 === r
                            ? void 0
                            : r.productId;
                      e.sliders.find(function (t, i) {
                        if (t.id === o)
                          return t.splide.destroy(), e.sliders.splice(i, 1), !0;
                      }),
                        new It(n, i, e.container, e.selectedVariantsId);
                      var a = e.container.querySelector(
                        '[data-product-splider-id="'.concat(o, '"]')
                      );
                      e.initOneGallery(a);
                      const currentIndex = e.splide.index; // Salva o índice atual
                      e.initBestsellersSlider(true, currentIndex); // Reinicia mantendo o índice
                    });
                  });
                t.addEventListener("mousedown", function () {
                    const currentIndex = e.splide.index; // Salva o índice atual
                    e.initBestsellersSlider(false, currentIndex); // Reinicia mantendo o índice
                });
    
                t.addEventListener("touchstart", function () {
                    const currentIndex = e.splide.index; // Salva o índice atual
                    e.initBestsellersSlider(false, currentIndex); // Reinicia mantendo o índice
                });
    
                t.addEventListener("mouseleave", function () {
                    const currentIndex = e.splide.index; // Salva o índice atual
                    e.initBestsellersSlider(true, currentIndex); // Reinicia mantendo o índice
                });
    
                t.addEventListener("touchend", function () {
                    const currentIndex = e.splide.index; // Salva o índice atual
                    e.initBestsellersSlider(true, currentIndex); // Reinicia mantendo o índice
                });

              }),
                o.mount();
            });
        },
        onLoad: function () {
          pt(this.id, this.initBestsellersSlider.bind(this)),
            pt(this.id, this.initBestsellersItemSlider.bind(this)),
            pt(this.id, this.initBestSellerProductSwatcher.bind(this)),
            this.initProductCard();
        },
        initProductCard: function () {
          var e = this,
            t = this.container.querySelectorAll("[data-product-card-wrapper]");
          (this.currentSellingPlanId = null),
            (this.selectedVariantsId = {}),
            t.forEach(function (t) {
              new qt(t, !1, e.currentSellingPlanId, e.selectedVariantsId);
            });
        },
        onUnload: function () {
          this.splide.destroy();
        },
        onDeselect: function () {
          this.splide.go(1);
        },
        onBlockSelect: function (e) {
          this._slideToBlock(+e.target.dataset.index);
        },
        onBlockDeselect: function () {
          this.splide.go(1);
        },
      });
      a("video", {
        init: function () {
          var e = this;
          this.eventHandlers = new WeakMap();
          var t = document.querySelectorAll("video");
          if (t.length) {
            var i = Array.from(t).filter(function (e) {
              return !e.classList.contains("js-player");
            });
            i.length &&
              i.forEach(function (t, i) {
                var n;
                t &&
                  ((n = t.getBoundingClientRect()).top >= 0 &&
                  n.left >= 0 &&
                  n.bottom <=
                    (window.innerHeight ||
                      document.documentElement.clientHeight) &&
                  n.right <=
                    (window.innerWidth || document.documentElement.clientWidth)
                    ? e.setupEventHandlers(t)
                    : new IntersectionObserver(
                        function (i, n) {
                          i.forEach(function (i) {
                            i.isIntersecting &&
                              (e.setupEventHandlers(t), n.unobserve(t));
                          });
                        },
                        { threshold: 0.1 }
                      ).observe(t));
              });
          }
        },
        setupEventHandlers: function (e) {
          var t = this,
            i = function () {
              return t.loadVideo(e);
            },
            n = function () {
              return t.loadVideo(e);
            };
          this.eventHandlers.set(e, { handleMouseMove: i, handleScroll: n }),
            document.addEventListener("mousemove", i),
            document.addEventListener("scroll", n);
        },
        initBackgroundVideo: function () {
          dt(this.container, function () {
            l.e(220).then(l.t.bind(l, 9528, 23)),
              l
                .e(443)
                .then(l.t.bind(l, 1443, 23))
                .then(function (e) {
                  var t = e.default;
                  Array.from(document.querySelectorAll(".js-player")).map(
                    function (e) {
                      var i = e.closest(".splide__slide"),
                        n = new t(e, {
                          autoplay: !1,
                          loop: { active: !0 },
                          autopause: !0,
                          muted: !0,
                          controls: ["play-large"],
                        });
                      if (!i)
                        return (
                          new IntersectionObserver(
                            function (t, i) {
                              t.forEach(function (t) {
                                t.isIntersecting
                                  ? (n.play(), (n.volume = 0), i.unobserve(e))
                                  : n.pause();
                              });
                            },
                            { threshold: 0.1 }
                          ).observe(e),
                          n
                        );
                      function r() {
                        var e;
                        i.classList.contains("is-active")
                          ? (e = i.getBoundingClientRect()).top >= 0 &&
                            e.left >= 0 &&
                            e.bottom <=
                              (window.innerHeight ||
                                document.documentElement.clientHeight) &&
                            e.right <=
                              (window.innerWidth ||
                                document.documentElement.clientWidth) &&
                            n.play()
                          : n.pause();
                      }
                      var o = new MutationObserver(function (e) {
                        var t, i;
                        try {
                          for (
                            var n = (function (e) {
                                var t =
                                    "function" == typeof Symbol &&
                                    Symbol.iterator,
                                  i = t && e[t],
                                  n = 0;
                                if (i) return i.call(e);
                                if (e && "number" == typeof e.length)
                                  return {
                                    next: function () {
                                      return (
                                        e && n >= e.length && (e = void 0),
                                        { value: e && e[n++], done: !e }
                                      );
                                    },
                                  };
                                throw new TypeError(
                                  t
                                    ? "Object is not iterable."
                                    : "Symbol.iterator is not defined."
                                );
                              })(e),
                              o = n.next();
                            !o.done;
                            o = n.next()
                          )
                            "class" === o.value.attributeName && r();
                        } catch (e) {
                          t = { error: e };
                        } finally {
                          try {
                            o && !o.done && (i = n.return) && i.call(n);
                          } finally {
                            if (t) throw t.error;
                          }
                        }
                      });
                      return (
                        o.observe(i, {
                          attributes: !0,
                          attributeFilter: ["class"],
                        }),
                        r(),
                        n
                      );
                    }
                  );
                });
          });
        },
        removeEventListeners: function (e) {
          var t = this.eventHandlers.get(e);
          t &&
            (document.removeEventListener("mousemove", t.handleMouseMove),
            document.removeEventListener("scroll", t.handleScroll),
            this.eventHandlers.delete(e));
        },
        loadVideo: function (e) {
          e.setAttribute("autoplay", ""),
            (e.muted = !0),
            e.play().catch(function (e) {
              console.log("Autoplay failed:", e);
            }),
            this.removeEventListeners(e);
        },
        onLoad: function () {
          pt(this.id, this.initBackgroundVideo.bind(this)), this.init();
        },
      }),
        a("slideshow", {
          _slideToBlock: function (e) {
            this.splide.go(e);
          },
          initSlider: function () {
            var e = this,
              t = 1e3 * this.container.dataset.slidesEvery,
              i = "true" === this.container.dataset.autorotate,
              n = +this.container.dataset.blocks > 1,
              r = !!i && { delay: t };
            Promise.resolve()
              .then(l.bind(l, 8595))
              .then(function (i) {
                var o = i.Splide;
                e.splide = new o(
                  e.container.querySelector(".slideshow-gallery"),
                  {
                    type: "fade",
                    speed: 3500,
                    rewind: n,
                    autoplay: r,
                    interval: t,
                    perPage: 1,
                    gap: 0,
                    pagination: !0,
                    arrows: !0,
                    keyboard: "focused",
                  }
                ).mount();
              });
          },
          onLoad: function () {
            pt(this.id, this.initSlider.bind(this));
          },
          onUnload: function () {
            this.splide.destroy();
          },
          onDeselect: function () {
            this.splide.go(1);
          },
          onBlockSelect: function (e) {
            this._slideToBlock(+e.target.dataset.index);
          },
          onBlockDeselect: function () {
            this.splide.go(1);
          },
        }),
        a("iframe-video", {
          initIframeVideo: function () {
            var e = this;
            dt(this.container, function () {
              var t = {
                autoplay: !0,
                muted: !0,
                loop: { active: !0 },
                fullscreen: { enabled: !1, fallback: !1, iosNative: !1 },
                controls: !1,
                hideControls: !0,
                disableContextMenu: !1,
                ratio: e.container
                  .querySelector(".media-block #player-".concat(e.id))
                  .getAttribute("data-ratio"),
                youtube: {
                  playsinline: 1,
                  fs: 0,
                  iv_load_policy: 3,
                  rel: 0,
                  autohide: 1,
                  showinfo: 0,
                  enablejsapi: 1,
                  muted: 1,
                  autoplay: 1,
                },
                vimeo: {
                  autoplay: !0,
                  muted: !0,
                  playsinline: !0,
                  controls: !1,
                  loop: !0,
                  byline: !0,
                },
              };
              l.e(443)
                .then(l.t.bind(l, 1443, 23))
                .then(function (i) {
                  var n,
                    r,
                    o = i.default;
                  (e.iframeVideo = new o(
                    e.container.querySelector(
                      ".media-block #player-".concat(e.id)
                    ),
                    t
                  )),
                    (window.plyrPlayer = e.iframeVideo),
                    document.addEventListener("ready", function () {
                      e.iframeVideo.play();
                    }),
                    (n = e.container.querySelector(".media-block")),
                    (r = function () {
                      return e.iframeVideo.pause();
                    }),
                    new IntersectionObserver(
                      function (e) {
                        e.forEach(function (e) {
                          !1 === e.isIntersecting && r();
                        });
                      },
                      { threshold: 0.1 }
                    ).observe(n);
                });
            });
          },
          onLoad: function () {
            pt(this.id, this.initIframeVideo.bind(this));
          },
        });
      var Mt = (function () {
          var e = function (t, i) {
            return (
              (e =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                  function (e, t) {
                    e.__proto__ = t;
                  }) ||
                function (e, t) {
                  for (var i in t)
                    Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                }),
              e(t, i)
            );
          };
          return function (t, i) {
            if ("function" != typeof i && null !== i)
              throw new TypeError(
                "Class extends value " +
                  String(i) +
                  " is not a constructor or null"
              );
            function n() {
              this.constructor = t;
            }
            e(t, i),
              (t.prototype =
                null === i
                  ? Object.create(i)
                  : ((n.prototype = i.prototype), new n()));
          };
        })(),
        Nt = (function (e) {
          function t(t) {
            return e.call(this, t) || this;
          }
          return (
            Mt(t, e),
            (t.prototype.changeVariantImage = function (e) {
              var t,
                i = this.wrapper.querySelector("[data-featured-image]");
              (null === (t = e.featured_image) || void 0 === t
                ? void 0
                : t.src) &&
                ((i.innerHTML = ""),
                i.insertAdjacentHTML(
                  "afterbegin",
                  ut(
                    e.featured_image.src,
                    ["288x288", "573x573"],
                    e.featured_image.alt,
                    !0
                  )
                ));
            }),
            (t.prototype.onOptionChange = function (e) {
              this.updatePickupAvailability(e),
                this.updateVariantPrice(e),
                this.updateVariantUnitPrice(e),
                this.updateSubmitButton(e),
                this.changeVariantImage(e);
            }),
            t
          );
        })(Ct);
      const jt = Nt;
      var Vt = (function () {
        function e(e) {
          this.initChooseOptions(e),
            (this.cards = e.querySelectorAll("[data-js-product-card]")),
            this.cards.forEach(function (e) {
              var t;
              if (!e.querySelector("[data-submit-button]")) return !1;
              var i = e.querySelector("[data-submit-button]"),
                n = {
                  items: [
                    {
                      quantity: 1,
                      id:
                        null ===
                          (t = e.querySelector("[data-current-variant-id]")) ||
                        void 0 === t
                          ? void 0
                          : t.getAttribute("data-current-variant-id"),
                    },
                  ],
                };
              i.addEventListener("click", function (e) {
                e.preventDefault(),
                  f(n).then(function (e) {
                    var t = e.items;
                    window.Store.dispatch(at(t[0])),
                      window.Store.dispatch(nt()),
                      "popup" === theme.cart.cartDrawer
                        ? window.Store.dispatch(ot())
                        : window.dispatchEvent(
                            new CustomEvent("productAddedOpenDrawer")
                          );
                  });
              });
            });
        }
        return (
          (e.prototype.removeModalHtml = function (e) {
            e.querySelector(".js-quick-card") &&
              e.querySelector(".js-quick-card").remove();
          }),
          (e.prototype.renderHtmlInModal = function (e, t) {
            this.removeModalHtml(e), e.insertAdjacentElement("afterbegin", t);
          }),
          (e.prototype.initProductCard = function (e) {
            new jt(e);
          }),
          (e.prototype.initFancybox = function () {
            var e = this;
            l.e(961).then(l.t.bind(l, 1950, 23)),
              l
                .e(252)
                .then(l.bind(l, 8252))
                .then(function (t) {
                  t.Fancybox.bind('[data-fancybox="quick-view"]', {
                    on: {
                      done: function (t, i) {
                        var n, r, o, a;
                        e.initProductCard(i.contentEl),
                          e.closeFancybox(
                            document.querySelector("dialog#cart-drawer"),
                            t
                          ),
                          (null ===
                            (r =
                              null === (n = window.Shopify) || void 0 === n
                                ? void 0
                                : n.PaymentButton) || void 0 === r
                            ? void 0
                            : r.init) &&
                            (null ===
                              (a = (o = window.Shopify.PaymentButton).init) ||
                              void 0 === a ||
                              a.call(o));
                      },
                    },
                    mainClass: "fancybox-quick-view",
                    type: "ajax",
                    trapFocus: !1,
                    autoFocus: !1,
                    click: "close",
                    dragToClose: !1,
                    Toolbar: !1,
                    Thumbs: !1,
                    groupAttr: !1,
                  });
                });
          }),
          (e.prototype.closeFancybox = function (e, t) {
            new MutationObserver(function (i) {
              i.forEach(function (i) {
                "attributes" === i.type &&
                  "open" === i.attributeName &&
                  e.hasAttribute("open") &&
                  t.close();
              });
            }).observe(e, { attributes: !0 });
          }),
          (e.prototype.initChooseOptions = function (e) {
            var t = e.querySelectorAll("[data-js-product-card]");
            if (
              ((this.modal = document.querySelector("#quick-view-popup")), !t)
            )
              return !1;
            this.initFancybox();
          }),
          e
        );
      })();
      const Dt = Vt;
      var Bt = function (e, t, i, n) {
          return new (i || (i = Promise))(function (r, o) {
            function a(e) {
              try {
                l(n.next(e));
              } catch (e) {
                o(e);
              }
            }
            function s(e) {
              try {
                l(n.throw(e));
              } catch (e) {
                o(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? r(e.value)
                : ((t = e.value),
                  t instanceof i
                    ? t
                    : new i(function (e) {
                        e(t);
                      })).then(a, s);
            }
            l((n = n.apply(e, t || [])).next());
          });
        },
        Ft = function (e, t) {
          var i,
            n,
            r,
            o,
            a = {
              label: 0,
              sent: function () {
                if (1 & r[0]) throw r[1];
                return r[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (o = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (o[Symbol.iterator] = function () {
                return this;
              }),
            o
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (i) throw new TypeError("Generator is already executing.");
                for (; o && ((o = 0), s[0] && (a = 0)), a; )
                  try {
                    if (
                      ((i = 1),
                      n &&
                        (r =
                          2 & s[0]
                            ? n.return
                            : s[0]
                            ? n.throw || ((r = n.return) && r.call(n), 0)
                            : n.next) &&
                        !(r = r.call(n, s[1])).done)
                    )
                      return r;
                    switch (((n = 0), r && (s = [2 & s[0], r.value]), s[0])) {
                      case 0:
                      case 1:
                        r = s;
                        break;
                      case 4:
                        return a.label++, { value: s[1], done: !1 };
                      case 5:
                        a.label++, (n = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = a.ops.pop()), a.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (r = (r = a.trys).length > 0 && r[r.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          a = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!r || (s[1] > r[0] && s[1] < r[3]))
                        ) {
                          a.label = s[1];
                          break;
                        }
                        if (6 === s[0] && a.label < r[1]) {
                          (a.label = r[1]), (r = s);
                          break;
                        }
                        if (r && a.label < r[2]) {
                          (a.label = r[2]), a.ops.push(s);
                          break;
                        }
                        r[2] && a.ops.pop(), a.trys.pop();
                        continue;
                    }
                    s = t.call(e, a);
                  } catch (e) {
                    (s = [6, e]), (n = 0);
                  } finally {
                    i = r = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        };
      !(function () {
        function e(e) {
          this.container = e;
        }
        (e.prototype.observeCollectionWrapper = function () {
          (this.observer = new IntersectionObserver(
            this._handleIntersection.bind(this),
            { threshold: 1 }
          )),
            this.observer.observe(this.spinnerHolder);
        }),
          (e.prototype._showSpinner = function () {
            this.spinner.classList.remove("hidden");
          }),
          (e.prototype._hideSpinner = function () {
            this.spinner.classList.add("hidden");
          }),
          (e.prototype._showSpinnerContainer = function () {
            this.spinnerHolder.classList.remove("hidden");
          }),
          (e.prototype._hideSpinnerContainer = function () {
            this.spinnerHolder.classList.add("hidden");
          }),
          (e.prototype._handleIntersection = function (e) {
            var t = this;
            e.map(function (e) {
              return Bt(t, void 0, void 0, function () {
                return Ft(this, function (t) {
                  switch (t.label) {
                    case 0:
                      return (
                        this.container.dataset.totalProductsQuantity,
                        e.isIntersecting
                          ? this.fetchInProgress
                            ? [2]
                            : [4, this.renderProducts()]
                          : [3, 2]
                      );
                    case 1:
                      t.sent(), new Dt(this.container), (t.label = 2);
                    case 2:
                      return [2];
                  }
                });
              });
            });
          }),
          (e.prototype.componentsForLoadingType = function () {
            var e = new URLSearchParams(window.location.search);
            (this.productLength = this.container.querySelector(
              ".js-products-wrapper"
            ).children.length),
              (this.page = e.has("page") ? +e.get("page") + 1 : 2),
              (this.fetchInProgress = !1),
              (this.loadedProductsQuantity = e.has("page")
                ? Number(e.get("page")) * this.productLength
                : this.productLength),
              (this.spinnerHolder =
                this.container.querySelector(".spinner-holder")),
              (this.spinner = this.spinnerHolder.querySelector(".spinner")),
              (this.productsWrapper = this.container.querySelector(
                ".js-products-wrapper"
              )),
              this.observeCollectionWrapper();
          }),
          (e.prototype.initInfiniteScroll = function () {
            var e = this;
            "true" === this.container.dataset.infinite &&
              (document.addEventListener("filterChange", function () {
                e.componentsForLoadingType(), e._showSpinnerContainer();
              }),
              this.componentsForLoadingType());
          }),
          (e.prototype.renderProducts = function () {
            return Bt(this, void 0, void 0, function () {
              var e,
                t,
                i,
                n,
                r = this;
              return Ft(this, function (o) {
                switch (o.label) {
                  case 0:
                    if (
                      ((this.fetchInProgress = !0),
                      (e = +this.container.dataset.totalProductsQuantity),
                      (t = +this.container.dataset.productsLimit),
                      !(
                        (this.productLength < t
                          ? e
                          : this.loadedProductsQuantity) < e
                      ))
                    )
                      return [3, 5];
                    this._showSpinner(), (o.label = 1);
                  case 1:
                    return o.trys.push([1, 3, , 4]), [4, this.fetchNextPage()];
                  case 2:
                    return (
                      (i = o.sent()),
                      (this.loadedProductsQuantity += i.length),
                      i.forEach(function (e) {
                        r.productsWrapper.appendChild(e);
                      }),
                      (this.page += 1),
                      this._hideSpinner(),
                      (this.fetchInProgress = !1),
                      this.initCollectionCardVariantSelectors(i),
                      [3, 4]
                    );
                  case 3:
                    return (n = o.sent()), console.error("Error", n), [3, 4];
                  case 4:
                    return [3, 6];
                  case 5:
                    this._hideSpinner(),
                      this._hideSpinnerContainer(),
                      this.observer.disconnect(),
                      (o.label = 6);
                  case 6:
                    return [2];
                }
              });
            });
          }),
          (e.prototype.fetchNextPage = function () {
            return Bt(this, void 0, void 0, function () {
              var e, t, i, n, r, o;
              return Ft(this, function (a) {
                switch (a.label) {
                  case 0:
                    return (
                      (e = new URLSearchParams(window.location.search)).delete(
                        "page"
                      ),
                      (t = Array.from(e.entries()).length),
                      (i = t > 0 ? "&".concat(e.toString()) : ""),
                      "collection" !== this.container.dataset.sectionType
                        ? [3, 2]
                        : [
                            4,
                            fetch(
                              "/collections/"
                                .concat(
                                  this.container.dataset.collectionHandle,
                                  "?page="
                                )
                                .concat(this.page)
                                .concat(i)
                            ),
                          ]
                    );
                  case 1:
                    return (n = a.sent()), [3, 4];
                  case 2:
                    return [
                      4,
                      fetch(
                        ""
                          .concat(window.location.pathname, "?page=")
                          .concat(this.page)
                          .concat(i)
                      ),
                    ];
                  case 3:
                    (n = a.sent()), (a.label = 4);
                  case 4:
                    return [4, n.text()];
                  case 5:
                    return (
                      (r = a.sent()),
                      (o = new DOMParser()
                        .parseFromString(r, "text/html")
                        .querySelectorAll("[data-product-container-js]")),
                      window.history.pushState({ path: n.url }, "", n.url),
                      [
                        2,
                        Array.from(o).map(function (e) {
                          return e.parentNode;
                        }),
                      ]
                    );
                }
              });
            });
          }),
          (e.prototype.initUpdateQuickViewEvent = function (e) {
            new Dt(e),
              document.addEventListener("updateQuickView", function () {
                new Dt(e);
              });
          }),
          (e.prototype.addEventListenersToColorSelectors = function (e) {
            var t = this,
              i = e.querySelectorAll('[name="filter-color"]');
            i &&
              i.forEach(function (e) {
                return e.addEventListener("change", function (e) {
                  return t.onVariantChange(e);
                });
              });
          }),
          (e.prototype.onVariantChange = function (e) {
            var t = e.target.closest("[data-js-product-card]"),
              i = JSON.parse(t.querySelector("script").innerText),
              n = e.target.dataset.variantId,
              r = i.find(function (e) {
                return e.id === parseInt(n, 10);
              }),
              o = null == t ? void 0 : t.querySelector("[data-quick-choose]");
            r.featured_image && this.changeCardImage(t, r),
              o && this.changeCardQuickViewLink(o, n),
              this.changeCardPrice(t, r),
              this.changeCardUnitPrice(r, t);
          }),
          (e.prototype.changeCardPrice = function (e, t) {
            var i = e.querySelector(".product-item__price");
            t &&
              (t.compare_at_price > t.price
                ? (i.innerHTML =
                    "\n          <ins class='text-base-sale-price no-underline'>"
                      .concat(
                        (0, p.l)(t.price, theme.moneyFormat),
                        "</ins>\n          <del>"
                      )
                      .concat(
                        (0, p.l)(t.compare_at_price, theme.moneyFormat),
                        "</del>\n        "
                      ))
                : (i.innerHTML = "<div>".concat(
                    (0, p.l)(t.price, theme.moneyFormat),
                    "</div>"
                  )));
          }),
          (e.prototype.changeCardUnitPrice = function (e, t) {
            ht(e, t);
          }),
          (e.prototype.changeCardQuickViewLink = function (e, t) {
            var i = e.getAttribute("data-product-url"),
              n = i.includes("?variant=")
                ? i.replace(
                    /(\?variant=)\d+/g,
                    "?variant=".concat(t, "&view=quick-card")
                  )
                : "".concat(i, "?variant=").concat(t, "&view=quick-card");
            e.setAttribute("data-product-url", n),
              e.setAttribute("data-src", n);
          }),
          (e.prototype.changeCardImage = function (e, t) {
            var i = new DOMParser().parseFromString(
              ut(
                t.featured_image.src,
                ["156x156", "323x323"],
                t.featured_image.alt,
                !0
              ),
              "text/html"
            );
            e.querySelector("picture").replaceWith(i.querySelector("picture"));
          }),
          (e.prototype.initCollectionCardVariantSelectors = function (e) {
            var t = this;
            e.forEach(function (e) {
              return t.addEventListenersToColorSelectors(e);
            });
          }),
          (e.prototype.initCollection = function () {
            var e = this;
            this.initInfiniteScroll(),
              this.initUpdateQuickViewEvent(this.container),
              "true" === this.container.dataset.colorSwatches &&
                (this.initCollectionCardVariantSelectors(
                  this.container.querySelectorAll(
                    ".js-products-wrapper [data-js-product-card]"
                  )
                ),
                document.addEventListener(
                  "collectionPageRerender",
                  function () {
                    return e.initCollectionCardVariantSelectors(
                      e.container.querySelectorAll(
                        ".js-products-wrapper [data-js-product-card]"
                      )
                    );
                  }
                ));
          }),
          (e.prototype.onLoad = function (e) {
            pt(this.id, this.initCollection.bind(this));
          });
      })(),
        a("footer", {
          onLoad: function () {
            var e = this.container.querySelector(
              '[onclick="GorgiasChat.open();"]'
            );
            e &&
              e.addEventListener("click", function () {
                event.preventDefault();
              });
          },
        });
      var Rt = l(1443),
        Ht = l.n(Rt);
      a("instagram-feed", {
        _slideToBlock: function (e) {
          this.splide.go(e);
        },
        initInstagramFeedSlider: function () {
          var e = this;
          Promise.resolve()
            .then(l.bind(l, 8595))
            .then(function (t) {
              var i = t.Splide;
              e.splide = new i(
                e.container.querySelector(".instagram-feed-slider"),
                {
                  type: "slide",
                  speed: 800,
                  perPage: 3,
                  perMove: 1,
                  gap: 5,
                  pagination: !1,
                  arrows: !1,
                  keyboard: "focused",
                  mediaQuery: "min",
                  breakpoints: {
                    768: { gap: 8, perPage: 3 },
                    1024: { perPage: 4 },
                    1200: { perPage: 5 },
                  },
                }
              ).mount();
            });
        },
        initBackgroundVideo: function () {
          Array.from(document.querySelectorAll(".js-player")).map(function (e) {
            var t = new (Ht())(e, { autoplay: !1, controls: !1 });
            return (
              e.addEventListener("mouseenter", function () {
                t.play(), (t.volume = 0.7);
              }),
              e.addEventListener("mouseleave", function () {
                t.pause(), (t.volume = 0);
              }),
              t
            );
          });
        },
        onLoad: function () {
          pt(this.id, this.initInstagramFeedSlider.bind(this)),
            pt(this.id, this.initBackgroundVideo.bind(this)),
            this.observeInstagramFeedSection();
        },
        onUnload: function () {
          this.splide.destroy();
        },
        onDeselect: function () {
          this.splide.go(1);
        },
        onBlockSelect: function (e) {
          this._slideToBlock(+e.target.dataset.index);
        },
        onBlockDeselect: function () {
          this.splide.go(1);
        },
        observeInstagramFeedSection: function () {
          var e = document.querySelector(
            '[data-section-type="instagram-feed"]'
          );
          if (e) {
            var t = new IntersectionObserver(
              function (i) {
                i.forEach(function (i) {
                  i.isIntersecting &&
                    (e.querySelectorAll(".js-player").forEach(function (e) {
                      var t = e.play();
                      void 0 !== t &&
                        t
                          .then(function (t) {
                            e.pause();
                          })
                          .catch(function (e) {
                            console.log("error ====>>>>>", e);
                          });
                    }),
                    t.unobserve(i.target));
                });
              },
              { root: null, rootMargin: "0px", threshold: 0.1 }
            );
            t.observe(e);
          }
        },
      }),
        a("products-gallery", {
          sliders: [],
          _slideToBlock: function (e) {
            this.splide.go(e);
          },
          initProductsGallery: function () {
            try {
              this.splide = new vt.default(
                this.container.querySelector(".product-gallery"),
                {
                  type: "slide",
                  speed: 800,
                  perPage: 2,
                  perMove: 1,
                  gap: 0,
                  pagination: !1,
                  arrows: !0,
                  keyboard: "focused",
                  drag: !1,
                  mediaQuery: "min",
                  breakpoints: {
                    768: { perPage: 3, gap: 20 },
                    1024: { perPage: 4, gap: 30 },
                  },
                }
              ).mount();
            } catch (e) {
              console.error("An error occurred in initProductsGallery:", e);
            }
          },
          initProductCardGallery: function () {
            var e = this;
            this.container
              .querySelectorAll(".product-card-gallery")
              .forEach(function (t) {
                e.initOneGallery(t);
              });
          },
          initOneGallery: function (e) {
            var t,
              i =
                null === (t = e.dataset) || void 0 === t
                  ? void 0
                  : t.productSpliderId,
              n = new vt.default(e, {
                type: "slide",
                speed: 800,
                perPage: 1,
                perMove: 1,
                gap: 0,
                pagination: !0,
                arrows: !1,
                keyboard: "focused",
              }).mount();
            this.sliders.push({ id: i, splide: n }), (e.splide = n);
          },
          initProductCardSwatcher: function () {
            var e = this;
            this.container
              .querySelectorAll(".product-card-thumbnails")
              .forEach(function (t) {
                var i = t.querySelectorAll(".splide__slide"),
                  n = i.length,
                  r = {
                    type: n < 6 ? "slide" : "loop",
                    speed: 800,
                    perPage: 6,
                    perMove: 1,
                    gap: "6px",
                    pagination: !1,
                    arrows: n >= 6,
                    keyboard: "focused",
                    mediaQuery: "min",
                    breakpoints: { 768: { gap: "8px" } },
                  },
                  o = new vt.default(t, r);
                o.on("mounted", function () {
                  var n = t.querySelectorAll(".splide__slide");
                  i.forEach(function (t, i) {
                    if (0 === i) {
                      var n = t.dataset.variantId;
                      e.container
                        .querySelectorAll('[data-variant-id="'.concat(n, '"]'))
                        .forEach(function (e) {
                          e.classList.add("is-active1");
                        });
                    }
                  }),
                    n.forEach(function (t, i) {
                      t.addEventListener("click", function () {
                        var r,
                          o =
                            null === (r = t.dataset) || void 0 === r
                              ? void 0
                              : r.productId;
                        e.sliders.find(function (t, i) {
                          if (t.id === o)
                            return (
                              t.splide.destroy(), e.sliders.splice(i, 1), !0
                            );
                        }),
                          new It(n, i, e.container, e.selectedVariantsId);
                        var a = e.container.querySelector(
                          '[data-product-splider-id="'.concat(o, '"]')
                        );
                        e.initOneGallery(a);
                      });
                    });
                }),
                  o.mount();
              });
          },
          initTestimonialsSlider: function () {
            this.container
              .querySelectorAll(".products-testimonials-slider")
              .forEach(function (e) {
                new vt.default(e, {
                  type: "loop",
                  speed: 800,
                  perPage: 1,
                  gap: 0,
                  pagination: !0,
                  arrows: !1,
                  keyboard: "focused",
                }).mount();
              });
          },
          onLoad: function () {
            this.initProductCard(),
              pt(this.id, this.initProductsGallery.bind(this)),
              pt(this.id, this.initProductCardGallery.bind(this)),
              pt(this.id, this.initProductCardSwatcher.bind(this)),
              pt(this.id, this.initTestimonialsSlider.bind(this));
          },
          initProductCard: function () {
            var e = this,
              t = this.container.querySelectorAll(
                "[data-product-card-wrapper]"
              );
            (this.currentSellingPlanId = null),
              (this.selectedVariantsId = {}),
              t.forEach(function (t) {
                new qt(t, !1, e.currentSellingPlanId, e.selectedVariantsId);
              });
          },
          onUnload: function () {
            this.splide.destroy();
          },
          onDeselect: function () {
            this.splide.go(1);
          },
          onBlockSelect: function (e) {
            this._slideToBlock(+e.target.dataset.index);
          },
          onBlockDeselect: function () {
            this.splide.go(1);
          },
        });
        a("dgf-products-slider", {
          sliders: [],
          _slideToBlock: function (e) {
              this.splide.go(e);
          },
          initDgfProductsSlider: function (dragEnabled = true, startIndex = 0) {
              try {
                  if (this.splide) {
                      this.splide.destroy();
                  }
      
                  this.splide = new vt.default(
                      this.container.querySelector(".dgf-products-slider"),
                      {
                          type: "slide",
                          speed: 800,
                          perPage: 2,
                          perMove: 1,
                          gap: 0,
                          pagination: false,
                          arrows: true,
                          keyboard: "focused",
                          drag: dragEnabled ? 1 : 0,
                          mediaQuery: "min",
                          breakpoints: { 768: { gap: "20px" }, 1024: { gap: "30px" } },
                          start: startIndex,
                      }
                  ).mount();
              } catch (e) {
                  console.error("An error occurred in initDgfProductsSlider:", e);
              }
          },
          initProductCardGallery: function () {
              var self = this;
      
              this.container
                  .querySelectorAll(".product-card-gallery")
                  .forEach(function (gallery) {
                      self.initOneGallery(gallery);
      
                      gallery.addEventListener("mousedown", function () {
                          const currentIndex = self.splide.index; // Salva o índice atual
                          self.initDgfProductsSlider(false, currentIndex); // Reinicia mantendo o índice
                      });
      
                      gallery.addEventListener("touchstart", function () {
                          const currentIndex = self.splide.index; // Salva o índice atual
                          self.initDgfProductsSlider(false, currentIndex); // Reinicia mantendo o índice
                      });
      
                      gallery.addEventListener("mouseleave", function () {
                          const currentIndex = self.splide.index; // Salva o índice atual
                          self.initDgfProductsSlider(true, currentIndex); // Reinicia mantendo o índice
                      });
      
                      gallery.addEventListener("touchend", function () {
                          const currentIndex = self.splide.index; // Salva o índice atual
                          self.initDgfProductsSlider(true, currentIndex); // Reinicia mantendo o índice
                      });
                  });
          },
          initOneGallery: function (e) {
              var t,
                  i =
                      null === (t = e.dataset) || void 0 === t
                          ? void 0
                          : t.productSpliderId,
                  n = new vt.default(e, {
                      type: "slide",
                      speed: 800,
                      perPage: 1,
                      perMove: 1,
                      gap: 0,
                      pagination: !0,
                      arrows: !1,
                      keyboard: "focused",
                  }).mount();
              this.sliders.push({ id: i, splide: n }), (e.splide = n);
          },
          initProductCardSwatcher: function () {
              var e = this;
              this.container
                  .querySelectorAll(".product-card-thumbnails")
                  .forEach(function (t) {
                      var i = t.querySelectorAll(".splide__slide"),
                          n = i.length,
                          r = {
                              type: n < 6 ? "slide" : "loop",
                              speed: 800,
                              perPage: 6,
                              perMove: 1,
                              gap: "6px",
                              pagination: !1,
                              arrows: n >= 6,
                              keyboard: "focused",
                              mediaQuery: "min",
                              breakpoints: { 768: { gap: "8px" } },
                          },
                          o = new vt.default(t, r);
                      o.on("mounted", function () {
                          var n = t.querySelectorAll(".splide__slide");
                          i.forEach(function (t, i) {
                              if (0 === i) {
                                  var n = t.dataset.variantId;
                                  e.container
                                      .querySelectorAll('[data-variant-id="'.concat(n, '"]'))
                                      .forEach(function (e) {
                                          e.classList.add("is-active1");
                                      });
                              }
                          }),
                              n.forEach(function (t, i) {
                                  t.addEventListener("click", function () {
                                      var r,
                                          o =
                                              null === (r = t.dataset) || void 0 === r
                                                  ? void 0
                                                  : r.productId;
                                      e.sliders.find(function (t, i) {
                                          if (t.id === o)
                                              return t.splide.destroy(), e.sliders.splice(i, 1), !0;
                                      }),
                                          new It(n, i, e.container, e.selectedVariantsId);
                                      var a = e.container.querySelector(
                                          '[data-product-splider-id="'.concat(o, '"]')
                                      );
                                      e.initOneGallery(a);
                                  });
                              });
                      }),
                          o.mount();
                  });
          },
          initProductCard: function () {
              var e = this,
                  t = this.container.querySelectorAll("[data-product-card-wrapper]");
              (this.currentSellingPlanId = null),
                  (this.selectedVariantsId = {}),
                  t.forEach(function (t) {
                      new qt(t, !1, e.currentSellingPlanId, e.selectedVariantsId);
                  });
          },
          initTestimonialsSlider: function () {
              this.container
                  .querySelectorAll(".products-testimonials-slider")
                  .forEach(function (e) {
                      new vt.default(e, {
                          type: "loop",
                          speed: 800,
                          perPage: 1,
                          gap: 0,
                          pagination: !0,
                          arrows: !1,
                          keyboard: "focused",
                      }).mount();
                  });
          },
          initBackgroundVideo: function () {
              return (function (e, t, i, n) {
                  return new (i || (i = Promise))(function (r, o) {
                      function a(e) {
                          try {
                              l(n.next(e));
                          } catch (e) {
                              o(e);
                          }
                      }
                      function s(e) {
                          try {
                              l(n.throw(e));
                          } catch (e) {
                              o(e);
                          }
                      }
                      function l(e) {
                          var t;
                          e.done
                              ? r(e.value)
                              : ((t = e.value),
                                  t instanceof i
                                      ? t
                                      : new i(function (e) {
                                            e(t);
                                        })).then(a, s);
                      }
                      l((n = n.apply(e, t || [])).next());
                  });
              })(this, void 0, void 0, function () {
                  var e, t, i;
                  return (function (e, t) {
                      var i,
                          n,
                          r,
                          o,
                          a = {
                              label: 0,
                              sent: function () {
                                  if (1 & r[0]) throw r[1];
                                  return r[1];
                              },
                              trys: [],
                              ops: [],
                          };
                      return (
                          (o = { next: s(0), throw: s(1), return: s(2) }),
                          "function" == typeof Symbol &&
                              (o[Symbol.iterator] = function () {
                                  return this;
                              }),
                          o
                      );
                      function s(s) {
                          return function (l) {
                              return (function (s) {
                                  if (i)
                                      throw new TypeError("Generator is already executing.");
                                  for (; o && ((o = 0), s[0] && (a = 0)), a; )
                                      try {
                                          if (
                                              ((i = 1),
                                              n &&
                                                  (r =
                                                      2 & s[0]
                                                          ? n.return
                                                          : s[0]
                                                          ? n.throw || ((r = n.return) && r.call(n), 0)
                                                          : n.next) &&
                                                  !(r = r.call(n, s[1])).done)
                                          )
                                              return r;
                                          switch (
                                              ((n = 0), r && (s = [2 & s[0], r.value]), s[0])
                                          ) {
                                              case 0:
                                              case 1:
                                                  r = s;
                                                  break;
                                              case 4:
                                                  return a.label++, { value: s[1], done: !1 };
                                              case 5:
                                                  a.label++, (n = s[1]), (s = [0]);
                                                  continue;
                                              case 7:
                                                  (s = a.ops.pop()), a.trys.pop();
                                                  continue;
                                              default:
                                                  if (
                                                      !(
                                                          (r =
                                                              (r = a.trys).length > 0 && r[r.length - 1]) ||
                                                          (6 !== s[0] && 2 !== s[0])
                                                      )
                                                  ) {
                                                      a = 0;
                                                      continue;
                                                  }
                                                  if (
                                                      3 === s[0] &&
                                                      (!r || (s[1] > r[0] && s[1] < r[3]))
                                                  ) {
                                                      a.label = s[1];
                                                      break;
                                                  }
                                                  if (6 === s[0] && a.label < r[1]) {
                                                      (a.label = r[1]), (r = s);
                                                      break;
                                                  }
                                                  if (r && a.label < r[2]) {
                                                      (a.label = r[2]), a.ops.push(s);
                                                      break;
                                                  }
                                                  r[2] && a.ops.pop(), a.trys.pop();
                                                  continue;
                                          }
                                          s = t.call(e, a);
                                      } catch (e) {
                                          (s = [6, e]), (n = 0);
                                      } finally {
                                          i = r = 0;
                                      }
                                  if (5 & s[0]) throw s[1];
                                  return { value: s[0] ? s[1] : void 0, done: !0 };
                              })([s, l]);
                          };
                      }
                  })(this, function (n) {
                      switch (n.label) {
                          case 0:
                              return (
                                  n.trys.push([0, 2, , 3]),
                                  [4, l.e(443).then(l.t.bind(l, 1443, 23))]
                              );
                          case 1:
                              return (
                                  (e = n.sent().default),
                                  (t = document.querySelector(".js-player")) &&
                                      new e(t, {
                                          autoplay: !0,
                                          loop: { active: !0 },
                                          autopause: !0,
                                          muted: !0,
                                          controls: ["play-large"],
                                      }),
                                  [3, 3]
                              );
                          case 2:
                              return (
                                  (i = n.sent()),
                                  console.error(
                                      "An error occurred in initBackgroundVideo:",
                                      i
                                  ),
                                  [3, 3]
                              );
                          case 3:
                              return [2];
                      }
                  });
              });
          },
          onLoad: function () {
              this.initProductCard(),
                  pt(this.id, this.initDgfProductsSlider.bind(this)),
                  pt(this.id, this.initProductCardGallery.bind(this)),
                  pt(this.id, this.initProductCardSwatcher.bind(this)),
                  pt(this.id, this.initTestimonialsSlider.bind(this)),
                  pt(this.id, this.initBackgroundVideo.bind(this));
          },
          onUnload: function () {
              this.splide.destroy();
          },
          onDeselect: function () {
              this.splide.go(1);
          },
          onBlockSelect: function (e) {
              this._slideToBlock(+e.target.dataset.index);
          },
          onBlockDeselect: function () {
              this.splide.go(1);
          },
      });
      a("products-slider", {
        sliders: [],
        _slideToBlock: function (e) {
          this.splide.go(e);
        },
        initProductsSlider: function () {
          try {
            this.splide = new vt.default(
              this.container.querySelector(".products-slider"),
              {
                type: "slide",
                speed: 800,
                perPage: 2,
                perMove: 1,
                gap: 0,
                pagination: !1,
                arrows: !0,
                keyboard: "focused",
                drag: !1,
                mediaQuery: "min",
                breakpoints: { 768: { gap: "20px" }, 1024: { gap: "30px" } },
              }
            ).mount();
          } catch (e) {
            console.error("An error occurred in initBestsellersSlider:", e);
          }
        },
        initProductCardGallery: function () {
          var e = this;
          this.container
            .querySelectorAll(".product-card-gallery")
            .forEach(function (t) {
              e.initOneGallery(t);
            });
        },
        initOneGallery: function (e) {
          var t,
            i =
              null === (t = e.dataset) || void 0 === t
                ? void 0
                : t.productSpliderId,
            n = new vt.default(e, {
              type: "slide",
              speed: 800,
              perPage: 1,
              perMove: 1,
              gap: 0,
              pagination: !0,
              arrows: !1,
              keyboard: "focused",
            }).mount();
          this.sliders.push({ id: i, splide: n }), (e.splide = n);
        },
        initProductCardSwatcher: function () {
          var e = this;
          this.container
            .querySelectorAll(".product-card-thumbnails")
            .forEach(function (t) {
              var i = t.querySelectorAll(".splide__slide"),
                n = i.length,
                r = {
                  type: n < 6 ? "slide" : "loop",
                  speed: 800,
                  perPage: 6,
                  perMove: 1,
                  gap: "6px",
                  pagination: !1,
                  arrows: n >= 6,
                  keyboard: "focused",
                  mediaQuery: "min",
                  breakpoints: { 768: { gap: "8px" } },
                },
                o = new vt.default(t, r);
              o.on("mounted", function () {
                var n = t.querySelectorAll(".splide__slide");
                i.forEach(function (t, i) {
                  if (0 === i) {
                    var n = t.dataset.variantId;
                    e.container
                      .querySelectorAll('[data-variant-id="'.concat(n, '"]'))
                      .forEach(function (e) {
                        e.classList.add("is-active1");
                      });
                  }
                }),
                  n.forEach(function (t, i) {
                    t.addEventListener("click", function () {
                      var r,
                        o =
                          null === (r = t.dataset) || void 0 === r
                            ? void 0
                            : r.productId;
                      e.sliders.find(function (t, i) {
                        if (t.id === o)
                          return t.splide.destroy(), e.sliders.splice(i, 1), !0;
                      }),
                        new It(n, i, e.container, e.selectedVariantsId);
                      var a = e.container.querySelector(
                        '[data-product-splider-id="'.concat(o, '"]')
                      );
                      e.initOneGallery(a);
                    });
                  });
              }),
                o.mount();
            });
        },
        initProductCard: function () {
          var e = this,
            t = this.container.querySelectorAll("[data-product-card-wrapper]");
          (this.currentSellingPlanId = null),
            (this.selectedVariantsId = {}),
            t.forEach(function (t) {
              new qt(t, !1, e.currentSellingPlanId, e.selectedVariantsId);
            });
        },
        initTestimonialsSlider: function () {
          this.container
            .querySelectorAll(".products-testimonials-slider")
            .forEach(function (e) {
              new vt.default(e, {
                type: "loop",
                speed: 800,
                perPage: 1,
                gap: 0,
                pagination: !0,
                arrows: !1,
                keyboard: "focused",
              }).mount();
            });
        },
        initBackgroundVideo: function () {
          return (function (e, t, i, n) {
            return new (i || (i = Promise))(function (r, o) {
              function a(e) {
                try {
                  l(n.next(e));
                } catch (e) {
                  o(e);
                }
              }
              function s(e) {
                try {
                  l(n.throw(e));
                } catch (e) {
                  o(e);
                }
              }
              function l(e) {
                var t;
                e.done
                  ? r(e.value)
                  : ((t = e.value),
                    t instanceof i
                      ? t
                      : new i(function (e) {
                          e(t);
                        })).then(a, s);
              }
              l((n = n.apply(e, t || [])).next());
            });
          })(this, void 0, void 0, function () {
            var e, t, i;
            return (function (e, t) {
              var i,
                n,
                r,
                o,
                a = {
                  label: 0,
                  sent: function () {
                    if (1 & r[0]) throw r[1];
                    return r[1];
                  },
                  trys: [],
                  ops: [],
                };
              return (
                (o = { next: s(0), throw: s(1), return: s(2) }),
                "function" == typeof Symbol &&
                  (o[Symbol.iterator] = function () {
                    return this;
                  }),
                o
              );
              function s(s) {
                return function (l) {
                  return (function (s) {
                    if (i)
                      throw new TypeError("Generator is already executing.");
                    for (; o && ((o = 0), s[0] && (a = 0)), a; )
                      try {
                        if (
                          ((i = 1),
                          n &&
                            (r =
                              2 & s[0]
                                ? n.return
                                : s[0]
                                ? n.throw || ((r = n.return) && r.call(n), 0)
                                : n.next) &&
                            !(r = r.call(n, s[1])).done)
                        )
                          return r;
                        switch (
                          ((n = 0), r && (s = [2 & s[0], r.value]), s[0])
                        ) {
                          case 0:
                          case 1:
                            r = s;
                            break;
                          case 4:
                            return a.label++, { value: s[1], done: !1 };
                          case 5:
                            a.label++, (n = s[1]), (s = [0]);
                            continue;
                          case 7:
                            (s = a.ops.pop()), a.trys.pop();
                            continue;
                          default:
                            if (
                              !(
                                (r =
                                  (r = a.trys).length > 0 && r[r.length - 1]) ||
                                (6 !== s[0] && 2 !== s[0])
                              )
                            ) {
                              a = 0;
                              continue;
                            }
                            if (
                              3 === s[0] &&
                              (!r || (s[1] > r[0] && s[1] < r[3]))
                            ) {
                              a.label = s[1];
                              break;
                            }
                            if (6 === s[0] && a.label < r[1]) {
                              (a.label = r[1]), (r = s);
                              break;
                            }
                            if (r && a.label < r[2]) {
                              (a.label = r[2]), a.ops.push(s);
                              break;
                            }
                            r[2] && a.ops.pop(), a.trys.pop();
                            continue;
                        }
                        s = t.call(e, a);
                      } catch (e) {
                        (s = [6, e]), (n = 0);
                      } finally {
                        i = r = 0;
                      }
                    if (5 & s[0]) throw s[1];
                    return { value: s[0] ? s[1] : void 0, done: !0 };
                  })([s, l]);
                };
              }
            })(this, function (n) {
              switch (n.label) {
                case 0:
                  return (
                    n.trys.push([0, 2, , 3]),
                    [4, l.e(443).then(l.t.bind(l, 1443, 23))]
                  );
                case 1:
                  return (
                    (e = n.sent().default),
                    (t = document.querySelector(".js-player")) &&
                      new e(t, {
                        autoplay: !0,
                        loop: { active: !0 },
                        autopause: !0,
                        muted: !0,
                        controls: ["play-large"],
                      }),
                    [3, 3]
                  );
                case 2:
                  return (
                    (i = n.sent()),
                    console.error(
                      "An error occurred in initBackgroundVideo:",
                      i
                    ),
                    [3, 3]
                  );
                case 3:
                  return [2];
              }
            });
          });
        },
        onLoad: function () {
          this.initProductCard(),
            pt(this.id, this.initProductsSlider.bind(this)),
            pt(this.id, this.initProductCardGallery.bind(this)),
            pt(this.id, this.initProductCardSwatcher.bind(this)),
            pt(this.id, this.initTestimonialsSlider.bind(this)),
            pt(this.id, this.initBackgroundVideo.bind(this));
        },
        onUnload: function () {
          this.splide.destroy();
        },
        onDeselect: function () {
          this.splide.go(1);
        },
        onBlockSelect: function (e) {
          this._slideToBlock(+e.target.dataset.index);
        },
        onBlockDeselect: function () {
          this.splide.go(1);
        },
      }),
        s("*");
    })();
})();
